export const tweets = [
  {
    source: "Twitter for iPhone",
    text:
      "...2nd Amendment, Strong Military, ISIS, historic VA improvement, Supreme Court Justice, Record Stock Market, lowest unemployment in 17 yrs!",
    created_at: "Sun Oct 22 00:09:21 +0000 2017",
    retweet_count: 10516,
    favorite_count: 46330,
    is_retweet: false,
    id_str: "921891186352287744"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...9 months than this Administration. Over 50 Legislation approvals, massive regulation cuts, energy freedom, pipelines, border security....",
    created_at: "Sun Oct 22 00:02:45 +0000 2017",
    retweet_count: 9975,
    favorite_count: 45786,
    is_retweet: false,
    id_str: "921889525881819136"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I agree getting Tax Cuts approved  is important (we will also get HealthCare), but perhaps no Administration has done more in its first.....",
    created_at: "Sat Oct 21 23:57:41 +0000 2017",
    retweet_count: 8537,
    favorite_count: 40536,
    is_retweet: false,
    id_str: "921888248707846144"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Just out, but lightly reported: "Fewest jobless claims since 1973 show firm U.S. Job Market" Lowest since March 1973. @bpolitics',
    created_at: "Sat Oct 21 22:51:57 +0000 2017",
    retweet_count: 11632,
    favorite_count: 43021,
    is_retweet: false,
    id_str: "921871707564101632"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Crooked Hillary Clinton spent hundreds of millions of dollars more on Presidential Election than I did. Facebook was on her side, not mine!",
    created_at: "Sat Oct 21 21:21:08 +0000 2017",
    retweet_count: 16643,
    favorite_count: 68238,
    is_retweet: false,
    id_str: "921848853090983938"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Keep hearing about "tiny" amount of money spent on Facebook ads. What about the billions of dollars of Fake News on CNN, ABC, NBC &amp; CBS?',
    created_at: "Sat Oct 21 20:06:00 +0000 2017",
    retweet_count: 17941,
    favorite_count: 70259,
    is_retweet: false,
    id_str: "921829947093733376"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Officials behind the now discredited "Dossier" plead the Fifth. Justice Department and/or FBI should immediately release who paid for it.',
    created_at: "Sat Oct 21 19:59:23 +0000 2017",
    retweet_count: 17130,
    favorite_count: 55209,
    is_retweet: false,
    id_str: "921828280998744066"
  },
  {
    source: "Twitter for iPhone",
    text:
      "“Trump hails liberation of Raqqa as critical breakthrough in anti-ISIS campaign” https://t.co/2eoYXJB7h0",
    created_at: "Sat Oct 21 16:50:33 +0000 2017",
    retweet_count: 8941,
    favorite_count: 36713,
    is_retweet: false,
    id_str: "921780758372642816"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Stock Market hits another all time high on Friday. 5.3 trillion dollars up since Election. Fake News doesn't spent much time on this!",
    created_at: "Sat Oct 21 13:14:33 +0000 2017",
    retweet_count: 18616,
    favorite_count: 80002,
    is_retweet: false,
    id_str: "921726400922619904"
  },
  {
    source: "Twitter for iPhone",
    text: "People get what is going on! https://t.co/Pdg7VqQv6M",
    created_at: "Sat Oct 21 13:08:17 +0000 2017",
    retweet_count: 13467,
    favorite_count: 45696,
    is_retweet: false,
    id_str: "921724821939130369"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IamVicky4Trump: TUNE IN: Maria Bartiromo Has an Exclusive Interview With President Trump https://t.co/H5VuJwy78o",
    created_at: "Sat Oct 21 13:02:14 +0000 2017",
    retweet_count: 4826,
    favorite_count: 0,
    is_retweet: true,
    id_str: "921723302481145857"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Subject to the receipt of further information, I will be allowing, as President, the long blocked and classified JFK FILES to be opened.",
    created_at: "Sat Oct 21 12:35:05 +0000 2017",
    retweet_count: 64340,
    favorite_count: 186653,
    is_retweet: false,
    id_str: "921716470140325889"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I hope the Fake News Media keeps talking about Wacky Congresswoman Wilson in that she, as a representative, is killing the Democrat Party!",
    created_at: "Sat Oct 21 12:07:16 +0000 2017",
    retweet_count: 18245,
    favorite_count: 79566,
    is_retweet: false,
    id_str: "921709468055896064"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Budget that just passed is a really big deal, especially in terms of what will be the biggest tax cut in U.S. history - MSM barely covered!",
    created_at: "Sat Oct 21 11:52:56 +0000 2017",
    retweet_count: 14109,
    favorite_count: 61633,
    is_retweet: false,
    id_str: "921705862992887808"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Great book just out, "A Place Called Heaven," by Dr. Robert Jeffress - A wonderful man!',
    created_at: "Fri Oct 20 23:52:17 +0000 2017",
    retweet_count: 13090,
    favorite_count: 65977,
    is_retweet: false,
    id_str: "921524504836395008"
  },
  {
    source: "Media Studio",
    text:
      "This is a once-in-a-generation opportunity to offer historic tax relief to the American people! Join me today: https://t.co/9czcJDbmVW https://t.co/s3kXpvbYih",
    created_at: "Fri Oct 20 21:10:37 +0000 2017",
    retweet_count: 14672,
    favorite_count: 58138,
    is_retweet: false,
    id_str: "921483820288921601"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today, it was an honor to have @UN\nSecretary-General @AntonioGuterres at the @WhiteHouse. Speaking for the U.S.A., we appreciate all you do! https://t.co/Sk0Jcazzxw",
    created_at: "Fri Oct 20 18:50:21 +0000 2017",
    retweet_count: 6592,
    favorite_count: 32853,
    is_retweet: false,
    id_str: "921448521617821701"
  },
  {
    source: "Media Studio",
    text:
      "Thank you @GeraldoRivera @FoxandFriends. Agree! https://t.co/8cZLdAbgzw",
    created_at: "Fri Oct 20 18:31:19 +0000 2017",
    retweet_count: 12158,
    favorite_count: 44655,
    is_retweet: false,
    id_str: "921443729990397952"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Just out report: "United Kingdom crime rises 13% annually amid spread of Radical Islamic terror." Not good, we must keep America safe!',
    created_at: "Fri Oct 20 10:31:50 +0000 2017",
    retweet_count: 28682,
    favorite_count: 103669,
    is_retweet: false,
    id_str: "921323063945453574"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....This now allows for the passage of large scale Tax Cuts (and Reform), which will be the biggest in the history of our country!",
    created_at: "Fri Oct 20 10:15:45 +0000 2017",
    retweet_count: 14854,
    favorite_count: 71531,
    is_retweet: false,
    id_str: "921319017826091008"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Budget passed late last night, 51 to 49. We got ZERO Democrat votes with only Rand Paul (he will vote for Tax Cuts) voting against.....",
    created_at: "Fri Oct 20 10:11:15 +0000 2017",
    retweet_count: 15509,
    favorite_count: 68057,
    is_retweet: false,
    id_str: "921317883321430016"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great news on the 2018 budget @SenateMajLdr McConnell - first step toward delivering MASSIVE tax cuts for the American people! #TaxReform https://t.co/aBzQR7KR0c",
    created_at: "Fri Oct 20 05:12:44 +0000 2017",
    retweet_count: 12479,
    favorite_count: 51693,
    is_retweet: false,
    id_str: "921242760685998080"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big ratings getter @seanhannity and Apprentice Champion John Rich are right now going on stage in Las Vegas for #VegasStrong. Great Show!",
    created_at: "Fri Oct 20 03:00:42 +0000 2017",
    retweet_count: 9604,
    favorite_count: 49551,
    is_retweet: false,
    id_str: "921209530628956161"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News is going crazy with wacky Congresswoman Wilson(D), who was SECRETLY on a very personal call, and gave a total lie on content!",
    created_at: "Fri Oct 20 02:53:42 +0000 2017",
    retweet_count: 20629,
    favorite_count: 87817,
    is_retweet: false,
    id_str: "921207772233990144"
  },
  {
    source: "Media Studio",
    text:
      'Keep up the GREAT work. I am with you 100%!\n\n"ISIS is losing its grip..."\nArmy Colonel Ryan Dillon\nCJTF–OIR\nhttps://t.co/jVGuvv5mzm https://t.co/PSCXg38CtS',
    created_at: "Fri Oct 20 01:43:00 +0000 2017",
    retweet_count: 12403,
    favorite_count: 52367,
    is_retweet: false,
    id_str: "921189980843663360"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was great to have Governor @RicardoRossello of #PuertoRico🇵🇷with us at the @WhiteHouse today. We are with you! #PRStrong https://t.co/Op2xDZxvNc",
    created_at: "Thu Oct 19 20:40:21 +0000 2017",
    retweet_count: 10688,
    favorite_count: 47704,
    is_retweet: false,
    id_str: "921113816053755904"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @USArmy333: @804StreetMedia @realDonaldTrump He’s done more in 9 months then obama did in8 yrs",
    created_at: "Thu Oct 19 12:25:19 +0000 2017",
    retweet_count: 8108,
    favorite_count: 0,
    is_retweet: true,
    id_str: "920989237276762112"
  },
  {
    source: "Twitter for iPhone",
    text: '.@foxandfriends "Russia sent millions to Clinton Foundation"',
    created_at: "Thu Oct 19 12:21:18 +0000 2017",
    retweet_count: 22987,
    favorite_count: 70025,
    is_retweet: false,
    id_str: "920988223362469891"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Workers of firm involved with the discredited and Fake Dossier take the 5th. Who paid for it, Russia, the FBI or the Dems (or all)?",
    created_at: "Thu Oct 19 11:56:15 +0000 2017",
    retweet_count: 24526,
    favorite_count: 83270,
    is_retweet: false,
    id_str: "920981920787386368"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Uranium deal to Russia, with Clinton help and Obama Administration knowledge, is the biggest story that Fake Media doesn't want to follow!",
    created_at: "Thu Oct 19 11:17:52 +0000 2017",
    retweet_count: 39402,
    favorite_count: 115855,
    is_retweet: false,
    id_str: "920972261032648705"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republicans are going for the big Budget approval today, first step toward massive tax cuts. I think we have the votes, but who knows?",
    created_at: "Thu Oct 19 10:54:09 +0000 2017",
    retweet_count: 13353,
    favorite_count: 70194,
    is_retweet: false,
    id_str: "920966294035451904"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"46% of Americans think the Media is inventing stories about Trump &amp; his Administration." @FoxNews   It is actually much worse than this!',
    created_at: "Thu Oct 19 03:03:29 +0000 2017",
    retweet_count: 18906,
    favorite_count: 81793,
    is_retweet: false,
    id_str: "920847844759699456"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@DanaPerino &amp; @BradThor,\nThank you so much for the wonderful compliment. Working hard! #MAGA https://t.co/AKWlsMsCVH",
    created_at: "Wed Oct 18 23:31:54 +0000 2017",
    retweet_count: 10180,
    favorite_count: 42708,
    is_retweet: false,
    id_str: "920794597265088512"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"20,000📈21,000📈22,000📈 23,000📈this year...FOUR one thousand milestones this year..." \n#Dow23K #MAGA https://t.co/GQ5f2eVvEI',
    created_at: "Wed Oct 18 22:49:42 +0000 2017",
    retweet_count: 14125,
    favorite_count: 56149,
    is_retweet: false,
    id_str: "920783976784171008"
  },
  {
    source: "Twitter for iPhone",
    text:
      "This is what REAL PRIDE in our COUNTRY is all about! #USA🇺🇸 https://t.co/kyv866prdE",
    created_at: "Wed Oct 18 22:19:12 +0000 2017",
    retweet_count: 17729,
    favorite_count: 68155,
    is_retweet: false,
    id_str: "920776302231244800"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@NFL: Too much talk, not enough action. Stand for the National Anthem.",
    created_at: "Wed Oct 18 20:42:05 +0000 2017",
    retweet_count: 22739,
    favorite_count: 96769,
    is_retweet: false,
    id_str: "920751863426842625"
  },
  {
    source: "Media Studio",
    text:
      '"Iran hides behind its assertion of technical compliance w/the nuclear deal, while it brazenly violates the other limits.."\nAmb. @NikkiHaley https://t.co/xvHgx7d1cT',
    created_at: "Wed Oct 18 19:27:26 +0000 2017",
    retweet_count: 11642,
    favorite_count: 40874,
    is_retweet: false,
    id_str: "920733077349064707"
  },
  {
    source: "Media Studio",
    text:
      "It was an honor to welcome Republican and Democratic members of the Senate Finance Committee to the @WhiteHouse today. #TaxReform https://t.co/ge4Xic9fId",
    created_at: "Wed Oct 18 18:20:39 +0000 2017",
    retweet_count: 7325,
    favorite_count: 35421,
    is_retweet: false,
    id_str: "920716270395371521"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Our hearts are with all affected by the wildfires in California. God bless our brave First Responders and @FEMA team. We support you! https://t.co/YaoPbaVI5L",
    created_at: "Wed Oct 18 16:58:23 +0000 2017",
    retweet_count: 8872,
    favorite_count: 42989,
    is_retweet: false,
    id_str: "920695565578592256"
  },
  {
    source: "Media Studio",
    text:
      "The current tax code is a burden on American taxpayers &amp; harmful to job-creators. Americans need #TaxReform! More: https://t.co/qXyiYiFWCO https://t.co/NGIjJOc3TP",
    created_at: "Wed Oct 18 15:07:07 +0000 2017",
    retweet_count: 10339,
    favorite_count: 42391,
    is_retweet: false,
    id_str: "920667567030710272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am supportive of Lamar as a person &amp; also of the process, but I can never support bailing out ins co's who have made a fortune w/ O'Care.",
    created_at: "Wed Oct 18 13:41:10 +0000 2017",
    retweet_count: 12853,
    favorite_count: 59351,
    is_retweet: false,
    id_str: "920645935981613057"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrat Congresswoman totally fabricated what I said to the wife of a soldier who died in action (and I have proof). Sad!",
    created_at: "Wed Oct 18 11:25:24 +0000 2017",
    retweet_count: 25322,
    favorite_count: 98157,
    is_retweet: false,
    id_str: "920611770775064576"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The NFL has decided that it will not force players to stand for the playing of our National Anthem. Total disrespect for our great country!",
    created_at: "Wed Oct 18 11:06:06 +0000 2017",
    retweet_count: 24176,
    favorite_count: 99810,
    is_retweet: false,
    id_str: "920606910109356032"
  },
  {
    source: "Twitter for iPhone",
    text:
      "As it has turned out, James Comey lied and leaked and totally protected Hillary Clinton. He was the best thing that ever happened to her!",
    created_at: "Wed Oct 18 10:56:36 +0000 2017",
    retweet_count: 25059,
    favorite_count: 92321,
    is_retweet: false,
    id_str: "920604520572424193"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats will only vote for Tax Increases. Hopefully, all Senate Republicans will vote for the largest Tax Cuts in U.S. history.",
    created_at: "Wed Oct 18 10:38:18 +0000 2017",
    retweet_count: 13940,
    favorite_count: 59429,
    is_retweet: false,
    id_str: "920599916371693568"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...people not interviewed, including Clinton herself. Comey stated under oath that he didn't do this-obviously a fix? Where is Justice Dept?",
    created_at: "Wed Oct 18 10:27:29 +0000 2017",
    retweet_count: 19416,
    favorite_count: 71760,
    is_retweet: false,
    id_str: "920597192666157057"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Wow, FBI confirms report that James Comey drafted letter exonerating  Crooked Hillary Clinton long before investigation was complete. Many..",
    created_at: "Wed Oct 18 10:21:00 +0000 2017",
    retweet_count: 24067,
    favorite_count: 84359,
    is_retweet: false,
    id_str: "920595564064100352"
  },
  {
    source: "Media Studio",
    text:
      "The most important truth our FOUNDERS understood was: FREEDOM is NOT a gift from Govt. FREEDOM is a GIFT from GOD. 🎥https://t.co/rmAzGt8SuG https://t.co/SrPavwrt2R",
    created_at: "Wed Oct 18 02:21:16 +0000 2017",
    retweet_count: 17643,
    favorite_count: 62673,
    is_retweet: false,
    id_str: "920474831749025795"
  },
  {
    source: "Media Studio",
    text:
      "Thank you @Heritage! This is our once-in-a-generation opportunity to revitalize our economy, revive our industry &amp; renew the AMERICAN DREAM! https://t.co/HI30nojsGo",
    created_at: "Wed Oct 18 00:44:43 +0000 2017",
    retweet_count: 9567,
    favorite_count: 41805,
    is_retweet: false,
    id_str: "920450535005851648"
  },
  {
    source: "Twitter for iPhone",
    text: "WOW! https://t.co/eKfRktNVuy",
    created_at: "Tue Oct 17 23:06:01 +0000 2017",
    retweet_count: 17009,
    favorite_count: 62821,
    is_retweet: false,
    id_str: "920425695507042305"
  },
  {
    source: "Twitter for iPhone",
    text: "BORDER WALL prototypes underway! https://t.co/arFNO80zmO",
    created_at: "Tue Oct 17 23:03:32 +0000 2017",
    retweet_count: 30690,
    favorite_count: 102866,
    is_retweet: false,
    id_str: "920425069964349445"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Any increase in ObamaCare premiums is the fault of the Democrats for giving us a "product" that never had a chance of working.',
    created_at: "Tue Oct 17 21:56:08 +0000 2017",
    retweet_count: 16653,
    favorite_count: 71568,
    is_retweet: false,
    id_str: "920408108194783232"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So much Fake News being put in dying magazines and newspapers. Only place worse may be @NBCNews, @CBSNews, @ABC and @CNN. Fiction writers!",
    created_at: "Tue Oct 17 21:51:34 +0000 2017",
    retweet_count: 16091,
    favorite_count: 63248,
    is_retweet: false,
    id_str: "920406959320371200"
  },
  {
    source: "Media Studio",
    text:
      "It was my great honor to welcome Prime Minister Alexis Tsipras of Greece to the WH today! 🎥https://t.co/Bn1vM6fYW9 📸https://t.co/j0roMFT3YL https://t.co/MPe5HWFcZ1",
    created_at: "Tue Oct 17 18:59:43 +0000 2017",
    retweet_count: 6681,
    favorite_count: 36827,
    is_retweet: false,
    id_str: "920363714062274560"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me LIVE from the Rose Garden at 1:30pmE with Prime Minister Alexis Tsipras of Greece. ➡️https://t.co/Bn1vM6fYW9 https://t.co/dZB4mDBKpi",
    created_at: "Tue Oct 17 17:25:44 +0000 2017",
    retweet_count: 4303,
    favorite_count: 24616,
    is_retweet: false,
    id_str: "920340060947574786"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"Dow Passes 23,000 for the First Time, Fueled by Strong Earnings"\n#Dow23K📈https://t.co/wnkrddYlb9 https://t.co/wlP0NCNcou',
    created_at: "Tue Oct 17 16:16:28 +0000 2017",
    retweet_count: 11413,
    favorite_count: 45391,
    is_retweet: false,
    id_str: "920322631412473856"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Rep.Tom Marino has informed me that he is withdrawing his name from consideration as drug czar. Tom is a fine man and a great Congressman!",
    created_at: "Tue Oct 17 12:39:45 +0000 2017",
    retweet_count: 8632,
    favorite_count: 49359,
    is_retweet: false,
    id_str: "920268091329859585"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: U.S. MARKETS FROM ELECTION DAY {Since 11/8/2016} 📈 https://t.co/HtjHrznQKJ",
    created_at: "Tue Oct 17 11:05:25 +0000 2017",
    retweet_count: 7713,
    favorite_count: 0,
    is_retweet: true,
    id_str: "920244350268903424"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Always great to see the wonderful people of South Carolina. Thank you for the beautiful welcome at Greenville-Spartanburg Int'l Airport! https://t.co/maO9Nc0sTe",
    created_at: "Mon Oct 16 23:32:05 +0000 2017",
    retweet_count: 12226,
    favorite_count: 65132,
    is_retweet: false,
    id_str: "920069869365878785"
  },
  {
    source: "Twitter for iPhone",
    text:
      'I was recently asked if Crooked Hillary Clinton is going to run in 2020? My answer was, "I hope so!"',
    created_at: "Mon Oct 16 13:12:43 +0000 2017",
    retweet_count: 35014,
    favorite_count: 151246,
    is_retweet: false,
    id_str: "919914000959397888"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The U.S. has gained more than 5.2 trillion dollars in Stock Market Value since Election Day! Also, record business enthusiasm.",
    created_at: "Mon Oct 16 12:57:50 +0000 2017",
    retweet_count: 19528,
    favorite_count: 95760,
    is_retweet: false,
    id_str: "919910256624447493"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Since Election Day on November 8, the Stock Market is up more than 25%, unemployment is at a 17 year low &amp; companies are coming back to U.S.",
    created_at: "Mon Oct 16 12:54:49 +0000 2017",
    retweet_count: 20143,
    favorite_count: 91990,
    is_retweet: false,
    id_str: "919909494200528897"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Dem Senator Schumer hated the Iran deal made by President Obama, but now that I am involved, he is OK with it. Tell that to Israel, Chuck!",
    created_at: "Mon Oct 16 12:49:27 +0000 2017",
    retweet_count: 20844,
    favorite_count: 76210,
    is_retweet: false,
    id_str: "919908143475412993"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats only want to increase taxes and obstruct. That's all they are good at!",
    created_at: "Mon Oct 16 12:21:49 +0000 2017",
    retweet_count: 12784,
    favorite_count: 56807,
    is_retweet: false,
    id_str: "919901190376259586"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Art Laffer just said that he doesn't know how a Democrat could vote against the big tax cut/reform bill and live with themselves!  @FoxNews",
    created_at: "Mon Oct 16 12:17:10 +0000 2017",
    retweet_count: 12863,
    favorite_count: 57542,
    is_retweet: false,
    id_str: "919900022409449474"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @ABCNewsRadio: Global fund championed by Ivanka Trump to help women entrepreneurs begins operations https://t.co/jUmsY3ON4x https://t.co…",
    created_at: "Mon Oct 16 00:55:02 +0000 2017",
    retweet_count: 5526,
    favorite_count: 0,
    is_retweet: true,
    id_str: "919728356765073408"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @mike_pence: .@EdWGillespie is fighting to grow the economy &amp; cut taxes! He’s fighting for a safer VA. And he’s is fighting for affordab…",
    created_at: "Mon Oct 16 00:49:41 +0000 2017",
    retweet_count: 5777,
    favorite_count: 0,
    is_retweet: true,
    id_str: "919727009797951488"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...approvals of The Keystone XL &amp; Dakota Access pipelines. Also, look at the recent EPA cancelations &amp; our great new Supreme Court Justice!",
    created_at: "Sun Oct 15 13:46:27 +0000 2017",
    retweet_count: 14854,
    favorite_count: 77017,
    is_retweet: false,
    id_str: "919560102725738498"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Failing @nytimes, in a story by Peter Baker, should have mentioned the rapid terminations by me of TPP &amp; The Paris Accord &amp; the fast....",
    created_at: "Sun Oct 15 13:25:05 +0000 2017",
    retweet_count: 12831,
    favorite_count: 60401,
    is_retweet: false,
    id_str: "919554724512387072"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @FoxNews: TONIGHT on "Justice," @JudgeJeanine talks to special guests @EricTrump and @LaraLeaTrump - Tune in at 9p ET on Fox News Channe…',
    created_at: "Sat Oct 14 23:22:04 +0000 2017",
    retweet_count: 4472,
    favorite_count: 0,
    is_retweet: true,
    id_str: "919342572526559232"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @EricTrump: .@LaraLeaTrump and I look forward to being on @JudgeJeanine tonight at 9pm! @FoxNews #MakeAmericaGreatAgain 🇺🇸🇺🇸🇺🇸 https://t…",
    created_at: "Sat Oct 14 21:29:38 +0000 2017",
    retweet_count: 5812,
    favorite_count: 0,
    is_retweet: true,
    id_str: "919314277177192448"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @mike_pence: We are heading to Virginia. Looking forward to supporting my friend @EdWGillespie. He will make a great Governor for the Co…",
    created_at: "Sat Oct 14 21:28:34 +0000 2017",
    retweet_count: 7935,
    favorite_count: 0,
    is_retweet: true,
    id_str: "919314010587230208"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats in the Southwest part of Virginia have been abandoned by their Party. Republican Ed Gillespie will never let you down!",
    created_at: "Sat Oct 14 21:27:22 +0000 2017",
    retweet_count: 15967,
    favorite_count: 70729,
    is_retweet: false,
    id_str: "919313707355787264"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Very proud of my Executive Order which will allow greatly expanded access and far lower costs for HealthCare. Millions of people benefit!",
    created_at: "Sat Oct 14 11:27:00 +0000 2017",
    retweet_count: 22784,
    favorite_count: 118063,
    is_retweet: false,
    id_str: "919162619889704961"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Health Insurance stocks, which have gone through the roof during the ObamaCare years, plunged yesterday after I ended their Dems windfall!",
    created_at: "Sat Oct 14 11:18:49 +0000 2017",
    retweet_count: 18414,
    favorite_count: 84062,
    is_retweet: false,
    id_str: "919160558712172544"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @realDonaldTrump: "Consumer confidence soars to highest level since 2004"\n📈https://t.co/RvxCPAFI2A https://t.co/U8MS9K45fX',
    created_at: "Sat Oct 14 11:12:16 +0000 2017",
    retweet_count: 11399,
    favorite_count: 0,
    is_retweet: true,
    id_str: "919158911164444672"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @RightlyNews: @realDonaldTrump @LouDobbs Trust in the media is at the lowest level in all of U.S. history. The American people see throu…",
    created_at: "Sat Oct 14 11:08:32 +0000 2017",
    retweet_count: 6923,
    favorite_count: 0,
    is_retweet: true,
    id_str: "919157971627724800"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @RightlyNews: @realDonaldTrump @LouDobbs It is NOT a coincidence that the economy boomed immediately after the 2016 election.",
    created_at: "Sat Oct 14 11:08:00 +0000 2017",
    retweet_count: 5085,
    favorite_count: 0,
    is_retweet: true,
    id_str: "919157838106300416"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Such a wonderful statement from the great @LouDobbs. "We take up what may be the most accomplished presidency in modern American history."',
    created_at: "Sat Oct 14 01:31:20 +0000 2017",
    retweet_count: 16011,
    favorite_count: 68213,
    is_retweet: false,
    id_str: "919012714827145216"
  },
  {
    source: "Twitter for iPhone",
    text:
      "ObamaCare is causing such grief and tragedy for so many. It is being dismantled but in the meantime, premiums &amp; deductibles are way up!",
    created_at: "Sat Oct 14 01:17:54 +0000 2017",
    retweet_count: 12384,
    favorite_count: 61196,
    is_retweet: false,
    id_str: "919009334016856065"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Money pouring into Insurance Companies profits, under the guise of ObamaCare, is over. They have made a fortune.\nDems must get smart &amp; deal!",
    created_at: "Sat Oct 14 01:10:55 +0000 2017",
    retweet_count: 15810,
    favorite_count: 68864,
    is_retweet: false,
    id_str: "919007577681354752"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Many people talking, with much agreement, on my Iran speech today. Participants in the deal are making lots of money on trade with Iran!",
    created_at: "Sat Oct 14 01:02:48 +0000 2017",
    retweet_count: 11303,
    favorite_count: 54267,
    is_retweet: false,
    id_str: "919005534883328000"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Starting to develop a much better relationship with Pakistan and its leaders. I want to thank them for their cooperation on many fronts.",
    created_at: "Sat Oct 14 00:53:59 +0000 2017",
    retweet_count: 14096,
    favorite_count: 69806,
    is_retweet: false,
    id_str: "919003314674634752"
  },
  {
    source: "Media Studio",
    text: "#WeeklyAddress🇺🇸 https://t.co/riqEiBNwk2",
    created_at: "Fri Oct 13 22:01:57 +0000 2017",
    retweet_count: 10635,
    favorite_count: 41344,
    is_retweet: false,
    id_str: "918960024256434176"
  },
  {
    source: "Media Studio",
    text:
      "Today, I announced our strategy to confront the Iranian regime’s hostile actions and to ensure that they never acquire a nuclear weapon. https://t.co/N4ISdjuEdC",
    created_at: "Fri Oct 13 18:09:00 +0000 2017",
    retweet_count: 17606,
    favorite_count: 66537,
    is_retweet: false,
    id_str: "918901399080935424"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"Consumer confidence soars to highest level since 2004"\n📈https://t.co/RvxCPAFI2A https://t.co/U8MS9K45fX',
    created_at: "Fri Oct 13 17:41:36 +0000 2017",
    retweet_count: 11399,
    favorite_count: 48626,
    is_retweet: false,
    id_str: "918894502185787392"
  },
  {
    source: "Twitter for iPhone",
    text:
      "In America, we don't worship government - we worship God. \n#ValuesVotersSummit https://t.co/YQ3iDlWylK",
    created_at: "Fri Oct 13 17:07:15 +0000 2017",
    retweet_count: 21093,
    favorite_count: 79898,
    is_retweet: false,
    id_str: "918885859230875649"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I have no greater privilege than to serve as your Commander-in-Chief. HAPPY BIRTHDAY to the incredible men and women @USNavy!\n#242NavyBday https://t.co/qcdB4U8CqA",
    created_at: "Fri Oct 13 16:30:28 +0000 2017",
    retweet_count: 16656,
    favorite_count: 73091,
    is_retweet: false,
    id_str: "918876603148652544"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The wonderful people of Puerto Rico, with their unmatched spirit, know how bad things were before the H's. I will always be with them!",
    created_at: "Fri Oct 13 12:01:02 +0000 2017",
    retweet_count: 11935,
    favorite_count: 63341,
    is_retweet: false,
    id_str: "918808798059483136"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Hard to believe that the Democrats, who have gone so far LEFT that they are no longer recognizable, are fighting so hard for Sanctuary crime",
    created_at: "Fri Oct 13 11:51:30 +0000 2017",
    retweet_count: 22843,
    favorite_count: 93073,
    is_retweet: false,
    id_str: "918806396875010048"
  },
  {
    source: "Twitter for iPhone",
    text:
      "ObamaCare is a broken mess. Piece by piece we will now begin the process of giving America the great HealthCare it deserves!",
    created_at: "Fri Oct 13 11:14:12 +0000 2017",
    retweet_count: 15473,
    favorite_count: 76195,
    is_retweet: false,
    id_str: "918797009133465600"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Sadly, they and others are Fake News, and the public is just beginning to figure it out! https://t.co/8B8AyA7V1s",
    created_at: "Fri Oct 13 11:10:30 +0000 2017",
    retweet_count: 11874,
    favorite_count: 51749,
    is_retweet: false,
    id_str: "918796079243677696"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @billoreilly: A free press is vital to protecting all Americans. A corrupt press damages the Republic.",
    created_at: "Fri Oct 13 11:07:39 +0000 2017",
    retweet_count: 15575,
    favorite_count: 0,
    is_retweet: true,
    id_str: "918795362122465280"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats ObamaCare is imploding. Massive subsidy payments to their pet insurance companies has stopped. Dems should call me to fix!",
    created_at: "Fri Oct 13 09:36:54 +0000 2017",
    retweet_count: 14188,
    favorite_count: 64153,
    is_retweet: false,
    id_str: "918772522983874561"
  },
  {
    source: "Media Studio",
    text:
      "It is time to take care of OUR COUNTRY, to rebuild OUR COMMUNITIES, and to protect our GREAT AMERICAN WORKERS! #TaxReform https://t.co/FEjGjT4xp9",
    created_at: "Fri Oct 13 01:18:23 +0000 2017",
    retweet_count: 16486,
    favorite_count: 68717,
    is_retweet: false,
    id_str: "918647067224035334"
  },
  {
    source: "Twitter for iPhone",
    text:
      "People are just now starting to find out how dishonest and disgusting (FakeNews) @NBCNews is. Viewers beware. May be worse than even @CNN!",
    created_at: "Fri Oct 13 00:12:59 +0000 2017",
    retweet_count: 22406,
    favorite_count: 87755,
    is_retweet: false,
    id_str: "918630610167529472"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Happy #NationalFarmersDay!\n📸https://t.co/dN39R1IMlA https://t.co/QbUG1pztaI",
    created_at: "Thu Oct 12 20:19:32 +0000 2017",
    retweet_count: 10973,
    favorite_count: 50140,
    is_retweet: false,
    id_str: "918571860308254720"
  },
  {
    source: "Media Studio",
    text:
      "We need a tax system that is FAIR to working FAMILIES &amp; that encourages companies to STAY in AMERICA, GROW in AMERICA, and HIRE in AMERICA! https://t.co/DdI1yWi7YZ",
    created_at: "Thu Oct 12 18:17:40 +0000 2017",
    retweet_count: 15614,
    favorite_count: 68290,
    is_retweet: false,
    id_str: "918541193037967361"
  },
  {
    source: "Media Studio",
    text:
      "The time has come to take action to IMPROVE access, INCREASE choices, and LOWER COSTS for HEALTHCARE! \n➡️https://t.co/mz5fdveTVh https://t.co/dDZLsKuNSe",
    created_at: "Thu Oct 12 17:06:26 +0000 2017",
    retweet_count: 12853,
    favorite_count: 52049,
    is_retweet: false,
    id_str: "918523263554412544"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News Is going all out in order to demean and denigrate! Such hatred!",
    created_at: "Thu Oct 12 12:45:29 +0000 2017",
    retweet_count: 16941,
    favorite_count: 80727,
    is_retweet: false,
    id_str: "918457595618365441"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...We cannot keep FEMA, the Military &amp; the First Responders, who have been amazing (under the most difficult circumstances) in P.R. forever!",
    created_at: "Thu Oct 12 11:07:00 +0000 2017",
    retweet_count: 13433,
    favorite_count: 64982,
    is_retweet: false,
    id_str: "918432809282342912"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...accountability say the Governor. Electric and all infrastructure was disaster before hurricanes. Congress to decide how much to spend....",
    created_at: "Thu Oct 12 10:58:53 +0000 2017",
    retweet_count: 10164,
    favorite_count: 50926,
    is_retweet: false,
    id_str: "918430769776914432"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"Puerto Rico survived the Hurricanes, now a financial crisis looms largely of their own making." says Sharyl Attkisson. A total lack of.....',
    created_at: "Thu Oct 12 10:49:42 +0000 2017",
    retweet_count: 10197,
    favorite_count: 47405,
    is_retweet: false,
    id_str: "918428456869916672"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Clips from tax speech and @seanhannity on @foxandfriends now. Have a great day!",
    created_at: "Thu Oct 12 10:04:11 +0000 2017",
    retweet_count: 6731,
    favorite_count: 37718,
    is_retweet: false,
    id_str: "918417002733154305"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @realDonaldTrump: I will be interviewed tonight on @FoxNews by @SeanHannity at 9pmE. Enjoy!",
    created_at: "Thu Oct 12 00:55:52 +0000 2017",
    retweet_count: 10406,
    favorite_count: 0,
    is_retweet: true,
    id_str: "918279015928037377"
  },
  {
    source: "Media Studio",
    text:
      "In even the darkest moments, the light of our people has shown through their goodness, their courage and their love. #USA🇺🇸 https://t.co/8JK8aM2a1L",
    created_at: "Thu Oct 12 00:40:57 +0000 2017",
    retweet_count: 13520,
    favorite_count: 60730,
    is_retweet: false,
    id_str: "918275261011038210"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @realDonaldTrump: I will be interviewed tonight on @FoxNews by @SeanHannity at 9pmE. Enjoy!",
    created_at: "Thu Oct 12 00:17:37 +0000 2017",
    retweet_count: 7042,
    favorite_count: 0,
    is_retweet: true,
    id_str: "918269386997321730"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Network news has become so partisan, distorted and fake that licenses must be challenged and, if appropriate, revoked. Not fair to public!",
    created_at: "Thu Oct 12 00:09:42 +0000 2017",
    retweet_count: 20348,
    favorite_count: 87960,
    is_retweet: false,
    id_str: "918267396493922304"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Joining @SeanHannity tonight at 9pmE on @FoxNews. Enjoy! https://t.co/RCfiJus5Rw",
    created_at: "Wed Oct 11 23:56:08 +0000 2017",
    retweet_count: 5611,
    favorite_count: 31715,
    is_retweet: false,
    id_str: "918263984029085697"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We need a tax system that is FAIR to working families &amp; that encourages companies to STAY in America, GROW in America, and HIRE in America🇺🇸 https://t.co/u9ZgijgLE3",
    created_at: "Wed Oct 11 23:28:49 +0000 2017",
    retweet_count: 12276,
    favorite_count: 56587,
    is_retweet: false,
    id_str: "918257107182473216"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be interviewed tonight on @FoxNews by @SeanHannity at 9pmE. Enjoy!",
    created_at: "Wed Oct 11 21:32:07 +0000 2017",
    retweet_count: 10407,
    favorite_count: 57891,
    is_retweet: false,
    id_str: "918227740700102657"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me LIVE at 5:45pmE from Harrisburg, Pennsylvania! \n#TaxReform #USA🇺🇸\nhttps://t.co/fDUEMpRTcE https://t.co/1mMjl1HNpl",
    created_at: "Wed Oct 11 21:18:49 +0000 2017",
    retweet_count: 5082,
    favorite_count: 27928,
    is_retweet: false,
    id_str: "918224393062551552"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @realDonaldTrump: Happy to announce we are awarding $1M to Las Vegas - in order to help local law enforcement working OT to respond to l…",
    created_at: "Wed Oct 11 19:50:03 +0000 2017",
    retweet_count: 14904,
    favorite_count: 0,
    is_retweet: true,
    id_str: "918202052102279170"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Happy to announce we are awarding $1M to Las Vegas - in order to help local law enforcement working OT to respond to last Sunday’s tragedy.",
    created_at: "Wed Oct 11 19:49:21 +0000 2017",
    retweet_count: 19130,
    favorite_count: 114117,
    is_retweet: false,
    id_str: "918201878479073280"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With all of the Fake News coming out of NBC and the Networks, at what point is it appropriate to challenge their License? Bad for country!",
    created_at: "Wed Oct 11 13:55:44 +0000 2017",
    retweet_count: 23284,
    favorite_count: 99249,
    is_retweet: false,
    id_str: "918112884630093825"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Fake @NBCNews made up a story that I wanted a "tenfold" increase in our U.S. nuclear arsenal. Pure fiction, made up to demean. NBC = CNN!',
    created_at: "Wed Oct 11 13:45:22 +0000 2017",
    retweet_count: 18962,
    favorite_count: 73826,
    is_retweet: false,
    id_str: "918110279367643137"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It is about time that Roger Goodell of the NFL is finally demanding that all players STAND for our great National Anthem-RESPECT OUR COUNTRY",
    created_at: "Wed Oct 11 10:47:10 +0000 2017",
    retweet_count: 20408,
    favorite_count: 105174,
    is_retweet: false,
    id_str: "918065431939829760"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats want MASSIVE tax increases &amp; soft, crime producing borders.The Republicans want the biggest tax cut in history &amp; the WALL!",
    created_at: "Wed Oct 11 10:36:37 +0000 2017",
    retweet_count: 19401,
    favorite_count: 84312,
    is_retweet: false,
    id_str: "918062778522505216"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It would be really nice if the Fake News Media would report the virtually unprecedented Stock Market growth since the election.Need tax cuts",
    created_at: "Wed Oct 11 10:31:18 +0000 2017",
    retweet_count: 15430,
    favorite_count: 74375,
    is_retweet: false,
    id_str: "918061437750267904"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...if Congress gives us the massive tax cuts (and reform) I am asking for, those numbers will grow by leaps and bounds. #MAGA",
    created_at: "Wed Oct 11 10:26:50 +0000 2017",
    retweet_count: 11212,
    favorite_count: 54905,
    is_retweet: false,
    id_str: "918060313748164608"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Stock Market has increased by 5.2 Trillion dollars since the election on November 8th, a 25% increase. Lowest unemployment in 16 years and..",
    created_at: "Wed Oct 11 10:21:15 +0000 2017",
    retweet_count: 18196,
    favorite_count: 79314,
    is_retweet: false,
    id_str: "918058910673760258"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...fired. This story is totally made up by the dishonest media.The Chief is doing a FANTASTIC job for me and, more importantly, for the USA!",
    created_at: "Wed Oct 11 01:21:43 +0000 2017",
    retweet_count: 15932,
    favorite_count: 77256,
    is_retweet: false,
    id_str: "917923131003719681"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News is at it again, this time trying to hurt one of the finest people I know, General John Kelly, by saying he will soon be.....",
    created_at: "Wed Oct 11 01:15:26 +0000 2017",
    retweet_count: 16058,
    favorite_count: 69502,
    is_retweet: false,
    id_str: "917921548677328896"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My great honor to host the 2017 back-to-back #StanleyCup Champion Pittsburgh Penguins at the WH with @FLOTUS today!\nhttps://t.co/qyT4bcHVuR https://t.co/rBwGmhMnPX",
    created_at: "Tue Oct 10 23:29:47 +0000 2017",
    retweet_count: 14143,
    favorite_count: 66095,
    is_retweet: false,
    id_str: "917894963832246272"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @IsraelUSAforevr: @realDonaldTrump  https://t.co/dBvwKDdesD",
    created_at: "Tue Oct 10 13:34:58 +0000 2017",
    retweet_count: 7440,
    favorite_count: 0,
    is_retweet: true,
    id_str: "917745272448602115"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Failing @nytimes set Liddle' Bob Corker up by recording his conversation. Was made to sound a fool, and that's what I am dealing with!",
    created_at: "Tue Oct 10 12:50:55 +0000 2017",
    retweet_count: 14669,
    favorite_count: 62413,
    is_retweet: false,
    id_str: "917734186848579584"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Highly respected author, Christopher Bedford, just came out with book, "The Art of the Donald, Lessons from America\'s...." Really good book!',
    created_at: "Tue Oct 10 12:13:54 +0000 2017",
    retweet_count: 11411,
    favorite_count: 58333,
    is_retweet: false,
    id_str: "917724872905777155"
  },
  {
    source: "Twitter for iPhone",
    text:
      'With Jemele Hill at the mike, it is no wonder ESPN ratings have "tanked," in fact, tanked so badly it is the talk of the industry!',
    created_at: "Tue Oct 10 10:42:23 +0000 2017",
    retweet_count: 20210,
    favorite_count: 95652,
    is_retweet: false,
    id_str: "917701841466593280"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Since Congress can't get its act together on HealthCare, I will be using the power of the pen to give great HealthCare to many people - FAST",
    created_at: "Tue Oct 10 10:30:28 +0000 2017",
    retweet_count: 22622,
    favorite_count: 99677,
    is_retweet: false,
    id_str: "917698839846576130"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The problem with agreeing to a policy on immigration is that the Democrats don't want secure borders,they don't care about safety for U.S.A.",
    created_at: "Tue Oct 10 10:18:34 +0000 2017",
    retweet_count: 22242,
    favorite_count: 86752,
    is_retweet: false,
    id_str: "917695847063805952"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Why is the NFL getting massive tax breaks while at the same time disrespecting our Anthem, Flag and Country? Change tax law!",
    created_at: "Tue Oct 10 10:13:47 +0000 2017",
    retweet_count: 32459,
    favorite_count: 138388,
    is_retweet: false,
    id_str: "917694644481413120"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IvankaTrump: .@realDonaldTrump stock market rally is close to becoming the greatest in 85 years https://t.co/5WlZa82Mij",
    created_at: "Tue Oct 10 02:31:49 +0000 2017",
    retweet_count: 16640,
    favorite_count: 0,
    is_retweet: true,
    id_str: "917578384800124929"
  },
  {
    source: "Twitter for iPhone",
    text: "We have just begun! https://t.co/x8pSdEB2Ur",
    created_at: "Tue Oct 10 02:30:46 +0000 2017",
    retweet_count: 474,
    favorite_count: 1787,
    is_retweet: false,
    id_str: "917578120819068928"
  },
  {
    source: "Twitter for iPhone",
    text:
      'A big salute to Jerry Jones, owner of the Dallas Cowboys, who will BENCH players who disrespect our Flag."Stand for Anthem or sit for game!"',
    created_at: "Tue Oct 10 01:51:32 +0000 2017",
    retweet_count: 34557,
    favorite_count: 166116,
    is_retweet: false,
    id_str: "917568245854605313"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"President Donald J. Trump Proclaims October 9, 2017, as #ColumbusDay" https://t.co/cbQRst4lN4',
    created_at: "Mon Oct 09 18:35:04 +0000 2017",
    retweet_count: 16500,
    favorite_count: 69189,
    is_retweet: false,
    id_str: "917458408927842305"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The trip by @VP Pence was long planned. He is receiving great praise for leaving game after the players showed such disrespect for country!",
    created_at: "Mon Oct 09 11:05:13 +0000 2017",
    retweet_count: 20791,
    favorite_count: 109311,
    is_retweet: false,
    id_str: "917345200414035969"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Our country has been unsuccessfully dealing with North Korea for 25 years, giving billions of dollars &amp; getting nothing. Policy didn't work!",
    created_at: "Mon Oct 09 10:50:34 +0000 2017",
    retweet_count: 21479,
    favorite_count: 107533,
    is_retweet: false,
    id_str: "917341511754436609"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"The Republican Party is racking up record amounts of small dollar donations - fueled by Trump supporters....."   @nypost  Thank you!',
    created_at: "Sun Oct 08 23:58:43 +0000 2017",
    retweet_count: 14656,
    favorite_count: 75617,
    is_retweet: false,
    id_str: "917177470532636672"
  },
  {
    source: "Media Studio",
    text:
      "Nobody could have done what I’ve done for #PuertoRico with so little appreciation. So much work! https://t.co/k2jAkIpfjI",
    created_at: "Sun Oct 08 23:37:34 +0000 2017",
    retweet_count: 19880,
    favorite_count: 78014,
    is_retweet: false,
    id_str: "917172144710103040"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Bob Corker gave us the Iran Deal, &amp; that's about it. We need HealthCare, we need Tax Cuts/Reform, we need people that can get the job done!",
    created_at: "Sun Oct 08 20:51:57 +0000 2017",
    retweet_count: 18418,
    favorite_count: 80627,
    is_retweet: false,
    id_str: "917130468025348096"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @opinionsamerica: @realDonaldTrump Strong administration leads to a strong response.",
    created_at: "Sun Oct 08 19:51:06 +0000 2017",
    retweet_count: 4454,
    favorite_count: 0,
    is_retweet: true,
    id_str: "917115154504077313"
  },
  {
    source: "Twitter for iPhone",
    text:
      "FEMA and first responders are working hard (yet again) on Hurricane Nate. Military helping. Very much under control!",
    created_at: "Sun Oct 08 19:49:32 +0000 2017",
    retweet_count: 11653,
    favorite_count: 66259,
    is_retweet: false,
    id_str: "917114761057357824"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I asked @VP Pence to leave stadium if any players kneeled, disrespecting our country. I am proud of him and @SecondLady Karen.",
    created_at: "Sun Oct 08 18:16:16 +0000 2017",
    retweet_count: 28144,
    favorite_count: 135146,
    is_retweet: false,
    id_str: "917091286607433728"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...Hence, I would fully expect Corker to be a negative voice and stand in the way of our great agenda. Didn't have the guts to run!",
    created_at: "Sun Oct 08 14:13:19 +0000 2017",
    retweet_count: 13716,
    favorite_count: 66385,
    is_retweet: false,
    id_str: "917030148867682304"
  },
  {
    source: "Twitter for iPhone",
    text:
      '..my endorsement). He also wanted to be Secretary of State, I said "NO THANKS." He is also largely responsible for the horrendous Iran Deal!',
    created_at: "Sun Oct 08 14:09:00 +0000 2017",
    retweet_count: 12830,
    favorite_count: 60890,
    is_retweet: false,
    id_str: "917029060471152640"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Senator Bob Corker "begged" me to endorse him for re-election in Tennessee. I said "NO" and he dropped out (said he could not win without...',
    created_at: "Sun Oct 08 13:59:58 +0000 2017",
    retweet_count: 15186,
    favorite_count: 69266,
    is_retweet: false,
    id_str: "917026789188399105"
  },
  {
    source: "Twitter for iPhone",
    text: "#LasVegasStrong #USA🇺🇸\n🎥https://t.co/4iGwdL4kia",
    created_at: "Sun Oct 08 13:49:11 +0000 2017",
    retweet_count: 6541,
    favorite_count: 36467,
    is_retweet: false,
    id_str: "917024076165734401"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @realDonaldTrump: More and more people are suggesting that Republicans (and me) should be given Equal Time on T.V. when you look at the…",
    created_at: "Sun Oct 08 12:41:44 +0000 2017",
    retweet_count: 18242,
    favorite_count: 0,
    is_retweet: true,
    id_str: "917007101519650817"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Leaving the White House for the Great State of North Carolina. Big progress being made on many fronts!",
    created_at: "Sat Oct 07 21:41:01 +0000 2017",
    retweet_count: 12180,
    favorite_count: 75987,
    is_retweet: false,
    id_str: "916780428253687808"
  },
  {
    source: "Twitter for iPhone",
    text: "Thanks for your support! https://t.co/iqUM1RfQso",
    created_at: "Sat Oct 07 20:33:31 +0000 2017",
    retweet_count: 12503,
    favorite_count: 60168,
    is_retweet: false,
    id_str: "916763438805848066"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...hasn't worked, agreements violated before the ink was dry, makings fools of U.S. negotiators. Sorry, but only one thing will work!",
    created_at: "Sat Oct 07 19:45:10 +0000 2017",
    retweet_count: 17797,
    favorite_count: 75919,
    is_retweet: false,
    id_str: "916751271960436737"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Presidents and their administrations have been talking to North Korea for 25 years, agreements made and massive amounts of money paid......",
    created_at: "Sat Oct 07 19:40:17 +0000 2017",
    retweet_count: 17900,
    favorite_count: 72835,
    is_retweet: false,
    id_str: "916750042014404608"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Will be joining @GovMikeHuckabee tonight at 8pmE on @TBN. Enjoy! https://t.co/Y5hGPpYZfl",
    created_at: "Sat Oct 07 19:31:42 +0000 2017",
    retweet_count: 7596,
    favorite_count: 35789,
    is_retweet: false,
    id_str: "916747884716011521"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Our great team at @FEMA is prepared for #HurricaneNate. Everyone in LA, MS, AL, and FL please listen to your local authorities &amp; be safe!",
    created_at: "Sat Oct 07 14:04:39 +0000 2017",
    retweet_count: 14110,
    favorite_count: 66371,
    is_retweet: false,
    id_str: "916665576940097536"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@NBCNews is so knowingly inaccurate with their reporting. The good news is that the PEOPLE get it, which is really all that matters! Not #1",
    created_at: "Sat Oct 07 13:24:48 +0000 2017",
    retweet_count: 15842,
    favorite_count: 73624,
    is_retweet: false,
    id_str: "916655548623413248"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I called Chuck Schumer yesterday to see if the Dems want to do a great HealthCare Bill. ObamaCare is badly broken, big premiums. Who knows!",
    created_at: "Sat Oct 07 12:17:47 +0000 2017",
    retweet_count: 12847,
    favorite_count: 69224,
    is_retweet: false,
    id_str: "916638685914951680"
  },
  {
    source: "Twitter for iPhone",
    text:
      "More and more people are suggesting that Republicans (and me) should be given Equal Time on T.V. when you look at the one-sided coverage?",
    created_at: "Sat Oct 07 12:04:05 +0000 2017",
    retweet_count: 18243,
    favorite_count: 93933,
    is_retweet: false,
    id_str: "916635236238274561"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Late Night host are dealing with the Democrats for their very "unfunny" &amp; repetitive material, always anti-Trump! Should we get Equal Time?',
    created_at: "Sat Oct 07 12:00:18 +0000 2017",
    retweet_count: 14619,
    favorite_count: 75482,
    is_retweet: false,
    id_str: "916634286811435008"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...contributions. The RNC is taking in far more $'s than the Dems, and much of it by my wonderful small donors. I am working hard for them!",
    created_at: "Sat Oct 07 11:11:50 +0000 2017",
    retweet_count: 12411,
    favorite_count: 66977,
    is_retweet: false,
    id_str: "916622087606980609"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Can\'t believe I finally got a good story in the @washingtonpost. It discusses the enthusiasm of "Trump" voters through campaign....',
    created_at: "Sat Oct 07 11:05:56 +0000 2017",
    retweet_count: 13579,
    favorite_count: 67198,
    is_retweet: false,
    id_str: "916620603741868032"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FoxBusiness: #StockAlert: U.S. markets since the election https://t.co/1kwamJuizO",
    created_at: "Fri Oct 06 02:16:32 +0000 2017",
    retweet_count: 12211,
    favorite_count: 0,
    is_retweet: true,
    id_str: "916124989736308736"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: .@POTUS @realDonaldTrump in the Oval Office w/senior U.S. military leaders prior to dinner hosted by the President &amp; First L…",
    created_at: "Fri Oct 06 02:15:36 +0000 2017",
    retweet_count: 8629,
    favorite_count: 0,
    is_retweet: true,
    id_str: "916124754620420097"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Ralph Northam,who is running for Governor of Virginia,is fighting for the violent MS-13 killer gangs &amp; sanctuary cities.  Vote Ed Gillespie!",
    created_at: "Fri Oct 06 01:58:27 +0000 2017",
    retweet_count: 25717,
    favorite_count: 92535,
    is_retweet: false,
    id_str: "916120435762266114"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Rex Tillerson never threatened to resign. This is Fake News put out by @NBCNews. Low news and reporting standards. No verification from me.",
    created_at: "Thu Oct 05 11:50:56 +0000 2017",
    retweet_count: 18744,
    favorite_count: 79704,
    is_retweet: false,
    id_str: "915907150333009920"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Stock Market hits an ALL-TIME high! Unemployment lowest in 16 years! Business and manufacturing enthusiasm at highest level in decades!",
    created_at: "Thu Oct 05 11:09:50 +0000 2017",
    retweet_count: 36546,
    favorite_count: 157404,
    is_retweet: false,
    id_str: "915896809536589824"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Why Isn't the Senate Intel Committee looking into the Fake News Networks in OUR country to see why so much of our news is just made up-FAKE!",
    created_at: "Thu Oct 05 10:59:40 +0000 2017",
    retweet_count: 23334,
    favorite_count: 93316,
    is_retweet: false,
    id_str: "915894251967385600"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you! https://t.co/YMuqSvvTSB",
    created_at: "Thu Oct 05 10:46:02 +0000 2017",
    retweet_count: 10819,
    favorite_count: 59426,
    is_retweet: false,
    id_str: "915890821228048385"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So wonderful to be in Las Vegas yesterday and meet with people, from police to doctors to the victims themselves, who I will never forget!",
    created_at: "Thu Oct 05 10:44:19 +0000 2017",
    retweet_count: 15342,
    favorite_count: 100016,
    is_retweet: false,
    id_str: "915890389269254145"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @ABC: Pres. Trump: "We cannot be defined by the evil that threatens us or the violence that incites such terror." https://t.co/eduBJDysI…',
    created_at: "Thu Oct 05 10:34:12 +0000 2017",
    retweet_count: 6346,
    favorite_count: 0,
    is_retweet: true,
    id_str: "915887841896484866"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: .@POTUS &amp; @FLOTUS w/ @LVMPD Officer Cook, 2nd day on job, received gunshot wound to the right chest &amp; right arm, saving live…",
    created_at: "Thu Oct 05 10:31:39 +0000 2017",
    retweet_count: 10040,
    favorite_count: 0,
    is_retweet: true,
    id_str: "915887200767758337"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: .@POTUS @realDonaldTrump and @FLOTUS Melania visit with @UMCSN patient Tiffany Huizarin Las Vegas earlier today. #VegasStron…",
    created_at: "Thu Oct 05 10:31:24 +0000 2017",
    retweet_count: 8296,
    favorite_count: 0,
    is_retweet: true,
    id_str: "915887139048574976"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FoxNews: Geraldo Blasts 'Fake News' Reports About Trump's Visit to Puerto Rico https://t.co/9jO0D3BMvE",
    created_at: "Thu Oct 05 10:30:40 +0000 2017",
    retweet_count: 11288,
    favorite_count: 0,
    is_retweet: true,
    id_str: "915886953194770433"
  },
  {
    source: "Twitter for iPhone",
    text:
      "On behalf of a GRATEFUL NATION, THANK YOU to all of the First Responders (HEROES) who saved countless lives in Las Vegas on Sunday night. https://t.co/ZxuMYWnNHv",
    created_at: "Thu Oct 05 01:08:28 +0000 2017",
    retweet_count: 23561,
    favorite_count: 111141,
    is_retweet: false,
    id_str: "915745470689005573"
  },
  {
    source: "Twitter for iPhone",
    text: "WE LOVE YOU LAS VEGAS! https://t.co/nxRWeR1gEz",
    created_at: "Wed Oct 04 23:36:37 +0000 2017",
    retweet_count: 23468,
    favorite_count: 96428,
    is_retweet: false,
    id_str: "915722355757985792"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be landing in Las Vegas shortly to pay my respects with @FLOTUS Melania. Everyone remains in our thoughts and prayers.",
    created_at: "Wed Oct 04 15:49:17 +0000 2017",
    retweet_count: 13699,
    favorite_count: 91338,
    is_retweet: false,
    id_str: "915604746936967168"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The @NBCNews story has just been totally refuted by Sec. Tillerson and @VP Pence. It is #FakeNews. They should issue an apology to AMERICA!",
    created_at: "Wed Oct 04 15:18:28 +0000 2017",
    retweet_count: 18225,
    favorite_count: 69909,
    is_retweet: false,
    id_str: "915596990674849792"
  },
  {
    source: "Twitter for iPhone",
    text:
      "NBC news is #FakeNews and more dishonest than even CNN. They are a disgrace to good reporting. No wonder their news ratings are way down!",
    created_at: "Wed Oct 04 14:47:53 +0000 2017",
    retweet_count: 21975,
    favorite_count: 95643,
    is_retweet: false,
    id_str: "915589297096536065"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Wow, so many Fake News stories today. No matter what I do or say, they will not write or speak truth. The Fake News Media is out of control!",
    created_at: "Wed Oct 04 11:29:43 +0000 2017",
    retweet_count: 38432,
    favorite_count: 157255,
    is_retweet: false,
    id_str: "915539424406114304"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A great day in Puerto Rico yesterday. While some of the news coverage is Fake, most showed great warmth and friendship.",
    created_at: "Wed Oct 04 10:25:58 +0000 2017",
    retweet_count: 14940,
    favorite_count: 88295,
    is_retweet: false,
    id_str: "915523382686478337"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My Administration will continue to work around the clock with Governor @RicardoRossello &amp; his team. Great progress being made! #PRStrong🇵🇷 https://t.co/1aL9YrwTvC",
    created_at: "Wed Oct 04 00:53:10 +0000 2017",
    retweet_count: 14309,
    favorite_count: 66953,
    is_retweet: false,
    id_str: "915379231454003200"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @PressSec: .@POTUS and @FLOTUS meet w/ some of America's finest on the USS Kearsarge off the coast of PR. https://t.co/sR3Jd6rvNK",
    created_at: "Wed Oct 04 00:28:24 +0000 2017",
    retweet_count: 8574,
    favorite_count: 0,
    is_retweet: true,
    id_str: "915372999385198592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @seanhannity: Tonight the truth about how despicable the media and the left are in America today. We will name names. 9 est Hannity Fox…",
    created_at: "Wed Oct 04 00:27:11 +0000 2017",
    retweet_count: 11139,
    favorite_count: 0,
    is_retweet: true,
    id_str: "915372694060830721"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IvankaTrump: 3/4: This Administration is deeply committed to those who serve &amp; their families who make it possible through their love a…",
    created_at: "Wed Oct 04 00:26:36 +0000 2017",
    retweet_count: 8271,
    favorite_count: 0,
    is_retweet: true,
    id_str: "915372545704173570"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @billoreilly: FNC dominated ratings last night. MSNBC-disaster demonstrating folks don't trust the network. https://t.co/rryWmyXe7C toni…",
    created_at: "Wed Oct 04 00:25:34 +0000 2017",
    retweet_count: 8211,
    favorite_count: 0,
    is_retweet: true,
    id_str: "915372286575816705"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Jenniffer2012: Thank you @realDonaldTrump for all the help you are providing for Puerto Rico. We’re are grateful and happy to welcome y…",
    created_at: "Wed Oct 04 00:24:02 +0000 2017",
    retweet_count: 14844,
    favorite_count: 0,
    is_retweet: true,
    id_str: "915371898774618112"
  },
  {
    source: "Twitter for iPhone",
    text:
      'It is a "miracle" how fast the Las Vegas Metropolitan Police were able to find the demented shooter and stop him from even more killing!',
    created_at: "Wed Oct 04 00:20:48 +0000 2017",
    retweet_count: 16656,
    favorite_count: 104356,
    is_retweet: false,
    id_str: "915371086249971712"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So proud of @FEMA, Military, and First Responders! Thank you! https://t.co/kWVMqVelri",
    created_at: "Tue Oct 03 23:02:51 +0000 2017",
    retweet_count: 12299,
    favorite_count: 59757,
    is_retweet: false,
    id_str: "915351470354108417"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great meeting with Governor Mapp of the #USVI. He is very thankful for the great job done by @FEMA and First Responders. https://t.co/AtBGEpDF9C",
    created_at: "Tue Oct 03 21:59:58 +0000 2017",
    retweet_count: 7410,
    favorite_count: 38977,
    is_retweet: false,
    id_str: "915335645719121920"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Leaving Puerto Rico now for D.C. Will be in Las Vegas early tomorrow to pay my respects. Everyone is in my thoughts and prayers. https://t.co/dBvZUIUfr0",
    created_at: "Tue Oct 03 21:22:19 +0000 2017",
    retweet_count: 13863,
    favorite_count: 74460,
    is_retweet: false,
    id_str: "915326171063242752"
  },
  {
    source: "Twitter for iPhone",
    text: "I am so proud of our great Country. God bless America!",
    created_at: "Tue Oct 03 11:40:47 +0000 2017",
    retweet_count: 43026,
    favorite_count: 212403,
    is_retweet: false,
    id_str: "915179824012042241"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My warmest condolences and sympathies to the victims and families of the terrible Las Vegas shooting. God bless you!",
    created_at: "Mon Oct 02 11:11:37 +0000 2017",
    retweet_count: 75476,
    favorite_count: 317744,
    is_retweet: false,
    id_str: "914810093874671617"
  },
  {
    source: "Media Studio",
    text:
      "Congratulations to #TeamUSA🇺🇸🏆on your great @PresidentsCup victory! https://t.co/fZeP1e9mo7",
    created_at: "Mon Oct 02 01:22:34 +0000 2017",
    retweet_count: 12152,
    favorite_count: 69743,
    is_retweet: false,
    id_str: "914661855947366406"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Being nice to Rocket Man hasn't worked in 25 years, why would it work now? Clinton failed, Bush failed, and Obama failed. I won't fail.",
    created_at: "Sun Oct 01 19:01:19 +0000 2017",
    retweet_count: 47699,
    favorite_count: 188927,
    is_retweet: false,
    id_str: "914565910798782465"
  },
  {
    source: "Twitter for iPhone",
    text: "...Save your energy Rex, we'll do what has to be done!",
    created_at: "Sun Oct 01 14:31:15 +0000 2017",
    retweet_count: 14060,
    favorite_count: 62997,
    is_retweet: false,
    id_str: "914497947517227008"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I told Rex Tillerson, our wonderful Secretary of State, that he is wasting his time trying to negotiate with Little Rocket Man...",
    created_at: "Sun Oct 01 14:30:59 +0000 2017",
    retweet_count: 25389,
    favorite_count: 102671,
    is_retweet: false,
    id_str: "914497877543735296"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...for safety. Thank you to the Governor of P.R. and to all of those who are working so closely with our First Responders. Fantastic job!",
    created_at: "Sun Oct 01 12:30:17 +0000 2017",
    retweet_count: 14147,
    favorite_count: 75918,
    is_retweet: false,
    id_str: "914467502251528192"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...people are now starting to recognize the amazing work that has been done by FEMA and our great Military. All buildings now inspected.....",
    created_at: "Sun Oct 01 12:26:26 +0000 2017",
    retweet_count: 16034,
    favorite_count: 80679,
    is_retweet: false,
    id_str: "914466534365569025"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We have done a great job with the almost impossible situation in Puerto Rico. Outside of the Fake News or politically motivated ingrates,...",
    created_at: "Sun Oct 01 12:22:14 +0000 2017",
    retweet_count: 18286,
    favorite_count: 82164,
    is_retweet: false,
    id_str: "914465475777695744"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @SLandinSoCal: When you kneel for our #NationalAnthem, you aren't protesting a specific issue, you are protesting our Nation and EVERYTH…",
    created_at: "Sun Oct 01 12:05:25 +0000 2017",
    retweet_count: 15059,
    favorite_count: 0,
    is_retweet: true,
    id_str: "914461244702232577"
  },
  {
    source: "Twitter for iPhone",
    text:
      "19,000 RESPECTING our National Anthem! #StandForOurAnthem🇺🇸 https://t.co/czutyGaMQV",
    created_at: "Sun Oct 01 02:08:00 +0000 2017",
    retweet_count: 31649,
    favorite_count: 116648,
    is_retweet: false,
    id_str: "914310901855129601"
  },
  {
    source: "Twitter for iPhone",
    text:
      "In analyzing the Alabama Primary race,FAKE NEWS always fails to mention that the candidate I endorsed went up MANY points after endorsement!",
    created_at: "Sat Sep 30 23:24:18 +0000 2017",
    retweet_count: 7429,
    favorite_count: 47224,
    is_retweet: false,
    id_str: "914269704440737792"
  },
  {
    source: "Twitter for iPhone",
    text:
      "In analyzing the Alabama Primary race, Fake News always fails to mention that the candidate I endorsed went up MANY points after Election!",
    created_at: "Sat Sep 30 23:16:31 +0000 2017",
    retweet_count: 294,
    favorite_count: 1416,
    is_retweet: false,
    id_str: "914267744345972737"
  },
  {
    source: "Media Studio",
    text:
      "Because of #FakeNews my people are not getting the credit they deserve for doing a great job. As seen here, they are ALL doing a GREAT JOB! https://t.co/1ltW2t3rwy",
    created_at: "Sat Sep 30 22:46:47 +0000 2017",
    retweet_count: 32238,
    favorite_count: 93788,
    is_retweet: false,
    id_str: "914260261304860672"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Very important that NFL players STAND tomorrow, and always, for the playing of our National Anthem. Respect our Flag and our Country!",
    created_at: "Sat Sep 30 22:26:55 +0000 2017",
    retweet_count: 27402,
    favorite_count: 125091,
    is_retweet: false,
    id_str: "914255264282480640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be in PR on Tues. to further ensure we continue doing everything possible to assist &amp; support the people in their time of great need.",
    created_at: "Sat Sep 30 22:15:02 +0000 2017",
    retweet_count: 13087,
    favorite_count: 67123,
    is_retweet: false,
    id_str: "914252271982178306"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Results of recovery efforts will speak much louder than complaints by San Juan Mayor. Doing everything we can to help great people of PR!",
    created_at: "Sat Sep 30 20:37:10 +0000 2017",
    retweet_count: 17620,
    favorite_count: 77379,
    is_retweet: false,
    id_str: "914227642131509248"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We must all be united in offering assistance to everyone suffering in Puerto Rico and elsewhere in the wake of this terrible disaster.",
    created_at: "Sat Sep 30 19:57:29 +0000 2017",
    retweet_count: 13973,
    favorite_count: 67747,
    is_retweet: false,
    id_str: "914217658517737472"
  },
  {
    source: "Twitter for iPhone",
    text:
      "@ricardorossello ......#FakeNews critics are working overtime, but we're getting great marks from the people that truly matter! \n#PRStrong🇵🇷",
    created_at: "Sat Sep 30 19:56:46 +0000 2017",
    retweet_count: 7866,
    favorite_count: 35979,
    is_retweet: false,
    id_str: "914217477495717889"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My Administration, Governor @RicardoRossello, and many others are working together to help the people of Puerto Rico in every way...",
    created_at: "Sat Sep 30 19:55:20 +0000 2017",
    retweet_count: 9869,
    favorite_count: 46227,
    is_retweet: false,
    id_str: "914217117695795201"
  },
  {
    source: "Twitter for iPhone",
    text:
      "To the people of Puerto Rico:\nDo not believe the #FakeNews!\n#PRStrong🇵🇷",
    created_at: "Sat Sep 30 19:53:51 +0000 2017",
    retweet_count: 16123,
    favorite_count: 63669,
    is_retweet: false,
    id_str: "914216744385904640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congresswoman Jennifer Gonzalez-Colon of Puerto Rico has been wonderful to deal with and a great representative of the people. Thank you!",
    created_at: "Sat Sep 30 19:43:54 +0000 2017",
    retweet_count: 12925,
    favorite_count: 62407,
    is_retweet: false,
    id_str: "914214237584674816"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just spoke to Governor Kenneth Mapp of the U.S. Virgin Islands who stated that #FEMA and Military are doing a GREAT job! Thank you Governor!",
    created_at: "Sat Sep 30 19:30:17 +0000 2017",
    retweet_count: 13452,
    favorite_count: 60671,
    is_retweet: false,
    id_str: "914210813237489666"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Governor of Puerto Rico, Ricardo Rossello, is a great guy and leader who is really working hard. Thank you Ricky!",
    created_at: "Sat Sep 30 19:19:36 +0000 2017",
    retweet_count: 14076,
    favorite_count: 66511,
    is_retweet: false,
    id_str: "914208123564494850"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Despite the Fake News Media in conjunction with the Dems, an amazing job is being done in Puerto Rico. Great people!",
    created_at: "Sat Sep 30 18:04:59 +0000 2017",
    retweet_count: 16977,
    favorite_count: 77186,
    is_retweet: false,
    id_str: "914189344533024768"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News Networks are working overtime in Puerto Rico doing their best to take the spirit away from our soldiers and first R's. Shame!",
    created_at: "Sat Sep 30 12:07:09 +0000 2017",
    retweet_count: 24741,
    favorite_count: 91657,
    is_retweet: false,
    id_str: "914099295963553792"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be going to Puerto Rico on Tuesday with Melania. Will hopefully be able to stop at the U.S. Virgin Islands (people working hard).",
    created_at: "Sat Sep 30 11:55:46 +0000 2017",
    retweet_count: 13869,
    favorite_count: 69263,
    is_retweet: false,
    id_str: "914096428879933440"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Fake News CNN and NBC are going out of their way to disparage our great First Responders as a way to "get Trump." Not fair to FR or effort!',
    created_at: "Sat Sep 30 11:48:36 +0000 2017",
    retweet_count: 20977,
    favorite_count: 80761,
    is_retweet: false,
    id_str: "914094625488502784"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FLOTUS: Thank you to all who participated in today's discussion on opioid abuse. By talking about it, we can start to make a real diffe…",
    created_at: "Sat Sep 30 11:41:09 +0000 2017",
    retweet_count: 10790,
    favorite_count: 0,
    is_retweet: true,
    id_str: "914092750924128262"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DeptofDefense: VIDEO: Elements of the #DoD and @FEMA are providing humanitarian relief for #PuertoRico 🇵🇷  and #USVI 🇻🇮 . https://t.co/…",
    created_at: "Sat Sep 30 11:40:42 +0000 2017",
    retweet_count: 7089,
    favorite_count: 0,
    is_retweet: true,
    id_str: "914092638403485696"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @usairforce: ⚡️ “#AirForce relief efforts in #PuertoRico &amp; #VirginIslands”\n\nhttps://t.co/gonmsZusSe",
    created_at: "Sat Sep 30 11:39:45 +0000 2017",
    retweet_count: 7415,
    favorite_count: 0,
    is_retweet: true,
    id_str: "914092399378526209"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @USCGSoutheast: .@USCG crews worked together with the @RedCross, @fema, and members of local #police, #fire and #government to distribut…",
    created_at: "Sat Sep 30 11:35:00 +0000 2017",
    retweet_count: 8730,
    favorite_count: 0,
    is_retweet: true,
    id_str: "914091203855048704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The military and first responders, despite no electric, roads, phones etc., have done an amazing job. Puerto Rico was totally destroyed.",
    created_at: "Sat Sep 30 11:33:59 +0000 2017",
    retweet_count: 13718,
    favorite_count: 62276,
    is_retweet: false,
    id_str: "914090947180470272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...want everything to be done for them when it should be a community effort. 10,000 Federal workers now on Island doing a fantastic job.",
    created_at: "Sat Sep 30 11:29:47 +0000 2017",
    retweet_count: 15666,
    favorite_count: 69049,
    is_retweet: false,
    id_str: "914089888596754434"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...Such poor leadership ability by the Mayor of San Juan, and others in Puerto Rico, who are not able to get their workers to help. They....",
    created_at: "Sat Sep 30 11:26:16 +0000 2017",
    retweet_count: 15524,
    favorite_count: 56498,
    is_retweet: false,
    id_str: "914089003745468417"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Mayor of San Juan, who was very complimentary only a few days ago, has now been told by the Democrats that you must be nasty to Trump.",
    created_at: "Sat Sep 30 11:19:14 +0000 2017",
    retweet_count: 21912,
    favorite_count: 70350,
    is_retweet: false,
    id_str: "914087234869047296"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: #USNSComfort en route to #PuertoRico, from Norfolk, Virginia to support Hurricane Maria relief efforts. 🇺🇸🇵🇷 https://t.co/HW…",
    created_at: "Sat Sep 30 01:33:27 +0000 2017",
    retweet_count: 7590,
    favorite_count: 0,
    is_retweet: true,
    id_str: "913939816236093440"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: Under POTUS' @realDonaldTrump \n☑️S&amp;P 500 38th📈Record High \n☑️NASDAQ 44th📈Record High\n☑️#MakeAmericaGreatAgain🇺🇸 https://t.co…",
    created_at: "Sat Sep 30 01:32:52 +0000 2017",
    retweet_count: 8009,
    favorite_count: 0,
    is_retweet: true,
    id_str: "913939669800202240"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @Scavino45: "Manufacturer Optimism Hits Record High After #TaxReform Plan Revealed" https://t.co/RbVmEe4sqq',
    created_at: "Sat Sep 30 01:30:27 +0000 2017",
    retweet_count: 4937,
    favorite_count: 0,
    is_retweet: true,
    id_str: "913939062276358149"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: POTUS' @realDonaldTrump on Hurricane Response Efforts in #PuertoRico on Instagram, part of 9/29/17 Weekly Address.\n🎥https://…",
    created_at: "Sat Sep 30 01:30:08 +0000 2017",
    retweet_count: 5567,
    favorite_count: 0,
    is_retweet: true,
    id_str: "913938985449328641"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @EricTrump: Congratulations @SeanHannity! Looking forward to being on the show tonight at 9pmET  Hannity beats Maddow - POLITICO https:/…",
    created_at: "Sat Sep 30 01:29:20 +0000 2017",
    retweet_count: 5973,
    favorite_count: 0,
    is_retweet: true,
    id_str: "913938781434204160"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FoxNews: TUNE IN: @EricTrump joins @seanhannity TONIGHT at 9p ET on @FoxNews Channel! #Hannityat9 https://t.co/foDzkcAKJe",
    created_at: "Sat Sep 30 01:28:35 +0000 2017",
    retweet_count: 2923,
    favorite_count: 0,
    is_retweet: true,
    id_str: "913938593370042368"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @LouDobbs: #AmericaFirst- @KellyannePolls: The Middle Class &amp; businesses will benefit from @POTUS' historic tax revolution. #Dobbs #MAGA…",
    created_at: "Sat Sep 30 01:24:10 +0000 2017",
    retweet_count: 5483,
    favorite_count: 0,
    is_retweet: true,
    id_str: "913937483515269120"
  },
  {
    source: "Twitter for iPhone",
    text:
      "@IMPDnews @POTUS THANK YOU to the amazing Indianapolis Metropolitan Police Department and all law enforcement officers, for all you do 24/7/365! #LESM https://t.co/XFqxbMBEbP",
    created_at: "Fri Sep 29 23:03:31 +0000 2017",
    retweet_count: 1506,
    favorite_count: 4444,
    is_retweet: false,
    id_str: "913902084461916161"
  },
  {
    source: "Media Studio",
    text:
      "Join me for my #WeeklyAddress🇺🇸\nhttps://t.co/QeeKnFuHue https://t.co/NnM2jOkEs0",
    created_at: "Fri Sep 29 22:23:31 +0000 2017",
    retweet_count: 6389,
    favorite_count: 28930,
    is_retweet: false,
    id_str: "913892019847778305"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My thoughts are with all those observing Yom Kippur, the holiest day of the Jewish year. https://t.co/0LuZCZl29D",
    created_at: "Fri Sep 29 22:10:07 +0000 2017",
    retweet_count: 12070,
    favorite_count: 53079,
    is_retweet: false,
    id_str: "913888647631577088"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you @ShopFloorNAM. An honor to be with you today. Great news! Manufacturers report record-high economic optimism in 2017. #TaxReform https://t.co/4sgMWGotOF",
    created_at: "Fri Sep 29 20:02:02 +0000 2017",
    retweet_count: 6440,
    favorite_count: 31181,
    is_retweet: false,
    id_str: "913856413541138432"
  },
  {
    source: "Media Studio",
    text:
      "This week we came one step closer to reaching the goal of aligning the skills taught in our nation’s classrooms with the jobs of the future. https://t.co/9s1ggeIJJ5",
    created_at: "Fri Sep 29 17:45:07 +0000 2017",
    retweet_count: 10290,
    favorite_count: 49919,
    is_retweet: false,
    id_str: "913821956625059840"
  },
  {
    source: "Twitter for iPhone",
    text: "RECORD HIGH FOR S &amp; P 500!",
    created_at: "Fri Sep 29 13:39:53 +0000 2017",
    retweet_count: 11365,
    favorite_count: 59678,
    is_retweet: false,
    id_str: "913760243770896389"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to FEMA, our great Military &amp; all First Responders who are working so hard,against terrible odds,in Puerto Rico. See you Tuesday!",
    created_at: "Fri Sep 29 13:30:27 +0000 2017",
    retweet_count: 14145,
    favorite_count: 72443,
    is_retweet: false,
    id_str: "913757869627133953"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...The fact is that Puerto Rico has been destroyed by two hurricanes. Big decisions will have to be made as to the cost of its rebuilding!",
    created_at: "Fri Sep 29 11:18:55 +0000 2017",
    retweet_count: 11359,
    favorite_count: 57484,
    is_retweet: false,
    id_str: "913724766208610304"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Puerto Rico Governor Ricardo Rossello just stated: \"The Administration and the President, every time we've spoken, they've delivered......",
    created_at: "Fri Sep 29 11:14:57 +0000 2017",
    retweet_count: 15833,
    favorite_count: 67110,
    is_retweet: false,
    id_str: "913723771336392704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "GDP was revised upward to 3.1 for last quarter. Many people thought it would be years before that happened. We have just begun!",
    created_at: "Fri Sep 29 02:22:36 +0000 2017",
    retweet_count: 22186,
    favorite_count: 91566,
    is_retweet: false,
    id_str: "913589799411490817"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @GOPChairwoman: The Trump Inaugural Committee is donating $3 million in surplus funds to victims of the latest hurricanes. \nhttps://t.co…",
    created_at: "Fri Sep 29 01:07:04 +0000 2017",
    retweet_count: 14428,
    favorite_count: 0,
    is_retweet: true,
    id_str: "913570791698173952"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Puerto Rico is devastated. Phone system, electric grid many roads, gone. FEMA and First Responders are amazing. Governor said "great job!"',
    created_at: "Fri Sep 29 00:03:09 +0000 2017",
    retweet_count: 13598,
    favorite_count: 65140,
    is_retweet: false,
    id_str: "913554705816711168"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @billoreilly: Hannity crushing MSNBC at 9. Good for him! Check the No Spin News on https://t.co/rryWmyXe7C. Killing England a huge bests…",
    created_at: "Thu Sep 28 23:49:35 +0000 2017",
    retweet_count: 9914,
    favorite_count: 0,
    is_retweet: true,
    id_str: "913551290717831170"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IvankaTrump: Thank you to the amazing men and women working tirelessly to bring relief to those in need. #PuertoRico #HurricaneMaria ht…",
    created_at: "Thu Sep 28 23:47:51 +0000 2017",
    retweet_count: 9702,
    favorite_count: 0,
    is_retweet: true,
    id_str: "913550853239443457"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...really hard to help but many have lost their homes. Military is now on site and I will be there Tuesday. Wish press would treat fairly!",
    created_at: "Thu Sep 28 23:45:24 +0000 2017",
    retweet_count: 14288,
    favorite_count: 73879,
    is_retweet: false,
    id_str: "913550237377138688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "FEMA &amp; First Responders are doing a GREAT job in Puerto Rico. Massive food &amp; water delivered. Docks &amp; electric grid dead. Locals trying....",
    created_at: "Thu Sep 28 23:41:58 +0000 2017",
    retweet_count: 11014,
    favorite_count: 54667,
    is_retweet: false,
    id_str: "913549374227181568"
  },
  {
    source: "Media Studio",
    text: "Welcome back @SteveScalise!\n#TeamScalise https://t.co/CoRed8rfL2",
    created_at: "Thu Sep 28 19:39:13 +0000 2017",
    retweet_count: 14373,
    favorite_count: 66214,
    is_retweet: false,
    id_str: "913488283321159680"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The electric power grid in Puerto Rico is totally shot. Large numbers of generators are now on Island. Food and water on site.",
    created_at: "Thu Sep 28 14:01:16 +0000 2017",
    retweet_count: 17962,
    favorite_count: 86464,
    is_retweet: false,
    id_str: "913403237033742336"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrats don't want massive tax cuts - how does that win elections? Great reviews for Tax Cut and Reform Bill.",
    created_at: "Thu Sep 28 11:55:48 +0000 2017",
    retweet_count: 17741,
    favorite_count: 79028,
    is_retweet: false,
    id_str: "913371663789625344"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It is time to take care of OUR people, to rebuild OUR NATION, and to fight for OUR GREAT AMERICAN WORKERS! #TaxReform #USA🇺🇸 https://t.co/LsZvHg3got",
    created_at: "Thu Sep 28 01:55:05 +0000 2017",
    retweet_count: 17736,
    favorite_count: 75874,
    is_retweet: false,
    id_str: "913220484640182272"
  },
  {
    source: "Media Studio",
    text:
      "This is the right TAX CUT @ the RIGHT TIME. We will ALL succeed &amp; grow TOGETHER – as one team, one people, &amp; one American family. #TaxReform https://t.co/rtLWANJjIQ",
    created_at: "Wed Sep 27 23:42:57 +0000 2017",
    retweet_count: 14948,
    favorite_count: 61577,
    is_retweet: false,
    id_str: "913187235452690432"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just arrived in Indianapolis, Indiana to make an announcement on #TaxReform! Together, we are going to MAKE AMERICA GREAT AGAIN! https://t.co/Dy9UwhkWHL",
    created_at: "Wed Sep 27 19:07:02 +0000 2017",
    retweet_count: 10854,
    favorite_count: 58822,
    is_retweet: false,
    id_str: "913117797231857664"
  },
  {
    source: "Twitter for iPhone",
    text:
      "..But the people were Pro-Trump! Virtually no President has accomplished what we have accomplished in the first 9 months-and economy roaring",
    created_at: "Wed Sep 27 13:41:25 +0000 2017",
    retweet_count: 18869,
    favorite_count: 96467,
    is_retweet: false,
    id_str: "913035855509491712"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Facebook was always anti-Trump.The Networks were always anti-Trump hence,Fake News, @nytimes(apologized) &amp; @WaPo were anti-Trump. Collusion?",
    created_at: "Wed Sep 27 13:36:24 +0000 2017",
    retweet_count: 16529,
    favorite_count: 67172,
    is_retweet: false,
    id_str: "913034591879024640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We will have the votes for Healthcare but not for the reconciliation deadline of Friday, after which we need 60. Get rid of Filibuster Rule!",
    created_at: "Wed Sep 27 11:36:21 +0000 2017",
    retweet_count: 13306,
    favorite_count: 64538,
    is_retweet: false,
    id_str: "913004378486984704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With one Yes vote in hospital &amp; very positive signs from Alaska and two others (McCain is out), we have the HCare Vote, but not for Friday!",
    created_at: "Wed Sep 27 11:32:13 +0000 2017",
    retweet_count: 10104,
    favorite_count: 54537,
    is_retweet: false,
    id_str: "913003340451188737"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Spoke to Jerry Jones of the Dallas Cowboys yesterday. Jerry is a winner who knows how to get things done. Players will stand for Country!",
    created_at: "Wed Sep 27 11:09:02 +0000 2017",
    retweet_count: 17292,
    favorite_count: 92200,
    is_retweet: false,
    id_str: "912997506900021248"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Spoke to Roy Moore of Alabama last night for the first time. Sounds like a really great guy who ran a fantastic race. He will help to #MAGA!",
    created_at: "Wed Sep 27 10:56:53 +0000 2017",
    retweet_count: 13116,
    favorite_count: 62258,
    is_retweet: false,
    id_str: "912994446219898880"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to Roy Moore on his Republican Primary win in Alabama. Luther Strange started way back &amp; ran a good race. Roy, WIN in Dec!",
    created_at: "Wed Sep 27 02:17:15 +0000 2017",
    retweet_count: 17659,
    favorite_count: 88267,
    is_retweet: false,
    id_str: "912863676792786946"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to Roy Moore on his Republican Primary win in Alabama. Luther Strange started way back &amp; ran a good race. Roy, WIN in Nov!",
    created_at: "Wed Sep 27 02:03:58 +0000 2017",
    retweet_count: 3296,
    favorite_count: 12517,
    is_retweet: false,
    id_str: "912860336100904960"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Even Usain Bolt from Jamaica, one of the greatest runners and athletes of all time, showed RESPECT for our National Anthem! 🇺🇸🇯🇲 https://t.co/zkenuAP9RS",
    created_at: "Wed Sep 27 01:15:55 +0000 2017",
    retweet_count: 43791,
    favorite_count: 146298,
    is_retweet: false,
    id_str: "912848241535971331"
  },
  {
    source: "Twitter for iPhone",
    text:
      "70 years ago today, the National Security Council met for the first time. Great history of advising Presidents-then &amp; now! Thanks NSC Staff!",
    created_at: "Wed Sep 27 00:30:55 +0000 2017",
    retweet_count: 8725,
    favorite_count: 54780,
    is_retweet: false,
    id_str: "912836917296877569"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to our wonderful team @USUN and their families. Keep up the GREAT work! #USA🇺🇸 https://t.co/s7KhlSMEqY",
    created_at: "Tue Sep 26 23:46:12 +0000 2017",
    retweet_count: 6359,
    favorite_count: 34145,
    is_retweet: false,
    id_str: "912825663694016522"
  },
  {
    source: "Media Studio",
    text:
      "It was an honor to welcome President @MarianoraJoy of Spain. Thank you for standing w/ us in our efforts to isolate the brutal #NoKo regime. https://t.co/43U4T34JgF",
    created_at: "Tue Sep 26 22:43:24 +0000 2017",
    retweet_count: 8536,
    favorite_count: 39563,
    is_retweet: false,
    id_str: "912809860965613568"
  },
  {
    source: "Media Studio",
    text:
      "I want to express our support and extend our prayers to all those affected by the vile terror attack in Spain last month. 🇺🇸🇪🇸 https://t.co/5mT0QXFlnL",
    created_at: "Tue Sep 26 22:32:25 +0000 2017",
    retweet_count: 8658,
    favorite_count: 46986,
    is_retweet: false,
    id_str: "912807096885723137"
  },
  {
    source: "Media Studio",
    text:
      "America's hearts &amp; prayers are with the people of #PuertoRico &amp; the #USVI. We will get through this - and we will get through this TOGETHER! https://t.co/NcmsF4Fqpr",
    created_at: "Tue Sep 26 21:34:20 +0000 2017",
    retweet_count: 10629,
    favorite_count: 46722,
    is_retweet: false,
    id_str: "912792478096302080"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Heading over to the @UN to meet with Ambassador @NikkiHaley and all of her great representatives! #USA🇺🇸",
    created_at: "Tue Sep 26 20:43:27 +0000 2017",
    retweet_count: 6984,
    favorite_count: 43553,
    is_retweet: false,
    id_str: "912779672257261569"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @ricardorossello: Briefed @POTUS @realDonaldTrump in #SituationRoom and thanked him for his leadership, quick response &amp; commitment to o…",
    created_at: "Tue Sep 26 20:11:48 +0000 2017",
    retweet_count: 8302,
    favorite_count: 0,
    is_retweet: true,
    id_str: "912771708544802823"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Honored to welcome Republican and Democrat members of the House Ways and Means Committee to the White House today! #USA🇺🇸 https://t.co/nWnX9CDP0d",
    created_at: "Tue Sep 26 16:13:46 +0000 2017",
    retweet_count: 6989,
    favorite_count: 37898,
    is_retweet: false,
    id_str: "912711807709667331"
  },
  {
    source: "Twitter for iPhone",
    text:
      "ALABAMA, get out and vote for Luther Strange - he has proven to me that he will never let you down! #MAGA",
    created_at: "Tue Sep 26 13:31:15 +0000 2017",
    retweet_count: 4968,
    favorite_count: 27784,
    is_retweet: false,
    id_str: "912670906828443648"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The NFL has all sorts of rules and regulations. The only way out for them is to set a rule that you can't kneel during our National Anthem!",
    created_at: "Tue Sep 26 13:06:05 +0000 2017",
    retweet_count: 19704,
    favorite_count: 89132,
    is_retweet: false,
    id_str: "912664574461120512"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to Carmen Yulin Cruz, the Mayor of San Juan, for your kind words on FEMA etc.We are working hard. Much food and water there/on way",
    created_at: "Tue Sep 26 12:13:00 +0000 2017",
    retweet_count: 14099,
    favorite_count: 67522,
    is_retweet: false,
    id_str: "912651215997202432"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great interview on @foxandfriends with the parents of Otto Warmbier: 1994 - 2017. Otto was tortured beyond belief by North Korea.",
    created_at: "Tue Sep 26 11:14:41 +0000 2017",
    retweet_count: 12494,
    favorite_count: 50076,
    is_retweet: false,
    id_str: "912636538156146688"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Luther Strange has been shooting up in the Alabama polls since my endorsement. Finish the job - vote today for "Big Luther."',
    created_at: "Tue Sep 26 10:55:47 +0000 2017",
    retweet_count: 4884,
    favorite_count: 29142,
    is_retweet: false,
    id_str: "912631781098221568"
  },
  {
    source: "Twitter for iPhone",
    text:
      "But while Dallas dropped to its knees as a team, they all stood up for our National Anthem. Big progress being made-we all love our country!",
    created_at: "Tue Sep 26 10:47:49 +0000 2017",
    retweet_count: 15275,
    favorite_count: 85702,
    is_retweet: false,
    id_str: "912629775629418501"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...But while Dallas dropped to it knees as a team, they ALL stood up for our National Anthem. Big progress being made - we love our country!",
    created_at: "Tue Sep 26 10:41:50 +0000 2017",
    retweet_count: 478,
    favorite_count: 1969,
    is_retweet: false,
    id_str: "912628271426269185"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The booing at the NFL football game last night, when the entire Dallas team dropped to its knees, was loudest I have ever heard. Great anger",
    created_at: "Tue Sep 26 10:35:43 +0000 2017",
    retweet_count: 22527,
    favorite_count: 113676,
    is_retweet: false,
    id_str: "912626731357540353"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Ratings for NFL football are way down except before game starts, when people tune in to see whether or not our country will be disrespected!",
    created_at: "Tue Sep 26 10:28:24 +0000 2017",
    retweet_count: 18510,
    favorite_count: 90392,
    is_retweet: false,
    id_str: "912624892239077376"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big election tomorrow in the Great State of Alabama. Vote for Senator Luther Strange, tough on crime &amp; border - will never let you down!",
    created_at: "Tue Sep 26 01:50:58 +0000 2017",
    retweet_count: 7432,
    favorite_count: 42817,
    is_retweet: false,
    id_str: "912494675206053888"
  },
  {
    source: "Media Studio",
    text:
      "A few of the many clips of John McCain talking about Repealing &amp; Replacing O'Care. My oh my has he changed-complete turn from years of talk! https://t.co/t9cXG2Io86",
    created_at: "Tue Sep 26 01:24:10 +0000 2017",
    retweet_count: 29849,
    favorite_count: 78278,
    is_retweet: false,
    id_str: "912487929783754755"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...owed to Wall Street and the banks which, sadly, must be dealt with. Food, water and medical are top priorities - and doing well. #FEMA",
    created_at: "Tue Sep 26 00:58:50 +0000 2017",
    retweet_count: 8343,
    favorite_count: 40493,
    is_retweet: false,
    id_str: "912481556127780865"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...It's old electrical grid, which was in terrible shape, was devastated. Much of the Island was destroyed, with billions of dollars....",
    created_at: "Tue Sep 26 00:50:40 +0000 2017",
    retweet_count: 9115,
    favorite_count: 43305,
    is_retweet: false,
    id_str: "912479500511965184"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Texas &amp; Florida are doing great but Puerto Rico, which was already suffering from broken infrastructure &amp; massive debt, is in deep trouble..",
    created_at: "Tue Sep 26 00:45:48 +0000 2017",
    retweet_count: 13539,
    favorite_count: 58093,
    is_retweet: false,
    id_str: "912478274508423168"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Tremendous backlash against the NFL and its players for disrespect of our Country.\n#StandForOurAnthem🇺🇸",
    created_at: "Mon Sep 25 22:29:18 +0000 2017",
    retweet_count: 27035,
    favorite_count: 112130,
    is_retweet: false,
    id_str: "912443924979077120"
  },
  {
    source: "Twitter for iPhone",
    text:
      "General John Kelly totally agrees w/ my stance on NFL players and the fact that they should not be disrespecting our FLAG or GREAT COUNTRY!",
    created_at: "Mon Sep 25 22:28:02 +0000 2017",
    retweet_count: 22128,
    favorite_count: 107087,
    is_retweet: false,
    id_str: "912443607084404736"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@CNN is #FakeNews. Just reported COS (John Kelly) was opposed to my stance on NFL players disrespecting FLAG, ANTHEM, COUNTRY. Total lie!",
    created_at: "Mon Sep 25 22:26:30 +0000 2017",
    retweet_count: 17397,
    favorite_count: 65726,
    is_retweet: false,
    id_str: "912443217227976704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @jayMAGA45: NFLplayer PatTillman joined U.S. Army in 2002. He was killed in action 2004. He fought 4our country/freedom. #StandForOurAnt…",
    created_at: "Mon Sep 25 13:06:42 +0000 2017",
    retweet_count: 21651,
    favorite_count: 0,
    is_retweet: true,
    id_str: "912302339360542720"
  },
  {
    source: "Twitter for iPhone",
    text: "#StandForOurAnthem",
    created_at: "Mon Sep 25 13:02:27 +0000 2017",
    retweet_count: 74410,
    favorite_count: 207402,
    is_retweet: false,
    id_str: "912301271817838593"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The White House never looked more beautiful than it did returning last night. Important meetings taking place today. Big tax cuts &amp; reform.",
    created_at: "Mon Sep 25 11:44:05 +0000 2017",
    retweet_count: 14142,
    favorite_count: 84347,
    is_retweet: false,
    id_str: "912281550712135680"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The issue of kneeling has nothing to do with race. It is about respect for our Country, Flag and National Anthem. NFL must respect this!",
    created_at: "Mon Sep 25 11:39:03 +0000 2017",
    retweet_count: 56083,
    favorite_count: 206672,
    is_retweet: false,
    id_str: "912280282224525312"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Many people booed the players who kneeled yesterday (which was a small percentage of total). These are fans who demand respect for our Flag!",
    created_at: "Mon Sep 25 11:31:43 +0000 2017",
    retweet_count: 24597,
    favorite_count: 137858,
    is_retweet: false,
    id_str: "912278438127525888"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So proud of NASCAR and its supporters and fans. They won't put up with disrespecting our Country or our Flag - they said it loud and clear!",
    created_at: "Mon Sep 25 11:25:25 +0000 2017",
    retweet_count: 36250,
    favorite_count: 173313,
    is_retweet: false,
    id_str: "912276850793213952"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Making America Safe is my number one priority. We will not admit those into our country we cannot safely vet.\nhttps://t.co/KJ886okyfC",
    created_at: "Sun Sep 24 23:49:43 +0000 2017",
    retweet_count: 23365,
    favorite_count: 99043,
    is_retweet: false,
    id_str: "912101775221706752"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Sports fans should never condone players that do not stand proud for their National Anthem or their Country. NFL should change policy!",
    created_at: "Sun Sep 24 22:25:20 +0000 2017",
    retweet_count: 40390,
    favorite_count: 174275,
    is_retweet: false,
    id_str: "912080538755846144"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Alaska, Arizona, Maine and Kentucky are big winners in the Healthcare proposal. 7 years of Repeal &amp; Replace and some Senators not there.",
    created_at: "Sun Sep 24 22:21:43 +0000 2017",
    retweet_count: 12571,
    favorite_count: 63341,
    is_retweet: false,
    id_str: "912079629648883712"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Courageous Patriots have fought and died for our great American Flag --- we MUST honor and respect it!  MAKE AMERICA GREAT AGAIN!",
    created_at: "Sun Sep 24 19:32:21 +0000 2017",
    retweet_count: 52950,
    favorite_count: 199204,
    is_retweet: false,
    id_str: "912037003923005440"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DonnaWR8: @realDonaldTrump I wonder what this BRAVE American would give to stand on his OWN two legs just ONCE MORE for our #Anthem?…",
    created_at: "Sun Sep 24 19:14:47 +0000 2017",
    retweet_count: 22730,
    favorite_count: 0,
    is_retweet: true,
    id_str: "912032583466340353"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DonnaWR8: @realDonaldTrump You can boycott our anthem \n\nWE CAN BOYCOTT YOU! \n\n#NFL #MAGA https://t.co/ryYzZnXjXE",
    created_at: "Sun Sep 24 19:12:50 +0000 2017",
    retweet_count: 20639,
    favorite_count: 0,
    is_retweet: true,
    id_str: "912032094687252485"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Please to inform that the Champion Pittsburgh Penguins of the NHL will be joining me at the White House for Ceremony. Great team!",
    created_at: "Sun Sep 24 18:24:36 +0000 2017",
    retweet_count: 33790,
    favorite_count: 162345,
    is_retweet: false,
    id_str: "912019957243883520"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great solidarity for our National Anthem and for our Country. Standing with locked arms is good, kneeling is not acceptable. Bad ratings!",
    created_at: "Sun Sep 24 18:20:35 +0000 2017",
    retweet_count: 27692,
    favorite_count: 135710,
    is_retweet: false,
    id_str: "912018945158402049"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...NFL attendance and ratings are WAY DOWN. Boring games yes, but many stay away because they love our country. League should back U.S.",
    created_at: "Sun Sep 24 11:13:11 +0000 2017",
    retweet_count: 33746,
    favorite_count: 157524,
    is_retweet: false,
    id_str: "911911385176723457"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If NFL fans refuse to go to games until players stop disrespecting our Flag &amp; Country, you will see change take place fast. Fire or suspend!",
    created_at: "Sun Sep 24 10:44:52 +0000 2017",
    retweet_count: 45225,
    favorite_count: 179990,
    is_retweet: false,
    id_str: "911904261553950720"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just heard Foreign Minister of North Korea speak at U.N. If he echoes thoughts of Little Rocket Man, they won't be around much longer!",
    created_at: "Sun Sep 24 03:08:07 +0000 2017",
    retweet_count: 37580,
    favorite_count: 135288,
    is_retweet: false,
    id_str: "911789314169823232"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Roger Goodell of NFL just put out a statement trying to justify the total disrespect certain players show to our country.Tell them to stand!",
    created_at: "Sat Sep 23 22:25:17 +0000 2017",
    retweet_count: 40988,
    favorite_count: 156381,
    is_retweet: false,
    id_str: "911718138747727872"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Democrats are laughingly saying that McCain had a "moment of courage." Tell that to the people of Arizona who were deceived. 116% increase!',
    created_at: "Sat Sep 23 22:20:47 +0000 2017",
    retweet_count: 26945,
    favorite_count: 105470,
    is_retweet: false,
    id_str: "911717004222091264"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Iran just test-fired a Ballistic Missile capable of reaching Israel.They are also working with North Korea.Not much of an agreement we have!",
    created_at: "Sat Sep 23 21:59:04 +0000 2017",
    retweet_count: 29011,
    favorite_count: 98305,
    is_retweet: false,
    id_str: "911711539815702529"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Very proud of our incredible First Lady (@FLOTUS.) She is a truly great representative for our country! https://t.co/yFv0WIjgby",
    created_at: "Sat Sep 23 21:16:51 +0000 2017",
    retweet_count: 18622,
    favorite_count: 102882,
    is_retweet: false,
    id_str: "911700914997792769"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...our Great American Flag (or Country) and should stand for the National Anthem. If not, YOU'RE FIRED. Find something else to do!",
    created_at: "Sat Sep 23 18:18:19 +0000 2017",
    retweet_count: 42328,
    favorite_count: 161691,
    is_retweet: false,
    id_str: "911655987857281024"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If a player wants the privilege of making millions of dollars in the NFL,or other leagues, he or she should not be allowed to disrespect....",
    created_at: "Sat Sep 23 18:11:10 +0000 2017",
    retweet_count: 47642,
    favorite_count: 184086,
    is_retweet: false,
    id_str: "911654184918880260"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Going to the White House is considered a great honor for a championship team.Stephen Curry is hesitating,therefore invitation is withdrawn!",
    created_at: "Sat Sep 23 12:45:19 +0000 2017",
    retweet_count: 64839,
    favorite_count: 214319,
    is_retweet: false,
    id_str: "911572182060453893"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was great being with Luther Strange last night in Alabama. What great people, what a crowd! Vote Luther on Tuesday.",
    created_at: "Sat Sep 23 11:17:05 +0000 2017",
    retweet_count: 7047,
    favorite_count: 45124,
    is_retweet: false,
    id_str: "911549980946714624"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Alaska had a 200% plus increase in premiums under ObamaCare, worst in the country. Deductibles high, people angry! Lisa M comes through.",
    created_at: "Sat Sep 23 11:13:35 +0000 2017",
    retweet_count: 15000,
    favorite_count: 64703,
    is_retweet: false,
    id_str: "911549099752804357"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I know Rand Paul and I think he may find a way to get there for the good of the Party!",
    created_at: "Sat Sep 23 11:04:21 +0000 2017",
    retweet_count: 10486,
    favorite_count: 58235,
    is_retweet: false,
    id_str: "911546774267006976"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Large Block Grants to States is a good thing to do. Better control &amp;  management. Great for Arizona. McCain let his best friend L.G. down!",
    created_at: "Sat Sep 23 10:59:12 +0000 2017",
    retweet_count: 10820,
    favorite_count: 54685,
    is_retweet: false,
    id_str: "911545480651378689"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Arizona had a 116% increase in ObamaCare premiums last year, with deductibles very high. Chuck Schumer sold John McCain a bill of goods. Sad",
    created_at: "Sat Sep 23 10:50:14 +0000 2017",
    retweet_count: 16391,
    favorite_count: 66300,
    is_retweet: false,
    id_str: "911543222731706368"
  },
  {
    source: "Twitter for iPhone",
    text:
      "John McCain never had any intention of voting for this Bill, which his Governor loves. He campaigned on Repeal &amp; Replace. Let Arizona down!",
    created_at: "Sat Sep 23 10:42:42 +0000 2017",
    retweet_count: 22206,
    favorite_count: 86966,
    is_retweet: false,
    id_str: "911541328013676544"
  },
  {
    source: "Twitter for iPhone",
    text: "Heading to Alabama now, big crowd!",
    created_at: "Fri Sep 22 21:18:37 +0000 2017",
    retweet_count: 8188,
    favorite_count: 60818,
    is_retweet: false,
    id_str: "911338971250216960"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to Doug Parker and American Airlines for all of the help you have given to the U.S. with Hurricane flights. Fantastic job!",
    created_at: "Fri Sep 22 17:54:59 +0000 2017",
    retweet_count: 13534,
    favorite_count: 78605,
    is_retweet: false,
    id_str: "911287725847908352"
  },
  {
    source: "Twitter for iPhone",
    text: "#USAatUNGA🇺🇸#UNGA https://t.co/miT2Lj7Q90",
    created_at: "Fri Sep 22 16:25:12 +0000 2017",
    retweet_count: 9198,
    favorite_count: 40194,
    is_retweet: false,
    id_str: "911265133279809536"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Will be in Alabama tonight. Luther Strange has gained mightily since my endorsement, but will be very close. He loves Alabama, and so do I!",
    created_at: "Fri Sep 22 11:39:28 +0000 2017",
    retweet_count: 7407,
    favorite_count: 45937,
    is_retweet: false,
    id_str: "911193223921635335"
  },
  {
    source: "Twitter for iPhone",
    text:
      'The greatest influence over our election was the Fake News Media "screaming" for Crooked Hillary Clinton. Next, she was a bad candidate!',
    created_at: "Fri Sep 22 11:26:06 +0000 2017",
    retweet_count: 19652,
    favorite_count: 90167,
    is_retweet: false,
    id_str: "911189860769255424"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Russia hoax continues, now it's ads on Facebook. What about the totally biased and dishonest Media coverage in favor of Crooked Hillary?",
    created_at: "Fri Sep 22 10:44:47 +0000 2017",
    retweet_count: 26853,
    favorite_count: 105163,
    is_retweet: false,
    id_str: "911179462745710593"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DonnaWR8: .@POTUS #TRUMP🇺🇸 &amp; @FLOTUS🌺\n\nWhen ALL seemed HOPELESS...YOU brought HOPE!\n\nYou INSPIRE us ALL!\n\n#MAGA #Harvey @Scavino45 #USA…",
    created_at: "Fri Sep 22 10:36:50 +0000 2017",
    retweet_count: 8452,
    favorite_count: 0,
    is_retweet: true,
    id_str: "911177460959662080"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @TwitterData: These are the 10 most Tweeted about world leaders during the first day of #UNGA General Debate https://t.co/HhlOlNAkDJ",
    created_at: "Fri Sep 22 10:30:56 +0000 2017",
    retweet_count: 5407,
    favorite_count: 0,
    is_retweet: true,
    id_str: "911175977878872064"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you! https://t.co/hlz48RLkIf",
    created_at: "Fri Sep 22 10:30:06 +0000 2017",
    retweet_count: 10934,
    favorite_count: 56418,
    is_retweet: false,
    id_str: "911175765718421504"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Kim Jong Un of North Korea, who is obviously a madman who doesn't mind starving or killing his people, will be tested like never before!",
    created_at: "Fri Sep 22 10:28:02 +0000 2017",
    retweet_count: 41831,
    favorite_count: 130442,
    is_retweet: false,
    id_str: "911175246853664768"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Rand Paul, or whoever votes against Hcare Bill, will forever (future political campaigns) be known as "the Republican who saved ObamaCare."',
    created_at: "Fri Sep 22 10:19:36 +0000 2017",
    retweet_count: 14476,
    favorite_count: 61009,
    is_retweet: false,
    id_str: "911173124976193536"
  },
  {
    source: "Twitter for iPhone",
    text: "A big day for the U.S. at the United Nations!",
    created_at: "Thu Sep 21 22:26:29 +0000 2017",
    retweet_count: 12206,
    favorite_count: 74560,
    is_retweet: false,
    id_str: "910993665568526337"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Senator Luther Strange has gone up a lot in the polls since I endorsed him a month ago. Now a close runoff. He will be great in D.C.",
    created_at: "Thu Sep 21 22:23:44 +0000 2017",
    retweet_count: 6946,
    favorite_count: 43678,
    is_retweet: false,
    id_str: "910992971620864004"
  },
  {
    source: "Media Studio",
    text:
      "Today, I announced a new Executive Order with re: to North Korea. We must all do our part to ensure the complete denuclearization of #NoKo. https://t.co/igjOSM7N7h",
    created_at: "Thu Sep 21 17:58:30 +0000 2017",
    retweet_count: 17960,
    favorite_count: 68542,
    is_retweet: false,
    id_str: "910926223684931585"
  },
  {
    source: "Media Studio",
    text:
      "It was a great privilege to meet with President Moon of South Korea.\nStay tuned! 🇺🇸🇰🇷#UNGA https://t.co/7xYDO5ddUm",
    created_at: "Thu Sep 21 16:06:32 +0000 2017",
    retweet_count: 9037,
    favorite_count: 44862,
    is_retweet: false,
    id_str: "910898047931912192"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was wonderful to have President Petro Poroshenko of Ukraine with us in New York City today. #UNGA\n🎥https://t.co/UKOMUj0ZuL https://t.co/GpkERy8WiP",
    created_at: "Thu Sep 21 15:17:42 +0000 2017",
    retweet_count: 6351,
    favorite_count: 31100,
    is_retweet: false,
    id_str: "910885755320459264"
  },
  {
    source: "Media Studio",
    text:
      "It was a pleasure to have President Ashraf Ghani of Afghanistan with us this morning! #USAatUNGA #UNGA https://t.co/HOEVfnMn14",
    created_at: "Thu Sep 21 15:15:19 +0000 2017",
    retweet_count: 6718,
    favorite_count: 35263,
    is_retweet: false,
    id_str: "910885156373721092"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Governor @RicardoRossello- \nWe are with you and the people of Puerto Rico. Stay safe! #PRStrong",
    created_at: "Thu Sep 21 03:13:07 +0000 2017",
    retweet_count: 11858,
    favorite_count: 58291,
    is_retweet: false,
    id_str: "910703407555600386"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Senator (Doctor) Bill Cassidy is a class act who really cares about people and their Health(care), he doesn't lie-just wants to help people!",
    created_at: "Thu Sep 21 01:06:25 +0000 2017",
    retweet_count: 11410,
    favorite_count: 56984,
    is_retweet: false,
    id_str: "910671525543645185"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The NRA strongly endorses Luther Strange for Senator of Alabama.That means all gun owners should vote for Big Luther. He won't let you down!",
    created_at: "Thu Sep 21 00:42:17 +0000 2017",
    retweet_count: 10219,
    favorite_count: 54174,
    is_retweet: false,
    id_str: "910665452048838661"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I would not sign Graham-Cassidy if it did not include coverage of pre-existing conditions. It does! A great Bill. Repeal &amp; Replace.",
    created_at: "Wed Sep 20 23:07:55 +0000 2017",
    retweet_count: 18142,
    favorite_count: 75542,
    is_retweet: false,
    id_str: "910641701064204288"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Alabama is sooo lucky to have a candidate like "Big" Luther Strange. Smart, tough on crime, borders &amp; trade, loves Vets &amp; Military. Tuesday!',
    created_at: "Wed Sep 20 22:42:35 +0000 2017",
    retweet_count: 7454,
    favorite_count: 43945,
    is_retweet: false,
    id_str: "910635327672512512"
  },
  {
    source: "Twitter for iPhone",
    text:
      "On behalf of all Americans, I want to wish Jewish families many blessings in the New Year. https://t.co/m4VWxYvONx https://t.co/iYG1G8GaLN",
    created_at: "Wed Sep 20 22:29:44 +0000 2017",
    retweet_count: 12067,
    favorite_count: 52143,
    is_retweet: false,
    id_str: "910632095088889857"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @VP: Went to the Senate today to say @POTUS &amp; I fully support Graham-Cassidy plan to repeal/replace Obamacare. Let's get this done. http…",
    created_at: "Wed Sep 20 19:09:58 +0000 2017",
    retweet_count: 7937,
    favorite_count: 0,
    is_retweet: true,
    id_str: "910581819078316034"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Honored to host a luncheon for African leaders this afternoon. Great discussions on the challenges &amp; opportunities facing our nations today. https://t.co/AbnBJtKCAI",
    created_at: "Wed Sep 20 19:05:18 +0000 2017",
    retweet_count: 9416,
    favorite_count: 43235,
    is_retweet: false,
    id_str: "910580644597649409"
  },
  {
    source: "Media Studio",
    text:
      "Honored to meet w/ Pres Abbas from the Palestinian Authority &amp; his delegation, who have been working hard w/everybody involved toward peace. https://t.co/4E8awDkX93",
    created_at: "Wed Sep 20 17:08:53 +0000 2017",
    retweet_count: 6866,
    favorite_count: 34683,
    is_retweet: false,
    id_str: "910551350408241152"
  },
  {
    source: "Media Studio",
    text:
      "It was a great honor to be with King Abdullah II of Jordan and his delegation this morning. We had a GREAT bilateral meeting!🇺🇸🇯🇴 https://t.co/6tYDHswKa3",
    created_at: "Wed Sep 20 15:23:46 +0000 2017",
    retweet_count: 8613,
    favorite_count: 43393,
    is_retweet: false,
    id_str: "910524897515905025"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Looking forward to Friday night in the Great State of Alabama. I am supporting "Big" Luther Strange because he was so loyal &amp; helpful to me!',
    created_at: "Wed Sep 20 12:29:01 +0000 2017",
    retweet_count: 8053,
    favorite_count: 47907,
    is_retweet: false,
    id_str: "910480918816739328"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I hope Republican Senators will vote for Graham-Cassidy and fulfill their promise to Repeal &amp; Replace ObamaCare. Money direct to States!",
    created_at: "Wed Sep 20 12:16:22 +0000 2017",
    retweet_count: 12989,
    favorite_count: 59827,
    is_retweet: false,
    id_str: "910477734635286528"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Rand Paul is a friend of mine but he is such a negative force when it comes to fixing healthcare. Graham-Cassidy Bill is GREAT! Ends Ocare!",
    created_at: "Wed Sep 20 12:09:54 +0000 2017",
    retweet_count: 10175,
    favorite_count: 49353,
    is_retweet: false,
    id_str: "910476107287269376"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Franklin_Graham: Join me in praying for @POTUS. He reminded the world, “If the righteous many do not confront the wicked few, then evil…",
    created_at: "Wed Sep 20 11:03:31 +0000 2017",
    retweet_count: 22093,
    favorite_count: 0,
    is_retweet: true,
    id_str: "910459401558986752"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you  @foxandfriends - great show!",
    created_at: "Wed Sep 20 11:00:34 +0000 2017",
    retweet_count: 5871,
    favorite_count: 39397,
    is_retweet: false,
    id_str: "910458657179086848"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @RealEagleBites: @realDonaldTrump It is the height of hypocrisy. Obama and Clinton in effect gave nuclear weapons to North Korea by thei…",
    created_at: "Wed Sep 20 10:47:35 +0000 2017",
    retweet_count: 7846,
    favorite_count: 0,
    is_retweet: true,
    id_str: "910455390038642688"
  },
  {
    source: "Twitter for iPhone",
    text: "The world is noticing, thanks! https://t.co/2NL6SlWnmH",
    created_at: "Wed Sep 20 10:44:06 +0000 2017",
    retweet_count: 12400,
    favorite_count: 58962,
    is_retweet: false,
    id_str: "910454516557983744"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DonnaWR8: @realDonaldTrump Thank you @POTUS for believing in Us like we believed in you! #MAGA https://t.co/C476SHWd0m",
    created_at: "Wed Sep 20 10:42:33 +0000 2017",
    retweet_count: 10858,
    favorite_count: 0,
    is_retweet: true,
    id_str: "910454124696752130"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After allowing North Korea to research and build Nukes while Secretary of State (Bill C also), Crooked Hillary now criticizes.",
    created_at: "Wed Sep 20 10:40:31 +0000 2017",
    retweet_count: 21917,
    favorite_count: 83684,
    is_retweet: false,
    id_str: "910453612630900736"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big meetings today at the United Nations. So many interesting leaders. America First will MAKE AMERICA GREAT AGAIN!",
    created_at: "Wed Sep 20 10:14:30 +0000 2017",
    retweet_count: 10607,
    favorite_count: 56923,
    is_retweet: false,
    id_str: "910447064944955392"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @Scavino45: "The Iran deal was one of the worst &amp; most one sided transactions the United States has EVER entered into."\n@POTUS @realDona…',
    created_at: "Wed Sep 20 10:00:18 +0000 2017",
    retweet_count: 9466,
    favorite_count: 0,
    is_retweet: true,
    id_str: "910443493511827456"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: #WeThePeople🇺🇸\n#USAatUNGA #UNGA https://t.co/8VsFL9MZxx",
    created_at: "Wed Sep 20 10:00:10 +0000 2017",
    retweet_count: 4295,
    favorite_count: 0,
    is_retweet: true,
    id_str: "910443458564894720"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: .@POTUS @realDonaldTrump and @UN Secretary-General @AntonioGuterres pose for📸prior to their expanded bilateral meeting. #USA…",
    created_at: "Wed Sep 20 09:59:48 +0000 2017",
    retweet_count: 3902,
    favorite_count: 0,
    is_retweet: true,
    id_str: "910443366911037440"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you Jacob! https://t.co/Wjjrv6KTVT",
    created_at: "Wed Sep 20 09:53:55 +0000 2017",
    retweet_count: 150,
    favorite_count: 505,
    is_retweet: false,
    id_str: "910441887164661760"
  },
  {
    source: "Twitter for iPhone",
    text:
      'I was saddened to see how bad the ratings were on the Emmys last night - the worst ever. Smartest people of them all are the "DEPLORABLES."',
    created_at: "Wed Sep 20 02:41:13 +0000 2017",
    retweet_count: 26332,
    favorite_count: 117255,
    is_retweet: false,
    id_str: "910332992756834304"
  },
  {
    source: "Twitter for iPhone",
    text: "So nice, thank you! https://t.co/Cg4dzHhbrv",
    created_at: "Wed Sep 20 02:33:32 +0000 2017",
    retweet_count: 8967,
    favorite_count: 51650,
    is_retweet: false,
    id_str: "910331061409902592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A great and important day at the United Nations.Met with leaders of many nations who agree with much (or all) of what I stated in my speech!",
    created_at: "Wed Sep 20 02:31:19 +0000 2017",
    retweet_count: 13618,
    favorite_count: 70682,
    is_retweet: false,
    id_str: "910330501411590146"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Puerto Rico being hit hard by new monster Hurricane. Be careful, our hearts are with you- will be there to help!",
    created_at: "Wed Sep 20 02:23:52 +0000 2017",
    retweet_count: 18792,
    favorite_count: 86870,
    is_retweet: false,
    id_str: "910328626075389952"
  },
  {
    source: "Twitter for iPhone",
    text: "The true question for the @UN...\n🎥https://t.co/tx5SnACAaS",
    created_at: "Wed Sep 20 01:19:00 +0000 2017",
    retweet_count: 6770,
    favorite_count: 30565,
    is_retweet: false,
    id_str: "910312303635116033"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was a great honor to have spoken before the countries of the world at the United Nations.\n#USAatUNGA🇺🇸#UNGA\nhttps://t.co/1maJwRGa3d https://t.co/6Hu3AeUp58",
    created_at: "Tue Sep 19 22:04:11 +0000 2017",
    retweet_count: 11254,
    favorite_count: 56477,
    is_retweet: false,
    id_str: "910263274918367236"
  },
  {
    source: "Twitter for iPhone",
    text:
      "God bless the people of Mexico City. We are with you and will be there for you.",
    created_at: "Tue Sep 19 20:05:32 +0000 2017",
    retweet_count: 53528,
    favorite_count: 190807,
    is_retweet: false,
    id_str: "910233418474098688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "As President of the United States of America, I will ALWAYS put #AmericaFirst🇺🇸#UNGA\nFull remarks: https://t.co/ksaMsQ2Lhm https://t.co/XrtpAWwuCn",
    created_at: "Tue Sep 19 19:09:35 +0000 2017",
    retweet_count: 17146,
    favorite_count: 67672,
    is_retweet: false,
    id_str: "910219338044657664"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The🇺🇸has great strength &amp; patience, but if it is forced to defend itself or its allies, we will have no choice but to totally destroy #NoKo. https://t.co/P4vAanXvgm",
    created_at: "Tue Sep 19 17:22:27 +0000 2017",
    retweet_count: 23766,
    favorite_count: 83066,
    is_retweet: false,
    id_str: "910192375267561472"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IvankaTrump: I have long respected India's accomplished and charismatic Foreign Minister @SushmaSwaraj, and it was an honor to meet her…",
    created_at: "Tue Sep 19 11:22:59 +0000 2017",
    retweet_count: 9439,
    favorite_count: 0,
    is_retweet: true,
    id_str: "910101913923997696"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big day at the United Nations - many good things, and some tricky ones, happening. We have a great team. Big speech at 10:00 A.M.",
    created_at: "Tue Sep 19 11:21:30 +0000 2017",
    retweet_count: 14041,
    favorite_count: 80488,
    is_retweet: false,
    id_str: "910101538336583680"
  },
  {
    source: "Media Studio",
    text: "#USAatUNGA🇺🇸 #UNGA https://t.co/MjIJ7HG3eU",
    created_at: "Tue Sep 19 04:47:03 +0000 2017",
    retweet_count: 8191,
    favorite_count: 37546,
    is_retweet: false,
    id_str: "910002272825831425"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We call for the full restoration of democracy and political freedoms in Venezuela, and we want it to happen very, very soon! https://t.co/bMJDOtAesl",
    created_at: "Tue Sep 19 04:18:41 +0000 2017",
    retweet_count: 19103,
    favorite_count: 60538,
    is_retweet: false,
    id_str: "909995135009804288"
  },
  {
    source: "Media Studio",
    text:
      "It was a great honor to be with President @EmmanuelMacron of France this afternoon with his delegation. Great bilateral meeting! #UNGA https://t.co/HnxDDU5d5F",
    created_at: "Tue Sep 19 03:01:25 +0000 2017",
    retweet_count: 7669,
    favorite_count: 39013,
    is_retweet: false,
    id_str: "909975689838731264"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Such an honor to have my good friend, Israel PM @Netanyahu, join us w/ his delegation in NYC this afternoon. #UNGA https://t.co/YEHWjdtQx8 https://t.co/jwU4e8Yk8A",
    created_at: "Mon Sep 18 23:31:07 +0000 2017",
    retweet_count: 11929,
    favorite_count: 51539,
    is_retweet: false,
    id_str: "909922763774861314"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Looking forward to meeting with Prime Minister @Netanyahu shortly. Peace in the Middle East would be a truly great legacy for ALL people!",
    created_at: "Mon Sep 18 16:57:27 +0000 2017",
    retweet_count: 13588,
    favorite_count: 74213,
    is_retweet: false,
    id_str: "909823695299981313"
  },
  {
    source: "Media Studio",
    text:
      "We commend SG @AntonioGuterres &amp; his call for the UN to focus more on people &amp; less on bureaucracy. #USAatUNGA #UNGA https://t.co/KVvCMznmcN https://t.co/UQn6RrC9Xw",
    created_at: "Mon Sep 18 16:36:09 +0000 2017",
    retweet_count: 8885,
    favorite_count: 37701,
    is_retweet: false,
    id_str: "909818335130525697"
  },
  {
    source: "Twitter for iPhone",
    text: "Happy 70th Birthday @CIA! https://t.co/CU3gOZMf7J",
    created_at: "Mon Sep 18 13:16:17 +0000 2017",
    retweet_count: 9725,
    favorite_count: 51073,
    is_retweet: false,
    id_str: "909768037787717633"
  },
  {
    source: "Twitter for iPhone",
    text: "Happy 70th Birthday @USAirForce! https://t.co/snkXO40vXM",
    created_at: "Mon Sep 18 13:14:46 +0000 2017",
    retweet_count: 12562,
    favorite_count: 62647,
    is_retweet: false,
    id_str: "909767654432526336"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @realDonaldTrump: Loser terrorists must be dealt with in a much tougher manner.The internet is their main recruitment tool which we must…",
    created_at: "Sun Sep 17 13:03:32 +0000 2017",
    retweet_count: 21445,
    favorite_count: 0,
    is_retweet: true,
    id_str: "909402439643750400"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @realDonaldTrump: The travel ban into the United States should be far larger, tougher and more specific-but stupidly, that would not be…",
    created_at: "Sun Sep 17 13:02:26 +0000 2017",
    retweet_count: 24616,
    favorite_count: 0,
    is_retweet: true,
    id_str: "909402164610715648"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Important meetings and calls scheduled for today. Military and economy are getting stronger by the day, and our enemies know it. #MAGA",
    created_at: "Sun Sep 17 13:00:05 +0000 2017",
    retweet_count: 13889,
    favorite_count: 68327,
    is_retweet: false,
    id_str: "909401572341370881"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @markets: What Is Trump worth to Twitter? One analyst estimates $2 billion https://t.co/knniVpqr35 https://t.co/djkZiRk5nL",
    created_at: "Sun Sep 17 12:29:57 +0000 2017",
    retweet_count: 5606,
    favorite_count: 0,
    is_retweet: true,
    id_str: "909393991635996672"
  },
  {
    source: "Twitter for iPhone",
    text: "My great honor! https://t.co/x25T9tQAnI",
    created_at: "Sun Sep 17 12:28:08 +0000 2017",
    retweet_count: 14929,
    favorite_count: 69853,
    is_retweet: false,
    id_str: "909393531143380992"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Fuctupmind: @realDonaldTrump Donald Trump's amazing golf swing #CrookedHillary https://t.co/vKhxxFCBV1",
    created_at: "Sun Sep 17 12:16:31 +0000 2017",
    retweet_count: 39631,
    favorite_count: 0,
    is_retweet: true,
    id_str: "909390607650521088"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @Team_Trump45: @realDonaldTrump  https://t.co/Vu56q4z2XJ",
    created_at: "Sun Sep 17 12:12:19 +0000 2017",
    retweet_count: 7038,
    favorite_count: 0,
    is_retweet: true,
    id_str: "909389552380514304"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @Team_Trump45: @realDonaldTrump  https://t.co/MOnPkuKxQM",
    created_at: "Sun Sep 17 12:12:02 +0000 2017",
    retweet_count: 3500,
    favorite_count: 0,
    is_retweet: true,
    id_str: "909389478795636736"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @Team_Trump45: @realDonaldTrump  https://t.co/1zo6zc2pxt",
    created_at: "Sun Sep 17 12:11:39 +0000 2017",
    retweet_count: 9098,
    favorite_count: 0,
    is_retweet: true,
    id_str: "909389385308700672"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @glamourizes: @realDonaldTrump Only true Americans can see that president Trump is making America great. He's the only person who can! H…",
    created_at: "Sun Sep 17 12:05:59 +0000 2017",
    retweet_count: 7581,
    favorite_count: 0,
    is_retweet: true,
    id_str: "909387958368784389"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @Team_Trump45: @realDonaldTrump  https://t.co/dw0zKYtyfT",
    created_at: "Sun Sep 17 12:02:42 +0000 2017",
    retweet_count: 5958,
    favorite_count: 0,
    is_retweet: true,
    id_str: "909387131952549888"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @dmartosko: This is the #NYTimes. Can you understand why so many reporters are cautious about working for them? https://t.co/LRJKtFNgM4",
    created_at: "Sun Sep 17 12:00:47 +0000 2017",
    retweet_count: 7623,
    favorite_count: 0,
    is_retweet: true,
    id_str: "909386650953961473"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you! https://t.co/vs4MNwXtei",
    created_at: "Sun Sep 17 11:57:20 +0000 2017",
    retweet_count: 6266,
    favorite_count: 37120,
    is_retweet: false,
    id_str: "909385782275788800"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I spoke with President Moon of South Korea last night. Asked him how Rocket Man is doing. Long gas lines forming in North Korea. Too bad!",
    created_at: "Sun Sep 17 11:53:35 +0000 2017",
    retweet_count: 44062,
    favorite_count: 148003,
    is_retweet: false,
    id_str: "909384837018112000"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Attorney General Bill Schuette will be a fantastic Governor for the great State of Michigan. I am bringing back your jobs and Bill will help",
    created_at: "Sun Sep 17 11:40:16 +0000 2017",
    retweet_count: 9507,
    favorite_count: 51876,
    is_retweet: false,
    id_str: "909381488445190145"
  },
  {
    source: "Twitter for iPhone",
    text:
      'I will be in Huntsville, Alabama, on Saturday night to support Luther Strange for Senate. "Big Luther" is a great guy who gets things done!',
    created_at: "Sat Sep 16 23:04:03 +0000 2017",
    retweet_count: 9977,
    favorite_count: 55512,
    is_retweet: false,
    id_str: "909191177810915328"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Attorney General Bill Shuette will be a fantastic Governor for the great State of Michigan. I am bringing back your jobs and Bill will help!",
    created_at: "Sat Sep 16 22:59:06 +0000 2017",
    retweet_count: 8412,
    favorite_count: 37789,
    is_retweet: false,
    id_str: "909189931154771970"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A great deal of good things happening for our country. Jobs and Stock Market at all time highs, and I believe will be getting even better!",
    created_at: "Sat Sep 16 22:40:23 +0000 2017",
    retweet_count: 16309,
    favorite_count: 83132,
    is_retweet: false,
    id_str: "909185223887347712"
  },
  {
    source: "Media Studio",
    text:
      "HAPPY 70th BIRTHDAY to the @USAirForce! The American people are eternally grateful. Thank you for keeping America PROUD, STRONG and FREE! https://t.co/DYxkh3gj0R",
    created_at: "Fri Sep 15 23:54:00 +0000 2017",
    retweet_count: 21656,
    favorite_count: 90587,
    is_retweet: false,
    id_str: "908841360131743744"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We will defend our people, our nations and our civilization from all who dare to threaten our way of life...cont: https://t.co/SYBRshx89b https://t.co/sIiAuxL3OE",
    created_at: "Fri Sep 15 22:58:30 +0000 2017",
    retweet_count: 14880,
    favorite_count: 57266,
    is_retweet: false,
    id_str: "908827394856947712"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Our hearts &amp; prayers go out to the people of London, who suffered a vicious terrorist attack.... https://t.co/Q2hTBV2l5t",
    created_at: "Fri Sep 15 20:54:52 +0000 2017",
    retweet_count: 14896,
    favorite_count: 66584,
    is_retweet: false,
    id_str: "908796281002307584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "NEVER forget our HEROES held prisoner or who have gone missing in action while serving their country.\nProclamation: https://t.co/4xBZGjAGj5 https://t.co/yZTr7rlpTV",
    created_at: "Fri Sep 15 19:02:43 +0000 2017",
    retweet_count: 13147,
    favorite_count: 52496,
    is_retweet: false,
    id_str: "908768057140629506"
  },
  {
    source: "Media Studio",
    text:
      "Frank “FX” Giaccio-\nOn behalf of @FLOTUS Melania &amp; myself, THANK YOU for doing a GREAT job this morning! @NatlParkService gives you an A+! https://t.co/135DxuapUI",
    created_at: "Fri Sep 15 16:49:31 +0000 2017",
    retweet_count: 33092,
    favorite_count: 116893,
    is_retweet: false,
    id_str: "908734537311678464"
  },
  {
    source: "Media Studio",
    text: "WEEKLY ADDRESS🇺🇸 https://t.co/MsaLA9POAt",
    created_at: "Fri Sep 15 16:09:10 +0000 2017",
    retweet_count: 10845,
    favorite_count: 42478,
    is_retweet: false,
    id_str: "908724382440284160"
  },
  {
    source: "Twitter for iPhone",
    text:
      "CHAIN MIGRATION cannot be allowed to be part of any legislation on Immigration!",
    created_at: "Fri Sep 15 13:00:48 +0000 2017",
    retweet_count: 18987,
    favorite_count: 76676,
    is_retweet: false,
    id_str: "908676979561570304"
  },
  {
    source: "Twitter for iPhone",
    text:
      "ESPN is paying a really big price for its politics (and bad programming). People are dumping it in RECORD numbers. Apologize for untruth!",
    created_at: "Fri Sep 15 11:20:08 +0000 2017",
    retweet_count: 28192,
    favorite_count: 112106,
    is_retweet: false,
    id_str: "908651641943003136"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We have made more progress in the last nine months against ISIS than the Obama Administration has made in 8 years.Must be proactive &amp; nasty!",
    created_at: "Fri Sep 15 11:00:01 +0000 2017",
    retweet_count: 21649,
    favorite_count: 101229,
    is_retweet: false,
    id_str: "908646582807089152"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The travel ban into the United States should be far larger, tougher and more specific-but stupidly, that would not be politically correct!",
    created_at: "Fri Sep 15 10:54:14 +0000 2017",
    retweet_count: 24579,
    favorite_count: 106622,
    is_retweet: false,
    id_str: "908645126146265090"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Loser terrorists must be dealt with in a much tougher manner.The internet is their main recruitment tool which we must cut off &amp; use better!",
    created_at: "Fri Sep 15 10:48:18 +0000 2017",
    retweet_count: 21411,
    favorite_count: 97462,
    is_retweet: false,
    id_str: "908643633901039617"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Another attack in London by a loser terrorist.These are sick and demented people who were in the sights of Scotland Yard. Must be proactive!",
    created_at: "Fri Sep 15 10:42:55 +0000 2017",
    retweet_count: 29327,
    favorite_count: 110223,
    is_retweet: false,
    id_str: "908642277987356673"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With the ridiculous Filibuster Rule in the Senate, Republicans need 60 votes to pass legislation, rather than 51. Can't get votes, END NOW!",
    created_at: "Fri Sep 15 10:37:38 +0000 2017",
    retweet_count: 12481,
    favorite_count: 53467,
    is_retweet: false,
    id_str: "908640949605163010"
  },
  {
    source: "Twitter for iPhone",
    text:
      "FLORIDA-\nJust like TX, WE are w/you today, we are w/you tomorrow, &amp; we will be w/you EVERY SINGLE DAY AFTER, to RESTORE, RECOVER, &amp; REBUILD! https://t.co/phRMudujxJ",
    created_at: "Fri Sep 15 00:55:05 +0000 2017",
    retweet_count: 12285,
    favorite_count: 58148,
    is_retweet: false,
    id_str: "908494344008749056"
  },
  {
    source: "Media Studio",
    text:
      "WE ARE WITH YOU FLORIDA!\n\nEmergency Information \n1-800-342-3557\nhttps://t.co/zbWkR5VmDp\n\nVolunteer \n1-800-FL-HELP-1\nhttps://t.co/ghkbVajBN0 https://t.co/2Jj85weO1U",
    created_at: "Thu Sep 14 21:11:18 +0000 2017",
    retweet_count: 13782,
    favorite_count: 53795,
    is_retweet: false,
    id_str: "908438028980490240"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...I told Republicans to approve healthcare fast or this would happen. But don't worry, I will veto because I love our country &amp; its people.",
    created_at: "Thu Sep 14 19:32:23 +0000 2017",
    retweet_count: 13299,
    favorite_count: 64966,
    is_retweet: false,
    id_str: "908413134196572161"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Bernie Sanders is pushing hard for a single payer healthcare plan - a curse on the U.S. &amp; its people...",
    created_at: "Thu Sep 14 19:31:55 +0000 2017",
    retweet_count: 17415,
    favorite_count: 73259,
    is_retweet: false,
    id_str: "908413019050463232"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Spoke to President of Mexico to give condolences on terrible earthquake. Unable to reach for 3 days b/c of his cell phone reception at site.",
    created_at: "Thu Sep 14 19:18:14 +0000 2017",
    retweet_count: 11340,
    favorite_count: 59066,
    is_retweet: false,
    id_str: "908409572943126528"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just left Florida for D.C. The people and spirit in THAT GREAT STATE is unbelievable. Damage horrific but will be better than ever!",
    created_at: "Thu Sep 14 19:04:22 +0000 2017",
    retweet_count: 10125,
    favorite_count: 60358,
    is_retweet: false,
    id_str: "908406085308096512"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Am leaving now for Florida to see our GREAT first responders and to thank the U.S. Coast Guard, FEMA etc. A real disaster, much work to do!",
    created_at: "Thu Sep 14 11:05:55 +0000 2017",
    retweet_count: 10775,
    favorite_count: 67205,
    is_retweet: false,
    id_str: "908285679335034880"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...They have been in our country for many years through no fault of their own - brought in by parents at young age. Plus BIG border security",
    created_at: "Thu Sep 14 10:35:41 +0000 2017",
    retweet_count: 10919,
    favorite_count: 53133,
    is_retweet: false,
    id_str: "908278070611779585"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Does anybody really want to throw out good, educated and accomplished young people who have jobs, some serving in the military? Really!.....",
    created_at: "Thu Sep 14 10:28:41 +0000 2017",
    retweet_count: 18471,
    favorite_count: 82554,
    is_retweet: false,
    id_str: "908276308265795585"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The WALL, which is already under construction in the form of new renovation of old and existing fences and walls, will continue to be built.",
    created_at: "Thu Sep 14 10:20:58 +0000 2017",
    retweet_count: 24085,
    favorite_count: 105068,
    is_retweet: false,
    id_str: "908274366739345409"
  },
  {
    source: "Twitter for iPhone",
    text:
      "No deal was made last night on DACA. Massive border security would have to be agreed to in exchange for consent. Would be subject to vote.",
    created_at: "Thu Sep 14 10:11:36 +0000 2017",
    retweet_count: 17444,
    favorite_count: 64610,
    is_retweet: false,
    id_str: "908272007011282944"
  },
  {
    source: "Twitter for iPhone",
    text:
      'The "deplorables" came back to haunt Hillary.They expressed their feelings loud and clear. She spent big money but, in the end, had no game!',
    created_at: "Thu Sep 14 02:52:34 +0000 2017",
    retweet_count: 20990,
    favorite_count: 94074,
    is_retweet: false,
    id_str: "908161523180285953"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Crooked Hillary Clinton blames everybody (and every thing) but herself for her election loss. She lost the debates and lost her direction!",
    created_at: "Thu Sep 14 02:47:23 +0000 2017",
    retweet_count: 26257,
    favorite_count: 114073,
    is_retweet: false,
    id_str: "908160218995068928"
  },
  {
    source: "Twitter for iPhone",
    text:
      "China has a business tax rate of 15%. We should do everything possible to match them in order to win with our economy. Jobs and wages!",
    created_at: "Thu Sep 14 02:22:57 +0000 2017",
    retweet_count: 17849,
    favorite_count: 76499,
    is_retweet: false,
    id_str: "908154067658174469"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With Irma and Harvey devastation, Tax Cuts and Tax Reform is needed more than ever before. Go Congress, go!",
    created_at: "Wed Sep 13 12:36:52 +0000 2017",
    retweet_count: 20177,
    favorite_count: 93742,
    is_retweet: false,
    id_str: "907946177022369792"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be traveling to Florida tomorrow to meet with our great Coast Guard, FEMA and many of the brave first responders &amp; others.",
    created_at: "Wed Sep 13 11:34:16 +0000 2017",
    retweet_count: 14812,
    favorite_count: 87319,
    is_retweet: false,
    id_str: "907930425657626624"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The approval process for the biggest Tax Cut &amp; Tax Reform package in the history of our country will soon begin. Move fast Congress!",
    created_at: "Wed Sep 13 11:28:10 +0000 2017",
    retweet_count: 17878,
    favorite_count: 80698,
    is_retweet: false,
    id_str: "907928888587808768"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was a great honor to welcome Prime Minister Najib Abdul Razak of Malaysia and his distinguished delegation to the @WhiteHouse today! https://t.co/3pWrBOh8dG",
    created_at: "Tue Sep 12 20:12:48 +0000 2017",
    retweet_count: 13955,
    favorite_count: 52354,
    is_retweet: false,
    id_str: "907698529606541312"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Congratulations to Eric &amp; Lara on the birth of their son, Eric "Luke" Trump this morning! https://t.co/Aw0AV82XdE',
    created_at: "Tue Sep 12 18:41:50 +0000 2017",
    retweet_count: 16958,
    favorite_count: 111516,
    is_retweet: false,
    id_str: "907675638055743489"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The devastation left by Hurricane Irma was far greater, at least in certain locations,than anyone thought - but amazing people working hard!",
    created_at: "Tue Sep 12 13:11:19 +0000 2017",
    retweet_count: 14735,
    favorite_count: 85323,
    is_retweet: false,
    id_str: "907592460070768641"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Fascinating to watch people writing books and major articles about me and yet they know nothing about me &amp; have zero access. #FAKE NEWS!",
    created_at: "Tue Sep 12 12:56:47 +0000 2017",
    retweet_count: 24187,
    favorite_count: 107606,
    is_retweet: false,
    id_str: "907588803161939968"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @LouDobbs: Making America Great Again- @Kellyannepolls: After #Irma @POTUS is focused on saving lives, not swamp shenanigans. #Dobbs #MA…",
    created_at: "Tue Sep 12 12:17:56 +0000 2017",
    retweet_count: 7631,
    favorite_count: 0,
    is_retweet: true,
    id_str: "907579024960098304"
  },
  {
    source: "Twitter for iPhone",
    text:
      "May God Forever Bless the United States of America. #NeverForget911 https://t.co/erycJgj23r",
    created_at: "Mon Sep 11 18:35:59 +0000 2017",
    retweet_count: 36633,
    favorite_count: 133936,
    is_retweet: false,
    id_str: "907311779331690496"
  },
  {
    source: "Twitter for iPhone",
    text: "#NeverForget https://t.co/rmQ1a5bDon",
    created_at: "Mon Sep 11 18:02:09 +0000 2017",
    retweet_count: 19251,
    favorite_count: 81914,
    is_retweet: false,
    id_str: "907303264458362880"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: Hurricane force winds hit Florida Keys. 390 shelters have been opened in Florida. Shelters near you➡️https://t.co/lL5pDP0N9D…",
    created_at: "Sun Sep 10 10:37:38 +0000 2017",
    retweet_count: 5494,
    favorite_count: 0,
    is_retweet: true,
    id_str: "906829008955957248"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @SecretarySonny: Serious @Cabinet meeting today, called by @POTUS at Camp David. Reports on #Irma's track, potential impact, fed &amp; state…",
    created_at: "Sun Sep 10 10:37:05 +0000 2017",
    retweet_count: 6338,
    favorite_count: 0,
    is_retweet: true,
    id_str: "906828871106002944"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @TravelGov: Continue to notify us of US citizens overseas impacted by #HurricaneIrma &amp; #HurricaneJose. https://t.co/EuIpTB144z https://t…",
    created_at: "Sun Sep 10 10:35:49 +0000 2017",
    retweet_count: 4394,
    favorite_count: 0,
    is_retweet: true,
    id_str: "906828550065582080"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @KellyannePolls: Love and prayers for friends Adrienne &amp; Eric Bolling. \n\nMay Eric Chase know eternal peace. https://t.co/rtoCsVpPGy",
    created_at: "Sun Sep 10 10:34:25 +0000 2017",
    retweet_count: 9156,
    favorite_count: 0,
    is_retweet: true,
    id_str: "906828199421767680"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @NYPDnews: Many supported NYers when Sandy hit. Now our NY Task Force-1 can be there to help others during Harvey &amp; #HurricaneIrma. Here…",
    created_at: "Sun Sep 10 10:33:42 +0000 2017",
    retweet_count: 6705,
    favorite_count: 0,
    is_retweet: true,
    id_str: "906828018651451392"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @seanhannity: @ericbolling To my dear friend, please know we all love you, will be here for you and your family.",
    created_at: "Sun Sep 10 10:32:36 +0000 2017",
    retweet_count: 11402,
    favorite_count: 0,
    is_retweet: true,
    id_str: "906827742632665094"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DonaldJTrumpJr: Great pic from a friend on @CBPflorida @CustomsBorder who have been helping with #harvey recovery and now with #irma. T…",
    created_at: "Sun Sep 10 10:28:19 +0000 2017",
    retweet_count: 5194,
    favorite_count: 0,
    is_retweet: true,
    id_str: "906826663484411905"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: Florida Governor Rick @FLGovScott. #HurricaineIrma https://t.co/ch3wx9HDMj",
    created_at: "Sun Sep 10 10:27:22 +0000 2017",
    retweet_count: 2808,
    favorite_count: 0,
    is_retweet: true,
    id_str: "906826427210792960"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @EricTrump: Please stay safe #Florida! You are in our thoughts and we are praying for you! 🇺🇸🇺🇸🇺🇸 https://t.co/B3998hZyHI",
    created_at: "Sun Sep 10 10:27:09 +0000 2017",
    retweet_count: 5672,
    favorite_count: 0,
    is_retweet: true,
    id_str: "906826370155720704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The U.S. Coast Guard, FEMA and all Federal and State brave people are ready. Here comes Irma. God bless everyone!",
    created_at: "Sun Sep 10 02:56:37 +0000 2017",
    retweet_count: 25075,
    favorite_count: 126385,
    is_retweet: false,
    id_str: "906712991940399104"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Heed the advice of @FLGovScott!\n\n\"If you're in an evacuation zone, you need to get to a shelter...there's not many hours left.\" Gov. Scott https://t.co/92W8ViNMUK",
    created_at: "Sun Sep 10 00:03:48 +0000 2017",
    retweet_count: 11360,
    favorite_count: 44856,
    is_retweet: false,
    id_str: "906669500984041472"
  },
  {
    source: "Media Studio",
    text:
      "This is a storm of enormous destructive power, and I ask everyone in the storm’s path to heed ALL instructions from government officials. https://t.co/nJfM2Sdme1",
    created_at: "Sat Sep 09 21:44:16 +0000 2017",
    retweet_count: 15094,
    favorite_count: 64650,
    is_retweet: false,
    id_str: "906634384702291968"
  },
  {
    source: "Twitter for iPhone",
    text:
      "FLORIDA- \nVisit https://t.co/pdBaD9t8SK to find shelters, road closures, &amp; evacuation routes. Helpful Twitter list: https://t.co/BUMVlxGFe8 https://t.co/ncnuqCeB5K",
    created_at: "Sat Sep 09 15:41:55 +0000 2017",
    retweet_count: 16347,
    favorite_count: 49234,
    is_retweet: false,
    id_str: "906543198599876608"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Churches in Texas should be entitled to reimbursement from FEMA Relief Funds for helping victims of Hurricane Harvey (just like others).",
    created_at: "Sat Sep 09 00:56:47 +0000 2017",
    retweet_count: 28990,
    favorite_count: 127726,
    is_retweet: false,
    id_str: "906320446882271232"
  },
  {
    source: "Media Studio",
    text:
      "A message to my fellow Americans🇺🇸#IrmaHurricane2017\n🎥https://t.co/jyg6AlyAAb\n🎥https://t.co/iPujtHzejr https://t.co/HCQ9kmKc4E",
    created_at: "Fri Sep 08 15:02:22 +0000 2017",
    retweet_count: 21133,
    favorite_count: 68359,
    is_retweet: false,
    id_str: "906170854362447875"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republicans must start the Tax Reform/Tax Cut legislation ASAP. Don't wait until the end of September. Needed now more than ever. Hurry!",
    created_at: "Fri Sep 08 12:57:11 +0000 2017",
    retweet_count: 20704,
    favorite_count: 79689,
    is_retweet: false,
    id_str: "906139352580972544"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...never allow the Republicans to pass even great legislation. 8 Dems control - will rarely get 60 (vs. 51) votes. It is a Repub Death Wish!",
    created_at: "Fri Sep 08 12:46:35 +0000 2017",
    retweet_count: 14829,
    favorite_count: 63330,
    is_retweet: false,
    id_str: "906136682952568832"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republicans, sorry, but I've been hearing about Repeal &amp; Replace for 7 years, didn't happen! Even worse, the Senate Filibuster Rule will....",
    created_at: "Fri Sep 08 12:41:32 +0000 2017",
    retweet_count: 17525,
    favorite_count: 70686,
    is_retweet: false,
    id_str: "906135414498631680"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Our incredible U.S. Coast Guard saved more than 15,000 lives last week with Harvey. Irma could be even tougher. We love our Coast Guard!",
    created_at: "Fri Sep 08 12:37:14 +0000 2017",
    retweet_count: 20615,
    favorite_count: 101114,
    is_retweet: false,
    id_str: "906134333467045888"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Hurricane Irma is of epic proportion, perhaps bigger than we have ever seen. Be safe and get out of its way,if possible. Federal G is ready!",
    created_at: "Fri Sep 08 12:34:13 +0000 2017",
    retweet_count: 14321,
    favorite_count: 63787,
    is_retweet: false,
    id_str: "906133573400481792"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We will confront ANY challenge, no matter how strong the winds or high the water. I’m proud to stand with Presidents for #OneAmericaAppeal.",
    created_at: "Fri Sep 08 01:33:38 +0000 2017",
    retweet_count: 15772,
    favorite_count: 80029,
    is_retweet: false,
    id_str: "905967331662319617"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I encourage EVERYONE in the path of #HurricaneIrma to heed the advice and orders of local &amp; state officials! https://t.co/AQmawTpZs0",
    created_at: "Fri Sep 08 00:57:52 +0000 2017",
    retweet_count: 19168,
    favorite_count: 67170,
    is_retweet: false,
    id_str: "905958330815926276"
  },
  {
    source: "Twitter for iPhone",
    text:
      "During my trip to Saudi Arabia, I spoke to the leaders of more than 50 Arab &amp; Muslim nations about the need to confront our shared enemies.. https://t.co/8oeAQfIeX8",
    created_at: "Thu Sep 07 20:18:42 +0000 2017",
    retweet_count: 10156,
    favorite_count: 42117,
    is_retweet: false,
    id_str: "905888075749974016"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Together, we will show the world that the forces of destruction and extremism are NO MATCH for the BLESSINGS of PROSPERITY and PEACE! https://t.co/aL6In83eWK",
    created_at: "Thu Sep 07 19:48:47 +0000 2017",
    retweet_count: 13855,
    favorite_count: 55694,
    is_retweet: false,
    id_str: "905880546185814016"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Welcome to the @WhiteHouse, Amir Sabah al-Ahmed al-Jaber al-Sabah of Kuwait! Joint press conference coming up soon: https://t.co/8T4Nyzlp4Y https://t.co/lfRa4AATaM",
    created_at: "Thu Sep 07 18:13:30 +0000 2017",
    retweet_count: 7763,
    favorite_count: 31422,
    is_retweet: false,
    id_str: "905856569329504256"
  },
  {
    source: "Twitter for iPhone",
    text:
      "For all of those (DACA) that are concerned about your status during the 6 month period, you have nothing to worry about - No action!",
    created_at: "Thu Sep 07 13:42:52 +0000 2017",
    retweet_count: 20287,
    favorite_count: 78769,
    is_retweet: false,
    id_str: "905788459301908480"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @GOP: .@IvankaTrump: This administration is committed to keeping working families at the forefront of our agenda.\nhttps://t.co/rHqFqUJGWI",
    created_at: "Thu Sep 07 12:53:07 +0000 2017",
    retweet_count: 5340,
    favorite_count: 0,
    is_retweet: true,
    id_str: "905775939862310912"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @WhiteHouse: The current tax code is a burden on American taxpayers and harmful to American job-creators. Learn more: https://t.co/w5eMl…",
    created_at: "Thu Sep 07 12:52:15 +0000 2017",
    retweet_count: 7201,
    favorite_count: 0,
    is_retweet: true,
    id_str: "905775722312212480"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @GOP: .@POTUS: I want to work with Congress, Republicans, and Democrats on a plan that is pro-growth, pro-jobs, pro-worker, and pro-Amer…",
    created_at: "Thu Sep 07 12:51:35 +0000 2017",
    retweet_count: 7856,
    favorite_count: 0,
    is_retweet: true,
    id_str: "905775554737078272"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you, our great honor! https://t.co/StrciEwuWs",
    created_at: "Thu Sep 07 12:51:12 +0000 2017",
    retweet_count: 12459,
    favorite_count: 46856,
    is_retweet: false,
    id_str: "905775458557538304"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Hurricane Irma is raging but we have great teams of talented and brave people already in place and ready to help. Be careful, be safe! #FEMA",
    created_at: "Thu Sep 07 12:33:12 +0000 2017",
    retweet_count: 16584,
    favorite_count: 81964,
    is_retweet: false,
    id_str: "905770927526432768"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We want our companies to hire &amp; grow in AMERICA, to raise wages for AMERICAN workers, &amp; to help rebuild our AMERICAN cities &amp; towns! #USA🇺🇸 https://t.co/sglubjcbW4",
    created_at: "Thu Sep 07 01:26:48 +0000 2017",
    retweet_count: 15232,
    favorite_count: 60633,
    is_retweet: false,
    id_str: "905603224379559936"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If we want to renew our PROSPERITY, restore OPPORTUNITY, &amp; re-establish our economic DOMINANCE, then we need tax reform that is pro-growth.. https://t.co/9NzLg2Qzpo",
    created_at: "Thu Sep 07 00:18:49 +0000 2017",
    retweet_count: 17172,
    favorite_count: 69771,
    is_retweet: false,
    id_str: "905586115440242689"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you for joining me in Mandan, ND Gov. @DougBurgum, Lt. Gov. @BrentSanfordND, @SenJohnHoeven, @RepKevinCramer &amp; @SenatorHeitkamp. https://t.co/8nIvtHvpu6",
    created_at: "Thu Sep 07 00:04:12 +0000 2017",
    retweet_count: 6481,
    favorite_count: 33283,
    is_retweet: false,
    id_str: "905582435538219011"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Wonderful to be in North Dakota with the incredible hardworking men &amp; women @ the Andeavor Refinery. \nFull remarks: 🎥https://t.co/uxBpyeERUm https://t.co/fV9R9gJxDS",
    created_at: "Wed Sep 06 23:20:48 +0000 2017",
    retweet_count: 8915,
    favorite_count: 42757,
    is_retweet: false,
    id_str: "905571513398693888"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just spoke w/ Governors Rick Scott of Florida, Kenneth Mapp of the U.S. Virgin Islands &amp; Ricardo Rosselló of Puerto Rico. WE ARE W/ YOU ALL! https://t.co/k92cslgKFa",
    created_at: "Wed Sep 06 19:26:09 +0000 2017",
    retweet_count: 18109,
    favorite_count: 72230,
    is_retweet: false,
    id_str: "905512462971232257"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'President Donald J. Trump Approves Emergency Declarations'\n\n➡️https://t.co/xSHSyNkvuP\n➡️https://t.co/UbBSFOhMM7\n➡️https://t.co/xWOfp9Z9iR https://t.co/qoJOM54Gy8",
    created_at: "Wed Sep 06 17:52:30 +0000 2017",
    retweet_count: 14665,
    favorite_count: 50510,
    is_retweet: false,
    id_str: "905488897186172928"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @VP: .@POTUS is committed to the health &amp; well-being of the US people &amp; we are confident Dr. Jerome Adams will succeed as our new surgeo…",
    created_at: "Wed Sep 06 11:37:18 +0000 2017",
    retweet_count: 11498,
    favorite_count: 0,
    is_retweet: true,
    id_str: "905394471969452032"
  },
  {
    source: "Twitter for iPhone",
    text: "Hurricane looks like largest ever recorded in the Atlantic!",
    created_at: "Wed Sep 06 10:53:45 +0000 2017",
    retweet_count: 13326,
    favorite_count: 59907,
    is_retweet: false,
    id_str: "905383515302264832"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Watching Hurricane closely. My team, which has done, and is doing, such a good job in Texas, is already in Florida. No rest for the weary!",
    created_at: "Wed Sep 06 10:51:52 +0000 2017",
    retweet_count: 5229,
    favorite_count: 109965,
    is_retweet: false,
    id_str: "905383039517282304"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Will be going to North Dakota today to discuss tax reform and tax cuts. We are the highest taxed nation in the world - that will change.",
    created_at: "Wed Sep 06 10:47:01 +0000 2017",
    retweet_count: 17766,
    favorite_count: 89928,
    is_retweet: false,
    id_str: "905381817695526912"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congress now has 6 months to legalize DACA (something the Obama Administration was unable to do). If they can't, I will revisit this issue!",
    created_at: "Wed Sep 06 00:38:27 +0000 2017",
    retweet_count: 24217,
    favorite_count: 92637,
    is_retweet: false,
    id_str: "905228667336499200"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I look forward to working w/ D's + R's in Congress to address immigration reform in a way that puts hardworking citizens of our country 1st.",
    created_at: "Tue Sep 05 20:45:27 +0000 2017",
    retweet_count: 24254,
    favorite_count: 104097,
    is_retweet: false,
    id_str: "905170032229056512"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @The_Trump_Train: @realDonaldTrump Make no mistake, we are going to put the interest of AMERICAN CITIZENS FIRST! \n\nThe forgotten men &amp; w…",
    created_at: "Tue Sep 05 12:50:00 +0000 2017",
    retweet_count: 17576,
    favorite_count: 0,
    is_retweet: true,
    id_str: "905050380484141056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am allowing Japan &amp; South Korea to buy a substantially increased amount of highly sophisticated military equipment from the United States.",
    created_at: "Tue Sep 05 12:36:57 +0000 2017",
    retweet_count: 33372,
    favorite_count: 125347,
    is_retweet: false,
    id_str: "905047095488516098"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DanScavino: 'Trump as Commander in Chief, Making the Hard Decisions' by LTG (Ret) Kellogg, a highly decorated Vietnam War Vet: https://…",
    created_at: "Tue Sep 05 12:07:09 +0000 2017",
    retweet_count: 5658,
    favorite_count: 0,
    is_retweet: true,
    id_str: "905039597050187777"
  },
  {
    source: "Twitter for iPhone",
    text: "Congress, get ready to do your job - DACA!",
    created_at: "Tue Sep 05 12:04:43 +0000 2017",
    retweet_count: 25910,
    favorite_count: 104531,
    is_retweet: false,
    id_str: "905038986883850240"
  },
  {
    source: "Twitter for iPhone",
    text: "Big week coming up!",
    created_at: "Tue Sep 05 02:49:26 +0000 2017",
    retweet_count: 26476,
    favorite_count: 99412,
    is_retweet: false,
    id_str: "904899243906879488"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We are building our future with American hands, American labor, American iron, aluminum and steel. Happy #LaborDay! https://t.co/lyvtNfQ5IO",
    created_at: "Mon Sep 04 16:38:46 +0000 2017",
    retweet_count: 27290,
    favorite_count: 120986,
    is_retweet: false,
    id_str: "904745562771259392"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The United States is considering, in addition to other options, stopping all trade with any country doing business with North Korea.",
    created_at: "Sun Sep 03 16:14:31 +0000 2017",
    retweet_count: 46856,
    favorite_count: 171720,
    is_retweet: false,
    id_str: "904377075049656322"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be meeting General Kelly, General Mattis and other military leaders at the White House to discuss North Korea. Thank you.",
    created_at: "Sun Sep 03 16:07:32 +0000 2017",
    retweet_count: 27471,
    favorite_count: 128967,
    is_retweet: false,
    id_str: "904375314830249984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "South Korea is finding, as I have told them, that their talk of appeasement with North Korea will not work, they only understand one thing!",
    created_at: "Sun Sep 03 11:46:07 +0000 2017",
    retweet_count: 25737,
    favorite_count: 93883,
    is_retweet: false,
    id_str: "904309527381716992"
  },
  {
    source: "Twitter for iPhone",
    text:
      "..North Korea is a rogue nation which has become a great threat and embarrassment to China, which is trying to help but with little success.",
    created_at: "Sun Sep 03 11:39:38 +0000 2017",
    retweet_count: 24112,
    favorite_count: 93269,
    is_retweet: false,
    id_str: "904307898213433344"
  },
  {
    source: "Twitter for iPhone",
    text:
      "North Korea has conducted a major Nuclear Test. Their words and actions continue to be very hostile and dangerous to the United States.....",
    created_at: "Sun Sep 03 11:30:41 +0000 2017",
    retweet_count: 28307,
    favorite_count: 94390,
    is_retweet: false,
    id_str: "904305644651634688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So much SPIRIT in LA! Thank you to all of our HEREOS who saved many lives. An honor to spend time w/ @NationalGuard, #LEOs &amp; the #CajunNavy! https://t.co/7PEtSL6RKF",
    created_at: "Sun Sep 03 05:17:04 +0000 2017",
    retweet_count: 19523,
    favorite_count: 79732,
    is_retweet: false,
    id_str: "904211620896886785"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Remember, Sunday is National Prayer Day (by Presidential Proclamation)!",
    created_at: "Sun Sep 03 03:02:31 +0000 2017",
    retweet_count: 33480,
    favorite_count: 132139,
    is_retweet: false,
    id_str: "904177758489776129"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just got back to the White House from the Great States of Texas and Louisiana, where things are going well. Such cooperation &amp; coordination!",
    created_at: "Sun Sep 03 02:57:43 +0000 2017",
    retweet_count: 15380,
    favorite_count: 91103,
    is_retweet: false,
    id_str: "904176553621307396"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Manufacturing Index rose to 59%, the highest level since early 2011 - and we can do much better!",
    created_at: "Sun Sep 03 02:50:58 +0000 2017",
    retweet_count: 13924,
    favorite_count: 69553,
    is_retweet: false,
    id_str: "904174851627286530"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @Team_Trump45: @realDonaldTrump  https://t.co/o1x6X2qQdM",
    created_at: "Sun Sep 03 02:42:36 +0000 2017",
    retweet_count: 24744,
    favorite_count: 0,
    is_retweet: true,
    id_str: "904172749135994882"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @ColumbiaBugle: @realDonaldTrump @FLOTUS President Trump greeting families affected by Hurricane Harvey. #TexasStrong https://t.co/5Ga3d…",
    created_at: "Sun Sep 03 02:41:40 +0000 2017",
    retweet_count: 7592,
    favorite_count: 0,
    is_retweet: true,
    id_str: "904172511222525955"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @ColumbiaBugle: @realDonaldTrump Love our @FLOTUS! https://t.co/6LT9mLAJ86",
    created_at: "Sun Sep 03 02:40:24 +0000 2017",
    retweet_count: 9085,
    favorite_count: 0,
    is_retweet: true,
    id_str: "904172194737123328"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Together, we will prevail in the GREAT state of Texas. We love you!\n\nGOD BLESS TEXAS &amp; GOD BLESS THE USA🇺🇸 https://t.co/1rzmEenQIb",
    created_at: "Sun Sep 03 01:55:30 +0000 2017",
    retweet_count: 42565,
    favorite_count: 140941,
    is_retweet: false,
    id_str: "904160894661296130"
  },
  {
    source: "Twitter for iPhone",
    text:
      "TEXAS: We are with you today, we are with you tomorrow, and we will be with you EVERY SINGLE DAY AFTER, to restore, recover, and REBUILD! https://t.co/p1Fh8jmmFA",
    created_at: "Sat Sep 02 16:56:51 +0000 2017",
    retweet_count: 26026,
    favorite_count: 110225,
    is_retweet: false,
    id_str: "904025340049285121"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Departing for Texas and Louisiana with @FLOTUS Melania right now @JBA_NAFW. We will see you soon. America is with you! https://t.co/z3bHVdJVPr",
    created_at: "Sat Sep 02 13:58:37 +0000 2017",
    retweet_count: 14873,
    favorite_count: 78403,
    is_retweet: false,
    id_str: "903980484966752257"
  },
  {
    source: "Twitter for iPhone",
    text:
      "On behalf of @FLOTUS Melania &amp; myself, THANK YOU for today's update &amp; GREAT WORK! #SouthernBaptist @SendRelief, @RedCross &amp; @SalvationArmyUS https://t.co/DLgFNiCxN2",
    created_at: "Sat Sep 02 00:34:32 +0000 2017",
    retweet_count: 13335,
    favorite_count: 62723,
    is_retweet: false,
    id_str: "903778130850131970"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be going to Texas and Louisiana tomorrow with First Lady. Great progress being made! Spending weekend working at White House.",
    created_at: "Sat Sep 02 00:03:00 +0000 2017",
    retweet_count: 17187,
    favorite_count: 100032,
    is_retweet: false,
    id_str: "903770196388831233"
  },
  {
    source: "Twitter for iPhone",
    text: "Stock Market up 5 months in a row!",
    created_at: "Fri Sep 01 23:47:38 +0000 2017",
    retweet_count: 17967,
    favorite_count: 95677,
    is_retweet: false,
    id_str: "903766326631698432"
  },
  {
    source: "Media Studio",
    text:
      "'President Donald J. Trump Proclaims September 3, 2017, as a National Day of Prayer' #HurricaneHarvey #PrayForTexas https://t.co/shen5JxChQ https://t.co/MpLB7WpxfT",
    created_at: "Fri Sep 01 19:47:23 +0000 2017",
    retweet_count: 24788,
    favorite_count: 79095,
    is_retweet: false,
    id_str: "903705867891204096"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Texas is healing fast thanks to all of the great men &amp; women who have been working so hard. But still so much to do. Will be back tomorrow!",
    created_at: "Fri Sep 01 12:58:48 +0000 2017",
    retweet_count: 18432,
    favorite_count: 98350,
    is_retweet: false,
    id_str: "903603043714957312"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...get things done at a record clip. Many big decisions to be made over the coming days and weeks. AMERICA FIRST!",
    created_at: "Fri Sep 01 12:47:46 +0000 2017",
    retweet_count: 13799,
    favorite_count: 69806,
    is_retweet: false,
    id_str: "903600265420578819"
  },
  {
    source: "Twitter for iPhone",
    text:
      "General John Kelly is doing a great job as Chief of Staff. I could not be happier or more impressed - and this Administration continues to..",
    created_at: "Fri Sep 01 12:35:27 +0000 2017",
    retweet_count: 13935,
    favorite_count: 76071,
    is_retweet: false,
    id_str: "903597166249246720"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Wow, looks like James Comey exonerated Hillary Clinton long before the investigation was over...and so much more. A rigged system!",
    created_at: "Fri Sep 01 11:56:45 +0000 2017",
    retweet_count: 42941,
    favorite_count: 137366,
    is_retweet: false,
    id_str: "903587428488839170"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Texas is heeling fast thanks to all of the great men &amp; women who have been working so hard. But still, so much to do. Will be back tomorrow!",
    created_at: "Fri Sep 01 11:50:34 +0000 2017",
    retweet_count: 4996,
    favorite_count: 22450,
    is_retweet: false,
    id_str: "903585873614303234"
  },
  {
    source: "Twitter for iPhone",
    text:
      "THANK YOU to all of the incredible HEROES in Texas. America is with you! #TexasStrong \nhttps://t.co/8N4ABo9Ihp",
    created_at: "Thu Aug 31 20:06:35 +0000 2017",
    retweet_count: 31751,
    favorite_count: 123076,
    is_retweet: false,
    id_str: "903348312421670912"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FoxNews: .@KellyannePolls on Harvey recovery: We hope when it comes to basic Hurricane Harvey funding that we can rely upon a nonpartis…",
    created_at: "Thu Aug 31 12:35:50 +0000 2017",
    retweet_count: 7231,
    favorite_count: 0,
    is_retweet: true,
    id_str: "903234878124249090"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @SecShulkin: Our Mobile Vet Center set up and ready to help #Veterans impacted by #HurricaneHarvey in Corpus Christi. https://t.co/P3qNX…",
    created_at: "Thu Aug 31 01:29:31 +0000 2017",
    retweet_count: 8566,
    favorite_count: 0,
    is_retweet: true,
    id_str: "903067192756928512"
  },
  {
    source: "Media Studio",
    text:
      "First responders have been doing heroic work. Their courage &amp; devotion has saved countless lives – they represent the very best of America! https://t.co/I0gvCQLTKO",
    created_at: "Thu Aug 31 01:00:50 +0000 2017",
    retweet_count: 23053,
    favorite_count: 101520,
    is_retweet: false,
    id_str: "903059975437733888"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IvankaTrump: We must reform our tax code so that all Americans can succeed in our modern economy &amp; achieve the American Dream! #TaxRefo…",
    created_at: "Thu Aug 31 00:50:13 +0000 2017",
    retweet_count: 10332,
    favorite_count: 0,
    is_retweet: true,
    id_str: "903057301032108032"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Texas &amp; Louisiana: We are w/ you today, we are w/ you tomorrow, &amp; we will be w/ you EVERY SINGLE DAY AFTER, to restore, recover, &amp; REBUILD! https://t.co/YQb82K2VSB",
    created_at: "Wed Aug 30 19:38:41 +0000 2017",
    retweet_count: 27108,
    favorite_count: 99389,
    is_retweet: false,
    id_str: "902978901223366656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Will be leaving for Missouri soon for a speech on tax cuts and tax reform - so badly needed!",
    created_at: "Wed Aug 30 13:42:20 +0000 2017",
    retweet_count: 14174,
    favorite_count: 83586,
    is_retweet: false,
    id_str: "902889225061896196"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After reading the false reporting and even ferocious anger in some dying magazines, it makes me wonder, WHY? All I want to do is #MAGA!",
    created_at: "Wed Aug 30 13:27:47 +0000 2017",
    retweet_count: 28527,
    favorite_count: 109867,
    is_retweet: false,
    id_str: "902885560552960000"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After witnessing first hand the horror &amp; devastation caused by Hurricane Harvey,my heart goes out even more so to the great people of Texas!",
    created_at: "Wed Aug 30 13:12:29 +0000 2017",
    retweet_count: 24876,
    favorite_count: 118782,
    is_retweet: false,
    id_str: "902881712010653697"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The U.S. has been talking to North Korea, and paying them extortion money, for 25 years. Talking is not the answer!",
    created_at: "Wed Aug 30 12:47:52 +0000 2017",
    retweet_count: 14522,
    favorite_count: 111271,
    is_retweet: false,
    id_str: "902875515534626817"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @BrazoriaCounty: https://t.co/sUTyXBzer9",
    created_at: "Tue Aug 29 16:06:57 +0000 2017",
    retweet_count: 15341,
    favorite_count: 0,
    is_retweet: true,
    id_str: "902563229968228353"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@foxandfriends   We are not looking to fill all of those positions. Don't need many of them - reduce size of government. @IngrahamAngle",
    created_at: "Tue Aug 29 12:26:55 +0000 2017",
    retweet_count: 17234,
    favorite_count: 80437,
    is_retweet: false,
    id_str: "902507855584092160"
  },
  {
    source: "Twitter for iPhone",
    text: "Leaving now for Texas!",
    created_at: "Tue Aug 29 12:10:30 +0000 2017",
    retweet_count: 22210,
    favorite_count: 143575,
    is_retweet: false,
    id_str: "902503724274331653"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @TheFive: "Trump just won on law &amp; order and now he\'s delivering the goods." -@jessebwatters #thefive',
    created_at: "Tue Aug 29 11:31:46 +0000 2017",
    retweet_count: 7469,
    favorite_count: 0,
    is_retweet: true,
    id_str: "902493977533968384"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @TXMilitary: #PhotosFromTheField: Aerial photos from our rescue crews earlier today. #Harvey #TMDHarvey @USNationalGuard https://t.co/fA…",
    created_at: "Tue Aug 29 11:22:57 +0000 2017",
    retweet_count: 7479,
    favorite_count: 0,
    is_retweet: true,
    id_str: "902491758235406346"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @NWSHouston: Historic flooding is still ongoing across the area. If evacuated, please DO NOT return home until authorities indicate it i…",
    created_at: "Tue Aug 29 11:22:40 +0000 2017",
    retweet_count: 5207,
    favorite_count: 0,
    is_retweet: true,
    id_str: "902491685720076288"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @GregAbbott_TX: Thanks to the Texas National Guard for their help to rescue flooded Texans. #HurricaneHarvey https://t.co/lhpJtAne10",
    created_at: "Mon Aug 28 13:13:16 +0000 2017",
    retweet_count: 12773,
    favorite_count: 0,
    is_retweet: true,
    id_str: "902157132270899200"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Inspire_Us: No color, no religion, no nationality should come between us, we are all children of God. - Mother Teresa",
    created_at: "Mon Aug 28 13:11:47 +0000 2017",
    retweet_count: 12688,
    favorite_count: 0,
    is_retweet: true,
    id_str: "902156761901264896"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @KatiePavlich: Your boss pardoned a traitor who gave U.S. enemies state secrets, he also pardoned a terrorist who killed Americans. Spar…",
    created_at: "Mon Aug 28 13:08:54 +0000 2017",
    retweet_count: 27208,
    favorite_count: 0,
    is_retweet: true,
    id_str: "902156034348904450"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DineshDSouza: Finally, as if by accident, the @washingtonpost breaks down &amp; admits the truth about where the violence is coming from ht…",
    created_at: "Mon Aug 28 13:08:39 +0000 2017",
    retweet_count: 31015,
    favorite_count: 0,
    is_retweet: true,
    id_str: "902155972990382081"
  },
  {
    source: "Twitter for iPhone",
    text:
      "HISTORIC rainfall in Houston, and all over Texas. Floods are unprecedented, and more rain coming. Spirit of the people is incredible.Thanks!",
    created_at: "Sun Aug 27 23:01:06 +0000 2017",
    retweet_count: 22608,
    favorite_count: 109527,
    is_retweet: false,
    id_str: "901942677461229569"
  },
  {
    source: "Twitter for iPhone",
    text: "Major rescue operations underway!",
    created_at: "Sun Aug 27 14:39:32 +0000 2017",
    retweet_count: 15578,
    favorite_count: 84755,
    is_retweet: false,
    id_str: "901816453736919040"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Going to a Cabinet Meeting (tele-conference) at 11:00 A.M. on #Harvey. Even experts have said they've never seen one like this!",
    created_at: "Sun Aug 27 14:31:35 +0000 2017",
    retweet_count: 11065,
    favorite_count: 54940,
    is_retweet: false,
    id_str: "901814456505831424"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We are in the NAFTA (worst trade deal ever made) renegotiation process with Mexico &amp; Canada.Both being very difficult,may have to terminate?",
    created_at: "Sun Aug 27 13:51:35 +0000 2017",
    retweet_count: 19214,
    favorite_count: 82758,
    is_retweet: false,
    id_str: "901804388649500672"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With Mexico being one of the highest crime Nations in the world, we must have THE WALL. Mexico will pay for it through reimbursement/other.",
    created_at: "Sun Aug 27 13:44:11 +0000 2017",
    retweet_count: 26925,
    favorite_count: 103497,
    is_retweet: false,
    id_str: "901802524981817344"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Wow - Now experts are calling #Harvey a once in 500 year flood! We have an all out effort going, and going well!",
    created_at: "Sun Aug 27 13:25:50 +0000 2017",
    retweet_count: 13312,
    favorite_count: 62989,
    is_retweet: false,
    id_str: "901797906046439426"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will also be going to a wonderful state, Missouri, that I won by a lot in '16. Dem C.M. is opposed to big tax cuts. Republican will win S!",
    created_at: "Sun Aug 27 13:15:18 +0000 2017",
    retweet_count: 12499,
    favorite_count: 68292,
    is_retweet: false,
    id_str: "901795255086968833"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be going to Texas as soon as that trip can be made without causing disruption. The focus must be life and safety.",
    created_at: "Sun Aug 27 12:59:56 +0000 2017",
    retweet_count: 22982,
    favorite_count: 112926,
    is_retweet: false,
    id_str: "901791391130554370"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Many people are now saying that this is the worst storm/hurricane they have ever seen. Good news is that we have great talent on the ground.",
    created_at: "Sun Aug 27 12:25:54 +0000 2017",
    retweet_count: 10653,
    favorite_count: 61923,
    is_retweet: false,
    id_str: "901782823522185218"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great coordination between agencies at all levels of government. Continuing rains and flash floods are being dealt with. Thousands rescued.",
    created_at: "Sun Aug 27 12:04:05 +0000 2017",
    retweet_count: 14243,
    favorite_count: 79142,
    is_retweet: false,
    id_str: "901777333513854976"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A great book by a great guy, highly recommended! https://t.co/3jbDDN8YmJ",
    created_at: "Sun Aug 27 11:45:04 +0000 2017",
    retweet_count: 14066,
    favorite_count: 56138,
    is_retweet: false,
    id_str: "901772550405070848"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Wonderful coordination between Federal, State and Local Governments in the Great State of Texas - TEAMWORK! Record setting rainfall.",
    created_at: "Sat Aug 26 22:57:22 +0000 2017",
    retweet_count: 18560,
    favorite_count: 93444,
    is_retweet: false,
    id_str: "901579350662938624"
  },
  {
    source: "Twitter for iPhone",
    text:
      "THANK YOU to all of the great volunteers helping out with #HurricaneHarvey relief in Texas! https://t.co/Ds95oSgo8f",
    created_at: "Sat Aug 26 19:46:30 +0000 2017",
    retweet_count: 17056,
    favorite_count: 74246,
    is_retweet: false,
    id_str: "901531320052051971"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Closely monitoring #HurricaneHarvey from Camp David. We are leaving nothing to chance. City, State and Federal Govs. working great together!",
    created_at: "Sat Aug 26 11:52:19 +0000 2017",
    retweet_count: 14595,
    favorite_count: 78264,
    is_retweet: false,
    id_str: "901411986302488576"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@ChuckGrassley - got your message loud and clear. We have fantastic people on the ground, got there long before #Harvey. So far, so good!",
    created_at: "Sat Aug 26 11:32:44 +0000 2017",
    retweet_count: 11097,
    favorite_count: 56514,
    is_retweet: false,
    id_str: "901407059547226112"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @VP: All Americans in harms way need to be prepared and should continue visiting https://t.co/2H22XpTtPj for critical updates on #Hurric…",
    created_at: "Sat Aug 26 11:23:50 +0000 2017",
    retweet_count: 6879,
    favorite_count: 0,
    is_retweet: true,
    id_str: "901404817008021505"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @EPAScottPruitt: Thoughts and prayers for those in Texas &amp; Louisiana. I am closely monitoring #Harvey developments along with @fema &amp; @E…",
    created_at: "Sat Aug 26 11:22:32 +0000 2017",
    retweet_count: 4631,
    favorite_count: 0,
    is_retweet: true,
    id_str: "901404488610787328"
  },
  {
    source: "Twitter for iPhone",
    text:
      "You are doing a great job - the world is watching! Be safe. https://t.co/PJLdxy3hD9",
    created_at: "Sat Aug 26 11:21:54 +0000 2017",
    retweet_count: 8828,
    favorite_count: 47886,
    is_retweet: false,
    id_str: "901404330024218624"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @GovAbbott: To ensure your safety ahead of #Harvey heed warnings from local officials &amp; review important safety information. https://t.c…",
    created_at: "Sat Aug 26 11:17:16 +0000 2017",
    retweet_count: 3682,
    favorite_count: 0,
    is_retweet: true,
    id_str: "901403166658498560"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We will remain fully engaged w/ open lines of communication as #HurricaneHarvey makes landfall. America is w/ you! @GovAbbott @FEMA @DHSgov https://t.co/PryIqRxgLr",
    created_at: "Sat Aug 26 04:47:27 +0000 2017",
    retweet_count: 12145,
    favorite_count: 51941,
    is_retweet: false,
    id_str: "901305065885114368"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am pleased to inform you that I have just granted a full Pardon to 85 year old American patriot Sheriff Joe Arpaio. He kept Arizona safe!",
    created_at: "Sat Aug 26 02:00:33 +0000 2017",
    retweet_count: 35477,
    favorite_count: 149540,
    is_retweet: false,
    id_str: "901263061511794688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @realDonaldTrump: At the request of the Governor of Texas, I have signed the Disaster Proclamation, which unleashes the full force of go…",
    created_at: "Sat Aug 26 01:48:01 +0000 2017",
    retweet_count: 1096,
    favorite_count: 0,
    is_retweet: true,
    id_str: "901259908137594881"
  },
  {
    source: "Twitter for iPhone",
    text:
      "At the request of the Governor of Texas, I have signed the Disaster Proclamation, which unleashes the full force of government help!",
    created_at: "Sat Aug 26 01:46:26 +0000 2017",
    retweet_count: 29500,
    favorite_count: 140436,
    is_retweet: false,
    id_str: "901259509632573440"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Storm turned Hurricane is getting much bigger and more powerful than projected. Federal Government is on site and ready to respond. Be safe!",
    created_at: "Fri Aug 25 22:12:11 +0000 2017",
    retweet_count: 21047,
    favorite_count: 104230,
    is_retweet: false,
    id_str: "901205593054162945"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just arrived at Camp David, where I am monitoring the path and doings of Hurricane Harvey (as it strengthens to a Class 3). 125 MPH winds!",
    created_at: "Fri Aug 25 21:12:08 +0000 2017",
    retweet_count: 11585,
    favorite_count: 66588,
    is_retweet: false,
    id_str: "901190479798312961"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just arrived at Camp David where I am closely watching the path and doings of Hurricane Harvey, as it strengthens to a Category 3. BE SAFE!",
    created_at: "Fri Aug 25 21:03:11 +0000 2017",
    retweet_count: 10741,
    favorite_count: 61805,
    is_retweet: false,
    id_str: "901188228174184448"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I encourage everyone in the path of #HurricaneHarvey to heed the advice &amp; orders of their local and state officials. https://t.co/N6uEWCZUrv",
    created_at: "Fri Aug 25 19:18:49 +0000 2017",
    retweet_count: 12935,
    favorite_count: 52857,
    is_retweet: false,
    id_str: "901161964994539520"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Received a #HurricaneHarvey briefing this morning from Acting @DHSgov Secretary Elaine Duke, @FEMA_Brock, @TomBossert45 and COS John Kelly. https://t.co/cnkRZd6D6Z",
    created_at: "Fri Aug 25 16:02:33 +0000 2017",
    retweet_count: 8523,
    favorite_count: 39543,
    is_retweet: false,
    id_str: "901112569322237952"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I have spoken w/ @GovAbbott of Texas and @LouisianaGov Edwards. Closely monitoring #HurricaneHarvey developments &amp; here to assist as needed.",
    created_at: "Fri Aug 25 15:46:40 +0000 2017",
    retweet_count: 12804,
    favorite_count: 59752,
    is_retweet: false,
    id_str: "901108572041433089"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Strange statement by Bob Corker considering that he is constantly asking me whether or not he should run again in '18. Tennessee not happy!",
    created_at: "Fri Aug 25 12:25:10 +0000 2017",
    retweet_count: 14378,
    favorite_count: 62953,
    is_retweet: false,
    id_str: "901057864516734978"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Nick Adams, "Retaking America"  "Best things of this presidency aren\'t reported about. Convinced this will be perhaps best presidency ever."',
    created_at: "Fri Aug 25 11:32:23 +0000 2017",
    retweet_count: 15734,
    favorite_count: 70475,
    is_retweet: false,
    id_str: "901044579750825985"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Few, if any, Administrations have done more in just 7 months than the Trump A. Bills passed, regulations killed, border, military, ISIS, SC!",
    created_at: "Fri Aug 25 10:44:17 +0000 2017",
    retweet_count: 15923,
    favorite_count: 73282,
    is_retweet: false,
    id_str: "901032475111116800"
  },
  {
    source: "Twitter for iPhone",
    text:
      "General John Kelly is doing a fantastic job as Chief of Staff. There is tremendous spirit and talent in the W.H. Don't believe the Fake News",
    created_at: "Fri Aug 25 10:40:32 +0000 2017",
    retweet_count: 18519,
    favorite_count: 86788,
    is_retweet: false,
    id_str: "901031532164468736"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If Senate Republicans don't get rid of the Filibuster Rule and go to a 51% majority, few bills will be passed. 8 Dems control the Senate!",
    created_at: "Fri Aug 25 10:33:32 +0000 2017",
    retweet_count: 17757,
    favorite_count: 68559,
    is_retweet: false,
    id_str: "901029770401546243"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @EricTrump: Honored to speak at the RNC Summer Meeting in Nashville Tennessee this evening! @GOP #MAGA @GOPChairwoman 🇺🇸🇺🇸🇺🇸 https://t.c…",
    created_at: "Fri Aug 25 10:25:06 +0000 2017",
    retweet_count: 5652,
    favorite_count: 0,
    is_retweet: true,
    id_str: "901027651216969728"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @GregAbbott_TX: Spoke with Pres. Trump &amp; heads of Homeland Security &amp; FEMA. They're helping Texas respond to #HurricaneHarvey. https://t…",
    created_at: "Fri Aug 25 03:23:34 +0000 2017",
    retweet_count: 10257,
    favorite_count: 0,
    is_retweet: true,
    id_str: "900921565868687360"
  },
  {
    source: "Media Studio",
    text:
      "A GREAT HONOR to spend time with our BRAVE HEROES at the @USMC Air Station Yuma. THANK YOU for your service to the United States of America! https://t.co/4lJ94nxODu",
    created_at: "Fri Aug 25 00:21:42 +0000 2017",
    retweet_count: 12389,
    favorite_count: 61284,
    is_retweet: false,
    id_str: "900875799292776448"
  },
  {
    source: "Media Studio",
    text:
      "A great honor to spend time with our brave HEROES at the @USMC Air Station Yuma. THANK YOU for your service to the United Staes of America! https://t.co/FUtGBoTJLo",
    created_at: "Thu Aug 24 22:39:59 +0000 2017",
    retweet_count: 4894,
    favorite_count: 21541,
    is_retweet: false,
    id_str: "900850201384157184"
  },
  {
    source: "Media Studio",
    text:
      "As #HurricaneHarvey intensifies - remember to #PlanAhead. \n☑️https://t.co/FMdmvohypy\n☑️https://t.co/YL56ldeqoW \n☑️https://t.co/t1s4AL3B47 https://t.co/tpXmOK70ug",
    created_at: "Thu Aug 24 19:31:00 +0000 2017",
    retweet_count: 15548,
    favorite_count: 55955,
    is_retweet: false,
    id_str: "900802642779267077"
  },
  {
    source: "Media Studio",
    text:
      "On Tuesday, I visited with the incredible men &amp; women of @ICEgov &amp; @DHSgov Border Patrol in Yuma, AZ. Thank you. We respect &amp; cherish you! https://t.co/KSQddGqWzJ",
    created_at: "Thu Aug 24 17:13:38 +0000 2017",
    retweet_count: 12623,
    favorite_count: 57465,
    is_retweet: false,
    id_str: "900768072503623680"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The only problem I have with Mitch McConnell is that, after hearing Repeal &amp; Replace for 7 years, he failed!That should NEVER have happened!",
    created_at: "Thu Aug 24 13:42:41 +0000 2017",
    retweet_count: 25299,
    favorite_count: 107399,
    is_retweet: false,
    id_str: "900714982823821313"
  },
  {
    source: "Twitter for iPhone",
    text:
      "James Clapper, who famously got caught lying to Congress, is now an authority on Donald Trump. Will he show you his beautiful letter to me?",
    created_at: "Thu Aug 24 13:15:22 +0000 2017",
    retweet_count: 22501,
    favorite_count: 77757,
    is_retweet: false,
    id_str: "900708110330978304"
  },
  {
    source: "Twitter for iPhone",
    text:
      "..(enthusiastic, dynamic and fun) and the American Legion - V.A. (respectful and strong). Too bad the Dems have no one who can change tones!",
    created_at: "Thu Aug 24 13:15:00 +0000 2017",
    retweet_count: 10967,
    favorite_count: 55215,
    is_retweet: false,
    id_str: "900708017909506048"
  },
  {
    source: "Twitter for iPhone",
    text:
      "James Clapper, who famously got caught lying to Congress, is now an authority on Donald Trump. Will he show you his beautiful letter to me?",
    created_at: "Thu Aug 24 13:10:20 +0000 2017",
    retweet_count: 1027,
    favorite_count: 3409,
    is_retweet: false,
    id_str: "900706843445612544"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...(enthusiastic, dynamic and fun) and the American Legion - V.A. (respectful and strong). To bad the Dems have no one who can change tones!",
    created_at: "Thu Aug 24 13:07:49 +0000 2017",
    retweet_count: 1014,
    favorite_count: 4467,
    is_retweet: false,
    id_str: "900706210042830848"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News is now complaining about my different types of back to back speeches. Well, there was Afghanistan (somber), the big Rally.....",
    created_at: "Thu Aug 24 13:07:34 +0000 2017",
    retweet_count: 14865,
    favorite_count: 69995,
    is_retweet: false,
    id_str: "900706146943717377"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...(enthusiastic, dynamic and fun) and the American Legion - V.A. (respectful and strong).To bad the Dems have no one who can change tones!",
    created_at: "Thu Aug 24 12:51:03 +0000 2017",
    retweet_count: 1815,
    favorite_count: 7696,
    is_retweet: false,
    id_str: "900701990312972289"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News is now complaining about my different types of back to back speeches. Well, their was Afghanistan (somber), the big Rally.....",
    created_at: "Thu Aug 24 12:41:14 +0000 2017",
    retweet_count: 2763,
    favorite_count: 11091,
    is_retweet: false,
    id_str: "900699520304066561"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @JerryTravone: @realDonaldTrump  https://t.co/6XJxEg1gSs",
    created_at: "Thu Aug 24 12:33:32 +0000 2017",
    retweet_count: 27013,
    favorite_count: 0,
    is_retweet: true,
    id_str: "900697580946034688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...didn't do it so now we have a big deal with Dems holding them up (as usual) on Debt Ceiling approval. Could have been so easy-now a mess!",
    created_at: "Thu Aug 24 12:25:03 +0000 2017",
    retweet_count: 13570,
    favorite_count: 62462,
    is_retweet: false,
    id_str: "900695448465399809"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I requested that Mitch M &amp; Paul R tie the Debt Ceiling legislation into the popular V.A. Bill (which just passed) for easy approval. They...",
    created_at: "Thu Aug 24 12:19:45 +0000 2017",
    retweet_count: 18169,
    favorite_count: 66284,
    is_retweet: false,
    id_str: "900694112940290049"
  },
  {
    source: "Media Studio",
    text:
      "Donald E. Ballard, on behalf of the people of the United States, THANK YOU for your courageous service. YOU INSPIRE US ALL! #ALConv2017 https://t.co/46m20cJkLB",
    created_at: "Thu Aug 24 00:52:51 +0000 2017",
    retweet_count: 12692,
    favorite_count: 59518,
    is_retweet: false,
    id_str: "900521251768213505"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A great honor to sign the Veterans Appeals Improvement &amp; Modernization Act into law w/ @AmericanLegion @SecShulkin.\n🎥https://t.co/fr2sf9oRvd https://t.co/bICsRm1tQx",
    created_at: "Wed Aug 23 22:41:19 +0000 2017",
    retweet_count: 11164,
    favorite_count: 49437,
    is_retweet: false,
    id_str: "900488148194516992"
  },
  {
    source: "Twitter for iPhone",
    text:
      "As long as we have faith in each other and confidence in our values, then there is no challenge too great for us to conquer! #ALConv2017 https://t.co/tsIAgHbFM7",
    created_at: "Wed Aug 23 19:10:13 +0000 2017",
    retweet_count: 17285,
    favorite_count: 72958,
    is_retweet: false,
    id_str: "900435023517499392"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If Republican Senate doesn't get rid of the Filibuster Rule &amp; go to a simple majority, which the Dems would do, they are just wasting time!",
    created_at: "Wed Aug 23 13:50:52 +0000 2017",
    retweet_count: 20059,
    favorite_count: 81165,
    is_retweet: false,
    id_str: "900354657133801474"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Last night in Phoenix I read the things from my statements on Charlottesville that the Fake News Media didn't cover fairly. People got it!",
    created_at: "Wed Aug 23 13:40:31 +0000 2017",
    retweet_count: 19691,
    favorite_count: 91085,
    is_retweet: false,
    id_str: "900352052068401154"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Phoenix crowd last night was amazing - a packed house. I love the Great State of Arizona. Not a fan of Jeff Flake, weak on crime &amp; border!",
    created_at: "Wed Aug 23 13:20:15 +0000 2017",
    retweet_count: 20194,
    favorite_count: 96417,
    is_retweet: false,
    id_str: "900346953120141312"
  },
  {
    source: "Media Studio",
    text: "MAKE AMERICA GREAT AGAIN! https://t.co/RzePiucV3h",
    created_at: "Wed Aug 23 07:01:01 +0000 2017",
    retweet_count: 16193,
    favorite_count: 68634,
    is_retweet: false,
    id_str: "900251514324647936"
  },
  {
    source: "Twitter for iPhone",
    text: "#DrainTheSwamp #PhoenixRally https://t.co/o7S6xoCBiC",
    created_at: "Wed Aug 23 06:00:39 +0000 2017",
    retweet_count: 11193,
    favorite_count: 51696,
    is_retweet: false,
    id_str: "900236323893673984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Not only does the media give a platform to hate groups, but the media turns a blind eye to the gang violence on our streets! https://t.co/Mau0B1qYIP",
    created_at: "Wed Aug 23 05:32:50 +0000 2017",
    retweet_count: 27775,
    favorite_count: 98412,
    is_retweet: false,
    id_str: "900229323801735168"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you Arizona. Beautiful turnout of 15,000 in Phoenix tonight! Full coverage of rally via my Facebook at: https://t.co/s0D12EFs40 https://t.co/WT4D9Vsen1",
    created_at: "Wed Aug 23 05:18:29 +0000 2017",
    retweet_count: 13248,
    favorite_count: 58229,
    is_retweet: false,
    id_str: "900225712522657792"
  },
  {
    source: "Media Studio",
    text:
      "THANK YOU to all of the great men and women at the U.S. Customs and Border Protection facility in Yuma, Arizona &amp; around the United States! https://t.co/tjFx8XjhDz",
    created_at: "Wed Aug 23 00:20:52 +0000 2017",
    retweet_count: 20358,
    favorite_count: 91008,
    is_retweet: false,
    id_str: "900150814081036288"
  },
  {
    source: "Media Studio",
    text:
      "We will push onward to victory w/hope in our hearts, courage in our souls &amp; everlasting pride in each &amp; every one of you. God Bless America. https://t.co/44QYFSq07a",
    created_at: "Tue Aug 22 23:12:04 +0000 2017",
    retweet_count: 16631,
    favorite_count: 70736,
    is_retweet: false,
    id_str: "900133498723237888"
  },
  {
    source: "Twitter for iPhone",
    text:
      "See you at 7:00 P.M. tonight Phoenix, Arizona! #MAGA🇺🇸\nTickets: https://t.co/2kUQfKqbsx https://t.co/1w3LVkpESE",
    created_at: "Tue Aug 22 20:03:41 +0000 2017",
    retweet_count: 8768,
    favorite_count: 42424,
    is_retweet: false,
    id_str: "900086092107571200"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We pray for our fallen heroes who died while serving our country in the @USNavy aboard the  #USSJohnSMcCain, and their families. https://t.co/t3kD8qj9Mt",
    created_at: "Tue Aug 22 19:15:40 +0000 2017",
    retweet_count: 16214,
    favorite_count: 71070,
    is_retweet: false,
    id_str: "900074005205528578"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Was with great people last night in Fort Myer, Virginia. The future of our country is strong!",
    created_at: "Tue Aug 22 10:46:29 +0000 2017",
    retweet_count: 15407,
    favorite_count: 90990,
    is_retweet: false,
    id_str: "899945866991206400"
  },
  {
    source: "Media Studio",
    text:
      "Address to the Nation\nFull Video &amp; Transcript:\nhttps://t.co/FELdImTuUM https://t.co/6ly3fNatiX",
    created_at: "Tue Aug 22 03:50:09 +0000 2017",
    retweet_count: 13820,
    favorite_count: 54577,
    is_retweet: false,
    id_str: "899841094761848832"
  },
  {
    source: "Media Studio",
    text:
      "Thank you to the men and women of Fort Myer, and every member of the U.S. Military at home and abroad. #USA🇺🇸 https://t.co/ticezYKkhz",
    created_at: "Tue Aug 22 03:20:50 +0000 2017",
    retweet_count: 15249,
    favorite_count: 75023,
    is_retweet: false,
    id_str: "899833714363949056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @marcorubio: Good #AfghanStrategy &amp; excellent speech by @POTUS laying it out to the nation.",
    created_at: "Tue Aug 22 03:01:28 +0000 2017",
    retweet_count: 8149,
    favorite_count: 0,
    is_retweet: true,
    id_str: "899828842075967489"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me live from Fort Myer in Arlington, Virginia. \n➡️https://t.co/LOV4StdJDj",
    created_at: "Tue Aug 22 01:00:10 +0000 2017",
    retweet_count: 6161,
    favorite_count: 42590,
    is_retweet: false,
    id_str: "899798313997926401"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you, the very dishonest Fake News Media is out of control! https://t.co/8J7y900VGK",
    created_at: "Mon Aug 21 13:32:06 +0000 2017",
    retweet_count: 20686,
    favorite_count: 87097,
    is_retweet: false,
    id_str: "899625157421039616"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Jerry Falwell of Liberty University was fantastic on @foxandfriends. The Fake News should listen to what he had to say. Thanks Jerry!",
    created_at: "Mon Aug 21 13:27:12 +0000 2017",
    retweet_count: 15972,
    favorite_count: 76326,
    is_retweet: false,
    id_str: "899623926082535425"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thoughts &amp; prayers are w/ our @USNavy sailors aboard the #USSJohnSMcCain where search &amp; rescue efforts are underway. https://t.co/DQU0zTRXNU",
    created_at: "Mon Aug 21 03:01:01 +0000 2017",
    retweet_count: 20975,
    favorite_count: 86029,
    is_retweet: false,
    id_str: "899466340238491648"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Heading back to Washington after working hard and watching some of the worst and most dishonest Fake News reporting I have ever seen!",
    created_at: "Sun Aug 20 23:22:07 +0000 2017",
    retweet_count: 28832,
    favorite_count: 130525,
    is_retweet: false,
    id_str: "899411254061694979"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I want to applaud the many protestors in Boston who are speaking out against bigotry and hate. Our country will soon come together as one!",
    created_at: "Sat Aug 19 20:41:49 +0000 2017",
    retweet_count: 33075,
    favorite_count: 158317,
    is_retweet: false,
    id_str: "899008521726861312"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Our great country has been divided for decades. Sometimes you need protest in order to heal, &amp; we will heal, &amp; be stronger than ever before!",
    created_at: "Sat Aug 19 20:41:15 +0000 2017",
    retweet_count: 28852,
    favorite_count: 142264,
    is_retweet: false,
    id_str: "899008381226299392"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Our great country has been divided for decades. Sometimes you need protest in order to heel, &amp; we will heel, &amp; be stronger than ever before!",
    created_at: "Sat Aug 19 20:34:44 +0000 2017",
    retweet_count: 1958,
    favorite_count: 6690,
    is_retweet: false,
    id_str: "899006740410269696"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great job by all law enforcement officers and Boston Mayor @Marty_Walsh.",
    created_at: "Sat Aug 19 19:29:29 +0000 2017",
    retweet_count: 15167,
    favorite_count: 83507,
    is_retweet: false,
    id_str: "898990321387925504"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Looks like many anti-police agitators in Boston. Police are looking tough and smart! Thank you.",
    created_at: "Sat Aug 19 19:22:47 +0000 2017",
    retweet_count: 25591,
    favorite_count: 124513,
    is_retweet: false,
    id_str: "898988632551370753"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Steve Bannon will be a tough and smart new voice at @BreitbartNews...maybe even better than ever before. Fake News needs the competition!",
    created_at: "Sat Aug 19 17:47:26 +0000 2017",
    retweet_count: 28313,
    favorite_count: 106751,
    is_retweet: false,
    id_str: "898964640817983488"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Important day spent at Camp David with our very talented Generals and military leaders. Many decisions made, including on Afghanistan.",
    created_at: "Sat Aug 19 11:47:31 +0000 2017",
    retweet_count: 16128,
    favorite_count: 85976,
    is_retweet: false,
    id_str: "898874064722427904"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I want to thank Steve Bannon for his service. He came to the campaign during my run against Crooked Hillary Clinton - it was great! Thanks S",
    created_at: "Sat Aug 19 11:33:51 +0000 2017",
    retweet_count: 25380,
    favorite_count: 119211,
    is_retweet: false,
    id_str: "898870621584596993"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My thoughts and prayers are with the @KissimmeePolice and their loved ones. We are with you!\n#LESM",
    created_at: "Sat Aug 19 04:59:01 +0000 2017",
    retweet_count: 21668,
    favorite_count: 95033,
    is_retweet: false,
    id_str: "898771262453026816"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today, I signed the Global War on Terrorism War Memorial Act (#HR873.) The bill authorizes....cont➡️https://t.co/c3zIkdtowc https://t.co/re6n0MS0cj",
    created_at: "Sat Aug 19 01:30:58 +0000 2017",
    retweet_count: 14892,
    favorite_count: 63149,
    is_retweet: false,
    id_str: "898718902200418306"
  },
  {
    source: "Media Studio",
    text:
      "Just returned to Bedminster, NJ from Camp David. GREAT meeting on National Security, the Border and the Military! #MAGA🇺🇸 https://t.co/Hjmcnnse9j",
    created_at: "Fri Aug 18 23:17:14 +0000 2017",
    retweet_count: 13916,
    favorite_count: 70122,
    is_retweet: false,
    id_str: "898685249726578688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I have directed that U.S. Cyber Command be elevated to the status of a Unified Combatant Command focused on....cont: https://t.co/3iScfuMw9s",
    created_at: "Fri Aug 18 15:28:52 +0000 2017",
    retweet_count: 14281,
    favorite_count: 57839,
    is_retweet: false,
    id_str: "898567378988015616"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @hughhewitt: @realDonaldTrump I spoke to a group of influential CA GOPers tonight, long time activists, bundlers, influencers. Support f…",
    created_at: "Fri Aug 18 15:27:55 +0000 2017",
    retweet_count: 12277,
    favorite_count: 0,
    is_retweet: true,
    id_str: "898567142466928640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @hughhewitt: #NeverTrumpers elite MSMers and virtue signalers are persuading themselves that @realDonaldTrump supporters are deserting.…",
    created_at: "Fri Aug 18 15:27:51 +0000 2017",
    retweet_count: 10351,
    favorite_count: 0,
    is_retweet: true,
    id_str: "898567122665611268"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Heading to Camp David for major meeting on National Security, the Border and the Military (which we are rapidly building to strongest ever).",
    created_at: "Fri Aug 18 14:09:24 +0000 2017",
    retweet_count: 16118,
    favorite_count: 87960,
    is_retweet: false,
    id_str: "898547379451740160"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Radical Islamic Terrorism must be stopped by whatever means necessary! The courts must give us back our protective rights. Have to be tough!",
    created_at: "Fri Aug 18 13:06:13 +0000 2017",
    retweet_count: 37669,
    favorite_count: 144838,
    is_retweet: false,
    id_str: "898531481185689600"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Obstructionist Democrats make Security for our country very difficult. They use the courts and associated delay at all times. Must stop!",
    created_at: "Fri Aug 18 12:55:33 +0000 2017",
    retweet_count: 23407,
    favorite_count: 98841,
    is_retweet: false,
    id_str: "898528795308642304"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Homeland Security and law enforcement are on alert &amp; closely watching for any sign of trouble. Our borders are far tougher than ever before!",
    created_at: "Fri Aug 18 12:31:27 +0000 2017",
    retweet_count: 22669,
    favorite_count: 112560,
    is_retweet: false,
    id_str: "898522732672933890"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Study what General Pershing of the United States did to terrorists when caught. There was no more Radical Islamic Terror for 35 years!",
    created_at: "Thu Aug 17 18:45:14 +0000 2017",
    retweet_count: 30534,
    favorite_count: 110455,
    is_retweet: false,
    id_str: "898254409511129088"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The United States condemns the terror attack in Barcelona, Spain, and will do whatever is necessary to help. Be tough &amp; strong, we love you!",
    created_at: "Thu Aug 17 18:00:58 +0000 2017",
    retweet_count: 66115,
    favorite_count: 222216,
    is_retweet: false,
    id_str: "898243270169563136"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...the beauty that is being taken out of our cities, towns and parks will be greatly missed and never able to be comparably replaced!",
    created_at: "Thu Aug 17 13:21:45 +0000 2017",
    retweet_count: 27230,
    favorite_count: 113707,
    is_retweet: false,
    id_str: "898172999945392131"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...can't change history, but you can learn from it. Robert E Lee, Stonewall Jackson - who's next, Washington, Jefferson? So foolish! Also...",
    created_at: "Thu Aug 17 13:15:58 +0000 2017",
    retweet_count: 34360,
    favorite_count: 137167,
    is_retweet: false,
    id_str: "898171544236687361"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Sad to see the history and culture of our great country being ripped apart with the removal of our beautiful statues and monuments. You.....",
    created_at: "Thu Aug 17 13:07:28 +0000 2017",
    retweet_count: 34483,
    favorite_count: 135039,
    is_retweet: false,
    id_str: "898169407213645824"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Many meetings today in Bedminster including with Secretary Linda M and Small Business. Job numbers are looking great!",
    created_at: "Thu Aug 17 12:59:02 +0000 2017",
    retweet_count: 11830,
    favorite_count: 66631,
    is_retweet: false,
    id_str: "898167282727366656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great to see that Dr. Kelli Ward is running against Flake Jeff Flake, who is WEAK on borders, crime and a non-factor in Senate. He's toxic!",
    created_at: "Thu Aug 17 10:56:33 +0000 2017",
    retweet_count: 23199,
    favorite_count: 86073,
    is_retweet: false,
    id_str: "898136462385979392"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The public is learning (even more so) how dishonest the Fake News is. They totally misrepresent what I say about hate, bigotry etc. Shame!",
    created_at: "Thu Aug 17 10:32:11 +0000 2017",
    retweet_count: 33033,
    favorite_count: 129351,
    is_retweet: false,
    id_str: "898130328916824064"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...and people like Ms. Heyer. Such a disgusting lie. He just can't forget his election trouncing.The people of South Carolina will remember!",
    created_at: "Thu Aug 17 10:24:05 +0000 2017",
    retweet_count: 15262,
    favorite_count: 71481,
    is_retweet: false,
    id_str: "898128290698989568"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Publicity seeking Lindsey Graham falsely stated that I said there is moral equivalency between the KKK, neo-Nazis &amp; white supremacists......",
    created_at: "Thu Aug 17 10:19:39 +0000 2017",
    retweet_count: 20156,
    favorite_count: 80998,
    is_retweet: false,
    id_str: "898127175525728256"
  },
  {
    source: "Media Studio",
    text:
      "THANK YOU @MayorGimenez for following the RULE OF LAW! Sanctuary cities make our country LESS SAFE! Full remarks: https://t.co/Kz2EsQ3f1v https://t.co/vD3BB3hyti",
    created_at: "Thu Aug 17 02:55:18 +0000 2017",
    retweet_count: 15690,
    favorite_count: 64481,
    is_retweet: false,
    id_str: "898015350914138112"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me at 7:00 P.M. on Tuesday, August 22nd in Phoenix, Arizona at the Phoenix Convention Center! Tickets at: https://t.co/2kUQfKqbsx https://t.co/5ua74dlVtq",
    created_at: "Thu Aug 17 00:11:28 +0000 2017",
    retweet_count: 13904,
    favorite_count: 50974,
    is_retweet: false,
    id_str: "897974118959783937"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today in Bedminster I signed the Harry W. Colmery Veterans Educational Assistance Act of 2017, joined by @DeptVetAffairs @SecShulkin. https://t.co/oMUIZ8X7oB",
    created_at: "Wed Aug 16 21:35:16 +0000 2017",
    retweet_count: 13790,
    favorite_count: 58663,
    is_retweet: false,
    id_str: "897934811909636096"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just landed in Bedminster, New Jersey. #MAGA 🎥https://t.co/6EQfmRzrnv",
    created_at: "Wed Aug 16 19:49:31 +0000 2017",
    retweet_count: 6394,
    favorite_count: 44529,
    is_retweet: false,
    id_str: "897908198098706433"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @JacobAWohl: @realDonaldTrump President Trump alone has succeeded in bringing the Stock Market, Small Business Index and Consumer Comfor…",
    created_at: "Wed Aug 16 17:50:13 +0000 2017",
    retweet_count: 12508,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897878175308546048"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Rather than putting pressure on the businesspeople of the Manufacturing Council &amp; Strategy &amp; Policy Forum, I am ending both. Thank you all!",
    created_at: "Wed Aug 16 17:14:27 +0000 2017",
    retweet_count: 20229,
    favorite_count: 87625,
    is_retweet: false,
    id_str: "897869174323728385"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Memorial service today for beautiful and incredible Heather Heyer, a truly special young woman. She will be long remembered by all!",
    created_at: "Wed Aug 16 14:58:14 +0000 2017",
    retweet_count: 17856,
    favorite_count: 96750,
    is_retweet: false,
    id_str: "897834894822342656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Wow, Senator Luther Strange picked up a lot of additional support since my endorsement. Now in September runoff. Strong on Wall &amp; Crime!",
    created_at: "Wed Aug 16 14:51:36 +0000 2017",
    retweet_count: 9986,
    favorite_count: 57932,
    is_retweet: false,
    id_str: "897833223501344769"
  },
  {
    source: "Twitter for iPhone",
    text: "MAKE AMERICA GREAT AGAIN!",
    created_at: "Wed Aug 16 12:39:07 +0000 2017",
    retweet_count: 52766,
    favorite_count: 175370,
    is_retweet: false,
    id_str: "897799882802704385"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Kim Jong Un of North Korea made a very wise and well reasoned decision. The alternative would have been both catastrophic and unacceptable!",
    created_at: "Wed Aug 16 11:39:34 +0000 2017",
    retweet_count: 27363,
    favorite_count: 119210,
    is_retweet: false,
    id_str: "897784898865553409"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @FoxNews: .@POTUS: "Our infrastructure will again be the best in the world. We used to have the greatest infrastructure anywhere in the…',
    created_at: "Wed Aug 16 11:32:39 +0000 2017",
    retweet_count: 8335,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897783159038910466"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @jessebwatters: Thanks for watching!! https://t.co/QEjLzzGjDk",
    created_at: "Wed Aug 16 11:32:12 +0000 2017",
    retweet_count: 5141,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897783045666766850"
  },
  {
    source: "Twitter for iPhone",
    text: "Congratulations John! https://t.co/vhmv7Qoutk",
    created_at: "Wed Aug 16 11:31:08 +0000 2017",
    retweet_count: 7291,
    favorite_count: 37879,
    is_retweet: false,
    id_str: "897782776468000768"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Harlan: Watching MSM you would have no idea @realDonaldTrump clearly, unambiguously &amp; repeatedly condemned the bigotry &amp; violence in Ch…",
    created_at: "Wed Aug 16 11:24:34 +0000 2017",
    retweet_count: 14618,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897781122658177024"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @CLewandowski_: Please watch @foxandfriends today at 7:30 AM to watch me discuss @realDonaldTrump.",
    created_at: "Wed Aug 16 11:23:24 +0000 2017",
    retweet_count: 1109,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897780828134141952"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulation to Roy Moore and Luther Strange for being the final two and heading into a September runoff in Alabama. Exciting race!",
    created_at: "Wed Aug 16 10:18:14 +0000 2017",
    retweet_count: 8973,
    favorite_count: 52183,
    is_retweet: false,
    id_str: "897764432369070080"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Amazon is doing great damage to tax paying retailers. Towns, cities and states throughout the U.S. are being hurt - many jobs being lost!",
    created_at: "Wed Aug 16 10:12:45 +0000 2017",
    retweet_count: 18254,
    favorite_count: 70636,
    is_retweet: false,
    id_str: "897763049226084352"
  },
  {
    source: "Twitter for iPhone",
    text:
      "For every CEO that drops out of the Manufacturing Council, I have many to take their place. Grandstanders should not have gone on. JOBS!",
    created_at: "Tue Aug 15 15:21:08 +0000 2017",
    retweet_count: 25350,
    favorite_count: 111590,
    is_retweet: false,
    id_str: "897478270442143744"
  },
  {
    source: "Twitter for iPhone",
    text: "Big day in Alabama. Vote for Luther Strange, he will be great!",
    created_at: "Tue Aug 15 12:08:01 +0000 2017",
    retweet_count: 11425,
    favorite_count: 61099,
    is_retweet: false,
    id_str: "897429670278385664"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @MikeHolden42: @foxandfriends @realDonaldTrump He's a fascist, so not unusual.",
    created_at: "Tue Aug 15 11:03:32 +0000 2017",
    retweet_count: 373,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897413442696597505"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @SLandinSoCal: @foxandfriends @realDonaldTrump Nothing can stop the #TrumpTrain‼️ https://t.co/PprEMbiZQa",
    created_at: "Tue Aug 15 11:03:23 +0000 2017",
    retweet_count: 769,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897413405002387456"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: FOX NEWS EXCLUSIVE: President Trump 'seriously considering' a pardon for ex-Sheriff Joe Arpaio https://t.co/Rgw8l7i9Xl",
    created_at: "Tue Aug 15 10:55:58 +0000 2017",
    retweet_count: 8994,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897411536460886016"
  },
  {
    source: "Twitter for iPhone",
    text:
      "@foxandfriends According to report just out, President Obama knew about Russian interference 3 years ago but he didn't want to anger Russia!",
    created_at: "Tue Aug 15 10:54:32 +0000 2017",
    retweet_count: 7462,
    favorite_count: 17572,
    is_retweet: false,
    id_str: "897411177583702016"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Senator Luther Strange, who is doing a great job for the people of Alabama, will be on @foxandfriends at 7:15. Tough on crime, borders etc.",
    created_at: "Tue Aug 15 10:30:55 +0000 2017",
    retweet_count: 7983,
    favorite_count: 47827,
    is_retweet: false,
    id_str: "897405235924275200"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @JackPosobiec: Meanwhile: 39 shootings in Chicago this weekend, 9 deaths. No national media outrage. Why is that? https://t.co/9Crutnnrp8",
    created_at: "Tue Aug 15 03:11:23 +0000 2017",
    retweet_count: 27432,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897294623000985601"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Feels good to be home after seven months, but the White House is very special, there is no place like it... and the U.S. is really my home!",
    created_at: "Tue Aug 15 03:06:52 +0000 2017",
    retweet_count: 20632,
    favorite_count: 122211,
    is_retweet: false,
    id_str: "897293484884979712"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Sec. Mattis: If North Korea fires missile at US, it's 'game on' https://t.co/CfPL9u2I2G",
    created_at: "Tue Aug 15 02:38:05 +0000 2017",
    retweet_count: 9439,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897286242886463489"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FiIibuster: @realDonaldTrump We have a President that is putting the security and prosperity of America first. Thank you, President Tru…",
    created_at: "Mon Aug 14 22:31:05 +0000 2017",
    retweet_count: 15547,
    favorite_count: 0,
    is_retweet: true,
    id_str: "897224082625880064"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Made additional remarks on Charlottesville and realize once again that the #Fake News Media will never be satisfied...truly bad people!",
    created_at: "Mon Aug 14 22:29:00 +0000 2017",
    retweet_count: 34084,
    favorite_count: 129183,
    is_retweet: false,
    id_str: "897223558073602049"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Leaving for New York City and meetings on military purchases and trade.",
    created_at: "Mon Aug 14 22:22:17 +0000 2017",
    retweet_count: 9402,
    favorite_count: 63273,
    is_retweet: false,
    id_str: "897221868784168960"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big day in Washington, D.C., even though White House &amp; Oval Office are being renovated. Great trade deals coming for American workers!",
    created_at: "Mon Aug 14 22:17:11 +0000 2017",
    retweet_count: 12759,
    favorite_count: 70590,
    is_retweet: false,
    id_str: "897220584211439616"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@Merck Pharma is a leader in higher &amp; higher drug prices while at the same time taking jobs out of the U.S. Bring jobs back &amp; LOWER PRICES!",
    created_at: "Mon Aug 14 22:09:09 +0000 2017",
    retweet_count: 14503,
    favorite_count: 65851,
    is_retweet: false,
    id_str: "897218560937922564"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Now that Ken Frazier of Merck Pharma has resigned from President's Manufacturing Council,he will have more time to LOWER RIPOFF DRUG PRICES!",
    created_at: "Mon Aug 14 12:54:47 +0000 2017",
    retweet_count: 22644,
    favorite_count: 94838,
    is_retweet: false,
    id_str: "897079051277537280"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Obstructionist Democrats have given us (or not fixed) some of the worst trade deals in World History. I am changing that fast!",
    created_at: "Mon Aug 14 10:54:08 +0000 2017",
    retweet_count: 20505,
    favorite_count: 97660,
    is_retweet: false,
    id_str: "897048688639574016"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Luther Strange of the Great State of Alabama has my endorsement. He is strong on Border &amp; Wall, the military, tax cuts &amp; law enforcement.",
    created_at: "Mon Aug 14 10:38:17 +0000 2017",
    retweet_count: 11474,
    favorite_count: 60284,
    is_retweet: false,
    id_str: "897044700124909569"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Heading to Washington this morning. Much work to do. Focus on trade and military. #MAGA",
    created_at: "Mon Aug 14 10:26:09 +0000 2017",
    retweet_count: 12362,
    favorite_count: 69555,
    is_retweet: false,
    id_str: "897041646659014657"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @axios: The DOJ is opening a civil rights investigation on the car attack in Charlottesville https://t.co/bkqmQENipV",
    created_at: "Sun Aug 13 22:03:32 +0000 2017",
    retweet_count: 7224,
    favorite_count: 0,
    is_retweet: true,
    id_str: "896854760099336192"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FoxNews: .@AlanDersh: Trump Has 'More Credibility' Than Obama With North Korea https://t.co/0w1L01EL0q https://t.co/9Q3FYUmNy1",
    created_at: "Sun Aug 13 22:01:17 +0000 2017",
    retweet_count: 10008,
    favorite_count: 0,
    is_retweet: true,
    id_str: "896854197114732544"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DailyCaller: Guam Governor To Trump: I’ve Never Felt Safer Than ‘With You At The Helm’ https://t.co/ESwleDjwuB https://t.co/2UwKmzJtPY",
    created_at: "Sun Aug 13 22:00:47 +0000 2017",
    retweet_count: 11914,
    favorite_count: 0,
    is_retweet: true,
    id_str: "896854071117787136"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @SecretService: Our thoughts &amp; prayers are with the families, friends &amp; colleagues of #Virginia's @VSPPIO Lt Cullen &amp; Tpr Bates #Charlot…",
    created_at: "Sun Aug 13 12:17:13 +0000 2017",
    retweet_count: 11416,
    favorite_count: 0,
    is_retweet: true,
    id_str: "896707210503483393"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Condolences to the family of the young woman killed today, and best regards to all of those injured, in Charlottesville, Virginia. So sad!",
    created_at: "Sat Aug 12 23:25:25 +0000 2017",
    retweet_count: 23601,
    favorite_count: 112225,
    is_retweet: false,
    id_str: "896512981319790592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Deepest condolences to the families &amp; fellow officers of the VA State Police who died today. You're all among the best this nation produces.",
    created_at: "Sat Aug 12 22:50:10 +0000 2017",
    retweet_count: 26774,
    favorite_count: 127578,
    is_retweet: false,
    id_str: "896504109670567936"
  },
  {
    source: "Media Studio",
    text:
      "We will continue to follow developments in Charlottesville, and will provide whatever assistance is needed. We are ready, willing and able. https://t.co/mCTYBgUePi",
    created_at: "Sat Aug 12 21:49:47 +0000 2017",
    retweet_count: 15556,
    favorite_count: 68383,
    is_retweet: false,
    id_str: "896488914877165569"
  },
  {
    source: "Media Studio",
    text:
      "We must remember this truth: No matter our color, creed, religion or political party, we are ALL AMERICANS FIRST. https://t.co/FesMiQSKKn",
    created_at: "Sat Aug 12 21:19:23 +0000 2017",
    retweet_count: 33786,
    favorite_count: 113556,
    is_retweet: false,
    id_str: "896481262776360960"
  },
  {
    source: "Twitter for iPhone",
    text:
      "What is vital now is a swift restoration of law and order and the protection of innocent lives.\n#Charlottesville https://t.co/DB22fgnu6L",
    created_at: "Sat Aug 12 20:23:15 +0000 2017",
    retweet_count: 17736,
    favorite_count: 69710,
    is_retweet: false,
    id_str: "896467135391596544"
  },
  {
    source: "Twitter for iPhone",
    text: "Join me live from Bedminster, New Jersey: https://t.co/P3cRVvE0cY",
    created_at: "Sat Aug 12 19:26:57 +0000 2017",
    retweet_count: 5263,
    favorite_count: 32522,
    is_retweet: false,
    id_str: "896452967741747200"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Am in Bedminster for meetings &amp; press conference on V.A. &amp; all that we have done, and are doing, to make it better-but Charlottesville sad!",
    created_at: "Sat Aug 12 18:00:28 +0000 2017",
    retweet_count: 11471,
    favorite_count: 60599,
    is_retweet: false,
    id_str: "896431205549318144"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We ALL must be united &amp; condemn all that hate stands for. There is no place for this kind of violence in America. Lets come together as one!",
    created_at: "Sat Aug 12 17:19:13 +0000 2017",
    retweet_count: 59652,
    favorite_count: 195440,
    is_retweet: false,
    id_str: "896420822780444672"
  },
  {
    source: "Media Studio",
    text:
      "Press Conference - Following National Security Briefing in Bedminster, New Jersey. 🎥https://t.co/v5O8GglOIK https://t.co/H1Zi5XRKEo",
    created_at: "Sat Aug 12 02:06:16 +0000 2017",
    retweet_count: 11145,
    favorite_count: 49032,
    is_retweet: false,
    id_str: "896191069733265408"
  },
  {
    source: "Media Studio",
    text:
      "As promised on the campaign trail, we will provide opportunity for Americans to gain skills needed to succeed &amp; thrive as the economy grows! https://t.co/ZycW4PPcU5",
    created_at: "Fri Aug 11 21:43:10 +0000 2017",
    retweet_count: 15708,
    favorite_count: 70638,
    is_retweet: false,
    id_str: "896124861571112960"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"Consumer Comfort Reaches 16-Year High on U.S. Economic Optimism" via Bloomberg https://t.co/X6KdszrxsS',
    created_at: "Fri Aug 11 20:42:45 +0000 2017",
    retweet_count: 11946,
    favorite_count: 52445,
    is_retweet: false,
    id_str: "896109655574708224"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We want to make sure that we have the workforce development programs we need to ensure these jobs are.... https://t.co/tyqbvvmBn4",
    created_at: "Fri Aug 11 18:29:26 +0000 2017",
    retweet_count: 11141,
    favorite_count: 51823,
    is_retweet: false,
    id_str: "896076107094474752"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @PacificCommand: #USAF B-1B Lancer #bombers on Guam stand ready to fulfill USFK’s #FightTonight mission if called upon to do so https://…",
    created_at: "Fri Aug 11 13:19:02 +0000 2017",
    retweet_count: 18626,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895997989272961025"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Military solutions are now fully in place,locked and loaded,should North Korea act unwisely.  Hopefully Kim Jong Un will find another path!",
    created_at: "Fri Aug 11 11:29:31 +0000 2017",
    retweet_count: 60063,
    favorite_count: 176749,
    is_retweet: false,
    id_str: "895970429734711298"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Trump fires new warning shot at McConnell, leaves door open on whether he should step down https://t.co/tJIRc0usWl",
    created_at: "Fri Aug 11 11:12:56 +0000 2017",
    retweet_count: 7505,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895966256813268994"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Senators learn the hard way about the fallout from turning on Trump https://t.co/wq8Im1cHpy",
    created_at: "Fri Aug 11 11:12:14 +0000 2017",
    retweet_count: 8655,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895966080690257920"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: FOX NEWS ALERT: 2 US drone strikes in Somalia target Al Qaeda and Al-Shabaab https://t.co/MqrY7zbMy2",
    created_at: "Fri Aug 11 11:08:03 +0000 2017",
    retweet_count: 7479,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895965025931808768"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"Trump approval rebounds to 45%, surges among Hispanics, union homes, men" https://t.co/vvJMDv9Gjl',
    created_at: "Thu Aug 10 23:51:36 +0000 2017",
    retweet_count: 19993,
    favorite_count: 79230,
    is_retweet: false,
    id_str: "895794792747216896"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@IvankaTrump will lead the U.S. delegation to India this fall, supporting women’s entrepreneurship globally.\n#GES2017 @narendramodi",
    created_at: "Thu Aug 10 20:18:30 +0000 2017",
    retweet_count: 18303,
    favorite_count: 87293,
    is_retweet: false,
    id_str: "895741164103639042"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Mitch, get back to work and put Repeal &amp; Replace, Tax Reform &amp; Cuts and a great Infrastructure Bill on my desk for signing. You can do it!",
    created_at: "Thu Aug 10 16:40:41 +0000 2017",
    retweet_count: 31253,
    favorite_count: 123211,
    is_retweet: false,
    id_str: "895686351529672704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: FOX NEWS ALERT: North Korea responds to U.S. with Guam attack plan as Secretary Mattis warns Kim Jung Un “he is grossly…",
    created_at: "Thu Aug 10 11:17:25 +0000 2017",
    retweet_count: 11239,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895604995537678336"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @ProgressPolls: Who is a better President of the United States? #ObamaDay",
    created_at: "Thu Aug 10 11:13:18 +0000 2017",
    retweet_count: 17482,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895603959565570048"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Can you believe that Mitch McConnell, who has screamed Repeal &amp; Replace for 7 years, couldn't get it done. Must Repeal &amp; Replace ObamaCare!",
    created_at: "Thu Aug 10 10:54:18 +0000 2017",
    retweet_count: 24945,
    favorite_count: 106233,
    is_retweet: false,
    id_str: "895599179522650112"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @markets: U.S. job openings surge to record https://t.co/3CPH78Sfvw via @ShoChandra https://t.co/JFhQ7HFN69",
    created_at: "Thu Aug 10 01:20:57 +0000 2017",
    retweet_count: 6318,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895454893133234176"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @TheFive: "@POTUS being unpredictable is a big asset, North Korea knew exactly what President Obama was going to do."- @jessebwatters',
    created_at: "Thu Aug 10 01:18:36 +0000 2017",
    retweet_count: 12125,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895454300607991809"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @AmbJohnBolton: Our country &amp; civilians are vulnerable today because @BarackObama did not believe in national missile defense. Let’s nev…",
    created_at: "Thu Aug 10 01:18:14 +0000 2017",
    retweet_count: 24181,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895454206244655104"
  },
  {
    source: "Media Studio",
    text: "#GodBlessTheUSA🇺🇸 https://t.co/Fkq2gJQOKk",
    created_at: "Wed Aug 09 21:36:44 +0000 2017",
    retweet_count: 22873,
    favorite_count: 84971,
    is_retweet: false,
    id_str: "895398465290723329"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Senator Mitch McConnell said I had "excessive expectations," but I don\'t think so. After 7 years of hearing Repeal &amp; Replace, why not done?',
    created_at: "Wed Aug 09 18:14:50 +0000 2017",
    retweet_count: 31529,
    favorite_count: 122404,
    is_retweet: false,
    id_str: "895347654431035393"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...Hopefully we will never have to use this power, but there will never be a time that we are not the most powerful nation in the world!",
    created_at: "Wed Aug 09 12:03:21 +0000 2017",
    retweet_count: 30355,
    favorite_count: 131370,
    is_retweet: false,
    id_str: "895254168570605568"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My first order as President was to renovate and modernize our nuclear arsenal. It is now far stronger and more powerful than ever before....",
    created_at: "Wed Aug 09 11:56:33 +0000 2017",
    retweet_count: 25729,
    favorite_count: 107542,
    is_retweet: false,
    id_str: "895252459152711680"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @foxandfriends: President Trump vows America will respond to North Korean threats with "fire &amp; fury" in a warning to the rogue nation ht…',
    created_at: "Wed Aug 09 11:26:47 +0000 2017",
    retweet_count: 10509,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895244964904542208"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: France vehicle attack leaves at least six soldiers injured\n\nhttps://t.co/bm7gevcQi2",
    created_at: "Wed Aug 09 11:24:44 +0000 2017",
    retweet_count: 4720,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895244450053726209"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Trump vows U.S. 'power' will meet North Korean threat https://t.co/od7Ohr51XD",
    created_at: "Wed Aug 09 11:23:25 +0000 2017",
    retweet_count: 5309,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895244121241255936"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Millions of gallons of Mexican waste threaten Border Patrol agents https://t.co/yGAq4IgHOs",
    created_at: "Wed Aug 09 11:22:58 +0000 2017",
    retweet_count: 6716,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895244004803194880"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: U.S. Air Force jets take off from Guam for training, ensuring they can 'fight tonight' https://t.co/E4EGIyNSHP",
    created_at: "Wed Aug 09 11:22:10 +0000 2017",
    retweet_count: 6781,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895243804013416449"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @TheFive: \"Media bias is not just about what they report, it's also about what they don't report.\"-@jessebwatters #thefive",
    created_at: "Wed Aug 09 10:56:36 +0000 2017",
    retweet_count: 9819,
    favorite_count: 0,
    is_retweet: true,
    id_str: "895237369032519681"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Senator Luther Strange has done a great job representing the people of the Great State of Alabama. He has my complete and total endorsement!",
    created_at: "Wed Aug 09 01:16:33 +0000 2017",
    retweet_count: 13060,
    favorite_count: 67083,
    is_retweet: false,
    id_str: "895091395379245056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FoxNews: Jobs added during @POTUS' time in office. https://t.co/zD0FkFvHVx",
    created_at: "Tue Aug 08 18:11:43 +0000 2017",
    retweet_count: 13514,
    favorite_count: 0,
    is_retweet: true,
    id_str: "894984483291750401"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After 200 days, rarely has any Administration achieved what we have achieved..not even close! Don't believe the Fake News Suppression Polls!",
    created_at: "Tue Aug 08 18:10:18 +0000 2017",
    retweet_count: 25703,
    favorite_count: 111343,
    is_retweet: false,
    id_str: "894984126582972416"
  },
  {
    source: "Twitter for iPhone",
    text:
      "E-mails show that the AmazonWashingtonPost and the FailingNewYorkTimes were reluctant to cover the Clinton/Lynch secret meeting in plane.",
    created_at: "Tue Aug 08 18:00:30 +0000 2017",
    retweet_count: 24056,
    favorite_count: 85946,
    is_retweet: false,
    id_str: "894981661926068228"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After many years of failure,countries are coming together to  finally address the dangers posed by North Korea. We must be tough &amp; decisive!",
    created_at: "Tue Aug 08 11:17:18 +0000 2017",
    retweet_count: 24362,
    favorite_count: 110433,
    is_retweet: false,
    id_str: "894880193839497216"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be holding a major briefing on the Opioid crisis, a major problem for our country, today at 3:00 P.M. in Bedminster, N.J.",
    created_at: "Tue Aug 08 11:11:49 +0000 2017",
    retweet_count: 14799,
    favorite_count: 72667,
    is_retweet: false,
    id_str: "894878812063846400"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: OPIOID CRISIS: Worse than we thought, with a new study showing overdose deaths were under reported https://t.co/27kLJKRX…",
    created_at: "Tue Aug 08 10:59:25 +0000 2017",
    retweet_count: 6898,
    favorite_count: 0,
    is_retweet: true,
    id_str: "894875690423726080"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Anthem announces it will withdraw from ObamaCare Exchange in Nevada https://t.co/d0CxeHQKwz",
    created_at: "Tue Aug 08 10:59:04 +0000 2017",
    retweet_count: 8881,
    favorite_count: 0,
    is_retweet: true,
    id_str: "894875602045607936"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: U.S. spy satellites detect North Korea moving anti-ship cruise missiles to patrol boat https://t.co/BPFXsLffgy",
    created_at: "Tue Aug 08 10:41:59 +0000 2017",
    retweet_count: 7175,
    favorite_count: 0,
    is_retweet: true,
    id_str: "894871302250668032"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I think Senator Blumenthal should take a nice long vacation in Vietnam, where he lied about his service, so he can at least say he was there",
    created_at: "Mon Aug 07 20:48:54 +0000 2017",
    retweet_count: 29933,
    favorite_count: 115856,
    is_retweet: false,
    id_str: "894661651760377856"
  },
  {
    source: "Twitter for iPhone",
    text:
      "How much longer will the failing nytimes, with its big losses and massive unfunded liability (and non-existent sources), remain in business?",
    created_at: "Mon Aug 07 20:39:46 +0000 2017",
    retweet_count: 17551,
    favorite_count: 82202,
    is_retweet: false,
    id_str: "894659355324424192"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News Media will not talk about the importance of the United Nations Security Council's 15-0 vote in favor of sanctions on N. Korea!",
    created_at: "Mon Aug 07 20:15:18 +0000 2017",
    retweet_count: 20272,
    favorite_count: 85330,
    is_retweet: false,
    id_str: "894653195112378368"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @realDonaldTrump: On #PurpleHeartDay💜I thank all the brave men and women who have sacrificed in battle for this GREAT NATION! #USA🇺🇸 htt…",
    created_at: "Mon Aug 07 18:18:33 +0000 2017",
    retweet_count: 5144,
    favorite_count: 0,
    is_retweet: true,
    id_str: "894623814079975425"
  },
  {
    source: "Twitter for iPhone",
    text:
      "On #PurpleHeartDay💜I thank all the brave men and women who have sacrificed in battle for this GREAT NATION! #USA🇺🇸 https://t.co/QmfdLSLp6p",
    created_at: "Mon Aug 07 18:03:42 +0000 2017",
    retweet_count: 15769,
    favorite_count: 76310,
    is_retweet: false,
    id_str: "894620077634592769"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...conquests, how brave he was, and it was all a lie. He cried like a baby and begged for forgiveness like a child. Now he judges collusion?",
    created_at: "Mon Aug 07 12:01:20 +0000 2017",
    retweet_count: 17375,
    favorite_count: 74752,
    is_retweet: false,
    id_str: "894528885701971970"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Never in U.S.history has anyone lied or defrauded voters like Senator Richard Blumenthal. He told stories about his Vietnam battles and....",
    created_at: "Mon Aug 07 11:52:32 +0000 2017",
    retweet_count: 19662,
    favorite_count: 78666,
    is_retweet: false,
    id_str: "894526670836781056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Interesting to watch Senator Richard Blumenthal of Connecticut talking about hoax Russian collusion when he was a  phony Vietnam con artist!",
    created_at: "Mon Aug 07 11:47:36 +0000 2017",
    retweet_count: 20919,
    favorite_count: 80581,
    is_retweet: false,
    id_str: "894525428236464128"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Working hard from New Jersey while White House goes through long planned renovation. Going to New York next week for more meetings.",
    created_at: "Mon Aug 07 11:32:56 +0000 2017",
    retweet_count: 13164,
    favorite_count: 66731,
    is_retweet: false,
    id_str: "894521737534197762"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Hard to believe that with 24/7 #Fake News on CNN, ABC, NBC, CBS, NYTIMES &amp; WAPO, the Trump base is getting stronger!",
    created_at: "Mon Aug 07 11:18:05 +0000 2017",
    retweet_count: 17420,
    favorite_count: 74243,
    is_retweet: false,
    id_str: "894518002795900928"
  },
  {
    source: "Twitter for iPhone",
    text:
      "... Supreme Court pick, economic enthusiasm, deregulation &amp; so much more have driven the Trump base even closer together. Will never change!",
    created_at: "Mon Aug 07 11:09:36 +0000 2017",
    retweet_count: 14447,
    favorite_count: 69591,
    is_retweet: false,
    id_str: "894515865802223616"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...and West Virginia. The fact is the Fake News Russian collusion story, record Stock Market, border security, military strength, jobs.....",
    created_at: "Mon Aug 07 11:04:19 +0000 2017",
    retweet_count: 12005,
    favorite_count: 59815,
    is_retweet: false,
    id_str: "894514535062790144"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Trump base is far bigger &amp;  stronger than ever before (despite some phony Fake News polling). Look at rallies in Penn, Iowa, Ohio.......",
    created_at: "Mon Aug 07 10:58:09 +0000 2017",
    retweet_count: 19426,
    favorite_count: 90640,
    is_retweet: false,
    id_str: "894512983384129536"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The failing @nytimes, which has made every wrong prediction about me including my big election win (apologized), is totally inept!",
    created_at: "Mon Aug 07 10:38:32 +0000 2017",
    retweet_count: 13598,
    favorite_count: 65244,
    is_retweet: false,
    id_str: "894508048844279809"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just completed call with President Moon of South Korea. Very happy and impressed with 15-0 United Nations vote on North Korea sanctions.",
    created_at: "Mon Aug 07 01:22:08 +0000 2017",
    retweet_count: 20422,
    favorite_count: 100546,
    is_retweet: false,
    id_str: "894368024765059073"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News refuses to report the success of the first 6 months: S.C., surging economy &amp; jobs,border &amp; military security,ISIS &amp; MS-13 etc.",
    created_at: "Mon Aug 07 01:18:08 +0000 2017",
    retweet_count: 23061,
    favorite_count: 95347,
    is_retweet: false,
    id_str: "894367017054208001"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IvankaTrump: The Administration is committed to supporting military spouses in the workforce. Thanks Kim for sharing your story! https:…",
    created_at: "Sun Aug 06 22:43:29 +0000 2017",
    retweet_count: 10769,
    favorite_count: 0,
    is_retweet: true,
    id_str: "894328101949374465"
  },
  {
    source: "Twitter for iPhone",
    text: "MAKE AMERICA GREAT AGAIN! https://t.co/g4ELhh9joH",
    created_at: "Sun Aug 06 13:15:41 +0000 2017",
    retweet_count: 34426,
    favorite_count: 113900,
    is_retweet: false,
    id_str: "894185208924262401"
  },
  {
    source: "Twitter for iPhone",
    text:
      "United Nations Resolution is the single largest economic sanctions package ever on North Korea. Over one billion dollars in cost to N.K.",
    created_at: "Sat Aug 05 23:14:18 +0000 2017",
    retweet_count: 18347,
    favorite_count: 83987,
    is_retweet: false,
    id_str: "893973466508079104"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you Nicole! https://t.co/KlWN05uFOx",
    created_at: "Sat Aug 05 23:01:05 +0000 2017",
    retweet_count: 10528,
    favorite_count: 52192,
    is_retweet: false,
    id_str: "893970139565129730"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After many years of LEAKS going on in Washington, it is great to see the A.G. taking action! For National Security, the tougher the better!",
    created_at: "Sat Aug 05 22:58:17 +0000 2017",
    retweet_count: 22371,
    favorite_count: 103975,
    is_retweet: false,
    id_str: "893969438139191296"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The United Nations Security Council just voted 15-0 to sanction North Korea. China and Russia voted with us. Very big financial impact!",
    created_at: "Sat Aug 05 22:44:34 +0000 2017",
    retweet_count: 25763,
    favorite_count: 110129,
    is_retweet: false,
    id_str: "893965986566733824"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Working in Bedminster, N.J., as long planned construction is being done at the White House. This is not a vacation - meetings and calls!",
    created_at: "Sat Aug 05 22:36:51 +0000 2017",
    retweet_count: 19955,
    favorite_count: 87982,
    is_retweet: false,
    id_str: "893964041630212098"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @RightlyNews: "What\'s a high priced Clinton attorney doing representing a low level IT staffer for the Democrats?" \n-@jessebwatters on t…',
    created_at: "Sat Aug 05 22:18:56 +0000 2017",
    retweet_count: 17977,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893959535425146881"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"Under Trump, gains against #ISIS have dramatically accelerated"\nhttps://t.co/jNtOTh0moL',
    created_at: "Sat Aug 05 22:12:26 +0000 2017",
    retweet_count: 14759,
    favorite_count: 63757,
    is_retweet: false,
    id_str: "893957896190533632"
  },
  {
    source: "Media Studio",
    text:
      "Prosperity is coming back to our shores because we are putting America WORKERS and FAMILIES first. #AmericaFirst🇺🇸 https://t.co/4kTc6Om308",
    created_at: "Sat Aug 05 16:00:59 +0000 2017",
    retweet_count: 24010,
    favorite_count: 92077,
    is_retweet: false,
    id_str: "893864420539068417"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FoxNews: More than 1 million jobs added since @POTUS took office. https://t.co/ZVsC9oi9Ds https://t.co/NNL1FwNMLU",
    created_at: "Sat Aug 05 11:12:08 +0000 2017",
    retweet_count: 11178,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893791726896381952"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IvankaTrump: Since @realDonaldTrump inauguration, over 1 million net new jobs have been created in the American economy! #MAGA",
    created_at: "Fri Aug 04 23:30:27 +0000 2017",
    retweet_count: 19731,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893615145053716480"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @dcexaminer: Emails show Washington Post, New York Times reporters unenthusiastic about covering Clinton-Lynch meeting https://t.co/PKSL…",
    created_at: "Fri Aug 04 23:27:36 +0000 2017",
    retweet_count: 10696,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893614425067839488"
  },
  {
    source: "Media Studio",
    text:
      "Great work being done by @FEMA @DHSgov w/state &amp; local leaders to prepare for hurricane season. Preparedness is an investment in our future! https://t.co/e4rbchY3zM",
    created_at: "Fri Aug 04 21:38:39 +0000 2017",
    retweet_count: 10103,
    favorite_count: 49730,
    is_retweet: false,
    id_str: "893587008312016896"
  },
  {
    source: "Twitter for iPhone",
    text:
      "No matter the mission, the brave men &amp; women of our @USCG proudly answer the call to serve 24/7/365. THANK YOU and HAPPY BIRTHDAY! #CG227🇺🇸 https://t.co/GY555t0vzN",
    created_at: "Fri Aug 04 15:48:28 +0000 2017",
    retweet_count: 14202,
    favorite_count: 63653,
    is_retweet: false,
    id_str: "893498883090907137"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @paultdove: @FoxBusiness Republican Senators who are opposing the President, look at the great economic news: Americans Are Noticing!",
    created_at: "Fri Aug 04 13:21:00 +0000 2017",
    retweet_count: 9463,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893461771813564416"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Bet22325450ste: @FoxBusiness @foxandfriends Come on America. Get on the Trump Train. The winners already have boarded! The losers are w…",
    created_at: "Fri Aug 04 13:20:21 +0000 2017",
    retweet_count: 9648,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893461607275270144"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FoxBusiness: #BreakingNews: U.S. employers added 209,000 jobs in July, unemployment rate down to 4.3% #JobsReport https://t.co/mWaTLMg1…",
    created_at: "Fri Aug 04 13:18:59 +0000 2017",
    retweet_count: 12591,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893461264474804224"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: .@JudgeJeanine: There will be an uproar in this country if they end up with an indictment against a Trump family member…",
    created_at: "Fri Aug 04 13:18:38 +0000 2017",
    retweet_count: 12310,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893461175278718976"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @RealJamesWoods: I've never witnessed such hatred for a man who is willing to work for free to make his beloved country a better place.…",
    created_at: "Fri Aug 04 13:18:21 +0000 2017",
    retweet_count: 56353,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893461105552609280"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Excellent Jobs Numbers just released - and I have only just begun. Many job stifling regulations continue to fall. Movement back to USA!",
    created_at: "Fri Aug 04 12:45:50 +0000 2017",
    retweet_count: 19333,
    favorite_count: 90292,
    is_retweet: false,
    id_str: "893452922427715584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "West Virginia was incredible last night. Crowds and enthusiasm were beyond, GDP at 3%, wow!Dem Governor became a Republican last night.",
    created_at: "Fri Aug 04 10:35:31 +0000 2017",
    retweet_count: 17395,
    favorite_count: 84848,
    is_retweet: false,
    id_str: "893420123641479168"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Team_Trump45: @realDonaldTrump We won. Move on. https://t.co/YnUKMoyegB",
    created_at: "Fri Aug 04 10:29:11 +0000 2017",
    retweet_count: 12222,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893418532809179136"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Consumer confidence is at a 16 year high....and for good reason. Much more regulation "busting" to come. Working hard on tax cuts &amp; reform!',
    created_at: "Fri Aug 04 10:26:16 +0000 2017",
    retweet_count: 14948,
    favorite_count: 75633,
    is_retweet: false,
    id_str: "893417795614121985"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....and don't forget that Foxconn will be spending up to 10 billion dollars on a top of the line plant/plants in Wisconsin.",
    created_at: "Fri Aug 04 10:21:34 +0000 2017",
    retweet_count: 11235,
    favorite_count: 60261,
    is_retweet: false,
    id_str: "893416615504748544"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Toyota &amp; Mazda to build a new $1.6B plant here in the U.S.A. and create 4K new American jobs. A great investment in American manufacturing!",
    created_at: "Fri Aug 04 10:02:24 +0000 2017",
    retweet_count: 26142,
    favorite_count: 117780,
    is_retweet: false,
    id_str: "893411790868160514"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you West Virginia! All across the country, Americans of every kind are coming together w/one simple goal: to MAKE AMERICA GREAT AGAIN! https://t.co/thRh7htVbH",
    created_at: "Fri Aug 04 04:19:31 +0000 2017",
    retweet_count: 15828,
    favorite_count: 68517,
    is_retweet: false,
    id_str: "893325503020642305"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just arrived in West Virginia for a MAKE AMERICA GREAT AGAIN rally in Huntington at 7:00pmE. Massive crowd expected - tune in! #MAGA🇺🇸",
    created_at: "Thu Aug 03 22:52:16 +0000 2017",
    retweet_count: 10787,
    favorite_count: 64611,
    is_retweet: false,
    id_str: "893243147580473344"
  },
  {
    source: "Media Studio",
    text:
      "Our GREAT VETERANS can now connect w/ their VA healthcare team from anywhere, using #VAVideoConnect - available at: https://t.co/WFFHLWn8nF. https://t.co/Dmq4htSps9",
    created_at: "Thu Aug 03 19:07:40 +0000 2017",
    retweet_count: 11806,
    favorite_count: 48821,
    is_retweet: false,
    id_str: "893186623193718784"
  },
  {
    source: "Media Studio",
    text:
      "Today, I  announced another historic breakthrough for the VA. We are working tirelessly to keep our promises to our GREAT VETERANS! #USA https://t.co/LexSINeM1J",
    created_at: "Thu Aug 03 18:03:33 +0000 2017",
    retweet_count: 16273,
    favorite_count: 70079,
    is_retweet: false,
    id_str: "893170489820151808"
  },
  {
    source: "Media Studio",
    text:
      "See you tonight Huntington, West Virginia!\n#MakeAmericaGreatAgain🇺🇸\nTickets: https://t.co/ERU0xUWdCr https://t.co/obtDsdV94t",
    created_at: "Thu Aug 03 16:04:10 +0000 2017",
    retweet_count: 9524,
    favorite_count: 44234,
    is_retweet: false,
    id_str: "893140445294940160"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Our relationship with Russia is at an all-time &amp; very dangerous  low. You can thank Congress, the same people that can't even give us HCare!",
    created_at: "Thu Aug 03 12:18:49 +0000 2017",
    retweet_count: 29173,
    favorite_count: 92727,
    is_retweet: false,
    id_str: "893083735633129472"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am continuing to get rid of costly and unnecessary regulations. Much work left to do but effect will be great! Business &amp; jobs will grow.",
    created_at: "Thu Aug 03 12:12:21 +0000 2017",
    retweet_count: 19770,
    favorite_count: 101225,
    is_retweet: false,
    id_str: "893082107081244672"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Business is looking better than ever with business enthusiasm at record levels. Stock Market at an all-time high. That doesn't just happen!",
    created_at: "Thu Aug 03 12:08:54 +0000 2017",
    retweet_count: 16533,
    favorite_count: 82679,
    is_retweet: false,
    id_str: "893081237082001409"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @JacobAWohl: @realDonaldTrump The #MAGA great again movement is WINNING, and the left-wing media can't stand it!",
    created_at: "Thu Aug 03 12:05:07 +0000 2017",
    retweet_count: 7271,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893080287755849729"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Insurers seeking huge premium hikes on ObamaCare plans https://t.co/YrUwvMKlyb",
    created_at: "Thu Aug 03 12:00:05 +0000 2017",
    retweet_count: 6638,
    favorite_count: 0,
    is_retweet: true,
    id_str: "893079018605621248"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I love the White House, one of the most beautiful buildings (homes) I have ever seen. But Fake News said I called it a dump - TOTALLY UNTRUE",
    created_at: "Thu Aug 03 01:29:46 +0000 2017",
    retweet_count: 32924,
    favorite_count: 137752,
    is_retweet: false,
    id_str: "892920397162848257"
  },
  {
    source: "Media Studio",
    text:
      "I campaigned on creating a merit-based immigration system that protects U.S. workers &amp; taxpayers. Watch: https://t.co/lv3ScSKnF6 #RAISEAct https://t.co/zCFK5OfYnB",
    created_at: "Wed Aug 02 18:29:04 +0000 2017",
    retweet_count: 20342,
    favorite_count: 78586,
    is_retweet: false,
    id_str: "892814520942460928"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"Why the Rust Belt just gave Donald Trump a hero\'s welcome"\nhttps://t.co/nqiZ8h8ajk',
    created_at: "Wed Aug 02 16:22:40 +0000 2017",
    retweet_count: 12432,
    favorite_count: 56159,
    is_retweet: false,
    id_str: "892782712322437120"
  },
  {
    source: "Media Studio",
    text:
      "It was my great honor to pay tribute to a VET who went above &amp; beyond the call of duty to PROTECT our COMRADES, our COUNTRY, &amp; OUR FREEDOM! https://t.co/YS6y1WR30G",
    created_at: "Wed Aug 02 14:09:37 +0000 2017",
    retweet_count: 16823,
    favorite_count: 82161,
    is_retweet: false,
    id_str: "892749228291874816"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Small business owners are the DREAMERS &amp; INNOVATORS who are powering us into the future!\nRead more and watch here: https://t.co/hZE3fUqKDf https://t.co/TJn5x6HrFG",
    created_at: "Wed Aug 02 13:38:00 +0000 2017",
    retweet_count: 11564,
    favorite_count: 51840,
    is_retweet: false,
    id_str: "892741272259133441"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Only the Fake News Media and Trump enemies want me to stop using Social Media (110 million people). Only way for me to get the truth out!",
    created_at: "Tue Aug 01 13:55:19 +0000 2017",
    retweet_count: 33675,
    favorite_count: 140273,
    is_retweet: false,
    id_str: "892383242535481344"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"Corporations have NEVER made as much money as they are making now." Thank you Stuart Varney @foxandfriends Jobs are starting to roar,watch!',
    created_at: "Tue Aug 01 13:03:59 +0000 2017",
    retweet_count: 16961,
    favorite_count: 79661,
    is_retweet: false,
    id_str: "892370324616089600"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Stock Market could hit all-time high (again) 22,000 today. Was 18,000 only 6 months ago on Election Day. Mainstream media seldom mentions!",
    created_at: "Tue Aug 01 12:49:22 +0000 2017",
    retweet_count: 23445,
    favorite_count: 107308,
    is_retweet: false,
    id_str: "892366646542782464"
  },
  {
    source: "Twitter for iPhone",
    text: "A great day at the White House!",
    created_at: "Mon Jul 31 22:19:11 +0000 2017",
    retweet_count: 25417,
    favorite_count: 122378,
    is_retweet: false,
    id_str: "892147656319004672"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: .@Suffolk_Sheriff praises President Trump for making gang eradication a priority https://t.co/uNY7jBhleE",
    created_at: "Mon Jul 31 12:29:08 +0000 2017",
    retweet_count: 7816,
    favorite_count: 0,
    is_retweet: true,
    id_str: "891999166074847232"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Highest Stock Market EVER, best economic numbers in years, unemployment lowest in 17 years, wages raising, border secure, S.C.: No WH chaos!",
    created_at: "Mon Jul 31 12:28:00 +0000 2017",
    retweet_count: 30726,
    favorite_count: 126845,
    is_retweet: false,
    id_str: "891998881009061888"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If ObamaCare is hurting people, &amp; it is, why shouldn't it hurt the insurance companies &amp; why should Congress not be paying what public pays?",
    created_at: "Mon Jul 31 12:16:46 +0000 2017",
    retweet_count: 35202,
    favorite_count: 131252,
    is_retweet: false,
    id_str: "891996053611917312"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Don't give up Republican Senators, the World is watching: Repeal &amp; Replace...and go to 51 votes (nuke option), get Cross State Lines &amp; more.",
    created_at: "Sun Jul 30 11:37:39 +0000 2017",
    retweet_count: 25010,
    favorite_count: 106525,
    is_retweet: false,
    id_str: "891623821702295552"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...they do NOTHING for us with North Korea, just talk. We will no longer allow this to continue. China could easily solve this problem!",
    created_at: "Sat Jul 29 23:35:13 +0000 2017",
    retweet_count: 24240,
    favorite_count: 99285,
    is_retweet: false,
    id_str: "891442016294494209"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am very disappointed in China. Our foolish past leaders have allowed them to make hundreds of billions of dollars a year in trade, yet...",
    created_at: "Sat Jul 29 23:29:05 +0000 2017",
    retweet_count: 26681,
    favorite_count: 101591,
    is_retweet: false,
    id_str: "891440474132795392"
  },
  {
    source: "Twitter for iPhone",
    text:
      'I love reading about all of the "geniuses" who were so instrumental in my election success. Problem is, most don\'t exist. #Fake News! MAGA',
    created_at: "Sat Jul 29 23:15:57 +0000 2017",
    retweet_count: 18571,
    favorite_count: 85767,
    is_retweet: false,
    id_str: "891437168798965761"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Unless the Republican Senators are total quitters, Repeal &amp; Replace is not dead! Demand another vote before voting on any other bill!",
    created_at: "Sat Jul 29 20:36:52 +0000 2017",
    retweet_count: 22095,
    favorite_count: 92349,
    is_retweet: false,
    id_str: "891397134662193152"
  },
  {
    source: "Twitter for iPhone",
    text: "U.S. Stock Market up almost 20% since Election!",
    created_at: "Sat Jul 29 17:04:20 +0000 2017",
    retweet_count: 22532,
    favorite_count: 106915,
    is_retweet: false,
    id_str: "891343645529567232"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If a new HealthCare Bill is not approved quickly, BAILOUTS for Insurance Companies and BAILOUTS for Members of Congress will end very soon!",
    created_at: "Sat Jul 29 16:27:39 +0000 2017",
    retweet_count: 29095,
    favorite_count: 106726,
    is_retweet: false,
    id_str: "891334415347060736"
  },
  {
    source: "Twitter for iPhone",
    text:
      'After seven years of "talking" Repeal &amp; Replace, the people of our great country are still being forced to live with imploding ObamaCare!',
    created_at: "Sat Jul 29 16:19:12 +0000 2017",
    retweet_count: 19365,
    favorite_count: 80415,
    is_retweet: false,
    id_str: "891332290474848257"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If the Senate Democrats ever got the chance, they would switch to a 51 majority vote in first minute. They are laughing at R's. MAKE CHANGE!",
    created_at: "Sat Jul 29 11:47:13 +0000 2017",
    retweet_count: 18985,
    favorite_count: 75811,
    is_retweet: false,
    id_str: "891263843908947969"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....8 Dems totally control the U.S. Senate. Many great Republican bills will never pass, like Kate's Law and complete Healthcare. Get smart!",
    created_at: "Sat Jul 29 11:39:25 +0000 2017",
    retweet_count: 17988,
    favorite_count: 70383,
    is_retweet: false,
    id_str: "891261878005092353"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republicans in the Senate will NEVER win if they don't go to a 51 vote majority NOW. They look like fools and are just wasting time......",
    created_at: "Sat Jul 29 11:32:52 +0000 2017",
    retweet_count: 18092,
    favorite_count: 73271,
    is_retweet: false,
    id_str: "891260230876659713"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The very outdated filibuster rule must go. Budget reconciliation is killing R's in Senate. Mitch M, go to 51 Votes NOW and WIN. IT'S TIME!",
    created_at: "Sat Jul 29 11:28:57 +0000 2017",
    retweet_count: 17724,
    favorite_count: 71934,
    is_retweet: false,
    id_str: "891259245106278400"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republican Senate must get rid of 60 vote NOW! It is killing the R Party, allows 8 Dems to control country. 200 Bills sit in Senate. A JOKE!",
    created_at: "Sat Jul 29 11:20:29 +0000 2017",
    retweet_count: 18453,
    favorite_count: 69689,
    is_retweet: false,
    id_str: "891257113565163520"
  },
  {
    source: "Twitter for iPhone",
    text:
      "In other words, Russia was against Trump in the 2016 Election - and why not, I want strong military &amp; low oil prices. Witch Hunt! https://t.co/mMSxj4Su5z",
    created_at: "Sat Jul 29 11:07:18 +0000 2017",
    retweet_count: 19020,
    favorite_count: 64793,
    is_retweet: false,
    id_str: "891253798500487168"
  },
  {
    source: "Media Studio",
    text:
      "We will defend our country, protect our communities and put the safety of the AMERICAN PEOPLE FIRST! Replay: https://t.co/dcZxPKOPZ9 https://t.co/0NGiIhGY18",
    created_at: "Sat Jul 29 00:06:26 +0000 2017",
    retweet_count: 15037,
    favorite_count: 62779,
    is_retweet: false,
    id_str: "891087485111087104"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I would like to thank Reince Priebus for his service and dedication to his country. We accomplished a lot together and I am proud of him!",
    created_at: "Fri Jul 28 21:00:19 +0000 2017",
    retweet_count: 15792,
    favorite_count: 80770,
    is_retweet: false,
    id_str: "891040645581873152"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...and a Great Leader. John has also done a spectacular job at Homeland Security. He has been a true star of my Administration",
    created_at: "Fri Jul 28 20:54:43 +0000 2017",
    retweet_count: 14468,
    favorite_count: 68485,
    is_retweet: false,
    id_str: "891039237319143424"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am pleased to inform you that I have just named General/Secretary John F Kelly as White House Chief of Staff. He is a Great American....",
    created_at: "Fri Jul 28 20:49:51 +0000 2017",
    retweet_count: 24516,
    favorite_count: 92878,
    is_retweet: false,
    id_str: "891038014314598400"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Departing for Long Island now. An area under siege from #MS13 gang members. We will not rest until #MS13 is eradicated. #LESM https://t.co/GsgbBUXyHS",
    created_at: "Fri Jul 28 16:24:30 +0000 2017",
    retweet_count: 13675,
    favorite_count: 58914,
    is_retweet: false,
    id_str: "890971233159962624"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We will always ENFORCE our laws, PROTECT our borders, and SUPPORT our police! #LESM\nHarrisburg, Pennsylvania \n#FlashbackFriday #MS13 https://t.co/79Tskiv69j",
    created_at: "Fri Jul 28 16:13:21 +0000 2017",
    retweet_count: 13971,
    favorite_count: 62365,
    is_retweet: false,
    id_str: "890968428370153472"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...Even though parts of healthcare could pass at 51, some really good things need 60. So many great future bills &amp; budgets need 60 votes....",
    created_at: "Fri Jul 28 14:00:42 +0000 2017",
    retweet_count: 10995,
    favorite_count: 55356,
    is_retweet: false,
    id_str: "890935044474380288"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If Republicans are going to pass great future legislation in the Senate, they must immediately go to a 51 vote majority, not senseless 60...",
    created_at: "Fri Jul 28 13:46:28 +0000 2017",
    retweet_count: 14432,
    favorite_count: 63380,
    is_retweet: false,
    id_str: "890931465885798400"
  },
  {
    source: "Twitter for iPhone",
    text:
      "3 Republicans and 48 Democrats let the American people down. As I said from the beginning, let ObamaCare implode, then deal. Watch!",
    created_at: "Fri Jul 28 06:25:33 +0000 2017",
    retweet_count: 27123,
    favorite_count: 93756,
    is_retweet: false,
    id_str: "890820505330212864"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Go Republican Senators, Go! Get there after waiting for 7 years. Give America great healthcare!",
    created_at: "Fri Jul 28 02:43:30 +0000 2017",
    retweet_count: 13641,
    favorite_count: 73164,
    is_retweet: false,
    id_str: "890764622852173826"
  },
  {
    source: "Media Studio",
    text:
      "It was my great HONOR to present our nation's highest award for a public safety officer - THE MEDAL OF VALOR to FIVE AMERICAN HEROES! https://t.co/j7ceXuBZ3f",
    created_at: "Thu Jul 27 22:49:05 +0000 2017",
    retweet_count: 13266,
    favorite_count: 63785,
    is_retweet: false,
    id_str: "890705628716466176"
  },
  {
    source: "Media Studio",
    text:
      "Today, we gathered in the East Room to pay tribute to the HEROES whose courageous actions under fire saved so many lives in Alexandria, VA. https://t.co/it52TkLsye",
    created_at: "Thu Jul 27 21:36:51 +0000 2017",
    retweet_count: 12683,
    favorite_count: 67187,
    is_retweet: false,
    id_str: "890687451156631555"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me live as we recognize the first responders to the June 14th shooting involving @SteveScalise. #TeamScalise https://t.co/qOolNmB65d https://t.co/6OCn9JfMAG",
    created_at: "Thu Jul 27 19:08:58 +0000 2017",
    retweet_count: 7887,
    favorite_count: 43084,
    is_retweet: false,
    id_str: "890650237060120576"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big progress being made in ridding our country of MS-13 gang members and gang members in general. MAKE AMERICA SAFE AGAIN!",
    created_at: "Thu Jul 27 18:37:44 +0000 2017",
    retweet_count: 19433,
    favorite_count: 94758,
    is_retweet: false,
    id_str: "890642377131515904"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...about then candidate Trump.\" Catherine Herridge @FoxNews. So why doesn't Fake News report this? Witch Hunt! Purposely phony reporting.",
    created_at: "Thu Jul 27 13:45:22 +0000 2017",
    retweet_count: 12467,
    favorite_count: 54808,
    is_retweet: false,
    id_str: "890568797941362690"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"One of the things that has been lost in the politics of this situation is that the Russians collected and spread negative information.....',
    created_at: "Thu Jul 27 13:35:35 +0000 2017",
    retweet_count: 13164,
    favorite_count: 57728,
    is_retweet: false,
    id_str: "890566339462672385"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @townhallcom: ABC, NBC, And CBS Pretty Much Bury IT Scandal Engulfing Debbie Wasserman Schultz's Office https://t.co/PjbZ2TGIKb",
    created_at: "Thu Jul 27 12:49:41 +0000 2017",
    retweet_count: 25716,
    favorite_count: 0,
    is_retweet: true,
    id_str: "890554786755555329"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Come on Republican Senators, you can do it on Healthcare. After 7 years, this is your chance to shine! Don't let the American people down!",
    created_at: "Thu Jul 27 11:24:52 +0000 2017",
    retweet_count: 21456,
    favorite_count: 93516,
    is_retweet: false,
    id_str: "890533442135502849"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Wow, the Failing @nytimes said about @foxandfriends "....the most powerful T.V. show in America."',
    created_at: "Thu Jul 27 10:48:53 +0000 2017",
    retweet_count: 11826,
    favorite_count: 55479,
    is_retweet: false,
    id_str: "890524387773997056"
  },
  {
    source: "Media Studio",
    text:
      "Thank you Foxconn, for investing $10 BILLION DOLLARS with the potential for up to 13K new jobs in Wisconsin! MadeInTheUSA🇺🇸 https://t.co/jJghVeb63s",
    created_at: "Thu Jul 27 00:01:35 +0000 2017",
    retweet_count: 21236,
    favorite_count: 91566,
    is_retweet: false,
    id_str: "890361489126805504"
  },
  {
    source: "Media Studio",
    text:
      "Congratulations to Boys and Girls Nation. It was my great honor to welcome you to the WH today! Full Remarks: https://t.co/Pb5FTTOyWf https://t.co/U6tfV93dDG",
    created_at: "Wed Jul 26 20:54:14 +0000 2017",
    retweet_count: 10041,
    favorite_count: 50280,
    is_retweet: false,
    id_str: "890314337696579584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "IN AMERICA WE DON'T WORSHIP GOVERNMENT - WE WORSHIP GOD!🎥https://t.co/jIejSgVnnA",
    created_at: "Wed Jul 26 17:21:19 +0000 2017",
    retweet_count: 37683,
    favorite_count: 131013,
    is_retweet: false,
    id_str: "890260758050856961"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...big dollars ($700,000) for his wife's political run from Hillary Clinton and her representatives. Drain the Swamp!",
    created_at: "Wed Jul 26 13:52:57 +0000 2017",
    retweet_count: 16929,
    favorite_count: 74591,
    is_retweet: false,
    id_str: "890208319566229504"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Why didn't A.G. Sessions replace Acting FBI Director Andrew McCabe, a Comey friend who was in charge of Clinton investigation but got....",
    created_at: "Wed Jul 26 13:48:02 +0000 2017",
    retweet_count: 16092,
    favorite_count: 64335,
    is_retweet: false,
    id_str: "890207082926022656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....victory and cannot be burdened with the tremendous medical costs and disruption that transgender in the military would entail. Thank you",
    created_at: "Wed Jul 26 13:08:21 +0000 2017",
    retweet_count: 43406,
    favorite_count: 143128,
    is_retweet: false,
    id_str: "890197095151546369"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....Transgender individuals to  serve in any capacity in the U.S. Military. Our military must be focused on decisive and overwhelming.....",
    created_at: "Wed Jul 26 13:04:39 +0000 2017",
    retweet_count: 45736,
    favorite_count: 138148,
    is_retweet: false,
    id_str: "890196164313833472"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After consultation with my Generals and military experts, please be advised that the United States Government will not accept or allow......",
    created_at: "Wed Jul 26 12:55:58 +0000 2017",
    retweet_count: 43443,
    favorite_count: 127153,
    is_retweet: false,
    id_str: "890193981585444864"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Senator @lisamurkowski of the Great State of Alaska really let the Republicans, and our country, down yesterday. Too bad!",
    created_at: "Wed Jul 26 11:13:28 +0000 2017",
    retweet_count: 14612,
    favorite_count: 59522,
    is_retweet: false,
    id_str: "890168183079960576"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The crowd in Ohio was amazing last night - broke all records. We all had a great time in a great State. Will be back soon!",
    created_at: "Wed Jul 26 10:49:28 +0000 2017",
    retweet_count: 12643,
    favorite_count: 76466,
    is_retweet: false,
    id_str: "890162144884514820"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Sen. John McCain making his return to the Senate ahead of health care vote https://t.co/VuojpRpcLM",
    created_at: "Wed Jul 26 10:44:10 +0000 2017",
    retweet_count: 1585,
    favorite_count: 0,
    is_retweet: true,
    id_str: "890160810294685696"
  },
  {
    source: "Media Studio",
    text:
      "People of Ohio are fantastic. Thank you so much. What an evening! https://t.co/KM0zoaULYH",
    created_at: "Wed Jul 26 04:40:09 +0000 2017",
    retweet_count: 10493,
    favorite_count: 55359,
    is_retweet: false,
    id_str: "890069204082151424"
  },
  {
    source: "Media Studio",
    text:
      "It was my great honor to join our wonderful Veterans at AMVETS Post 44 in Youngstown, Ohio this evening. A grateful nation salutes you! https://t.co/RxobYHP1oR",
    created_at: "Wed Jul 26 04:05:03 +0000 2017",
    retweet_count: 12063,
    favorite_count: 60984,
    is_retweet: false,
    id_str: "890060370861334529"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just arrived in Youngstown, Ohio with @FLOTUS Melania!\n#MakeAmericaGreatAgain🇺🇸\n🎥https://t.co/A1mrxSksR3 https://t.co/jWX9yBlX8z",
    created_at: "Tue Jul 25 22:15:50 +0000 2017",
    retweet_count: 9246,
    favorite_count: 52162,
    is_retweet: false,
    id_str: "889972487844491265"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@SenJohnMcCain-Thank you for coming to D.C. for such a vital vote. Congrats to all Rep. We can now deliver grt healthcare to all Americans!",
    created_at: "Tue Jul 25 19:24:40 +0000 2017",
    retweet_count: 14599,
    favorite_count: 67747,
    is_retweet: false,
    id_str: "889929412539543552"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Joint Press Conference with Prime Minister Saad Hariri of Lebanon beginning shortly. Join us live!\n➡️https://t.co/7pquWbEutn https://t.co/JHVHKgrPOY",
    created_at: "Tue Jul 25 19:07:42 +0000 2017",
    retweet_count: 4586,
    favorite_count: 26651,
    is_retweet: false,
    id_str: "889925142675062784"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"America\'s Labor Market Continues to Boom" JOBS, JOBS, JOBS! https://t.co/LuOaR1Iz2e',
    created_at: "Tue Jul 25 15:35:42 +0000 2017",
    retweet_count: 12527,
    favorite_count: 51509,
    is_retweet: false,
    id_str: "889871789198802944"
  },
  {
    source: "Media Studio",
    text:
      "The American people have waited long enough. There has been enough talk and no action for seven years. Now is the time for action! https://t.co/VdTiYL0Ua7",
    created_at: "Tue Jul 25 15:20:01 +0000 2017",
    retweet_count: 13969,
    favorite_count: 59968,
    is_retweet: false,
    id_str: "889867842186649600"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Will be traveling to the Great State of Ohio tonight. Big crowd expected. See you there!",
    created_at: "Tue Jul 25 12:29:03 +0000 2017",
    retweet_count: 12243,
    favorite_count: 69155,
    is_retweet: false,
    id_str: "889824817473605632"
  },
  {
    source: "Twitter for iPhone",
    text:
      "This will be a very interesting day for HealthCare.The Dems are obstructionists but the Republicans can have a great victory for the people!",
    created_at: "Tue Jul 25 12:19:29 +0000 2017",
    retweet_count: 12075,
    favorite_count: 58423,
    is_retweet: false,
    id_str: "889822411356602369"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Working on major Trade Deal with the United Kingdom. Could be very big &amp; exciting. JOBS! The E.U. is very protectionist with the U.S. STOP!",
    created_at: "Tue Jul 25 12:16:34 +0000 2017",
    retweet_count: 16722,
    favorite_count: 70843,
    is_retweet: false,
    id_str: "889821674987761664"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Jared Kushner did very well yesterday in proving he did not collude with the Russians. Witch Hunt. Next up, 11 year old Barron Trump!",
    created_at: "Tue Jul 25 10:52:27 +0000 2017",
    retweet_count: 22579,
    favorite_count: 91712,
    is_retweet: false,
    id_str: "889800510106107904"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So great that John McCain is coming back to vote. Brave - American hero! Thank you John.",
    created_at: "Tue Jul 25 10:44:06 +0000 2017",
    retweet_count: 22788,
    favorite_count: 82480,
    is_retweet: false,
    id_str: "889798407228989441"
  },
  {
    source: "Twitter for iPhone",
    text:
      "ObamaCare is torturing the American People.The Democrats have fooled the people long enough. Repeal or Repeal &amp; Replace! I have pen in hand.",
    created_at: "Tue Jul 25 10:38:11 +0000 2017",
    retweet_count: 16409,
    favorite_count: 70145,
    is_retweet: false,
    id_str: "889796918615920640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big day for HealthCare. After 7 years of talking, we will soon see whether or not Republicans are willing to step up to the plate!",
    created_at: "Tue Jul 25 10:27:47 +0000 2017",
    retweet_count: 13852,
    favorite_count: 64975,
    is_retweet: false,
    id_str: "889794300913045508"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Problem is that the acting head of the FBI &amp; the person in charge of the Hillary investigation, Andrew McCabe, got $700,000 from H for wife!",
    created_at: "Tue Jul 25 10:21:41 +0000 2017",
    retweet_count: 22532,
    favorite_count: 72206,
    is_retweet: false,
    id_str: "889792764363276288"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Attorney General Jeff Sessions has taken a VERY weak position on Hillary Clinton crimes (where are E-mails &amp; DNC server) &amp; Intel leakers!",
    created_at: "Tue Jul 25 10:12:24 +0000 2017",
    retweet_count: 19778,
    favorite_count: 71253,
    is_retweet: false,
    id_str: "889790429398528000"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Ukrainian efforts to sabotage Trump campaign - "quietly working to boost Clinton." So where is the investigation A.G. @seanhannity',
    created_at: "Tue Jul 25 10:03:33 +0000 2017",
    retweet_count: 17167,
    favorite_count: 58316,
    is_retweet: false,
    id_str: "889788202172780544"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Is Fake News Washington Post being used as a lobbyist weapon against Congress to keep Politicians from looking into Amazon no-tax monopoly?",
    created_at: "Tue Jul 25 02:36:17 +0000 2017",
    retweet_count: 17448,
    favorite_count: 63048,
    is_retweet: false,
    id_str: "889675644396867584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So many stories about me in the @washingtonpost are Fake News. They are as bad as ratings challenged @CNN. Lobbyist for Amazon and taxes?",
    created_at: "Tue Jul 25 02:28:44 +0000 2017",
    retweet_count: 13338,
    favorite_count: 55705,
    is_retweet: false,
    id_str: "889673743873843200"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Amazon Washington Post fabricated the facts on my ending massive, dangerous, and wasteful payments to Syrian rebels fighting Assad.....",
    created_at: "Tue Jul 25 02:23:18 +0000 2017",
    retweet_count: 15482,
    favorite_count: 59829,
    is_retweet: false,
    id_str: "889672374458646528"
  },
  {
    source: "Media Studio",
    text:
      "#2017Jambo- Remember your duty. Honor your history. Take care of the people God puts into your life – and LOVE &amp; CHERISH your country! https://t.co/DnNYxGJm4I",
    created_at: "Tue Jul 25 01:13:42 +0000 2017",
    retweet_count: 19511,
    favorite_count: 71804,
    is_retweet: false,
    id_str: "889654862379589633"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Any senator who votes against starting debate is telling America that you are fine w/ the #OCareNightmare! \nRemarks: https://t.co/tSvWaMdxBA https://t.co/DI7e78hr6N",
    created_at: "Mon Jul 24 21:33:25 +0000 2017",
    retweet_count: 11724,
    favorite_count: 42868,
    is_retweet: false,
    id_str: "889599425458327552"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Arriving at Joint Base Andrews with @SecretaryPerry, @SecretaryZinke, and @SecPriceMD..... https://t.co/Yxm94XKtuv",
    created_at: "Mon Jul 24 20:15:25 +0000 2017",
    retweet_count: 10620,
    favorite_count: 45954,
    is_retweet: false,
    id_str: "889579795176181761"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republicans have a last chance to do the right thing on Repeal &amp; Replace after years of talking &amp; campaigning on it.",
    created_at: "Mon Jul 24 13:18:07 +0000 2017",
    retweet_count: 19819,
    favorite_count: 83561,
    is_retweet: false,
    id_str: "889474780356915206"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Sleazy Adam Schiff, the totally biased Congressman looking into "Russia," spends all of his time on television pushing the Dem loss excuse!',
    created_at: "Mon Jul 24 13:12:59 +0000 2017",
    retweet_count: 21363,
    favorite_count: 81461,
    is_retweet: false,
    id_str: "889473486506385409"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So why aren't the Committees and investigators, and of course our beleaguered A.G., looking into Crooked Hillarys crimes &amp; Russia relations?",
    created_at: "Mon Jul 24 12:49:38 +0000 2017",
    retweet_count: 24879,
    favorite_count: 88254,
    is_retweet: false,
    id_str: "889467610332528641"
  },
  {
    source: "Twitter for iPhone",
    text:
      'After 1 year of investigation with Zero evidence being found, Chuck Schumer just stated that "Democrats should blame ourselves,not Russia."',
    created_at: "Mon Jul 24 10:52:39 +0000 2017",
    retweet_count: 28633,
    favorite_count: 100874,
    is_retweet: false,
    id_str: "889438168721874944"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Drain the Swamp should be changed to Drain the Sewer - it's actually much worse than anyone ever thought, and it begins with the Fake News!",
    created_at: "Mon Jul 24 10:40:28 +0000 2017",
    retweet_count: 33079,
    favorite_count: 117414,
    is_retweet: false,
    id_str: "889435104841523201"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to @LOUDOBBS for giving the first six months of the Trump Administration an A+. S.C.,reg cutting,Stock M, jobs,border etc. = TRUE!",
    created_at: "Mon Jul 24 00:23:40 +0000 2017",
    retweet_count: 20417,
    favorite_count: 83996,
    is_retweet: false,
    id_str: "889279880336166914"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If Republicans don't Repeal and Replace the disastrous ObamaCare, the repercussions will be far greater than any of them understand!",
    created_at: "Mon Jul 24 00:01:47 +0000 2017",
    retweet_count: 22133,
    favorite_count: 89832,
    is_retweet: false,
    id_str: "889274373689028609"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It's hard to read the Failing New York Times or the Amazon Washington Post because every story/opinion, even if should be positive, is bad!",
    created_at: "Sun Jul 23 23:57:36 +0000 2017",
    retweet_count: 15589,
    favorite_count: 71155,
    is_retweet: false,
    id_str: "889273320574783489"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It's very sad that Republicans, even some that were carried over the line on my back, do very little to protect their President.",
    created_at: "Sun Jul 23 20:14:32 +0000 2017",
    retweet_count: 35200,
    favorite_count: 134160,
    is_retweet: false,
    id_str: "889217183930351621"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @realDonaldTrump: As the phony Russian Witch Hunt continues, two groups are laughing at this excuse for a lost election taking hold, Dem…",
    created_at: "Sun Jul 23 20:11:11 +0000 2017",
    retweet_count: 1015,
    favorite_count: 0,
    is_retweet: true,
    id_str: "889216341013655552"
  },
  {
    source: "Twitter for iPhone",
    text:
      "As the phony Russian Witch Hunt continues, two groups are laughing at this excuse for a lost election taking hold, Democrats and Russians!",
    created_at: "Sun Jul 23 20:09:05 +0000 2017",
    retweet_count: 20088,
    favorite_count: 87621,
    is_retweet: false,
    id_str: "889215815022727168"
  },
  {
    source: "Media Studio",
    text:
      "To every PATRIOT who will serve on the #USSGeraldRFord:\n☑️Keep the watch🇺🇸\n☑️Protect her🇺🇸\n☑️Defend her🇺🇸\n☑️LOVE HER🇺🇸\nGood Luck &amp; Godspeed! https://t.co/shcz5GQkCh",
    created_at: "Sun Jul 23 00:50:17 +0000 2017",
    retweet_count: 27239,
    favorite_count: 111217,
    is_retweet: false,
    id_str: "888924192573235201"
  },
  {
    source: "Twitter for iPhone",
    text:
      "American steel &amp; American hands have constructed a 100,000 ton message to the world: American MIGHT IS SECOND TO NONE!\n#USSGeraldRFord #USA https://t.co/Pibf37Eybg",
    created_at: "Sat Jul 22 22:57:01 +0000 2017",
    retweet_count: 13339,
    favorite_count: 56799,
    is_retweet: false,
    id_str: "888895687865380864"
  },
  {
    source: "Media Studio",
    text:
      "A ship is only as good as the people who serve on it — and the AMERICAN SAILOR is the BEST in the world. @USNavy #USSGeraldRFord https://t.co/YmiTLXcCEh",
    created_at: "Sat Jul 22 19:22:35 +0000 2017",
    retweet_count: 16695,
    favorite_count: 73092,
    is_retweet: false,
    id_str: "888841724759597057"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me live for the commissioning ceremony of the USS Gerald R. Ford!\n➡️https://t.co/F78iOR64TW #USA https://t.co/PrVceEmPOB",
    created_at: "Sat Jul 22 14:43:18 +0000 2017",
    retweet_count: 8557,
    favorite_count: 46317,
    is_retweet: false,
    id_str: "888771440014749697"
  },
  {
    source: "Twitter for iPhone",
    text:
      "ObamaCare is dead and the Democrats are obstructionists, no ideas or votes, only obstruction. It is solely up to the 52 Republican Senators!",
    created_at: "Sat Jul 22 12:23:30 +0000 2017",
    retweet_count: 20453,
    favorite_count: 84103,
    is_retweet: false,
    id_str: "888736256145985536"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Republican Senators must step up to the plate and, after 7 years, vote to Repeal and Replace. Next, Tax Reform and Infrastructure. WIN!",
    created_at: "Sat Jul 22 12:17:54 +0000 2017",
    retweet_count: 19637,
    favorite_count: 86049,
    is_retweet: false,
    id_str: "888734848550043648"
  },
  {
    source: "Twitter for iPhone",
    text:
      "In all fairness to Anthony Scaramucci, he wanted to endorse me 1st, before the Republican Primaries started, but didn't think I was running!",
    created_at: "Sat Jul 22 12:10:41 +0000 2017",
    retweet_count: 11206,
    favorite_count: 58321,
    is_retweet: false,
    id_str: "888733031875346432"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My son Donald openly gave his e-mails to the media &amp; authorities whereas Crooked Hillary Clinton deleted (&amp; acid washed) her 33,000 e-mails!",
    created_at: "Sat Jul 22 12:00:30 +0000 2017",
    retweet_count: 27447,
    favorite_count: 109944,
    is_retweet: false,
    id_str: "888730468732067841"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...What about all of the Clinton ties to Russia, including Podesta Company, Uranium deal, Russian Reset, big dollar speeches etc.",
    created_at: "Sat Jul 22 11:47:53 +0000 2017",
    retweet_count: 24813,
    favorite_count: 87505,
    is_retweet: false,
    id_str: "888727293346156546"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So many people are asking why isn't the A.G. or Special Council looking at the many Hillary Clinton or Comey crimes. 33,000 e-mails deleted?",
    created_at: "Sat Jul 22 11:44:29 +0000 2017",
    retweet_count: 29545,
    favorite_count: 105571,
    is_retweet: false,
    id_str: "888726438265966592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "While all agree the U. S. President has the complete power to pardon, why think of that when only crime so far is LEAKS against us.FAKE NEWS",
    created_at: "Sat Jul 22 11:35:34 +0000 2017",
    retweet_count: 17458,
    favorite_count: 72192,
    is_retweet: false,
    id_str: "888724194820857857"
  },
  {
    source: "Twitter for iPhone",
    text:
      "This morning I will be going to the Commissioning Ceremony for the largest aircraft carrier in the world, The Gerald R. Ford.  Norfolk, Va.",
    created_at: "Sat Jul 22 10:52:00 +0000 2017",
    retweet_count: 12151,
    favorite_count: 74010,
    is_retweet: false,
    id_str: "888713231065391104"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Failing New York Times foiled U.S. attempt to kill the single most wanted terrorist,Al-Baghdadi.Their sick agenda over National Security",
    created_at: "Sat Jul 22 10:45:05 +0000 2017",
    retweet_count: 20637,
    favorite_count: 69595,
    is_retweet: false,
    id_str: "888711488717934592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A new INTELLIGENCE LEAK from the Amazon Washington Post,this time against A.G. Jeff Sessions.These illegal leaks, like Comey's, must stop!",
    created_at: "Sat Jul 22 10:33:01 +0000 2017",
    retweet_count: 19168,
    favorite_count: 73455,
    is_retweet: false,
    id_str: "888708453560184832"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Sean Spicer is a wonderful person who took tremendous abuse from the Fake News Media - but his future is bright!",
    created_at: "Sat Jul 22 01:46:33 +0000 2017",
    retweet_count: 23056,
    favorite_count: 120240,
    is_retweet: false,
    id_str: "888575966259314691"
  },
  {
    source: "Media Studio",
    text:
      "Today, it was my privilege to welcome survivors of the #USSArizona to the @WhiteHouse. #HonorThem🇺🇸\nRemarks: https://t.co/gySxxqazBl https://t.co/6IPmbqVi10",
    created_at: "Fri Jul 21 22:47:40 +0000 2017",
    retweet_count: 14925,
    favorite_count: 69792,
    is_retweet: false,
    id_str: "888530948811366400"
  },
  {
    source: "Media Studio",
    text:
      "Today, it was my privilege to welcome survivors of the #USSArizona to the WH. Remarks: https://t.co/gySxxqazBl\n\nhttps://t.co/gySxxqazBl https://t.co/ZJaLAfBcv0",
    created_at: "Fri Jul 21 22:42:30 +0000 2017",
    retweet_count: 459,
    favorite_count: 1736,
    is_retweet: false,
    id_str: "888529645381062656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Manufacturers’ record-high optimism reported in the 1st qtr has carried into the 2nd qtr of 2017 via @ShopFloorNAM:\nhttps://t.co/a42fNElct1 https://t.co/WHZtcAxhRQ",
    created_at: "Fri Jul 21 19:19:56 +0000 2017",
    retweet_count: 10206,
    favorite_count: 41284,
    is_retweet: false,
    id_str: "888478670502932480"
  },
  {
    source: "Media Studio",
    text:
      "ICYMI- This week we hosted a #MadeInAmerica event, right here at the @WhiteHouse! If it is MADE IN AMERICA, it is the BEST! USA🇺🇸 https://t.co/q4vB9GdE5y",
    created_at: "Fri Jul 21 16:06:04 +0000 2017",
    retweet_count: 13032,
    favorite_count: 58876,
    is_retweet: false,
    id_str: "888429879603191811"
  },
  {
    source: "Media Studio",
    text:
      '"Six months in - it is the hope of GROWTH📈that is making America🇺🇸FOUR TRILLION DOLLARS💰RICHER." -Stuart @VarneyCo\n🎥https://t.co/s7fYOicWGV https://t.co/x9MeUzDom6',
    created_at: "Fri Jul 21 15:28:38 +0000 2017",
    retweet_count: 15615,
    favorite_count: 56880,
    is_retweet: false,
    id_str: "888420461075476480"
  },
  {
    source: "Twitter for iPhone",
    text:
      "#MadeInAmerica🇺🇸\n📸https://t.co/39dwlGHI7R https://t.co/VfIrc5Xssx",
    created_at: "Fri Jul 21 13:41:01 +0000 2017",
    retweet_count: 9028,
    favorite_count: 42436,
    is_retweet: false,
    id_str: "888393378970439682"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Billions of dollars in investments &amp; thousands of new jobs in America! An initiative via Corning, Merck &amp; Pfizer: https://t.co/QneN48bSiq https://t.co/5VtMfuY3PM",
    created_at: "Fri Jul 21 03:31:45 +0000 2017",
    retweet_count: 13909,
    favorite_count: 59311,
    is_retweet: false,
    id_str: "888240051599134721"
  },
  {
    source: "Media Studio",
    text:
      "I am asking all citizens to believe in yourselves, believe in your future, and believe, once more, in America. #AmericaFirst🇺🇸 https://t.co/NOnhJyWp4J",
    created_at: "Thu Jul 20 20:08:58 +0000 2017",
    retweet_count: 34804,
    favorite_count: 122092,
    is_retweet: false,
    id_str: "888128621784838144"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Departing The Pentagon after meetings with @VP Pence, Secretary James Mattis, and our great teams. #MAGA🇺🇸 https://t.co/5d1MSzhjQS",
    created_at: "Thu Jul 20 17:27:40 +0000 2017",
    retweet_count: 13124,
    favorite_count: 60572,
    is_retweet: false,
    id_str: "888088029428150272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Melania and I send our thoughts and prayers to Senator McCain, Cindy, and their entire family. Get well soon. \nhttps://t.co/fONWVlmYyz",
    created_at: "Thu Jul 20 02:33:15 +0000 2017",
    retweet_count: 15805,
    favorite_count: 84370,
    is_retweet: false,
    id_str: "887862941109940225"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Republicans never discuss how good their healthcare bill is, &amp; it will get even better at lunchtime.The Dems scream death as OCare dies!",
    created_at: "Wed Jul 19 12:46:14 +0000 2017",
    retweet_count: 16272,
    favorite_count: 75511,
    is_retweet: false,
    id_str: "887654816507408384"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be having lunch at the White House today with Republican Senators concerning healthcare. They MUST keep their promise to America!",
    created_at: "Wed Jul 19 12:30:22 +0000 2017",
    retweet_count: 18641,
    favorite_count: 93049,
    is_retweet: false,
    id_str: "887650824515661824"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @FoxNews: U.S. Markets since election. https://t.co/rlWSt30GUd",
    created_at: "Wed Jul 19 01:03:43 +0000 2017",
    retweet_count: 11443,
    favorite_count: 0,
    is_retweet: true,
    id_str: "887478019346051075"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News is becoming more and more dishonest! Even a dinner arranged for top 20 leaders in Germany is made to look sinister!",
    created_at: "Wed Jul 19 00:59:56 +0000 2017",
    retweet_count: 27469,
    favorite_count: 109127,
    is_retweet: false,
    id_str: "887477071160762369"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Fake News story of secret dinner with Putin is "sick." All G 20 leaders, and spouses, were invited by the Chancellor of Germany. Press knew!',
    created_at: "Wed Jul 19 00:53:12 +0000 2017",
    retweet_count: 26708,
    favorite_count: 98186,
    is_retweet: false,
    id_str: "887475373981696000"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Senate must go to a 51 vote majority instead of current 60 votes. Even parts of full Repeal need 60. 8 Dems control Senate. Crazy!",
    created_at: "Tue Jul 18 13:26:47 +0000 2017",
    retweet_count: 19171,
    favorite_count: 74152,
    is_retweet: false,
    id_str: "887302632687251456"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With only a very small majority, the Republicans in the House &amp; Senate need more victories next year since Dems totally obstruct, no votes!",
    created_at: "Tue Jul 18 13:15:55 +0000 2017",
    retweet_count: 15648,
    favorite_count: 67041,
    is_retweet: false,
    id_str: "887299895803203584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "As I have always said, let ObamaCare fail and then come together and do a great healthcare plan. Stay tuned!",
    created_at: "Tue Jul 18 11:58:22 +0000 2017",
    retweet_count: 18484,
    favorite_count: 84372,
    is_retweet: false,
    id_str: "887280380423938048"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We were let down by all of the Democrats and a few Republicans. Most Republicans were loyal, terrific &amp; worked really hard. We will return!",
    created_at: "Tue Jul 18 11:53:05 +0000 2017",
    retweet_count: 16670,
    favorite_count: 78612,
    is_retweet: false,
    id_str: "887279050263285761"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republicans should just REPEAL failing ObamaCare now &amp; work on a new Healthcare Plan that will start from a clean slate. Dems will join in!",
    created_at: "Tue Jul 18 02:17:50 +0000 2017",
    retweet_count: 28599,
    favorite_count: 114485,
    is_retweet: false,
    id_str: "887134287350439936"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Most politicians would have gone to a meeting like the one Don jr attended in order to get info on an opponent. That's politics!",
    created_at: "Mon Jul 17 14:07:55 +0000 2017",
    retweet_count: 20486,
    favorite_count: 102537,
    is_retweet: false,
    id_str: "886950594220568576"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Heading back to Washington, D.C. Much will be accomplished this week on trade, the military and security!",
    created_at: "Mon Jul 17 00:24:28 +0000 2017",
    retweet_count: 15861,
    favorite_count: 89884,
    is_retweet: false,
    id_str: "886743367815766021"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to Sung Hyun Park on winning the 2017 @USGA #USWomensOpen🇺🇸",
    created_at: "Mon Jul 17 00:22:50 +0000 2017",
    retweet_count: 7168,
    favorite_count: 48125,
    is_retweet: false,
    id_str: "886742955251335168"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am at the @USGA  #USWomensOpen. An amateur player is co-leading for the first time in many decades - very exciting!",
    created_at: "Sun Jul 16 21:00:03 +0000 2017",
    retweet_count: 7332,
    favorite_count: 51984,
    is_retweet: false,
    id_str: "886691926233239556"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The #USSJohnFinn will provide essential capabilities to keep America safe. Our sailors are the best anywhere in the world. Congratulations! https://t.co/yTnMwSh1Kg",
    created_at: "Sun Jul 16 17:16:32 +0000 2017",
    retweet_count: 15103,
    favorite_count: 69926,
    is_retweet: false,
    id_str: "886635676787232768"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The ABC/Washington Post Poll, even though almost 40% is not bad at this time, was just about the most inaccurate poll around election time!",
    created_at: "Sun Jul 16 14:10:25 +0000 2017",
    retweet_count: 14212,
    favorite_count: 72783,
    is_retweet: false,
    id_str: "886588838902206464"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With all of its phony unnamed sources &amp; highly slanted &amp; even fraudulent reporting, #Fake News is DISTORTING DEMOCRACY in our country!",
    created_at: "Sun Jul 16 11:15:10 +0000 2017",
    retweet_count: 23939,
    favorite_count: 96428,
    is_retweet: false,
    id_str: "886544734788997125"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to former campaign adviser Michael Caputo for saying so powerfully that there was no Russian collusion in our winning campaign.",
    created_at: "Sun Jul 16 11:04:07 +0000 2017",
    retweet_count: 19730,
    favorite_count: 92061,
    is_retweet: false,
    id_str: "886541955311816705"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to all of the supporters, who far out-numbered the protesters, yesterday at the Women's U.S. Open. Very cool!",
    created_at: "Sun Jul 16 10:51:12 +0000 2017",
    retweet_count: 19513,
    favorite_count: 112717,
    is_retweet: false,
    id_str: "886538703547621376"
  },
  {
    source: "Twitter for iPhone",
    text:
      "HillaryClinton can illegally get the questions to the Debate &amp; delete 33,000 emails but my son Don is being scorned by the Fake News Media?",
    created_at: "Sun Jul 16 10:35:44 +0000 2017",
    retweet_count: 38330,
    favorite_count: 143851,
    is_retweet: false,
    id_str: "886534810575020032"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The women played great today at the @USGA #USWomensOpen🇺🇸 I look forward to being there tomorrow for the final round! https://t.co/2oWyptgfIY",
    created_at: "Sun Jul 16 03:04:47 +0000 2017",
    retweet_count: 7506,
    favorite_count: 46187,
    is_retweet: false,
    id_str: "886421324637380609"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just got to the #USWomensOpen in Bedminster, New Jersey. People are really happy with record high stock market - up over 17% since election!",
    created_at: "Sat Jul 15 20:29:54 +0000 2017",
    retweet_count: 11542,
    favorite_count: 66479,
    is_retweet: false,
    id_str: "886321948275429381"
  },
  {
    source: "Twitter for iPhone",
    text: "MAKE AMERICA GREAT AGAIN! https://t.co/3eYF3nir4B",
    created_at: "Sat Jul 15 20:19:28 +0000 2017",
    retweet_count: 15555,
    favorite_count: 65311,
    is_retweet: false,
    id_str: "886319322154586112"
  },
  {
    source: "Media Studio",
    text:
      "Next week the Senate is going to vote on legislation to save Americans from the ObamaCare DISASTER. #WeeklyAddress🇺🇸 https://t.co/xjVDkgo1NK",
    created_at: "Sat Jul 15 17:56:57 +0000 2017",
    retweet_count: 13679,
    favorite_count: 60683,
    is_retweet: false,
    id_str: "886283456644251652"
  },
  {
    source: "Twitter for iPhone",
    text: "Will be at the Women's U.S. Open today!",
    created_at: "Sat Jul 15 16:33:34 +0000 2017",
    retweet_count: 6887,
    favorite_count: 55281,
    is_retweet: false,
    id_str: "886262474277888002"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Stock Market hit another all-time high yesterday - despite the Russian hoax story! Also, jobs numbers are starting to look very good!",
    created_at: "Sat Jul 15 16:30:23 +0000 2017",
    retweet_count: 18658,
    favorite_count: 87173,
    is_retweet: false,
    id_str: "886261674029854721"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Stock Market at new all-time high! Working on new trade deals that will be great for U.S. and its workers!",
    created_at: "Sat Jul 15 16:21:12 +0000 2017",
    retweet_count: 16386,
    favorite_count: 85526,
    is_retweet: false,
    id_str: "886259363412926464"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be at the @USGA #USWomensOpen in Bedminster, NJ tomorrow. Big crowds expected &amp; the women are playing great-should be very exciting!",
    created_at: "Sat Jul 15 03:02:59 +0000 2017",
    retweet_count: 7710,
    favorite_count: 50762,
    is_retweet: false,
    id_str: "886058483392622592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Honored to serve as Commander-in-Chief to the courageous men and women of our U.S. Armed Forces. A grateful nation thanks you! https://t.co/wERNV7J4oO",
    created_at: "Sat Jul 15 01:34:31 +0000 2017",
    retweet_count: 23174,
    favorite_count: 112362,
    is_retweet: false,
    id_str: "886036222308757504"
  },
  {
    source: "Media Studio",
    text:
      "President @EmmanuelMacron,\nThank you for inviting Melania and myself to such a historic celebration in France. #BastilleDay #14juillet https://t.co/KZjJQOo0H1",
    created_at: "Fri Jul 14 22:39:14 +0000 2017",
    retweet_count: 18800,
    favorite_count: 79045,
    is_retweet: false,
    id_str: "885992108565291008"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just landed from Paris, France. It was an incredible visit with President @EmmanuelMacron. A lot discussed and accomplished in two days!",
    created_at: "Fri Jul 14 22:22:58 +0000 2017",
    retweet_count: 10359,
    favorite_count: 61382,
    is_retweet: false,
    id_str: "885988016912838656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Left Paris for U.S.A. Will be heading to New Jersey and attending the\n#USWomensOpen, their most important tournament, this afternoon.",
    created_at: "Fri Jul 14 14:16:34 +0000 2017",
    retweet_count: 9377,
    favorite_count: 58385,
    is_retweet: false,
    id_str: "885865609971605508"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great conversations with President @EmmanuelMacron and his representatives on trade, military and security.",
    created_at: "Fri Jul 14 13:47:19 +0000 2017",
    retweet_count: 9169,
    favorite_count: 51117,
    is_retweet: false,
    id_str: "885858247277727746"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The United States mourns for the victims of Nice, France. We pledge our solidarity with France against terror. 🇺🇸🇫🇷 https://t.co/7irbz08oT3",
    created_at: "Fri Jul 14 13:39:47 +0000 2017",
    retweet_count: 11096,
    favorite_count: 53025,
    is_retweet: false,
    id_str: "885856351557210112"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was a great honor to represent the United States at the magnificent #BastilleDay parade. Congratulations President @EmmanuelMacron! https://t.co/1J4vZiy98y",
    created_at: "Fri Jul 14 11:04:16 +0000 2017",
    retweet_count: 14740,
    favorite_count: 67582,
    is_retweet: false,
    id_str: "885817217455140864"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@VP Mike Pence is working hard on HealthCare and getting our wonderful Republican Senators to do what is right for the people.",
    created_at: "Fri Jul 14 08:09:05 +0000 2017",
    retweet_count: 11260,
    favorite_count: 60424,
    is_retweet: false,
    id_str: "885773130723205120"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After all of these years of suffering thru ObamaCare, Republican Senators must come through as they have promised!",
    created_at: "Fri Jul 14 08:07:29 +0000 2017",
    retweet_count: 16005,
    favorite_count: 74543,
    is_retweet: false,
    id_str: "885772727315030020"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So impt Rep Senators, under leadership of @SenateMajLdr McConnell get healthcare plan approved. After 7yrs of O'Care disaster, must happen!",
    created_at: "Fri Jul 14 08:05:36 +0000 2017",
    retweet_count: 9810,
    favorite_count: 50000,
    is_retweet: false,
    id_str: "885772254017187840"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republicans Senators are working hard to get their failed ObamaCare replacement approved. I will be at my desk, pen in hand!",
    created_at: "Fri Jul 14 07:57:33 +0000 2017",
    retweet_count: 13878,
    favorite_count: 70229,
    is_retweet: false,
    id_str: "885770227514052608"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great evening with President @EmmanuelMacron &amp; Mrs. Macron. Went to Eiffel Tower for dinner. Relationship with France stronger than ever. https://t.co/ib1pdUYoEU",
    created_at: "Fri Jul 14 07:56:26 +0000 2017",
    retweet_count: 8872,
    favorite_count: 45347,
    is_retweet: false,
    id_str: "885769944482414593"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great bilateral meetings at Élysée Palace w/ President @EmmanuelMacron. The friendship between our two nations and ourselves is unbreakable. https://t.co/IOSoC0MdPv",
    created_at: "Thu Jul 13 19:20:56 +0000 2017",
    retweet_count: 12681,
    favorite_count: 58829,
    is_retweet: false,
    id_str: "885579818875670528"
  },
  {
    source: "Twitter for iPhone",
    text:
      "President @EmmanuelMacron,\nThank you for the beautiful welcome ceremony at Les Invalides today! https://t.co/RKir1GcRrB",
    created_at: "Thu Jul 13 18:45:49 +0000 2017",
    retweet_count: 11399,
    favorite_count: 57924,
    is_retweet: false,
    id_str: "885570979975639040"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Melania and I were thrilled to join the dedicated men and women of the @USEmbassyFrance, members of the U.S. Military and their families. https://t.co/ZSdsJ0Bsbl",
    created_at: "Thu Jul 13 12:50:16 +0000 2017",
    retweet_count: 14527,
    favorite_count: 70714,
    is_retweet: false,
    id_str: "885481504780013568"
  },
  {
    source: "Twitter Web Client",
    text:
      "Just landed in Paris, France with @FLOTUS Melania. https://t.co/knULGOQF1K",
    created_at: "Thu Jul 13 08:06:11 +0000 2017",
    retweet_count: 13860,
    favorite_count: 77588,
    is_retweet: false,
    id_str: "885410010167226370"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big WIN today for building the wall. It will secure the border &amp; save lives. Now the full House &amp; Senate must act! ➡️https://t.co/TTg7lvBdo2 https://t.co/xhiknXko70",
    created_at: "Wed Jul 12 23:24:08 +0000 2017",
    retweet_count: 21554,
    favorite_count: 70931,
    is_retweet: false,
    id_str: "885278633014812673"
  },
  {
    source: "Twitter for iPhone",
    text: "JOBS, JOBS, JOBS! #MAGA🇺🇸 https://t.co/HScS4Y9ZJK",
    created_at: "Wed Jul 12 23:12:03 +0000 2017",
    retweet_count: 23367,
    favorite_count: 81023,
    is_retweet: false,
    id_str: "885275592681295872"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Stock market hits another high with spirit and enthusiasm so positive. Jobs outlook looking very good! #MAGA🇺🇸 https://t.co/Vwxsb2vWGe",
    created_at: "Wed Jul 12 23:06:19 +0000 2017",
    retweet_count: 15993,
    favorite_count: 65621,
    is_retweet: false,
    id_str: "885274148012011520"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Getting rdy to leave for France @ the invitation of President Macron to celebrate &amp; honor Bastille Day and 100yrs since U.S. entry into WWI.",
    created_at: "Wed Jul 12 22:35:53 +0000 2017",
    retweet_count: 14907,
    favorite_count: 82798,
    is_retweet: false,
    id_str: "885266492765466625"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"After 14 years, U.S. beef hits Chinese market. Trade deal an exciting opportunity for agriculture." https://t.co/gDGgejqFMs',
    created_at: "Wed Jul 12 20:20:56 +0000 2017",
    retweet_count: 17717,
    favorite_count: 69870,
    is_retweet: false,
    id_str: "885232527656538113"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The W.H. is functioning perfectly, focused on HealthCare, Tax Cuts/Reform &amp; many other things. I have very little time for watching T.V.",
    created_at: "Wed Jul 12 13:39:25 +0000 2017",
    retweet_count: 20749,
    favorite_count: 99408,
    is_retweet: false,
    id_str: "885131482397908992"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Why aren't the same standards placed on the Democrats. Look what Hillary Clinton may have gotten away with. Disgraceful!",
    created_at: "Wed Jul 12 13:27:03 +0000 2017",
    retweet_count: 26011,
    favorite_count: 104325,
    is_retweet: false,
    id_str: "885128373441355777"
  },
  {
    source: "Twitter for iPhone",
    text:
      '.@WashTimes states "Democrats have willfully used Moscow disinformation to influence the presidential election against Donald Trump."',
    created_at: "Wed Jul 12 12:12:42 +0000 2017",
    retweet_count: 15959,
    favorite_count: 63060,
    is_retweet: false,
    id_str: "885109663217352704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "ISIS is on the run &amp; will soon be wiped out of Syria &amp; Iraq, illegal border crossings are way down (75%) &amp; MS 13 gangs are being removed.",
    created_at: "Wed Jul 12 11:05:53 +0000 2017",
    retweet_count: 29725,
    favorite_count: 127630,
    is_retweet: false,
    id_str: "885092844511387654"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Getting the job done! Sen. Mitch McConnell delays August recess to work on health care bill https://t.co/wBjha8ldeK",
    created_at: "Wed Jul 12 10:40:32 +0000 2017",
    retweet_count: 6459,
    favorite_count: 0,
    is_retweet: true,
    id_str: "885086466061340674"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Remember, when you hear the words "sources say" from the Fake Media, often times those sources are made up and do not exist.',
    created_at: "Wed Jul 12 10:32:56 +0000 2017",
    retweet_count: 31309,
    favorite_count: 117629,
    is_retweet: false,
    id_str: "885084555421634561"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My son Donald did a good job last night. He was open, transparent and innocent. This is the greatest Witch Hunt in political history. Sad!",
    created_at: "Wed Jul 12 10:19:32 +0000 2017",
    retweet_count: 25705,
    favorite_count: 120675,
    is_retweet: false,
    id_str: "885081181980590084"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @FoxNews: .@jessebwatters on @DonaldJTrumpJr meeting with Russian attorney: "I believe Don Jr. is the victim here." #TheFive https://t.c…',
    created_at: "Wed Jul 12 09:55:47 +0000 2017",
    retweet_count: 7737,
    favorite_count: 0,
    is_retweet: true,
    id_str: "885075206905188352"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My son, Donald, will be interviewed by @seanhannity tonight at 10:00 P.M. He is a great person who loves our country!",
    created_at: "Wed Jul 12 00:24:10 +0000 2017",
    retweet_count: 17502,
    favorite_count: 96284,
    is_retweet: false,
    id_str: "884931352201756672"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: FOX NEWS ALERT: U.S. flexes its defense muscles, destroys incoming test missile off coast of Alaska https://t.co/gdpnc6a…",
    created_at: "Tue Jul 11 12:57:47 +0000 2017",
    retweet_count: 10973,
    favorite_count: 0,
    is_retweet: true,
    id_str: "884758617282531329"
  },
  {
    source: "Twitter for iPhone",
    text: "Big wins against ISIS!",
    created_at: "Tue Jul 11 12:23:45 +0000 2017",
    retweet_count: 29001,
    favorite_count: 129612,
    is_retweet: false,
    id_str: "884750055776948225"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Marine Plane crash in Mississippi is heartbreaking. Melania and I send our deepest condolences to all!",
    created_at: "Tue Jul 11 12:09:22 +0000 2017",
    retweet_count: 22784,
    favorite_count: 121286,
    is_retweet: false,
    id_str: "884746435039768576"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Working hard to get the Olympics for the United States (L.A.). Stay tuned!",
    created_at: "Tue Jul 11 11:46:00 +0000 2017",
    retweet_count: 20083,
    favorite_count: 108873,
    is_retweet: false,
    id_str: "884740553040175104"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Senate Democrats have only confirmed 48 of 197 Presidential Nominees. They  can't win so all they do is slow things down &amp; obstruct!",
    created_at: "Tue Jul 11 10:59:58 +0000 2017",
    retweet_count: 28202,
    favorite_count: 97500,
    is_retweet: false,
    id_str: "884728971530829824"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: SEN. CRUZ: It's crazy to go an August recess without having Obamacare repealed. We should work every day until it is don…",
    created_at: "Tue Jul 11 10:49:16 +0000 2017",
    retweet_count: 13399,
    favorite_count: 0,
    is_retweet: true,
    id_str: "884726279014100992"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: White House calls out Senate Democrats for obstructing nominees https://t.co/O6Rsx5i2CZ",
    created_at: "Tue Jul 11 10:48:41 +0000 2017",
    retweet_count: 9958,
    favorite_count: 0,
    is_retweet: true,
    id_str: "884726129910853634"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Head of the NYPD union slams Mayor de Blasio for skipping vigil for assassinated cop Miosotis Familia https://t.co/nVWLb…",
    created_at: "Mon Jul 10 11:54:41 +0000 2017",
    retweet_count: 15497,
    favorite_count: 0,
    is_retweet: true,
    id_str: "884380352436985856"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: .@jasoninthehouse: Comey went silent when I asked him about his memos, which raised a lot of eyebrows. https://t.co/BfSP…",
    created_at: "Mon Jul 10 11:54:15 +0000 2017",
    retweet_count: 13730,
    favorite_count: 0,
    is_retweet: true,
    id_str: "884380242936254464"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @seanhannity: HRC mishandles and destroys classified info-NO PROBLEM! Pay/play on Uranium one NO PROBLEM! Lynch BC tarmac: it's a \"matte…",
    created_at: "Mon Jul 10 11:52:18 +0000 2017",
    retweet_count: 18652,
    favorite_count: 0,
    is_retweet: true,
    id_str: "884379751665848322"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If Chelsea Clinton were asked to hold the seat for her mother,as her mother gave our country away, the Fake News would say CHELSEA FOR PRES!",
    created_at: "Mon Jul 10 11:47:49 +0000 2017",
    retweet_count: 26620,
    favorite_count: 108995,
    is_retweet: false,
    id_str: "884378624660582405"
  },
  {
    source: "Twitter for iPhone",
    text:
      "When I left Conference Room for short meetings with Japan and other countries, I asked Ivanka to hold seat. Very standard. Angela M agrees!",
    created_at: "Mon Jul 10 11:31:33 +0000 2017",
    retweet_count: 18259,
    favorite_count: 88831,
    is_retweet: false,
    id_str: "884374529660903424"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I cannot imagine that Congress would dare to leave Washington without a beautiful new HealthCare bill fully approved and ready to go!",
    created_at: "Mon Jul 10 10:47:33 +0000 2017",
    retweet_count: 23155,
    favorite_count: 102395,
    is_retweet: false,
    id_str: "884363456849342464"
  },
  {
    source: "Twitter for iPhone",
    text:
      "James Comey leaked CLASSIFIED INFORMATION to the media. That is so illegal!",
    created_at: "Mon Jul 10 10:40:16 +0000 2017",
    retweet_count: 30033,
    favorite_count: 112155,
    is_retweet: false,
    id_str: "884361623514656769"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Report accuses material James Comey leaked to a friend contained top secret information https://t.co/Hkg4cAb6o9",
    created_at: "Mon Jul 10 10:34:01 +0000 2017",
    retweet_count: 13340,
    favorite_count: 0,
    is_retweet: true,
    id_str: "884360051808448512"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: .@carriesheffield: The mainstream media is neglecting their duty to represent the public. They've failed to represent ha…",
    created_at: "Mon Jul 10 10:32:08 +0000 2017",
    retweet_count: 9872,
    favorite_count: 0,
    is_retweet: true,
    id_str: "884359576996511745"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @RealJamesWoods: Only now with a #RealPresident do we see the scope of destruction engineered by #Obama and the #Democrat cabal.  @realD…",
    created_at: "Mon Jul 10 10:30:13 +0000 2017",
    retweet_count: 21547,
    favorite_count: 0,
    is_retweet: true,
    id_str: "884359096689971201"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The fact that President Putin and I discussed a Cyber Security unit  doesn't mean I think it can happen. It can't-but a ceasefire can,&amp; did!",
    created_at: "Mon Jul 10 00:45:13 +0000 2017",
    retweet_count: 19730,
    favorite_count: 91092,
    is_retweet: false,
    id_str: "884211874518192128"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Syrian ceasefire seems to be holding. Many lives can be saved. Came out of meeting. Good!",
    created_at: "Sun Jul 09 20:09:52 +0000 2017",
    retweet_count: 20196,
    favorite_count: 100274,
    is_retweet: false,
    id_str: "884142582191849474"
  },
  {
    source: "Twitter for iPhone",
    text:
      'For years, even as a "civilian," I listened as Republicans pushed the Repeal and Replace of ObamaCare. Now they finally have their chance!',
    created_at: "Sun Jul 09 20:07:11 +0000 2017",
    retweet_count: 26582,
    favorite_count: 110727,
    is_retweet: false,
    id_str: "884141905436696576"
  },
  {
    source: "Media Studio",
    text: "MAKE AMERICA GREAT AGAIN! https://t.co/NVDVRrWLs4",
    created_at: "Sun Jul 09 12:57:58 +0000 2017",
    retweet_count: 24791,
    favorite_count: 98445,
    is_retweet: false,
    id_str: "884033889613828096"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Sanctions were not discussed at my meeting with President Putin. Nothing will be done until the Ukrainian &amp; Syrian problems are solved!",
    created_at: "Sun Jul 09 12:31:23 +0000 2017",
    retweet_count: 19673,
    favorite_count: 83119,
    is_retweet: false,
    id_str: "884027201804488704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...have it. Fake News said 17 intel agencies when actually 4 (had to apologize). Why did Obama do NOTHING when he had info before election?",
    created_at: "Sun Jul 09 12:06:30 +0000 2017",
    retweet_count: 20187,
    favorite_count: 89030,
    is_retweet: false,
    id_str: "884020939264073728"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...and safe. Questions were asked about why the CIA &amp; FBI had to ask the DNC 13 times for their SERVER, and were rejected, still don't....",
    created_at: "Sun Jul 09 11:57:55 +0000 2017",
    retweet_count: 18820,
    favorite_count: 78813,
    is_retweet: false,
    id_str: "884018776391503872"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Putin &amp; I discussed forming an impenetrable Cyber Security unit    so that election hacking, &amp; many other negative things, will be guarded..",
    created_at: "Sun Jul 09 11:50:24 +0000 2017",
    retweet_count: 20029,
    favorite_count: 83092,
    is_retweet: false,
    id_str: "884016887692234753"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...We negotiated a ceasefire in parts of Syria which will save lives. Now it is time to move forward in working constructively with Russia!",
    created_at: "Sun Jul 09 11:37:42 +0000 2017",
    retweet_count: 22811,
    favorite_count: 98082,
    is_retweet: false,
    id_str: "884013689736769536"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I strongly pressed President Putin twice about Russian meddling in our election. He vehemently denied it. I've already given my opinion.....",
    created_at: "Sun Jul 09 11:31:22 +0000 2017",
    retweet_count: 18913,
    favorite_count: 83868,
    is_retweet: false,
    id_str: "884012097805406208"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The G 20 Summit was a great success for the U.S. - Explained that the U.S. must fix the many bad trade deals it has made. Will get done!",
    created_at: "Sun Jul 09 11:15:58 +0000 2017",
    retweet_count: 17005,
    favorite_count: 81459,
    is_retweet: false,
    id_str: "884008221970763776"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you @SenatorDole, very kind! https://t.co/cXrYiK46Qq",
    created_at: "Sun Jul 09 00:29:21 +0000 2017",
    retweet_count: 24263,
    favorite_count: 87832,
    is_retweet: false,
    id_str: "883845492790235136"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Leaving Hamburg for Washington, D.C. and the WH. Just left China’s President Xi where we had an excellent meeting on trade &amp; North Korea.",
    created_at: "Sat Jul 08 18:55:23 +0000 2017",
    retweet_count: 18168,
    favorite_count: 98393,
    is_retweet: false,
    id_str: "883761448064864257"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Law enforcement &amp; military did a spectacular job in Hamburg. Everybody felt totally safe despite the anarchists. @PolizeiHamburg #G20Summit",
    created_at: "Sat Jul 08 18:50:10 +0000 2017",
    retweet_count: 19447,
    favorite_count: 93205,
    is_retweet: false,
    id_str: "883760134333378561"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The #G20Summit was a wonderful success and carried out beautifully by Chancellor Angela Merkel. Thank you!",
    created_at: "Sat Jul 08 18:20:56 +0000 2017",
    retweet_count: 15346,
    favorite_count: 86036,
    is_retweet: false,
    id_str: "883752778379792386"
  },
  {
    source: "Twitter for iPhone",
    text: "We will fight the #FakeNews with you! https://t.co/zOMiXTeLJq",
    created_at: "Sat Jul 08 18:17:24 +0000 2017",
    retweet_count: 27003,
    favorite_count: 99318,
    is_retweet: false,
    id_str: "883751888491098112"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great first day with world leaders at the #G20Summit here in Hamburg, Germany. Looking forward to day two! #USA https://t.co/bLKgZKQemw",
    created_at: "Fri Jul 07 23:33:26 +0000 2017",
    retweet_count: 18604,
    favorite_count: 84512,
    is_retweet: false,
    id_str: "883469033059864578"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you! \n\n“Trump’s Defining Speech” \nWSJ Editorial: https://t.co/YuDgVfRroR https://t.co/T0R4u4IHDJ",
    created_at: "Fri Jul 07 21:56:53 +0000 2017",
    retweet_count: 16321,
    favorite_count: 68592,
    is_retweet: false,
    id_str: "883444736849305600"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will represent our country well and fight for its interests! Fake News Media will never cover me accurately but who cares! We will #MAGA!",
    created_at: "Fri Jul 07 07:44:07 +0000 2017",
    retweet_count: 33937,
    favorite_count: 136965,
    is_retweet: false,
    id_str: "883230130885324802"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I look forward to all meetings today with world leaders, including my meeting with Vladimir Putin. Much to discuss.\n#G20Summit #USA🇺🇸",
    created_at: "Fri Jul 07 07:42:37 +0000 2017",
    retweet_count: 19323,
    favorite_count: 96810,
    is_retweet: false,
    id_str: "883229754077392896"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Everyone here is talking about why John Podesta refused to give the DNC server to the FBI and the CIA. Disgraceful!",
    created_at: "Fri Jul 07 07:40:42 +0000 2017",
    retweet_count: 33107,
    favorite_count: 119041,
    is_retweet: false,
    id_str: "883229270943911936"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After Poland had a great meeting with Chancellor Merkel and then with PM Shinzō Abe of Japan &amp; President Moon of South Korea.",
    created_at: "Fri Jul 07 07:07:20 +0000 2017",
    retweet_count: 13291,
    favorite_count: 76189,
    is_retweet: false,
    id_str: "883220875444715520"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My experience yesterday in Poland was a great one. Thank you to everyone, including the haters, for the great reviews of the speech!",
    created_at: "Fri Jul 07 06:59:02 +0000 2017",
    retweet_count: 26058,
    favorite_count: 129353,
    is_retweet: false,
    id_str: "883218784663818241"
  },
  {
    source: "Twitter Web Client",
    text:
      "A strong Poland is a blessing to the nations of Europe, and a strong Europe is a blessing to the West, and to the world. https://t.co/vHzPwMtJSm",
    created_at: "Thu Jul 06 20:45:21 +0000 2017",
    retweet_count: 31801,
    favorite_count: 117598,
    is_retweet: false,
    id_str: "883064346519187456"
  },
  {
    source: "Media Studio",
    text:
      "THE WEST WILL NEVER BE BROKEN. Our values will PREVAIL. Our people will THRIVE and our civilization will TRIUMPH! https://t.co/sozuVgdp5T",
    created_at: "Thu Jul 06 17:21:18 +0000 2017",
    retweet_count: 37528,
    favorite_count: 134381,
    is_retweet: false,
    id_str: "883012994145280000"
  },
  {
    source: "Media Studio",
    text:
      "America is proud to stand shoulder-to-shoulder with Poland in the fight to eradicate the evils of terrorism and extremism. #POTUSinPoland https://t.co/MHxRmVvtsh",
    created_at: "Thu Jul 06 16:02:25 +0000 2017",
    retweet_count: 22801,
    favorite_count: 91612,
    is_retweet: false,
    id_str: "882993144194838528"
  },
  {
    source: "Twitter for iPhone",
    text:
      "On behalf of @FLOTUS Melania and myself, thank you Poland!🇺🇸🇵🇱\n#ICYMI, watch here➡️ https://t.co/COpVXnn8YG #POTUSinPoland https://t.co/ylU3wLZV2H",
    created_at: "Thu Jul 06 14:02:13 +0000 2017",
    retweet_count: 20309,
    favorite_count: 86331,
    is_retweet: false,
    id_str: "882962893288882176"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to the dedicated professionals of the USSS as they celebrate their 152nd anniversary. Thank you! ➡️https://t.co/mDhFzDm3ED https://t.co/BcB3wLjILg",
    created_at: "Wed Jul 05 23:23:42 +0000 2017",
    retweet_count: 14620,
    favorite_count: 76182,
    is_retweet: false,
    id_str: "882741809931309056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Trade between China and North Korea grew almost 40% in the first quarter. So much for China working with us - but we had to give it a try!",
    created_at: "Wed Jul 05 11:21:23 +0000 2017",
    retweet_count: 24525,
    favorite_count: 102191,
    is_retweet: false,
    id_str: "882560030884716544"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The United States made some of the worst Trade Deals in world history.Why should we continue these deals with countries that do not help us?",
    created_at: "Wed Jul 05 11:14:11 +0000 2017",
    retweet_count: 26831,
    favorite_count: 129296,
    is_retweet: false,
    id_str: "882558219285131265"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Getting ready to leave for Poland, after which I will travel to Germany for the G-20. Will be back on Saturday.",
    created_at: "Wed Jul 05 10:51:59 +0000 2017",
    retweet_count: 16169,
    favorite_count: 95884,
    is_retweet: false,
    id_str: "882552631905988609"
  },
  {
    source: "Twitter for iPhone",
    text: "#HappyIndependenceDay #USA🇺🇸 https://t.co/9pfqnRsh1Z",
    created_at: "Wed Jul 05 02:19:23 +0000 2017",
    retweet_count: 47259,
    favorite_count: 205493,
    is_retweet: false,
    id_str: "882423634639425536"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Gas prices are the lowest in the U.S. in over ten years! I would like to see them go even lower.",
    created_at: "Tue Jul 04 19:55:28 +0000 2017",
    retweet_count: 31544,
    favorite_count: 162421,
    is_retweet: false,
    id_str: "882327018070790144"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Getting ready to celebrate the 4th of July with a big crowd at the White House. Happy 4th to everyone. Our country will grow and prosper!",
    created_at: "Tue Jul 04 19:49:16 +0000 2017",
    retweet_count: 25478,
    favorite_count: 138501,
    is_retweet: false,
    id_str: "882325456162361344"
  },
  {
    source: "Twitter for iPhone",
    text: "#HappyIndependenceDay \n#July4 #USA🇺🇸 https://t.co/NsFslPEFrp",
    created_at: "Tue Jul 04 10:38:40 +0000 2017",
    retweet_count: 30936,
    favorite_count: 116835,
    is_retweet: false,
    id_str: "882186896285282304"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....and Japan will put up with this much longer. Perhaps China will put a heavy move on North Korea and end this nonsense once and for all!",
    created_at: "Tue Jul 04 02:24:39 +0000 2017",
    retweet_count: 30583,
    favorite_count: 116328,
    is_retweet: false,
    id_str: "882062572081512449"
  },
  {
    source: "Twitter for iPhone",
    text:
      "North Korea has just launched another missile. Does this guy have anything better to do with his life? Hard to believe that South Korea.....",
    created_at: "Tue Jul 04 02:19:02 +0000 2017",
    retweet_count: 51684,
    favorite_count: 148904,
    is_retweet: false,
    id_str: "882061157900718081"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @JacobAWohl: @realDonaldTrump When Obama was President, the #MSM LOVED talking about stock market rallies! Now they barely mention new a…",
    created_at: "Tue Jul 04 01:33:50 +0000 2017",
    retweet_count: 16931,
    favorite_count: 0,
    is_retweet: true,
    id_str: "882049782541414400"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Dow hit a new intraday all-time high! I wonder whether or not the Fake News Media will so report?",
    created_at: "Mon Jul 03 21:10:25 +0000 2017",
    retweet_count: 24956,
    favorite_count: 113935,
    is_retweet: false,
    id_str: "881983493533822976"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Really great numbers on jobs &amp; the economy! Things are starting to kick in now, and we have just begun! Don't like steel &amp; aluminum dumping!",
    created_at: "Mon Jul 03 20:54:08 +0000 2017",
    retweet_count: 20129,
    favorite_count: 96173,
    is_retweet: false,
    id_str: "881979394373406720"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you to Shawn Steel for the nice words on @FoxNews.",
    created_at: "Mon Jul 03 20:44:27 +0000 2017",
    retweet_count: 9535,
    favorite_count: 61582,
    is_retweet: false,
    id_str: "881976958556549120"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Reince: With a strong candidate in @POTUS &amp; @GOP revolutionary data program, Republicans carried WI for 1st time in 30 years\nhttps://t.…",
    created_at: "Mon Jul 03 19:38:06 +0000 2017",
    retweet_count: 9003,
    favorite_count: 0,
    is_retweet: true,
    id_str: "881960261263011841"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If we can help little #CharlieGard, as per our friends in the U.K. and the Pope, we would be delighted to do so.",
    created_at: "Mon Jul 03 14:00:21 +0000 2017",
    retweet_count: 37176,
    favorite_count: 123341,
    is_retweet: false,
    id_str: "881875263700783104"
  },
  {
    source: "Twitter for iPhone",
    text:
      "At some point the Fake News will be forced to discuss our great jobs numbers, strong economy, success with ISIS, the border &amp; so much else!",
    created_at: "Mon Jul 03 12:10:44 +0000 2017",
    retweet_count: 31314,
    favorite_count: 131610,
    is_retweet: false,
    id_str: "881847676232503297"
  },
  {
    source: "Twitter for iPhone",
    text: "Will be speaking with Italy this morning!",
    created_at: "Mon Jul 03 11:38:20 +0000 2017",
    retweet_count: 10875,
    favorite_count: 72540,
    is_retweet: false,
    id_str: "881839523126272000"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Spoke yesterday with the King of Saudi Arabia about peace in the Middle-East. Interesting things are happening!",
    created_at: "Mon Jul 03 11:19:08 +0000 2017",
    retweet_count: 22408,
    favorite_count: 85961,
    is_retweet: false,
    id_str: "881834692282109953"
  },
  {
    source: "Twitter for iPhone",
    text: "Will be speaking with Germany and France this morning.",
    created_at: "Mon Jul 03 11:00:56 +0000 2017",
    retweet_count: 11325,
    favorite_count: 69696,
    is_retweet: false,
    id_str: "881830110114009089"
  },
  {
    source: "Media Studio",
    text:
      "America's men &amp; women in uniform is the story of FREEDOM overcoming OPPRESSION, the STRONG protecting the WEAK, &amp; G… https://t.co/LtTpGsP3fC",
    created_at: "Mon Jul 03 02:13:07 +0000 2017",
    retweet_count: 25922,
    favorite_count: 104824,
    is_retweet: false,
    id_str: "881697281233354753"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Stock Market at all time high, unemployment at lowest level in years (wages will start going up) and our base has never been stronger!",
    created_at: "Sun Jul 02 23:55:23 +0000 2017",
    retweet_count: 31927,
    favorite_count: 136448,
    is_retweet: false,
    id_str: "881662619282702338"
  },
  {
    source: "Media Studio",
    text:
      "The dishonest media will NEVER keep us from accomplishing our objectives on behalf of our GREAT AMERICAN PEOPLE!… https://t.co/EwnwCeuGMv",
    created_at: "Sun Jul 02 20:04:24 +0000 2017",
    retweet_count: 28208,
    favorite_count: 111220,
    is_retweet: false,
    id_str: "881604490041995271"
  },
  {
    source: "Twitter for iPhone",
    text: "#FraudNewsCNN #FNN https://t.co/WYUnHjjUjg",
    created_at: "Sun Jul 02 13:21:42 +0000 2017",
    retweet_count: 369530,
    favorite_count: 605098,
    is_retweet: false,
    id_str: "881503147168071680"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We will always take care of our GREAT VETERANS. You have shed your blood, poured your love, and bared your soul, in… https://t.co/bTPuerxLOr",
    created_at: "Sun Jul 02 04:47:04 +0000 2017",
    retweet_count: 30040,
    favorite_count: 129665,
    is_retweet: false,
    id_str: "881373634585079808"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My use of social media is not Presidential - it’s MODERN DAY PRESIDENTIAL. Make America Great Again!",
    created_at: "Sat Jul 01 22:41:58 +0000 2017",
    retweet_count: 56387,
    favorite_count: 199049,
    is_retweet: false,
    id_str: "881281755017355264"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am thinking about changing the name #FakeNews CNN to #FraudNewsCNN!",
    created_at: "Sat Jul 01 22:08:37 +0000 2017",
    retweet_count: 30847,
    favorite_count: 121832,
    is_retweet: false,
    id_str: "881273362454118400"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....the 2016 election with interviews, speeches and social media. I had to beat #FakeNews, and did. We will continue to WIN!",
    created_at: "Sat Jul 01 22:02:27 +0000 2017",
    retweet_count: 18274,
    favorite_count: 89370,
    is_retweet: false,
    id_str: "881271809433374721"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The FAKE &amp; FRAUDULENT NEWS MEDIA is working hard to convince Republicans and others I should not use social media - but remember, I won....",
    created_at: "Sat Jul 01 22:02:12 +0000 2017",
    retweet_count: 29823,
    favorite_count: 129842,
    is_retweet: false,
    id_str: "881271748280365056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Getting rdy to leave for tonight's Celebrate Freedom Concert honoring our GREAT VETERANS w/ so many of my evangelic… https://t.co/shfTAoMJry",
    created_at: "Sat Jul 01 21:38:32 +0000 2017",
    retweet_count: 11356,
    favorite_count: 62718,
    is_retweet: false,
    id_str: "881265792700035073"
  },
  {
    source: "Media Studio",
    text:
      "Weekly Address🇺🇸 #KatesLaw\n#NoSanctuaryForCriminalsAct\nStatement: https://t.co/I8cqKGDK2B https://t.co/00mao6Vk7R",
    created_at: "Sat Jul 01 21:01:20 +0000 2017",
    retweet_count: 11420,
    favorite_count: 50441,
    is_retweet: false,
    id_str: "881256428626956288"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Crazy Joe Scarborough and dumb as a rock Mika are not bad people, but their low rated show is dominated by their NBC bosses. Too bad!",
    created_at: "Sat Jul 01 13:20:35 +0000 2017",
    retweet_count: 24262,
    favorite_count: 101893,
    is_retweet: false,
    id_str: "881140479454310401"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am extremely pleased to see that @CNN has finally been exposed as #FakeNews and garbage journalism. It's about time!",
    created_at: "Sat Jul 01 13:12:40 +0000 2017",
    retweet_count: 41262,
    favorite_count: 151428,
    is_retweet: false,
    id_str: "881138485905772549"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Numerous states are refusing to give information to the very distinguished VOTER FRAUD PANEL. What are they trying to hide?",
    created_at: "Sat Jul 01 13:07:05 +0000 2017",
    retweet_count: 32189,
    favorite_count: 110887,
    is_retweet: false,
    id_str: "881137079958241280"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Word is that @Greta Van Susteren was let go by her out of control bosses at @NBC &amp; @Comcast because she refused to go along w/ 'Trump hate!'",
    created_at: "Sat Jul 01 12:59:52 +0000 2017",
    retweet_count: 20308,
    favorite_count: 80092,
    is_retweet: false,
    id_str: "881135264441257984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Happy Canada Day to all of the great people of Canada and to your Prime Minister and my new found friend @JustinTrudeau. #Canada150",
    created_at: "Sat Jul 01 12:44:23 +0000 2017",
    retweet_count: 16360,
    favorite_count: 78780,
    is_retweet: false,
    id_str: "881131368520056832"
  },
  {
    source: "Twitter Ads",
    text:
      "America will THINK BIG once again. We will inspire millions of children to carry on the proud tradition of American… https://t.co/hZCMp5cSJc",
    created_at: "Fri Jun 30 22:43:58 +0000 2017",
    retweet_count: 19603,
    favorite_count: 85823,
    is_retweet: false,
    id_str: "880919871353217024"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The era of strategic patience with the North Korea regime has failed. That patience is over. We are working closely… https://t.co/MxN04V2Yn4",
    created_at: "Fri Jun 30 20:55:44 +0000 2017",
    retweet_count: 17773,
    favorite_count: 72750,
    is_retweet: false,
    id_str: "880892632142143490"
  },
  {
    source: "Twitter Web Client",
    text:
      "I am encouraged by President Moon's assurances that he will work to level the playing field for American workers, b… https://t.co/DUZh6aMjJS",
    created_at: "Fri Jun 30 18:19:13 +0000 2017",
    retweet_count: 12384,
    favorite_count: 57618,
    is_retweet: false,
    id_str: "880853246126022656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Watched low rated @Morning_Joe for first time in long time. FAKE NEWS. He called me to stop a National Enquirer article. I said no! Bad show",
    created_at: "Fri Jun 30 12:55:08 +0000 2017",
    retweet_count: 19328,
    favorite_count: 83669,
    is_retweet: false,
    id_str: "880771685460344832"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Crime and killings in Chicago have reached such epidemic proportions that I am sending in Federal help. 1714 shootings in Chicago this year!",
    created_at: "Fri Jun 30 10:48:38 +0000 2017",
    retweet_count: 32567,
    favorite_count: 120116,
    is_retweet: false,
    id_str: "880739852286918656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If Republican Senators are unable to pass what they are working on now, they should immediately REPEAL, and then REPLACE at a later date!",
    created_at: "Fri Jun 30 10:37:57 +0000 2017",
    retweet_count: 24777,
    favorite_count: 93597,
    is_retweet: false,
    id_str: "880737163247267840"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just finished a very good meeting with the President of South Korea. Many subjects discussed including North Korea and new trade deal!",
    created_at: "Fri Jun 30 01:44:01 +0000 2017",
    retweet_count: 19755,
    favorite_count: 92733,
    is_retweet: false,
    id_str: "880602793341591552"
  },
  {
    source: "Twitter Web Client",
    text:
      "Our new American Energy Policy will unlock MILLIONS of jobs &amp; TRILLIONS in wealth. We are on the cusp of a true ene… https://t.co/w5Y7UXZSSD",
    created_at: "Thu Jun 29 23:10:47 +0000 2017",
    retweet_count: 18768,
    favorite_count: 77736,
    is_retweet: false,
    id_str: "880564232588107779"
  },
  {
    source: "Twitter for iPhone",
    text:
      "When it comes to the future of America’s energy needs, we will FIND IT, we will DREAM IT, and we will BUILD IT.… https://t.co/m0HmPbUZ6C",
    created_at: "Thu Jun 29 23:09:01 +0000 2017",
    retweet_count: 12068,
    favorite_count: 55492,
    is_retweet: false,
    id_str: "880563788705148928"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Statement on House Passage of Kate’s Law and No Sanctuary for Criminals Act. https://t.co/uPRy9XgK5A",
    created_at: "Thu Jun 29 22:53:49 +0000 2017",
    retweet_count: 12664,
    favorite_count: 57604,
    is_retweet: false,
    id_str: "880559961855729664"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Good news out of the House with the passing of 'No Sanctuary for Criminals Act.' Hopefully Senate will follow.",
    created_at: "Thu Jun 29 22:28:23 +0000 2017",
    retweet_count: 20630,
    favorite_count: 94460,
    is_retweet: false,
    id_str: "880553561008078848"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Good news, House just passed #KatesLaw. Hopefully Senate will follow.",
    created_at: "Thu Jun 29 21:37:02 +0000 2017",
    retweet_count: 23135,
    favorite_count: 101416,
    is_retweet: false,
    id_str: "880540637358981120"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"Mattis Says Trump’s Warning Stopped Chemical Weapons Attack In Syria" https://t.co/XL9LLNKh8i',
    created_at: "Thu Jun 29 21:13:22 +0000 2017",
    retweet_count: 14651,
    favorite_count: 59595,
    is_retweet: false,
    id_str: "880534684479897600"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me LIVE with @VP, @SecretaryPerry, @SecretaryZinke and @EPAScottPruitt. \n#UnleashingAmericanEnergy\nhttps://t.co/hlM7F2BQD9",
    created_at: "Thu Jun 29 19:31:13 +0000 2017",
    retweet_count: 4995,
    favorite_count: 29944,
    is_retweet: false,
    id_str: "880508977590697984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "MAKE AMERICA SAFE AGAIN!\n\n#NoSanctuaryForCriminalsAct \n#KatesLaw #SaveAmericanLives \n\nhttps://t.co/jbN4hPjqjS",
    created_at: "Thu Jun 29 18:13:16 +0000 2017",
    retweet_count: 15347,
    favorite_count: 65347,
    is_retweet: false,
    id_str: "880489358431850496"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today, the House votes on two crucial bills:\n☑️#NoSanctuaryForCriminalsAct \n☑️#KatesLaw \n☑️Pass these bills &amp; lets… https://t.co/4N2c0oxMve",
    created_at: "Thu Jun 29 16:53:44 +0000 2017",
    retweet_count: 19979,
    favorite_count: 75538,
    is_retweet: false,
    id_str: "880469342835666944"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...to Mar-a-Lago 3 nights in a row around New Year's Eve, and insisted on joining me. She was bleeding badly from a face-lift. I said no!",
    created_at: "Thu Jun 29 12:58:23 +0000 2017",
    retweet_count: 20927,
    favorite_count: 80481,
    is_retweet: false,
    id_str: "880410114456465411"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I heard poorly rated @Morning_Joe speaks badly of me (don't watch anymore). Then how come low I.Q. Crazy Mika, along with Psycho Joe, came..",
    created_at: "Thu Jun 29 12:52:17 +0000 2017",
    retweet_count: 21887,
    favorite_count: 83771,
    is_retweet: false,
    id_str: "880408582310776832"
  },
  {
    source: "Twitter for iPhone",
    text:
      "New Sugar deal negotiated with Mexico is a very good one for both Mexico and the U.S. Had no deal for many years which hurt U.S. badly.",
    created_at: "Thu Jun 29 12:27:35 +0000 2017",
    retweet_count: 17960,
    favorite_count: 83921,
    is_retweet: false,
    id_str: "880402366373269504"
  },
  {
    source: "Media Studio",
    text:
      "Tomorrow the House votes on #KatesLaw &amp; No Sanctuary For Criminals Act. Lawmakers must vote to put American safety… https://t.co/p3vd8IXXaD",
    created_at: "Thu Jun 29 01:51:18 +0000 2017",
    retweet_count: 21350,
    favorite_count: 83031,
    is_retweet: false,
    id_str: "880242238000955392"
  },
  {
    source: "Twitter for iPhone",
    text:
      "From my first day in office, we’ve taken swift action to lift the crushing restrictions on American energy. Remarks… https://t.co/VBoEubD59k",
    created_at: "Wed Jun 28 22:32:47 +0000 2017",
    retweet_count: 11703,
    favorite_count: 55478,
    is_retweet: false,
    id_str: "880192282254872576"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrats purposely misstated Medicaid under new Senate bill - actually goes up. https://t.co/necCt4K6UH",
    created_at: "Wed Jun 28 21:26:27 +0000 2017",
    retweet_count: 16480,
    favorite_count: 51210,
    is_retweet: false,
    id_str: "880175585418465284"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today, I hosted an immigration roundtable ahead of two votes taking place in Congress tomorrow. Watch and read more… https://t.co/5k8WzW1t68",
    created_at: "Wed Jun 28 21:15:37 +0000 2017",
    retweet_count: 8492,
    favorite_count: 39782,
    is_retweet: false,
    id_str: "880172859108331520"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was my great honor to welcome the 2016 World Series Champion Chicago @Cubs ⚾️ to the @WhiteHouse this afternoon.… https://t.co/GvPhJ9hZdv",
    created_at: "Wed Jun 28 21:06:39 +0000 2017",
    retweet_count: 14024,
    favorite_count: 74871,
    is_retweet: false,
    id_str: "880170602690215936"
  },
  {
    source: "Media Studio",
    text:
      "#ICYMI- on Monday, I had the great honor of welcoming India's Prime Minister @narendramodi to the WH. Full Remarks:… https://t.co/7IIQEh7xXv",
    created_at: "Wed Jun 28 20:19:38 +0000 2017",
    retweet_count: 10884,
    favorite_count: 45347,
    is_retweet: false,
    id_str: "880158771762286592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The #AmazonWashingtonPost, sometimes referred to as the guardian of Amazon not paying internet taxes (which they should) is FAKE NEWS!",
    created_at: "Wed Jun 28 13:06:14 +0000 2017",
    retweet_count: 13407,
    favorite_count: 54720,
    is_retweet: false,
    id_str: "880049704620494848"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: HAPPENING TODAY: House to vote on immigration bills including 'Kate’s Law' and 'No Sanctuary for Criminals Act' https://…",
    created_at: "Wed Jun 28 11:03:33 +0000 2017",
    retweet_count: 12653,
    favorite_count: 0,
    is_retweet: true,
    id_str: "880018828603912194"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Some of the Fake News Media likes to say that I am not totally engaged in healthcare. Wrong, I know the subject well &amp; want victory for U.S.",
    created_at: "Wed Jun 28 10:58:59 +0000 2017",
    retweet_count: 19282,
    favorite_count: 91340,
    is_retweet: false,
    id_str: "880017678978736129"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The failing @nytimes writes false story after false story about me. They don't even call to verify the facts of a story. A Fake News Joke!",
    created_at: "Wed Jun 28 10:49:22 +0000 2017",
    retweet_count: 20564,
    favorite_count: 85278,
    is_retweet: false,
    id_str: "880015261004435456"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I just finished a great meeting with the Republican Senators concerning HealthCare. They really want to get it right, unlike OCare!",
    created_at: "Tue Jun 27 22:27:48 +0000 2017",
    retweet_count: 17808,
    favorite_count: 92179,
    is_retweet: false,
    id_str: "879828637733793793"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With ZERO Democrats to help, and a failed, expensive and dangerous ObamaCare as the Dems legacy, the Republican Senators are working hard!",
    created_at: "Tue Jun 27 22:22:55 +0000 2017",
    retweet_count: 15485,
    favorite_count: 79017,
    is_retweet: false,
    id_str: "879827411008974852"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So they caught Fake News CNN cold, but what about NBC, CBS &amp; ABC? What about the failing @nytimes &amp; @washingtonpost? They are all Fake News!",
    created_at: "Tue Jun 27 12:47:17 +0000 2017",
    retweet_count: 33366,
    favorite_count: 112223,
    is_retweet: false,
    id_str: "879682547235651584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Fake News CNN is looking at big management changes now that they got caught falsely pushing their phony Russian stories. Ratings way down!",
    created_at: "Tue Jun 27 12:30:38 +0000 2017",
    retweet_count: 33067,
    favorite_count: 121670,
    is_retweet: false,
    id_str: "879678356450676736"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @ericbolling: Good morning friends!  "The Swamp" out today.  President Trump has a copy... get yours here https://t.co/TntLPNCCjR. #maga…',
    created_at: "Tue Jun 27 11:32:15 +0000 2017",
    retweet_count: 6864,
    favorite_count: 0,
    is_retweet: true,
    id_str: "879663665645056000"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: President Trump officially nominates former Assistant Attorney General Christopher Wray to head the FBI https://t.co/ld7…",
    created_at: "Tue Jun 27 11:23:35 +0000 2017",
    retweet_count: 8465,
    favorite_count: 0,
    is_retweet: true,
    id_str: "879661481360588800"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Another Dem 'queasy' over claim of Loretta Lynch meddling in Clinton case https://t.co/wdQ9MduxOO",
    created_at: "Tue Jun 27 11:19:39 +0000 2017",
    retweet_count: 6984,
    favorite_count: 0,
    is_retweet: true,
    id_str: "879660494218547202"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Hannity: Russia allegations 'boomeranging back' on Democrats https://t.co/lvdrpxpcp9",
    created_at: "Tue Jun 27 11:00:53 +0000 2017",
    retweet_count: 8242,
    favorite_count: 0,
    is_retweet: true,
    id_str: "879655772111679488"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Mark Levin: The collusion is among the Democrats https://t.co/Qrca7r01BI",
    created_at: "Tue Jun 27 11:00:07 +0000 2017",
    retweet_count: 6884,
    favorite_count: 0,
    is_retweet: true,
    id_str: "879655576803913728"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @JeffTutorials: @realDonaldTrump  https://t.co/6sDcyiW4Kt",
    created_at: "Tue Jun 27 10:46:02 +0000 2017",
    retweet_count: 11369,
    favorite_count: 0,
    is_retweet: true,
    id_str: "879652031799205888"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Wow, CNN had to retract big story on "Russia," with 3 employees forced to resign. What about all the other phony stories they do? FAKE NEWS!',
    created_at: "Tue Jun 27 10:33:42 +0000 2017",
    retweet_count: 34028,
    favorite_count: 124621,
    is_retweet: false,
    id_str: "879648931172556802"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great day for America's future Security and Safety, courtesy of the U.S. Supreme Court. I will keep fighting for the American people, &amp; WIN!",
    created_at: "Tue Jun 27 02:31:16 +0000 2017",
    retweet_count: 24203,
    favorite_count: 110626,
    is_retweet: false,
    id_str: "879527520957325314"
  },
  {
    source: "Twitter for iPhone",
    text:
      'From @FoxNews "Bombshell: In 2016, Obama dismissed idea that anyone could rig an American election."  Check out his statement - Witch Hunt!',
    created_at: "Tue Jun 27 02:24:30 +0000 2017",
    retweet_count: 18383,
    favorite_count: 73622,
    is_retweet: false,
    id_str: "879525817361068032"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @WhiteHouse: FACT: when #Obamacare was signed, CBO estimated that 23M would be covered in 2017. They were off by 100%. Only 10.3M people…",
    created_at: "Tue Jun 27 01:30:15 +0000 2017",
    retweet_count: 11948,
    favorite_count: 0,
    is_retweet: true,
    id_str: "879512164553420809"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Very grateful for the 9-O decision from the U. S. Supreme Court. We must keep America SAFE!",
    created_at: "Mon Jun 26 18:25:18 +0000 2017",
    retweet_count: 35830,
    favorite_count: 140532,
    is_retweet: false,
    id_str: "879405223399350272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @WhiteHouse: Today @POTUS will welcome the Prime Minister of India, @narendramodi, to the White House. https://t.co/MIi1ifmdAN",
    created_at: "Mon Jun 26 18:16:47 +0000 2017",
    retweet_count: 9820,
    favorite_count: 0,
    is_retweet: true,
    id_str: "879403082114846722"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @WhiteHouse: #Obamacare has led to higher costs and fewer health insurance options for millions of Americans. It has failed the American…",
    created_at: "Mon Jun 26 18:16:24 +0000 2017",
    retweet_count: 9633,
    favorite_count: 0,
    is_retweet: true,
    id_str: "879402984756711425"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republican Senators are working very hard to get there, with no help from the Democrats. Not easy! Perhaps just let OCare crash &amp; burn!",
    created_at: "Mon Jun 26 13:14:24 +0000 2017",
    retweet_count: 15454,
    favorite_count: 71889,
    is_retweet: false,
    id_str: "879326984794517507"
  },
  {
    source: "Twitter for iPhone",
    text:
      '..under a magnifying glass, they have zero "tapes" of T people colluding. There is no collusion &amp; no obstruction. I should be given apology!',
    created_at: "Mon Jun 26 13:05:01 +0000 2017",
    retweet_count: 19511,
    favorite_count: 87496,
    is_retweet: false,
    id_str: "879324620159160322"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The real story is that President Obama did NOTHING after being informed in August about Russian meddling. With 4 months looking at Russia...",
    created_at: "Mon Jun 26 12:59:31 +0000 2017",
    retweet_count: 19276,
    favorite_count: 76461,
    is_retweet: false,
    id_str: "879323238425395200"
  },
  {
    source: "Twitter for iPhone",
    text:
      '...and did not want to "rock the boat." He didn\'t "choke," he colluded or obstructed, and it did the Dems and Crooked Hillary no good.',
    created_at: "Mon Jun 26 12:50:15 +0000 2017",
    retweet_count: 16204,
    favorite_count: 71698,
    is_retweet: false,
    id_str: "879320905608044544"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The reason that President Obama did NOTHING about Russia after being notified by the CIA of meddling is that he expected Clinton would win..",
    created_at: "Mon Jun 26 12:37:16 +0000 2017",
    retweet_count: 25091,
    favorite_count: 92384,
    is_retweet: false,
    id_str: "879317636164841474"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats have become nothing but OBSTRUCTIONISTS, they have no policies or ideas. All they do is delay and complain.They own ObamaCare!",
    created_at: "Mon Jun 26 12:30:12 +0000 2017",
    retweet_count: 20614,
    favorite_count: 83433,
    is_retweet: false,
    id_str: "879315860178993152"
  },
  {
    source: "Twitter for iPhone",
    text: "I am on @foxandfriends - Enjoy!",
    created_at: "Sun Jun 25 12:07:41 +0000 2017",
    retweet_count: 4556,
    favorite_count: 29777,
    is_retweet: false,
    id_str: "878947806442119168"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Hillary Clinton colluded with the Democratic Party in order to beat Crazy Bernie Sanders. Is she allowed to so collude? Unfair to Bernie!",
    created_at: "Sun Jun 25 12:00:37 +0000 2017",
    retweet_count: 26895,
    favorite_count: 107302,
    is_retweet: false,
    id_str: "878946025662296064"
  },
  {
    source: "Twitter for iPhone",
    text: "MAKE AMERICA GREAT AGAIN!",
    created_at: "Sat Jun 24 21:23:52 +0000 2017",
    retweet_count: 46890,
    favorite_count: 162744,
    is_retweet: false,
    id_str: "878725385235701761"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I cannot imagine that these very fine Republican Senators would allow the American people to suffer a broken ObamaCare any longer!",
    created_at: "Sat Jun 24 20:50:56 +0000 2017",
    retweet_count: 19519,
    favorite_count: 86830,
    is_retweet: false,
    id_str: "878717095701336064"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Obama Administration official said they "choked" when it came to acting on Russian meddling of election. They didn\'t want to hurt Hillary?',
    created_at: "Sat Jun 24 20:44:36 +0000 2017",
    retweet_count: 23108,
    favorite_count: 88368,
    is_retweet: false,
    id_str: "878715504063643648"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Since the Obama Administration was told way before the 2016 Election that the Russians were meddling, why no action? Focus on them, not T!",
    created_at: "Sat Jun 24 20:28:46 +0000 2017",
    retweet_count: 21460,
    favorite_count: 88955,
    is_retweet: false,
    id_str: "878711517537083392"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrats slam GOP healthcare proposal as Obamacare premiums &amp; deductibles increase by over 100%. Remember keep your doctor, keep your plan?",
    created_at: "Sat Jun 24 12:51:33 +0000 2017",
    retweet_count: 20917,
    favorite_count: 81571,
    is_retweet: false,
    id_str: "878596457741287424"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just out: The Obama Administration knew far in advance of November 8th about election meddling by Russia. Did nothing about it. WHY?",
    created_at: "Sat Jun 24 00:43:48 +0000 2017",
    retweet_count: 30820,
    favorite_count: 103975,
    is_retweet: false,
    id_str: "878413313188802560"
  },
  {
    source: "Media Studio",
    text: "WEEKLY ADDRESS🇺🇸 https://t.co/P1f12i9Gvt",
    created_at: "Fri Jun 23 21:32:29 +0000 2017",
    retweet_count: 12308,
    favorite_count: 49890,
    is_retweet: false,
    id_str: "878365166538285057"
  },
  {
    source: "Media Studio",
    text:
      "Today, it was a tremendous honor for me to sign the #VAaccountability Act into law, delivering my campaign promise… https://t.co/G0k8nFWqNj",
    created_at: "Fri Jun 23 19:56:29 +0000 2017",
    retweet_count: 16739,
    favorite_count: 73540,
    is_retweet: false,
    id_str: "878341007103987712"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I've helped pass and signed 38 Legislative Bills, mostly with no Democratic support, and gotten rid of massive amounts of regulations. Nice!",
    created_at: "Fri Jun 23 10:39:50 +0000 2017",
    retweet_count: 25607,
    favorite_count: 121754,
    is_retweet: false,
    id_str: "878200921980891136"
  },
  {
    source: "Twitter for iPhone",
    text: "Will be on @foxandfriends. Enjoy!",
    created_at: "Fri Jun 23 10:07:50 +0000 2017",
    retweet_count: 6612,
    favorite_count: 49717,
    is_retweet: false,
    id_str: "878192867847675904"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: POTUS the predictor? President Trump foretold housing upswing in 2012 https://t.co/N3LMDZKTK1",
    created_at: "Fri Jun 23 03:02:26 +0000 2017",
    retweet_count: 4730,
    favorite_count: 0,
    is_retweet: true,
    id_str: "878085811941539849"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxnation: .@SenTedCruz: I want to Get to a 'Yes' Vote: https://t.co/g0vafw4ef2",
    created_at: "Fri Jun 23 03:00:00 +0000 2017",
    retweet_count: 4312,
    favorite_count: 0,
    is_retweet: true,
    id_str: "878085201494147076"
  },
  {
    source: "Media Studio",
    text:
      ".@FLOTUS &amp; I were honored to host our first WH Congressional Picnic. A wonderful evening &amp; tradition. @MarineBand:… https://t.co/h5L4myWmam",
    created_at: "Fri Jun 23 02:33:37 +0000 2017",
    retweet_count: 10160,
    favorite_count: 54519,
    is_retweet: false,
    id_str: "878078560715538432"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We're all thinking of you @SteveScalise! #TeamScalise https://t.co/Yqf6exhm7x",
    created_at: "Thu Jun 22 23:27:50 +0000 2017",
    retweet_count: 11857,
    favorite_count: 56627,
    is_retweet: false,
    id_str: "878031806506848256"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Together, we are going to MAKE AMERICA GREAT AGAIN!\n#AmericaFirst🇺🇸 https://t.co/MVJbs44AtR",
    created_at: "Thu Jun 22 23:12:12 +0000 2017",
    retweet_count: 13160,
    favorite_count: 61765,
    is_retweet: false,
    id_str: "878027873650475008"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am very supportive of the Senate #HealthcareBill. Look forward to making it really special! Remember, ObamaCare is dead.",
    created_at: "Thu Jun 22 22:40:27 +0000 2017",
    retweet_count: 11200,
    favorite_count: 55678,
    is_retweet: false,
    id_str: "878019881353871360"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Mexico was just ranked the second deadliest country in the world, after only Syria. Drug trade is largely the cause. We will BUILD THE WALL!",
    created_at: "Thu Jun 22 22:15:39 +0000 2017",
    retweet_count: 43956,
    favorite_count: 143033,
    is_retweet: false,
    id_str: "878013639613186049"
  },
  {
    source: "Twitter for iPhone",
    text:
      'As promised, our campaign against the MS-13 gang continues. \n\n"@ICEgov Busts 39 MS-13 Members in New York Operation"\nhttps://t.co/ki41GXeCMy',
    created_at: "Thu Jun 22 21:49:07 +0000 2017",
    retweet_count: 12946,
    favorite_count: 51873,
    is_retweet: false,
    id_str: "878006964072189952"
  },
  {
    source: "Twitter for iPhone",
    text:
      '...whether there are "tapes" or recordings of my conversations with James Comey, but I did not make, and do not have, any such recordings.',
    created_at: "Thu Jun 22 16:55:02 +0000 2017",
    retweet_count: 13147,
    favorite_count: 55734,
    is_retweet: false,
    id_str: "877932956458795008"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With all of the recently reported electronic surveillance, intercepts, unmasking and illegal leaking of information, I have no idea...",
    created_at: "Thu Jun 22 16:54:50 +0000 2017",
    retweet_count: 14534,
    favorite_count: 63688,
    is_retweet: false,
    id_str: "877932907137966080"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I certainly hope the Democrats do not force Nancy P out. That would be very bad for the Republican Party - and please let Cryin' Chuck stay!",
    created_at: "Thu Jun 22 14:15:48 +0000 2017",
    retweet_count: 26668,
    favorite_count: 101602,
    is_retweet: false,
    id_str: "877892883352702976"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...Why did the DNC REFUSE to turn over its Server to the FBI, and still hasn't? It's all a big Dem scam and excuse for losing the election!",
    created_at: "Thu Jun 22 14:08:50 +0000 2017",
    retweet_count: 25178,
    favorite_count: 93519,
    is_retweet: false,
    id_str: "877891129194102785"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...Why did Democratic National Committee turn down the DHS offer to protect against hacks (long prior to election). It's all a big Dem HOAX!",
    created_at: "Thu Jun 22 14:01:10 +0000 2017",
    retweet_count: 19755,
    favorite_count: 75311,
    is_retweet: false,
    id_str: "877889199353077760"
  },
  {
    source: "Twitter for iPhone",
    text:
      "By the way, if Russia was working so hard on the 2016 Election, it all took place during the Obama Admin. Why didn't they stop them?",
    created_at: "Thu Jun 22 13:22:04 +0000 2017",
    retweet_count: 26454,
    favorite_count: 95899,
    is_retweet: false,
    id_str: "877879361130688512"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Former Homeland Security Advisor Jeh Johnson is latest top intelligence official to state there was no grand scheme between Trump &amp; Russia.",
    created_at: "Thu Jun 22 13:18:09 +0000 2017",
    retweet_count: 19154,
    favorite_count: 74394,
    is_retweet: false,
    id_str: "877878375045447680"
  },
  {
    source: "Twitter for iPhone",
    text: "Great night in Iowa - special people. Thank you!",
    created_at: "Thu Jun 22 11:11:25 +0000 2017",
    retweet_count: 10209,
    favorite_count: 68048,
    is_retweet: false,
    id_str: "877846483021602816"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you Kirkwood Community College. Heading to the U.S. Cellular Center now for an 8pmE MAKE AMERICA GREAT AGAIN… https://t.co/n6LS32a6Zn",
    created_at: "Wed Jun 21 23:48:58 +0000 2017",
    retweet_count: 8820,
    favorite_count: 51527,
    is_retweet: false,
    id_str: "877674738364989440"
  },
  {
    source: "Twitter for iPhone",
    text: "Just landed in Iowa. See everyone soon! #MAGA🇺🇸",
    created_at: "Wed Jun 21 23:04:54 +0000 2017",
    retweet_count: 8273,
    favorite_count: 62038,
    is_retweet: false,
    id_str: "877663648713330688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrats would do much better as a party if they got together with Republicans on Healthcare,Tax Cuts,Security. Obstruction doesn't work!",
    created_at: "Wed Jun 21 10:32:46 +0000 2017",
    retweet_count: 28275,
    favorite_count: 117542,
    is_retweet: false,
    id_str: "877474368661618688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Well, the Special Elections are over and those that want to MAKE AMERICA GREAT AGAIN are 5 and O! All the Fake News, all the money spent = 0",
    created_at: "Wed Jun 21 03:48:37 +0000 2017",
    retweet_count: 35330,
    favorite_count: 131758,
    is_retweet: false,
    id_str: "877372660455546880"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Ralph Norman ran a fantastic race to win in the Great State of South Carolina's 5th District. We are all honored by your success tonight!",
    created_at: "Wed Jun 21 03:12:00 +0000 2017",
    retweet_count: 15716,
    favorite_count: 82411,
    is_retweet: false,
    id_str: "877363446530007040"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to Karen Handel on her big win in Georgia 6th. Fantastic job, we are all very proud of you!",
    created_at: "Wed Jun 21 02:41:23 +0000 2017",
    retweet_count: 25197,
    favorite_count: 119303,
    is_retweet: false,
    id_str: "877355739383287808"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Thank you @FoxNews "Huge win for President Trump and GOP in Georgia Congressional Special Election."',
    created_at: "Wed Jun 21 02:33:40 +0000 2017",
    retweet_count: 18523,
    favorite_count: 91654,
    is_retweet: false,
    id_str: "877353797760286720"
  },
  {
    source: "Twitter for iPhone",
    text: "Things are looking great for Karen H!",
    created_at: "Wed Jun 21 02:21:36 +0000 2017",
    retweet_count: 10188,
    favorite_count: 69998,
    is_retweet: false,
    id_str: "877350761742688256"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was a great honor to welcome President Petro Poroshenko of Ukraine to the @WhiteHouse today with @VP Pence.\n➡️… https://t.co/J1ulOd6pYQ",
    created_at: "Wed Jun 21 01:42:59 +0000 2017",
    retweet_count: 9130,
    favorite_count: 47291,
    is_retweet: false,
    id_str: "877341043171241984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "While I greatly appreciate the efforts of President Xi &amp; China to help with North Korea, it has not worked out. At least I know China tried!",
    created_at: "Tue Jun 20 18:38:11 +0000 2017",
    retweet_count: 18358,
    favorite_count: 83117,
    is_retweet: false,
    id_str: "877234140483121152"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The U.S. once again condemns the brutality of the North Korean regime as we mourn its latest victim. Video: https://t.co/Rvm11ZbPk7",
    created_at: "Tue Jun 20 16:41:10 +0000 2017",
    retweet_count: 14601,
    favorite_count: 63708,
    is_retweet: false,
    id_str: "877204691851108353"
  },
  {
    source: "Twitter for iPhone",
    text:
      "KAREN HANDEL FOR CONGRESS. She will fight for lower taxes, great healthcare strong security-a hard worker who will never give up! VOTE TODAY",
    created_at: "Tue Jun 20 10:02:06 +0000 2017",
    retweet_count: 21313,
    favorite_count: 82075,
    is_retweet: false,
    id_str: "877104262463008771"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @SheriffClarke: Happy Father's Day to all dads. My dad. Like father, like son, @realDonaldTrump supporters to the end. He an Airborne Ra…",
    created_at: "Tue Jun 20 09:52:26 +0000 2017",
    retweet_count: 11939,
    favorite_count: 0,
    is_retweet: true,
    id_str: "877101828143542272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrat Jon Ossoff, who wants to raise your taxes to the highest level and is weak on crime and security, doesn't even live in district.",
    created_at: "Tue Jun 20 09:49:50 +0000 2017",
    retweet_count: 19250,
    favorite_count: 70567,
    is_retweet: false,
    id_str: "877101173412638720"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Big day tomorrow in Georgia and South Carolina. ObamaCare is dead. Dems want to raise taxes big! They can only obstruct, no ideas. Vote "R"',
    created_at: "Tue Jun 20 00:45:00 +0000 2017",
    retweet_count: 20698,
    favorite_count: 82229,
    is_retweet: false,
    id_str: "876964061027684352"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @joegooding: What's happening in our country isn't just an assault on our @POTUS @realDonaldTrump it's an assault on the American people…",
    created_at: "Mon Jun 19 23:57:48 +0000 2017",
    retweet_count: 5931,
    favorite_count: 0,
    is_retweet: true,
    id_str: "876952186143506432"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FoxNews: New Poll Shows @POTUS Approval at 50 Percent\nhttps://t.co/FRWlSVvxzQ",
    created_at: "Mon Jun 19 23:56:27 +0000 2017",
    retweet_count: 8734,
    favorite_count: 0,
    is_retweet: true,
    id_str: "876951845880688644"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Melania and I offer our deepest condolences to the family of Otto Warmbier. Full statement: https://t.co/8kmcA6YtFD https://t.co/EhrP4BiJeB",
    created_at: "Mon Jun 19 23:44:02 +0000 2017",
    retweet_count: 17317,
    favorite_count: 70714,
    is_retweet: false,
    id_str: "876948721468141573"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was my great honor to welcome President @JC_Varela &amp; Mrs. Varela from Panama this afternoon.🇺🇸🇵🇦\n➡️… https://t.co/770OJj2uYb",
    created_at: "Mon Jun 19 21:53:56 +0000 2017",
    retweet_count: 7109,
    favorite_count: 38936,
    is_retweet: false,
    id_str: "876921011668738050"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....because he doesn't even live there! He wants to raise taxes and kill healthcare. On Tuesday, #VoteKarenHandel.",
    created_at: "Mon Jun 19 20:35:37 +0000 2017",
    retweet_count: 10734,
    favorite_count: 43659,
    is_retweet: false,
    id_str: "876901304207069185"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Karen Handel's opponent in #GA06 can't even vote in the district he wants to represent....",
    created_at: "Mon Jun 19 20:34:11 +0000 2017",
    retweet_count: 16696,
    favorite_count: 56264,
    is_retweet: false,
    id_str: "876900944444837890"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....because he doesn't live there! He wants to raise taxes &amp; kill healthcare. On Tuesday, #VoteKarenHandel.",
    created_at: "Mon Jun 19 20:29:59 +0000 2017",
    retweet_count: 1458,
    favorite_count: 4996,
    is_retweet: false,
    id_str: "876899886272319489"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Karen Handle's opponent in #GA06 can't even vote in the district he wants to represent....",
    created_at: "Mon Jun 19 20:29:38 +0000 2017",
    retweet_count: 854,
    favorite_count: 2906,
    is_retweet: false,
    id_str: "876899797994790912"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....getting great border security and healthcare. #VoteRalphNorman tomorrow!",
    created_at: "Mon Jun 19 20:27:27 +0000 2017",
    retweet_count: 8245,
    favorite_count: 40256,
    is_retweet: false,
    id_str: "876899250071904256"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Ralph Norman, who is running for Congress in SC's 5th District, will be a fantastic help to me in cutting taxes, and....",
    created_at: "Mon Jun 19 20:27:10 +0000 2017",
    retweet_count: 13012,
    favorite_count: 53526,
    is_retweet: false,
    id_str: "876899176562524160"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My heartfelt thoughts and prayers are with the 7 @USNavy sailors of the #USSFitzgerald and their families. ➡️… https://t.co/L3u5c8Iymh",
    created_at: "Mon Jun 19 20:15:07 +0000 2017",
    retweet_count: 12454,
    favorite_count: 56016,
    is_retweet: false,
    id_str: "876896144944762880"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Dems want to stop tax cuts, good healthcare and Border Security.Their ObamaCare is dead with 100% increases in P's. Vote now for Karen H",
    created_at: "Mon Jun 19 12:27:01 +0000 2017",
    retweet_count: 22909,
    favorite_count: 84993,
    is_retweet: false,
    id_str: "876778344636928000"
  },
  {
    source: "Twitter for iPhone",
    text: "Jay Sekulow on @foxandfriends now.",
    created_at: "Mon Jun 19 11:59:56 +0000 2017",
    retweet_count: 1174,
    favorite_count: 5481,
    is_retweet: false,
    id_str: "876771526208626688"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @WhiteHouse: Happy Father's Day! https://t.co/32tFoVa4Ov",
    created_at: "Sun Jun 18 21:52:26 +0000 2017",
    retweet_count: 8023,
    favorite_count: 0,
    is_retweet: true,
    id_str: "876558248631042049"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Camp David is a very special place. An honor to have spent the weekend there. Military runs it so well and are so proud of what they do!",
    created_at: "Sun Jun 18 21:51:39 +0000 2017",
    retweet_count: 18017,
    favorite_count: 108462,
    is_retweet: false,
    id_str: "876558049565188096"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DonaldJTrumpJr: Not surprising at all! \nFather Of Otto Warmbier: Obama Admin Told Us To Keep Quiet, Trump Admin Brought Him Home  https…",
    created_at: "Sun Jun 18 21:28:25 +0000 2017",
    retweet_count: 17978,
    favorite_count: 0,
    is_retweet: true,
    id_str: "876552203187736577"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DiamondandSilk: The Media Says:  The President Should Stop Tweeting about Russia. \n Well, Why Don't the Media Take Their Own Advice &amp; S…",
    created_at: "Sun Jun 18 21:07:12 +0000 2017",
    retweet_count: 14442,
    favorite_count: 0,
    is_retweet: true,
    id_str: "876546864669237253"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The new Rasmussen Poll, one of the most accurate in the 2016 Election, just out with a Trump 50% Approval Rating.That's higher than O's #'s!",
    created_at: "Sun Jun 18 11:02:04 +0000 2017",
    retweet_count: 23060,
    favorite_count: 104478,
    is_retweet: false,
    id_str: "876394578777174021"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...massive regulation cuts, 36 new legislative bills signed, great new S.C.Justice, and Infrastructure, Healthcare and Tax Cuts in works!",
    created_at: "Sun Jun 18 10:46:35 +0000 2017",
    retweet_count: 18026,
    favorite_count: 89002,
    is_retweet: false,
    id_str: "876390681056600066"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The MAKE AMERICA GREAT AGAIN agenda is doing very well despite the distraction of the Witch Hunt. Many new jobs, high business enthusiasm,..",
    created_at: "Sun Jun 18 10:38:51 +0000 2017",
    retweet_count: 21269,
    favorite_count: 102054,
    is_retweet: false,
    id_str: "876388733607694336"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thoughts and prayers with the sailors of USS Fitzgerald and their families. Thank you to our Japanese allies for th… https://t.co/BBvmTFxVkk",
    created_at: "Sat Jun 17 14:08:48 +0000 2017",
    retweet_count: 20363,
    favorite_count: 85868,
    is_retweet: false,
    id_str: "876079184417882116"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @seanhannity: #Hannity Starts in 30 minutes with @newtgingrich and my monologue on the Deep State’s allies in the media",
    created_at: "Sat Jun 17 01:31:01 +0000 2017",
    retweet_count: 5765,
    favorite_count: 0,
    is_retweet: true,
    id_str: "875888479942651909"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Back from Miami where my Cuban/American friends are very happy with what I signed today. Another campaign promise that I did not forget!",
    created_at: "Sat Jun 17 01:30:08 +0000 2017",
    retweet_count: 21073,
    favorite_count: 105285,
    is_retweet: false,
    id_str: "875888258407858176"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"National Security Presidential Memorandum on Strengthening the Policy of the United States Toward Cuba"\nMemorandum… https://t.co/RVr9Dg2hXt',
    created_at: "Fri Jun 16 22:32:20 +0000 2017",
    retweet_count: 9381,
    favorite_count: 44120,
    is_retweet: false,
    id_str: "875843513761583104"
  },
  {
    source: "Media Studio",
    text:
      '"Remarks by President Trump on the Policy of the U.S.A. Towards Cuba"\nVideo: https://t.co/jUWCjgxX5D\nTranscript:… https://t.co/hILCHbPJet',
    created_at: "Fri Jun 16 22:18:54 +0000 2017",
    retweet_count: 10546,
    favorite_count: 46393,
    is_retweet: false,
    id_str: "875840132238032897"
  },
  {
    source: "Twitter for iPhone",
    text: "Great news! #MAGA https://t.co/pirHR7lAyT",
    created_at: "Fri Jun 16 15:12:27 +0000 2017",
    retweet_count: 18156,
    favorite_count: 73067,
    is_retweet: false,
    id_str: "875732813278048256"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am being investigated for firing the FBI Director by the man who told me to fire the FBI Director! Witch Hunt",
    created_at: "Fri Jun 16 13:07:55 +0000 2017",
    retweet_count: 47625,
    favorite_count: 153281,
    is_retweet: false,
    id_str: "875701471999864833"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Despite the phony Witch Hunt going on in America, the economic &amp; jobs numbers are great. Regulations way down, jobs and enthusiasm way up!",
    created_at: "Fri Jun 16 12:54:22 +0000 2017",
    retweet_count: 24781,
    favorite_count: 112906,
    is_retweet: false,
    id_str: "875698062030778368"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News Media hates when I use what has turned out to be my very powerful Social Media - over 100 million people! I can go around them",
    created_at: "Fri Jun 16 12:23:08 +0000 2017",
    retweet_count: 29017,
    favorite_count: 135395,
    is_retweet: false,
    id_str: "875690204564258816"
  },
  {
    source: "Twitter for iPhone",
    text:
      'After 7 months of investigations &amp; committee hearings about my "collusion with the Russians,"  nobody has been able to show any proof. Sad!',
    created_at: "Fri Jun 16 11:53:56 +0000 2017",
    retweet_count: 25548,
    favorite_count: 110443,
    is_retweet: false,
    id_str: "875682853585129472"
  },
  {
    source: "Media Studio",
    text: "#CongressionalBaseballGame⚾️ https://t.co/u8InOJTf6D",
    created_at: "Thu Jun 15 23:49:24 +0000 2017",
    retweet_count: 17119,
    favorite_count: 75576,
    is_retweet: false,
    id_str: "875500520840060928"
  },
  {
    source: "Twitter Web Client",
    text:
      "Thank you Wisconsin! Tuesday was a great success for #WorkforceWeek at @WCTC w/ @IvankaTrump &amp; @GovWalker. \nRemarks… https://t.co/L8o396yYKX",
    created_at: "Thu Jun 15 21:43:14 +0000 2017",
    retweet_count: 9432,
    favorite_count: 49507,
    is_retweet: false,
    id_str: "875468769212149760"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Crooked H destroyed phones w/ hammer, 'bleached' emails, &amp; had husband meet w/AG days before she was cleared- &amp; they talk about obstruction?",
    created_at: "Thu Jun 15 19:56:01 +0000 2017",
    retweet_count: 54056,
    favorite_count: 154284,
    is_retweet: false,
    id_str: "875441788110110727"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Why is that Hillary Clintons family and Dems dealings with Russia are not looked at, but my non-dealings are?",
    created_at: "Thu Jun 15 19:43:31 +0000 2017",
    retweet_count: 36781,
    favorite_count: 124937,
    is_retweet: false,
    id_str: "875438639823675392"
  },
  {
    source: "Twitter for iPhone",
    text:
      "You are witnessing the single greatest WITCH HUNT in American political history - led by some very bad and conflicted people!  #MAGA",
    created_at: "Thu Jun 15 11:57:57 +0000 2017",
    retweet_count: 35463,
    favorite_count: 122162,
    is_retweet: false,
    id_str: "875321478849363968"
  },
  {
    source: "Twitter for iPhone",
    text:
      "They made up a phony collusion with the Russians story, found zero proof, so now they go for obstruction of justice on the phony story. Nice",
    created_at: "Thu Jun 15 10:55:37 +0000 2017",
    retweet_count: 42090,
    favorite_count: 144441,
    is_retweet: false,
    id_str: "875305788708974592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just left hospital. Rep. Steve Scalise, one of the truly great people, is in very tough shape - but he is a real fighter. Pray for Steve!",
    created_at: "Thu Jun 15 01:41:45 +0000 2017",
    retweet_count: 41305,
    favorite_count: 195471,
    is_retweet: false,
    id_str: "875166406417010688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Happy birthday to U.S. ARMY and our soldiers. Thank you for your bravery, sacrifices, &amp; dedication. Proud to be your Commander-in-Chief!",
    created_at: "Wed Jun 14 14:07:31 +0000 2017",
    retweet_count: 30031,
    favorite_count: 144619,
    is_retweet: false,
    id_str: "874991696186142721"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Rep. Steve Scalise of Louisiana, a true friend and patriot, was badly injured but will fully recover. Our thoughts and prayers are with him.",
    created_at: "Wed Jun 14 12:48:26 +0000 2017",
    retweet_count: 33044,
    favorite_count: 142370,
    is_retweet: false,
    id_str: "874971795362897921"
  },
  {
    source: "Twitter for iPhone",
    text: "Just got back from Wisconsin. Great day, great people!",
    created_at: "Wed Jun 14 02:53:45 +0000 2017",
    retweet_count: 11894,
    favorite_count: 85859,
    is_retweet: false,
    id_str: "874822136782880768"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @TuckerCarlson: .@RichardGrenell : @realDonaldTrump told Tillerson he had the full support of the U.S. Gov't to bring #OttoWarmbier home…",
    created_at: "Wed Jun 14 02:50:17 +0000 2017",
    retweet_count: 6908,
    favorite_count: 0,
    is_retweet: true,
    id_str: "874821262987730944"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The passage of the @DeptVetAffairs Accountability and Whistleblower Protection Act is GREAT news for veterans! I lo… https://t.co/k45aci25BT",
    created_at: "Tue Jun 13 23:18:19 +0000 2017",
    retweet_count: 13965,
    favorite_count: 58154,
    is_retweet: false,
    id_str: "874767922295705600"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just arrived in Wisconsin to discuss JOBS, JOBS, JOBS! #MAGA🇺🇸 https://t.co/lEJ9S817yb",
    created_at: "Tue Jun 13 20:41:37 +0000 2017",
    retweet_count: 12677,
    favorite_count: 67349,
    is_retweet: false,
    id_str: "874728484475744257"
  },
  {
    source: "Twitter for iPhone",
    text:
      "2 million more people just dropped out of ObamaCare. It is in a death spiral. Obstructionist Democrats gave up, have no answer = resist!",
    created_at: "Tue Jun 13 13:56:20 +0000 2017",
    retweet_count: 21456,
    favorite_count: 83675,
    is_retweet: false,
    id_str: "874626492310978564"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Heading to the Great State of Wisconsin to talk about JOBS, JOBS, JOBS! Big progress being made as the Real News is reporting.",
    created_at: "Tue Jun 13 13:29:59 +0000 2017",
    retweet_count: 13123,
    favorite_count: 68603,
    is_retweet: false,
    id_str: "874619861019840512"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Fake News is at an all time high. Where is their apology to me for all of the incorrect stories???",
    created_at: "Tue Jun 13 12:48:44 +0000 2017",
    retweet_count: 23231,
    favorite_count: 96026,
    is_retweet: false,
    id_str: "874609480301936640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A.G. Lynch made law enforcement decisions for political purposes...gave Hillary Clinton a free pass and protection. Totally illegal!",
    created_at: "Tue Jun 13 12:45:11 +0000 2017",
    retweet_count: 28688,
    favorite_count: 95369,
    is_retweet: false,
    id_str: "874608587473080320"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Corrynmb: @realDonaldTrump Liberals have an agenda and it's not in America's best interest. Keep fighting the good fight! We stand with…",
    created_at: "Tue Jun 13 12:07:36 +0000 2017",
    retweet_count: 15166,
    favorite_count: 0,
    is_retweet: true,
    id_str: "874599130018054145"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Well, as predicted, the 9th Circuit did it again - Ruled against the TRAVEL BAN at such a dangerous time in the history of our country. S.C.",
    created_at: "Tue Jun 13 10:44:16 +0000 2017",
    retweet_count: 17015,
    favorite_count: 67025,
    is_retweet: false,
    id_str: "874578159676665857"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News Media has never been so wrong or so dirty. Purposely incorrect stories and phony sources to meet their agenda of hate. Sad!",
    created_at: "Tue Jun 13 10:35:55 +0000 2017",
    retweet_count: 25099,
    favorite_count: 97362,
    is_retweet: false,
    id_str: "874576057579565056"
  },
  {
    source: "Twitter Web Client",
    text:
      "Congratulations to the 2016 @ClemsonFB Tigers!\nFull ceremony: https://t.co/syJUGoMhHJ\n#NationalChampions🏈 https://t.co/F23NZoX2BI",
    created_at: "Tue Jun 13 00:09:54 +0000 2017",
    retweet_count: 9745,
    favorite_count: 46728,
    is_retweet: false,
    id_str: "874418514240688129"
  },
  {
    source: "Twitter Ads",
    text:
      "Finally held our first full @Cabinet meeting today. With this great team, we can restore American prosperity and br… https://t.co/b0roksHTFE",
    created_at: "Mon Jun 12 21:10:10 +0000 2017",
    retweet_count: 16634,
    favorite_count: 74839,
    is_retweet: false,
    id_str: "874373283919089664"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations! \n\n'First New Coal Mine of Trump Era Opens in Pennsylvania' https://t.co/aIRllxNLQA",
    created_at: "Mon Jun 12 17:59:27 +0000 2017",
    retweet_count: 17016,
    favorite_count: 70386,
    is_retweet: false,
    id_str: "874325287143604224"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We will NEVER FORGET the victims who lost their lives one year ago today in the horrific #PulseNightClub shooting.… https://t.co/7lZGgDJkxZ",
    created_at: "Mon Jun 12 16:58:25 +0000 2017",
    retweet_count: 22775,
    favorite_count: 90399,
    is_retweet: false,
    id_str: "874309930232184833"
  },
  {
    source: "Twitter for iPhone",
    text: "Ivanka on @foxandfriends now!",
    created_at: "Mon Jun 12 10:55:27 +0000 2017",
    retweet_count: 5068,
    favorite_count: 45592,
    is_retweet: false,
    id_str: "874218586155479040"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great numbers on the economy. All of our work, including the passage of many bills &amp; regulation killing Executive Orders, now kicking in!",
    created_at: "Mon Jun 12 02:14:29 +0000 2017",
    retweet_count: 19144,
    favorite_count: 89422,
    is_retweet: false,
    id_str: "874087477807599616"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: .@GeraldoRivera: Chances of impeachment went from 3% to 0% with Comey's testimony https://t.co/kfeXKdpJGe",
    created_at: "Mon Jun 12 02:09:10 +0000 2017",
    retweet_count: 7794,
    favorite_count: 0,
    is_retweet: true,
    id_str: "874086142425083904"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: \"Yesterday's hearings provided zero evidence of collusion between our campaign and the Russians because there wasn't any…",
    created_at: "Mon Jun 12 02:07:30 +0000 2017",
    retweet_count: 5770,
    favorite_count: 0,
    is_retweet: true,
    id_str: "874085723762286592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My daughter, Ivanka, will be on @foxandfriends tomorrow morning. Enjoy!",
    created_at: "Mon Jun 12 02:02:23 +0000 2017",
    retweet_count: 8589,
    favorite_count: 60025,
    is_retweet: false,
    id_str: "874084433460154368"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats have no message,  not on economics, not on taxes,  not on jobs, not on failing #Obamacare. They are only OBSTRUCTIONISTS!",
    created_at: "Sun Jun 11 12:49:00 +0000 2017",
    retweet_count: 30589,
    favorite_count: 111616,
    is_retweet: false,
    id_str: "873884774041079808"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I believe the James Comey leaks will be far more prevalent than anyone ever thought possible. Totally illegal? Very 'cowardly!'",
    created_at: "Sun Jun 11 12:29:46 +0000 2017",
    retweet_count: 24684,
    favorite_count: 96527,
    is_retweet: false,
    id_str: "873879934040780801"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...way up. Regulations way down. 600,000+ new jobs added. Unemployment down to 4.3%. Business and economic enthusiasm way up- record levels!",
    created_at: "Sun Jun 11 12:23:01 +0000 2017",
    retweet_count: 19014,
    favorite_count: 88930,
    is_retweet: false,
    id_str: "873878232264822784"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The #FakeNews MSM doesn't report the great economic news since Election Day. #DOW up 16%. #NASDAQ up 19.5%. Drilling &amp; energy sector...",
    created_at: "Sun Jun 11 12:22:20 +0000 2017",
    retweet_count: 24411,
    favorite_count: 99607,
    is_retweet: false,
    id_str: "873878061778907137"
  },
  {
    source: "Twitter Ads",
    text:
      "America is going to build again. Under budget and ahead of schedule. Time to put #AmericaFirst! #InfrastructureWeek… https://t.co/D5TbbjXcN3",
    created_at: "Sat Jun 10 20:52:00 +0000 2017",
    retweet_count: 19809,
    favorite_count: 80310,
    is_retweet: false,
    id_str: "873643935993708544"
  },
  {
    source: "Twitter Ads",
    text:
      "Time to start building in our country, with American workers &amp; with American iron, aluminum &amp; steel. It is time to… https://t.co/rGZCRyeCMZ",
    created_at: "Sat Jun 10 01:38:15 +0000 2017",
    retweet_count: 21877,
    favorite_count: 94622,
    is_retweet: false,
    id_str: "873353586025132038"
  },
  {
    source: "Twitter Web Client",
    text:
      "It is time to rebuild OUR country, to bring back OUR jobs, to restore OUR dreams, &amp; yes, to put #AmericaFirst! TY O… https://t.co/2b2bXwxGkA",
    created_at: "Fri Jun 09 22:52:23 +0000 2017",
    retweet_count: 21822,
    favorite_count: 92325,
    is_retweet: false,
    id_str: "873311842956914688"
  },
  {
    source: "Twitter Web Client",
    text:
      "A great honor to host and welcome leaders from around America to the @WhiteHouse Infrastructure Summit.… https://t.co/5f6cN3HboQ",
    created_at: "Fri Jun 09 18:48:54 +0000 2017",
    retweet_count: 12286,
    favorite_count: 60282,
    is_retweet: false,
    id_str: "873250570508922880"
  },
  {
    source: "Twitter Web Client",
    text:
      "An honor to join the @FaithandFreedom Coalition yesterday. In America, we don't worship government. We worship God.… https://t.co/1ds8BrzUQe",
    created_at: "Fri Jun 09 18:28:41 +0000 2017",
    retweet_count: 15214,
    favorite_count: 60938,
    is_retweet: false,
    id_str: "873245481488535554"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to Jeb Hensarling &amp; Republicans on successful House vote to repeal major parts of the 2010 Dodd-Frank financial law. GROWTH!",
    created_at: "Fri Jun 09 14:22:00 +0000 2017",
    retweet_count: 17023,
    favorite_count: 80398,
    is_retweet: false,
    id_str: "873183401620230144"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @AlanDersh: We should stop talking about obstruction of justice. No plausible case. We must distinguish crimes from pol sins https://t.c…",
    created_at: "Fri Jun 09 14:10:33 +0000 2017",
    retweet_count: 14664,
    favorite_count: 0,
    is_retweet: true,
    id_str: "873180518493429765"
  },
  {
    source: "Twitter for iPhone",
    text: "Great reporting by @foxandfriends and so many others. Thank you!",
    created_at: "Fri Jun 09 10:54:43 +0000 2017",
    retweet_count: 14648,
    favorite_count: 85924,
    is_retweet: false,
    id_str: "873131235614347264"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Despite so many false statements and lies, total and complete vindication...and WOW, Comey is a leaker!",
    created_at: "Fri Jun 09 10:10:37 +0000 2017",
    retweet_count: 37128,
    favorite_count: 126953,
    is_retweet: false,
    id_str: "873120139222306817"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Getting ready to leave for Cincinnati, in the GREAT STATE of OHIO, to meet with ObamaCare victims and talk Healthcare &amp; also Infrastructure!",
    created_at: "Wed Jun 07 12:17:13 +0000 2017",
    retweet_count: 17063,
    favorite_count: 90839,
    is_retweet: false,
    id_str: "872427222392504320"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be nominating Christopher A. Wray, a man of impeccable credentials, to be the new Director of the FBI. Details to follow.",
    created_at: "Wed Jun 07 11:44:37 +0000 2017",
    retweet_count: 24451,
    favorite_count: 97952,
    is_retweet: false,
    id_str: "872419018799550464"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Senate passed the VA Accountability Act. The House should get this bill to my desk ASAP! We can’t tolerate substandard care for our vets.",
    created_at: "Wed Jun 07 01:07:39 +0000 2017",
    retweet_count: 24787,
    favorite_count: 104378,
    is_retweet: false,
    id_str: "872258719404482561"
  },
  {
    source: "Twitter for iPhone",
    text:
      "#ICYMI: Announcement of Air Traffic Control Initiative \n\nWatch➡️https://t.co/IMiZr22gAw",
    created_at: "Wed Jun 07 00:44:56 +0000 2017",
    retweet_count: 7633,
    favorite_count: 42059,
    is_retweet: false,
    id_str: "872253002266161153"
  },
  {
    source: "Twitter Ads",
    text:
      "Great meeting with @HouseGOP and @SenateGOP leaders, including @SpeakerRyan, @SenateMajLdr, @GOPLeader, @JohnCornyn… https://t.co/G03W8CEtCS",
    created_at: "Wed Jun 07 00:06:50 +0000 2017",
    retweet_count: 9205,
    favorite_count: 45189,
    is_retweet: false,
    id_str: "872243414930264065"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today we remember the courage and bravery of our troops that stormed the beaches of Normandy 73 years ago. #DDay… https://t.co/zhR24dMzYB",
    created_at: "Tue Jun 06 17:47:33 +0000 2017",
    retweet_count: 27081,
    favorite_count: 101067,
    is_retweet: false,
    id_str: "872147965451882496"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...extremism, and all reference was pointing to Qatar. Perhaps this will be the beginning of the end to the horror of terrorism!",
    created_at: "Tue Jun 06 13:44:55 +0000 2017",
    retweet_count: 43776,
    favorite_count: 70116,
    is_retweet: false,
    id_str: "872086906804240384"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So good to see the Saudi Arabia visit with the King and 50 countries already paying off. They said they would take a hard line on funding...",
    created_at: "Tue Jun 06 13:36:50 +0000 2017",
    retweet_count: 41498,
    favorite_count: 68556,
    is_retweet: false,
    id_str: "872084870620520448"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Sorry folks, but if I would have relied on the Fake News of CNN, NBC, ABC, CBS, washpost or nytimes, I would have had ZERO chance winning WH",
    created_at: "Tue Jun 06 12:15:36 +0000 2017",
    retweet_count: 26473,
    favorite_count: 108333,
    is_retweet: false,
    id_str: "872064426568036353"
  },
  {
    source: "Twitter for iPhone",
    text:
      "During my recent trip to the Middle East I stated that there can no longer be funding of Radical Ideology. Leaders pointed to Qatar - look!",
    created_at: "Tue Jun 06 12:06:35 +0000 2017",
    retweet_count: 87163,
    favorite_count: 79181,
    is_retweet: false,
    id_str: "872062159789985792"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The FAKE MSM is working so hard trying to get me not to use Social Media. They hate that I can get the honest and unfiltered message out.",
    created_at: "Tue Jun 06 11:58:00 +0000 2017",
    retweet_count: 28097,
    favorite_count: 113941,
    is_retweet: false,
    id_str: "872059997429022722"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big meeting today with Republican leadership concerning Tax Cuts and Healthcare. We are all pushing hard - must get it right!",
    created_at: "Tue Jun 06 10:51:39 +0000 2017",
    retweet_count: 12932,
    favorite_count: 72350,
    is_retweet: false,
    id_str: "872043300949295104"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: FOX NEWS ALERT: ISIS claims responsibility for hostage siege in Melbourne, Australia that killed 1 person and injured 3…",
    created_at: "Tue Jun 06 10:43:17 +0000 2017",
    retweet_count: 8484,
    favorite_count: 0,
    is_retweet: true,
    id_str: "872041195618349056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Sen. Ted Cruz: Trump's air traffic control plan is a 'win-win' for Democrats and Republicans https://t.co/TsggUEfOO2",
    created_at: "Tue Jun 06 10:41:25 +0000 2017",
    retweet_count: 6926,
    favorite_count: 0,
    is_retweet: true,
    id_str: "872040726120550404"
  },
  {
    source: "Twitter for iPhone",
    text:
      "That's right, we need a TRAVEL BAN for certain DANGEROUS countries, not some politically correct term that won't help us protect our people!",
    created_at: "Tue Jun 06 01:20:17 +0000 2017",
    retweet_count: 32010,
    favorite_count: 122724,
    is_retweet: false,
    id_str: "871899511525961728"
  },
  {
    source: "Twitter Ads",
    text:
      "Today, I announced an Air Traffic Control Initiative to take American air travel into the future - finally!\n➡️… https://t.co/NIIorkSRJN",
    created_at: "Mon Jun 05 21:25:16 +0000 2017",
    retweet_count: 12804,
    favorite_count: 60074,
    is_retweet: false,
    id_str: "871840367070412800"
  },
  {
    source: "Twitter Ads",
    text:
      ".@SecShulkin's decision is one of the biggest wins for our VETERANS in decades. Our HEROES deserve the best! \n➡️… https://t.co/RnNp9q7Tdh",
    created_at: "Mon Jun 05 20:45:05 +0000 2017",
    retweet_count: 9650,
    favorite_count: 43754,
    is_retweet: false,
    id_str: "871830255396192256"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Pathetic excuse by London Mayor Sadiq Khan who had to think fast on his "no reason to be alarmed" statement. MSM is working hard to sell it!',
    created_at: "Mon Jun 05 13:49:56 +0000 2017",
    retweet_count: 29370,
    favorite_count: 97128,
    is_retweet: false,
    id_str: "871725780535062528"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@foxandfriends  Dems are taking forever to approve my people, including Ambassadors. They are nothing but OBSTRUCTIONISTS! Want approvals.",
    created_at: "Mon Jun 05 13:35:00 +0000 2017",
    retweet_count: 21201,
    favorite_count: 80877,
    is_retweet: false,
    id_str: "871722020278587393"
  },
  {
    source: "Twitter for iPhone",
    text:
      "In any event we are EXTREME VETTING people coming into the U.S. in order to help keep our country safe. The courts are slow and political!",
    created_at: "Mon Jun 05 10:44:18 +0000 2017",
    retweet_count: 20282,
    favorite_count: 90754,
    is_retweet: false,
    id_str: "871679061847879682"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Justice Dept. should ask for an expedited hearing of the watered down Travel Ban before the Supreme Court - &amp; seek much tougher version!",
    created_at: "Mon Jun 05 10:37:59 +0000 2017",
    retweet_count: 15040,
    favorite_count: 66932,
    is_retweet: false,
    id_str: "871677472202477568"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Justice Dept. should have stayed with the original Travel Ban, not the watered down, politically correct version they submitted to S.C.",
    created_at: "Mon Jun 05 10:29:08 +0000 2017",
    retweet_count: 15606,
    favorite_count: 72427,
    is_retweet: false,
    id_str: "871675245043888128"
  },
  {
    source: "Twitter for iPhone",
    text:
      "People, the lawyers and the courts can call it whatever they want, but I am calling it what we need and what it is, a TRAVEL BAN!",
    created_at: "Mon Jun 05 10:25:02 +0000 2017",
    retweet_count: 21969,
    favorite_count: 90410,
    is_retweet: false,
    id_str: "871674214356484096"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Do you notice we are not having a gun debate right now? That's because they used knives and a truck!",
    created_at: "Sun Jun 04 11:43:30 +0000 2017",
    retweet_count: 50591,
    favorite_count: 168637,
    is_retweet: false,
    id_str: "871331574649901056"
  },
  {
    source: "Twitter for iPhone",
    text:
      'At least 7 dead and 48 wounded in terror attack and Mayor of London says there is "no reason to be alarmed!"',
    created_at: "Sun Jun 04 11:31:00 +0000 2017",
    retweet_count: 63789,
    favorite_count: 163688,
    is_retweet: false,
    id_str: "871328428963901440"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We must stop being politically correct and get down to the business of security for our people. If we don't get smart it will only get worse",
    created_at: "Sun Jun 04 11:19:47 +0000 2017",
    retweet_count: 76260,
    favorite_count: 246690,
    is_retweet: false,
    id_str: "871325606901895168"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Whatever the United States can do to help out in London and the U. K., we will be there - WE ARE WITH YOU. GOD BLESS!",
    created_at: "Sat Jun 03 23:24:45 +0000 2017",
    retweet_count: 65851,
    favorite_count: 266026,
    is_retweet: false,
    id_str: "871145660036378624"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We need to be smart, vigilant and tough. We need the courts to give us back our rights. We need the Travel Ban as an extra level of safety!",
    created_at: "Sat Jun 03 23:17:13 +0000 2017",
    retweet_count: 54075,
    favorite_count: 180015,
    is_retweet: false,
    id_str: "871143765473406976"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DRUDGE_REPORT: Fears of new terror attack after van 'mows down 20 people' on London Bridge...",
    created_at: "Sat Jun 03 23:01:54 +0000 2017",
    retweet_count: 7666,
    favorite_count: 0,
    is_retweet: true,
    id_str: "871139911298101248"
  },
  {
    source: "Twitter Ads",
    text: "#WeeklyAddress🇺🇸 https://t.co/DNzRZiKxhd",
    created_at: "Sat Jun 03 19:35:33 +0000 2017",
    retweet_count: 12240,
    favorite_count: 52698,
    is_retweet: false,
    id_str: "871087981225926656"
  },
  {
    source: "Twitter for iPhone",
    text: "#MakeAmericaGreatAgain🇺🇸\nhttps://t.co/eJxeVZ3A1r",
    created_at: "Fri Jun 02 18:30:41 +0000 2017",
    retweet_count: 16640,
    favorite_count: 79292,
    is_retweet: false,
    id_str: "870709271477932032"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @EricTrump: #MakeAmericaGreatAgain!!! 🇺🇸🇺🇸 https://t.co/MStWl628xe",
    created_at: "Fri Jun 02 10:40:22 +0000 2017",
    retweet_count: 11199,
    favorite_count: 0,
    is_retweet: true,
    id_str: "870590911222349824"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @HeyTammyBruce: Coming up at 720a ET on @foxandfriends! See you there! 🇺🇸 #maga",
    created_at: "Fri Jun 02 10:35:32 +0000 2017",
    retweet_count: 2011,
    favorite_count: 0,
    is_retweet: true,
    id_str: "870589692294647808"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @LindseyGrahamSC: I support President Trump’s desire to re-enter the Paris Accord after the agreement becomes a better deal for America…",
    created_at: "Fri Jun 02 10:34:42 +0000 2017",
    retweet_count: 7597,
    favorite_count: 0,
    is_retweet: true,
    id_str: "870589482675916800"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Reince45: Promise kept. @POTUS exits flawed #ParisAccord to seek better deal for U.S. workers &amp; economy. This WH will always put #Ameri…",
    created_at: "Fri Jun 02 10:33:37 +0000 2017",
    retweet_count: 9027,
    favorite_count: 0,
    is_retweet: true,
    id_str: "870589212978032640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @GOPLeader: .@POTUS made the right call in leaving a deal that would have put an unnecessary burden on the United States. https://t.co/q…",
    created_at: "Fri Jun 02 10:32:39 +0000 2017",
    retweet_count: 8267,
    favorite_count: 0,
    is_retweet: true,
    id_str: "870588968475275264"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Jim_Jordan: President Trump did the right thing by withdrawing us from Paris treaty - it would hurt American companies and American wor…",
    created_at: "Fri Jun 02 10:32:10 +0000 2017",
    retweet_count: 9485,
    favorite_count: 0,
    is_retweet: true,
    id_str: "870588844793581569"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @VP: Our President is choosing to put American jobs, American consumers, American energy, and American industry first. https://t.co/y2Op…",
    created_at: "Fri Jun 02 10:31:03 +0000 2017",
    retweet_count: 9649,
    favorite_count: 0,
    is_retweet: true,
    id_str: "870588565595578370"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Wall Street hits record highs after Trump pulls out of Climate pact https://t.co/PDmwj13Lus",
    created_at: "Fri Jun 02 10:08:24 +0000 2017",
    retweet_count: 9639,
    favorite_count: 0,
    is_retweet: true,
    id_str: "870582867084050432"
  },
  {
    source: "Twitter for iPhone",
    text: "MAKE AMERICA GREAT AGAIN!",
    created_at: "Fri Jun 02 01:00:35 +0000 2017",
    retweet_count: 48844,
    favorite_count: 165602,
    is_retweet: false,
    id_str: "870445001125355522"
  },
  {
    source: "Twitter Ads",
    text:
      "My job as President is to do everything within my power to give America a level playing field. #AmericaFirst🇺🇸\n➡️… https://t.co/hL7OwbWzyi",
    created_at: "Thu Jun 01 22:50:29 +0000 2017",
    retweet_count: 22622,
    favorite_count: 94084,
    is_retweet: false,
    id_str: "870412262900740096"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me live at the @WhiteHouse.\n\n➡️https://t.co/9VOb99W42r https://t.co/sjb5VHLHYH",
    created_at: "Thu Jun 01 19:03:10 +0000 2017",
    retweet_count: 7187,
    favorite_count: 38990,
    is_retweet: false,
    id_str: "870355056327000065"
  },
  {
    source: "Twitter for iPhone",
    text:
      'The big story is the "unmasking and surveillance" of people that took place during the Obama Administration.',
    created_at: "Thu Jun 01 11:05:21 +0000 2017",
    retweet_count: 25862,
    favorite_count: 93499,
    is_retweet: false,
    id_str: "870234811616677889"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be announcing my decision on Paris Accord, Thursday at 3:00 P.M.  The White House Rose Garden.  MAKE AMERICA GREAT AGAIN!",
    created_at: "Thu Jun 01 01:05:17 +0000 2017",
    retweet_count: 17633,
    favorite_count: 80485,
    is_retweet: false,
    id_str: "870083798981111808"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Crooked Hillary Clinton now blames everybody but herself, refuses to say she was a terrible candidate. Hits Facebook &amp; even Dems &amp; DNC.",
    created_at: "Thu Jun 01 00:40:01 +0000 2017",
    retweet_count: 29836,
    favorite_count: 116138,
    is_retweet: false,
    id_str: "870077441401905152"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was an honor to welcome the Prime Minister of Vietnam, Nguyễn Xuân Phúc to the @WhiteHouse this afternoon. https://t.co/6YbrIvJUCY",
    created_at: "Wed May 31 21:52:54 +0000 2017",
    retweet_count: 7480,
    favorite_count: 43852,
    is_retweet: false,
    id_str: "870035383458963456"
  },
  {
    source: "Twitter Ads",
    text:
      "We traveled the world to strengthen long-standing alliances, and to form new partnerships. See more at:… https://t.co/FT4kyPoAl0",
    created_at: "Wed May 31 20:04:45 +0000 2017",
    retweet_count: 13237,
    favorite_count: 60536,
    is_retweet: false,
    id_str: "870008165827575808"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be announcing my decision on the Paris Accord over the next few days. MAKE AMERICA GREAT AGAIN!",
    created_at: "Wed May 31 13:08:41 +0000 2017",
    retweet_count: 14084,
    favorite_count: 73547,
    is_retweet: false,
    id_str: "869903459511918592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Hopefully Republican Senators, good people all, can quickly get together and pass a new (repeal &amp; replace) HEALTHCARE bill. Add saved $'s.",
    created_at: "Wed May 31 13:05:14 +0000 2017",
    retweet_count: 12422,
    favorite_count: 66248,
    is_retweet: false,
    id_str: "869902591005741056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Kathy Griffin should be ashamed of herself. My children, especially my 11 year old son, Barron, are having a hard time with this. Sick!",
    created_at: "Wed May 31 11:14:48 +0000 2017",
    retweet_count: 54196,
    favorite_count: 195529,
    is_retweet: false,
    id_str: "869874798087819264"
  },
  {
    source: "Twitter for iPhone",
    text:
      '...case against him &amp; now wants to clear his name by showing "the false or misleading testimony by James Comey, John Brennan..." Witch Hunt!',
    created_at: "Wed May 31 10:45:27 +0000 2017",
    retweet_count: 13108,
    favorite_count: 59792,
    is_retweet: false,
    id_str: "869867413776601088"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So now it is reported that the Democrats, who have excoriated Carter Page about Russia, don't want him to testify. He blows away their....",
    created_at: "Wed May 31 10:37:42 +0000 2017",
    retweet_count: 13947,
    favorite_count: 56683,
    is_retweet: false,
    id_str: "869865463584620544"
  },
  {
    source: "Twitter for iPhone",
    text: 'Who can figure out the true meaning of "covfefe" ???  Enjoy!',
    created_at: "Wed May 31 10:09:22 +0000 2017",
    retweet_count: 85555,
    favorite_count: 209543,
    is_retweet: false,
    id_str: "869858333477523458"
  },
  {
    source: "Twitter for iPhone",
    text: "Despite the constant negative press covfefe",
    created_at: "Wed May 31 04:06:25 +0000 2017",
    retweet_count: 127507,
    favorite_count: 162788,
    is_retweet: false,
    id_str: "869766994899468288"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Jared Kushner didn't suggest Russian communications channel in meeting, source says https://t.co/nF6bM1FEt1",
    created_at: "Tue May 30 14:01:16 +0000 2017",
    retweet_count: 7606,
    favorite_count: 0,
    is_retweet: true,
    id_str: "869554306806157312"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: President Trump pays respects and  delivers #MemorialDay remarks at Arlington National Cemetery. https://t.co/D5rl948J6u",
    created_at: "Tue May 30 14:00:50 +0000 2017",
    retweet_count: 6310,
    favorite_count: 0,
    is_retweet: true,
    id_str: "869554194658844673"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The U.S. Senate should switch to 51 votes, immediately, and get Healthcare and TAX CUTS approved, fast and easy. Dems would do it, no doubt!",
    created_at: "Tue May 30 13:59:28 +0000 2017",
    retweet_count: 19892,
    favorite_count: 78400,
    is_retweet: false,
    id_str: "869553853750013953"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Russian officials must be laughing at the U.S. &amp; how a lame excuse for why the Dems lost the election has taken over the Fake News.",
    created_at: "Tue May 30 11:04:48 +0000 2017",
    retweet_count: 22034,
    favorite_count: 87501,
    is_retweet: false,
    id_str: "869509894688387072"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We have a MASSIVE trade deficit with Germany, plus they pay FAR LESS than they should on NATO &amp; military. Very bad for U.S. This will change",
    created_at: "Tue May 30 10:40:36 +0000 2017",
    retweet_count: 22631,
    favorite_count: 89874,
    is_retweet: false,
    id_str: "869503804307275776"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I look forward to paying my respects to our brave men and women on this Memorial Day at Arlington National Cemetery later this morning.",
    created_at: "Mon May 29 12:36:37 +0000 2017",
    retweet_count: 15186,
    favorite_count: 92882,
    is_retweet: false,
    id_str: "869170615881793536"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today we remember the men and women who made the ultimate sacrifice in serving. Thank you, God bless your families &amp; God bless the USA!",
    created_at: "Mon May 29 12:35:34 +0000 2017",
    retweet_count: 36848,
    favorite_count: 151852,
    is_retweet: false,
    id_str: "869170351049240576"
  },
  {
    source: "Twitter for iPhone",
    text:
      "North Korea has shown great disrespect for their neighbor, China, by shooting off yet another ballistic missile...but China is trying hard!",
    created_at: "Mon May 29 12:18:52 +0000 2017",
    retweet_count: 12587,
    favorite_count: 65854,
    is_retweet: false,
    id_str: "869166145894535169"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Honoring the men and women who made the ultimate sacrifice in service to America. Home of the free, because of the brave. #MemorialDay🇺🇸",
    created_at: "Mon May 29 12:11:59 +0000 2017",
    retweet_count: 26921,
    favorite_count: 106579,
    is_retweet: false,
    id_str: "869164414662049793"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News Media works hard at disparaging &amp; demeaning my use of social media because they don't want America to hear the real story!",
    created_at: "Mon May 29 00:20:11 +0000 2017",
    retweet_count: 29919,
    favorite_count: 116488,
    is_retweet: false,
    id_str: "868985285207629825"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The massive TAX CUTS/REFORM that I have submitted is moving along in the process very well, actually ahead of schedule. Big benefits to all!",
    created_at: "Mon May 29 00:07:01 +0000 2017",
    retweet_count: 15858,
    favorite_count: 75896,
    is_retweet: false,
    id_str: "868981969664843777"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I suggest that we add more dollars to Healthcare and make it the best anywhere. ObamaCare is dead - the Republicans will do much better!",
    created_at: "Sun May 28 23:57:19 +0000 2017",
    retweet_count: 13708,
    favorite_count: 70770,
    is_retweet: false,
    id_str: "868979531641741313"
  },
  {
    source: "Twitter for iPhone",
    text:
      "British Prime Minister May was very angry that the info the U.K. gave to U.S. about Manchester was leaked. Gave me full details!",
    created_at: "Sun May 28 14:43:53 +0000 2017",
    retweet_count: 16699,
    favorite_count: 70377,
    is_retweet: false,
    id_str: "868840252227674113"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Does anyone notice how the Montana Congressional race was such a big deal to Dems &amp; Fake News until the Republican won? V was poorly covered",
    created_at: "Sun May 28 12:45:45 +0000 2017",
    retweet_count: 14925,
    favorite_count: 71019,
    is_retweet: false,
    id_str: "868810522942164993"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....it is very possible that those sources don't exist but are made up by fake news writers. #FakeNews is the enemy!",
    created_at: "Sun May 28 12:45:16 +0000 2017",
    retweet_count: 13302,
    favorite_count: 60156,
    is_retweet: false,
    id_str: "868810404335673344"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Does anyone notice how the Montana Congressional race was such a big deal to Dems &amp; Fake News until the Republican won? V was poorly covered",
    created_at: "Sun May 28 12:40:33 +0000 2017",
    retweet_count: 848,
    favorite_count: 3463,
    is_retweet: false,
    id_str: "868809214365487104"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....it is very possible that those sources don't exsist but are made up by fake news writers. #FakeNews is the enemy!",
    created_at: "Sun May 28 12:35:29 +0000 2017",
    retweet_count: 1502,
    favorite_count: 5484,
    is_retweet: false,
    id_str: "868807940744126464"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Whenever you see the words 'sources say' in the fake news media, and they don't mention names....",
    created_at: "Sun May 28 12:34:44 +0000 2017",
    retweet_count: 19254,
    favorite_count: 78731,
    is_retweet: false,
    id_str: "868807754231820291"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It is my opinion that many of the leaks coming out of the White House are fabricated lies made up by the #FakeNews media.",
    created_at: "Sun May 28 12:33:03 +0000 2017",
    retweet_count: 17617,
    favorite_count: 72408,
    is_retweet: false,
    id_str: "868807327130025984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just returned from Europe. Trip was a great success for America. Hard work but big results!",
    created_at: "Sun May 28 12:10:43 +0000 2017",
    retweet_count: 14289,
    favorite_count: 82738,
    is_retweet: false,
    id_str: "868801710038372352"
  },
  {
    source: "Twitter for iPhone",
    text: "Big win in Montana for Republicans!",
    created_at: "Sun May 28 12:02:05 +0000 2017",
    retweet_count: 9739,
    favorite_count: 64205,
    is_retweet: false,
    id_str: "868799536420065281"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just arrived in Italy after having a very successful NATO meeting in Brussels. Told other nations they must pay more, not fair to  U.S.",
    created_at: "Sun May 28 11:57:20 +0000 2017",
    retweet_count: 416,
    favorite_count: 1889,
    is_retweet: false,
    id_str: "868798339671830529"
  },
  {
    source: "Twitter for iPhone",
    text: "Big win in Montana for Republicans! We",
    created_at: "Sun May 28 11:57:20 +0000 2017",
    retweet_count: 428,
    favorite_count: 1878,
    is_retweet: false,
    id_str: "868798339676086273"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Bringing hundreds of billions of dollars back to the U.S.A. from the Middle East - which will mean JOBS, JOBS, JOBS!",
    created_at: "Sat May 27 17:19:37 +0000 2017",
    retweet_count: 24706,
    favorite_count: 92580,
    is_retweet: false,
    id_str: "868517059407335424"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I look forward to reading the @CommerceGov 232 analysis of steel and aluminum- to be released in June. Will take major action if necessary.",
    created_at: "Sat May 27 16:22:01 +0000 2017",
    retweet_count: 7859,
    favorite_count: 42946,
    is_retweet: false,
    id_str: "868502563347451904"
  },
  {
    source: "Twitter for iPhone",
    text:
      '...."we push for the removal of all trade-distorting practices....to foster a truly level playing field."',
    created_at: "Sat May 27 16:17:30 +0000 2017",
    retweet_count: 7471,
    favorite_count: 41671,
    is_retweet: false,
    id_str: "868501423566315520"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just left the #G7Summit. Had great meetings on everything, especially on trade where....",
    created_at: "Sat May 27 16:16:47 +0000 2017",
    retweet_count: 8056,
    favorite_count: 46903,
    is_retweet: false,
    id_str: "868501243823575040"
  },
  {
    source: "Twitter for iPhone",
    text: "I will make my final decision on the Paris Accord next week!",
    created_at: "Sat May 27 12:17:51 +0000 2017",
    retweet_count: 10469,
    favorite_count: 54099,
    is_retweet: false,
    id_str: "868441116726710272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Many NATO countries have agreed to step up payments considerably, as they should. Money is beginning to pour in- NATO will be much stronger.",
    created_at: "Sat May 27 10:03:12 +0000 2017",
    retweet_count: 16574,
    favorite_count: 76409,
    is_retweet: false,
    id_str: "868407229380268033"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big G7 meetings today. Lots of very important matters under discussion. First on the list, of course, is terrorism. #G7Taormina",
    created_at: "Sat May 27 09:58:37 +0000 2017",
    retweet_count: 9489,
    favorite_count: 51123,
    is_retweet: false,
    id_str: "868406076995235840"
  },
  {
    source: "Twitter for iPhone",
    text:
      "On behalf of @FLOTUS Melania and myself, thank you for a wonderful dinner and evening, President Sergio Mattarella.… https://t.co/EhvWgjkRrY",
    created_at: "Fri May 26 20:39:51 +0000 2017",
    retweet_count: 11987,
    favorite_count: 62776,
    is_retweet: false,
    id_str: "868205058743250944"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Terrorists are engaged in a war against civilization- it is up to all who value life to confront &amp; defeat this evil➡️https://t.co/haeuvCIF6I",
    created_at: "Fri May 26 20:26:55 +0000 2017",
    retweet_count: 20388,
    favorite_count: 75014,
    is_retweet: false,
    id_str: "868201805934678017"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Getting ready to engage G7 leaders on many issues including economic growth, terrorism, and security.",
    created_at: "Fri May 26 10:14:12 +0000 2017",
    retweet_count: 11322,
    favorite_count: 63352,
    is_retweet: false,
    id_str: "868047612301148160"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just arrived in Italy for the G7. Trip has been very successful. We made and saved the USA many billions of dollars and millions of jobs.",
    created_at: "Fri May 26 10:13:41 +0000 2017",
    retweet_count: 13761,
    favorite_count: 72558,
    is_retweet: false,
    id_str: "868047480847568896"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just arrived in Taormina with @FLOTUS Melania. \n#G7Summit #USA🇺🇸 https://t.co/l7aXolKBiK",
    created_at: "Thu May 25 22:44:57 +0000 2017",
    retweet_count: 9847,
    favorite_count: 54765,
    is_retweet: false,
    id_str: "867874154497937408"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you for your support. Together, we will MAKE AMERICA SAFE AND GREAT AGAIN!\n#POTUSAbroad #USA🇺🇸 https://t.co/42vCwr5GkA",
    created_at: "Thu May 25 20:06:09 +0000 2017",
    retweet_count: 16733,
    favorite_count: 73422,
    is_retweet: false,
    id_str: "867834190078906370"
  },
  {
    source: "Twitter Ads",
    text:
      "Today's ceremony is a day for both remembrance and resolve.\n#NATOMeeting #NATO https://t.co/YNZV3bTekB",
    created_at: "Thu May 25 17:54:17 +0000 2017",
    retweet_count: 11394,
    favorite_count: 50720,
    is_retweet: false,
    id_str: "867801005018230786"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FLOTUS: Thank u to Queen Fabiola University Hospital! Enjoyed creating paper flowers with amazing patients &amp; getting a tour. #Brussels…",
    created_at: "Thu May 25 14:33:51 +0000 2017",
    retweet_count: 10007,
    favorite_count: 0,
    is_retweet: true,
    id_str: "867750567220715521"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you for the warm welcome to Brussels, Belgium this afternoon! https://t.co/1AvYSameD4",
    created_at: "Wed May 24 20:11:18 +0000 2017",
    retweet_count: 10949,
    favorite_count: 57900,
    is_retweet: false,
    id_str: "867473100434161664"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Honor of a lifetime to meet His Holiness Pope Francis. I leave the Vatican more determined than ever to pursue PEAC… https://t.co/Jhe7SROaxD",
    created_at: "Wed May 24 12:20:07 +0000 2017",
    retweet_count: 25209,
    favorite_count: 110689,
    is_retweet: false,
    id_str: "867354520526872576"
  },
  {
    source: "Twitter for iPhone",
    text:
      "All civilized nations must join together to protect human life and the sacred right of our citizens to live in safety and in peace.",
    created_at: "Tue May 23 15:58:37 +0000 2017",
    retweet_count: 30140,
    favorite_count: 120808,
    is_retweet: false,
    id_str: "867047119974170625"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Israel, Saudi Arabia and the Middle East were great. Trying hard for PEACE. Doing well. Heading to Vatican &amp; Pope, then #G7 and #NATO.",
    created_at: "Tue May 23 15:47:21 +0000 2017",
    retweet_count: 12733,
    favorite_count: 67826,
    is_retweet: false,
    id_str: "867044286352809984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you for such a wonderful and unforgettable visit, Prime Minister @Netanyahu and @PresidentRuvi.",
    created_at: "Tue May 23 15:43:16 +0000 2017",
    retweet_count: 9799,
    favorite_count: 61159,
    is_retweet: false,
    id_str: "867043258932875264"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We stand in absolute solidarity with the people of the United Kingdom. https://t.co/X6fUUxxYXE",
    created_at: "Tue May 23 12:04:48 +0000 2017",
    retweet_count: 34384,
    favorite_count: 142171,
    is_retweet: false,
    id_str: "866988278184116224"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Prime Minister @Netanyahu and @PresidentRuvi- on behalf of @FLOTUS Melania and myself, thank you for the invitation… https://t.co/Z5YCpaRV6t",
    created_at: "Mon May 22 20:14:46 +0000 2017",
    retweet_count: 13640,
    favorite_count: 67115,
    is_retweet: false,
    id_str: "866749195297976320"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @netanyahu: Ever Stronger\nחזקים תמיד\n🇮🇱🇺🇸 https://t.co/Ecf5p4HjfZ",
    created_at: "Mon May 22 13:13:48 +0000 2017",
    retweet_count: 20862,
    favorite_count: 0,
    is_retweet: true,
    id_str: "866643258390302721"
  },
  {
    source: "Twitter for iPhone",
    text: "#RiyadhSummit #POTUSAbroad🇺🇸 https://t.co/WdDEOiV6oS",
    created_at: "Sun May 21 21:51:53 +0000 2017",
    retweet_count: 18121,
    favorite_count: 62535,
    is_retweet: false,
    id_str: "866411249092902912"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Speech transcript at Arab Islamic American Summit ➡️https://t.co/eUWxJXJxbe\n\nReplay ➡️https://t.co/VtmlSqciXx\n\n#RiyadhSummit #POTUSAbroad",
    created_at: "Sun May 21 16:47:25 +0000 2017",
    retweet_count: 11498,
    favorite_count: 43456,
    is_retweet: false,
    id_str: "866334629036384256"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FLOTUS: I had a wonderful time with the students at the American International School #Riyadh today. #SaudiaArabia https://t.co/AVzVV0W…",
    created_at: "Sun May 21 11:15:30 +0000 2017",
    retweet_count: 19462,
    favorite_count: 0,
    is_retweet: true,
    id_str: "866251096649588738"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to the BRAVE servicemen &amp; women who have served, and continue to serve the United States- our true HEROES… https://t.co/ZTV9F639xM",
    created_at: "Sat May 20 15:50:29 +0000 2017",
    retweet_count: 19476,
    favorite_count: 79015,
    is_retweet: false,
    id_str: "865957909565366272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great to be in Riyadh, Saudi Arabia. Looking forward to the afternoon and evening ahead. #POTUSAbroad https://t.co/JJOra0KfyR",
    created_at: "Sat May 20 09:44:31 +0000 2017",
    retweet_count: 97922,
    favorite_count: 104413,
    is_retweet: false,
    id_str: "865865814099939328"
  },
  {
    source: "Twitter for iPhone",
    text:
      "#WeeklyAddress🇺🇸\n➡️https://t.co/UYEhgch4Hl https://t.co/HIQoFuc5cy",
    created_at: "Fri May 19 22:16:06 +0000 2017",
    retweet_count: 7462,
    favorite_count: 36320,
    is_retweet: false,
    id_str: "865692565454106624"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Getting ready for my big foreign trip. Will be strongly protecting American interests - that's what I like to do!",
    created_at: "Fri May 19 14:24:08 +0000 2017",
    retweet_count: 20489,
    favorite_count: 108289,
    is_retweet: false,
    id_str: "865573793531478017"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"President Donald J. Trump Proclaims 5/14/2017 through 5/20/2017 as #PoliceWeek"\nProclamation➡️… https://t.co/EcCsGaizWu',
    created_at: "Fri May 19 02:03:58 +0000 2017",
    retweet_count: 12661,
    favorite_count: 56437,
    is_retweet: false,
    id_str: "865387523371143168"
  },
  {
    source: "Twitter Ads",
    text:
      "A great honor to welcome President Juan Manuel Santos of Colombia to the White House today!🇺🇸🇨🇴\nJoint Press Conf➡️… https://t.co/uWfiQEdsaY",
    created_at: "Thu May 18 22:45:15 +0000 2017",
    retweet_count: 10016,
    favorite_count: 52084,
    is_retweet: false,
    id_str: "865337513245913089"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With all of the illegal acts that took place in the Clinton campaign &amp; Obama Administration, there was never a special counsel appointed!",
    created_at: "Thu May 18 14:07:06 +0000 2017",
    retweet_count: 30639,
    favorite_count: 107510,
    is_retweet: false,
    id_str: "865207118785372160"
  },
  {
    source: "Twitter for iPhone",
    text:
      "This is the single greatest witch hunt of a politician in American history!",
    created_at: "Thu May 18 11:52:14 +0000 2017",
    retweet_count: 36875,
    favorite_count: 123598,
    is_retweet: false,
    id_str: "865173176854204416"
  },
  {
    source: "Twitter for iPhone",
    text:
      "With all of the illegal acts that took place in the Clinton campaign &amp; Obama Administration, there was never a special councel appointed!",
    created_at: "Thu May 18 11:39:19 +0000 2017",
    retweet_count: 14300,
    favorite_count: 43793,
    is_retweet: false,
    id_str: "865169927644340224"
  },
  {
    source: "Twitter Ads",
    text:
      "It was my great honor to deliver the #CGACommencement17 at the @USCGAcademy. CONGRATULATIONS to the Class of 2017!… https://t.co/ehQanQXiSy",
    created_at: "Wed May 17 20:36:02 +0000 2017",
    retweet_count: 13549,
    favorite_count: 69370,
    is_retweet: false,
    id_str: "864942610191978496"
  },
  {
    source: "Twitter Ads",
    text:
      "It was a great honor to welcome the President of Turkey, Recep Tayyip Erdoğan, to the @WhiteHouse today! https://t.co/4BWjOCgnNv",
    created_at: "Tue May 16 19:38:42 +0000 2017",
    retweet_count: 19675,
    favorite_count: 75883,
    is_retweet: false,
    id_str: "864565791076872192"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'U.S. Industrial Production Surged in April' https://t.co/S0Z4SEIRhi",
    created_at: "Tue May 16 16:02:17 +0000 2017",
    retweet_count: 12494,
    favorite_count: 52833,
    is_retweet: false,
    id_str: "864511331029921792"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I have been asking Director Comey &amp; others, from the beginning of my administration, to find the LEAKERS in the intelligence community.....",
    created_at: "Tue May 16 12:10:29 +0000 2017",
    retweet_count: 19953,
    favorite_count: 80922,
    is_retweet: false,
    id_str: "864452996129853444"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...to terrorism and airline flight safety. Humanitarian reasons, plus I want Russia to greatly step up their fight against ISIS &amp; terrorism.",
    created_at: "Tue May 16 11:13:00 +0000 2017",
    retweet_count: 18110,
    favorite_count: 77454,
    is_retweet: false,
    id_str: "864438529472049152"
  },
  {
    source: "Twitter for iPhone",
    text:
      "As President I wanted to share with Russia (at an openly scheduled W.H. meeting) which I have the absolute right to do, facts pertaining....",
    created_at: "Tue May 16 11:03:36 +0000 2017",
    retweet_count: 19636,
    favorite_count: 77202,
    is_retweet: false,
    id_str: "864436162567471104"
  },
  {
    source: "Twitter for iPhone",
    text:
      "#PeaceOfficersMemorialDay and\n#PoliceWeek Proclamation: https://t.co/o4IXVfZuHw https://t.co/UMJ6hklx4a",
    created_at: "Tue May 16 01:47:43 +0000 2017",
    retweet_count: 18322,
    favorite_count: 72674,
    is_retweet: false,
    id_str: "864296272844529664"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today, I delivered remarks at the 36th Annual National Peace Officers' Memorial Service. \n#NationalPoliceWeek\nWatch… https://t.co/3EioVDCTqb",
    created_at: "Mon May 15 19:54:09 +0000 2017",
    retweet_count: 11326,
    favorite_count: 55356,
    is_retweet: false,
    id_str: "864207293289771012"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Wishing @FLOTUS Melania and all of the great mothers out there a wonderful day ahead with family and friends! \n\nHappy #MothersDay",
    created_at: "Sun May 14 15:13:45 +0000 2017",
    retweet_count: 21966,
    favorite_count: 135259,
    is_retweet: false,
    id_str: "863774341921742848"
  },
  {
    source: "Twitter Ads",
    text:
      "I was thrilled to be back @LibertyU. Congratulations to the Class of 2017! This is your day, and you've earned it.… https://t.co/87RYOPwBiY",
    created_at: "Sat May 13 18:57:33 +0000 2017",
    retweet_count: 15678,
    favorite_count: 72298,
    is_retweet: false,
    id_str: "863468271668002817"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Will be interviewed by @JudgeJeanine on @FoxNews at 9:00 P.M. (Saturday night). Enjoy!",
    created_at: "Sat May 13 17:54:31 +0000 2017",
    retweet_count: 7672,
    favorite_count: 46104,
    is_retweet: false,
    id_str: "863452412459307009"
  },
  {
    source: "Twitter for iPhone",
    text: "We",
    created_at: "Sat May 13 17:31:14 +0000 2017",
    retweet_count: 560,
    favorite_count: 482,
    is_retweet: false,
    id_str: "863446552559398916"
  },
  {
    source: "Twitter Ads",
    text:
      "#WeeklyAddress🇺🇸\n➡️https://t.co/uT4K4fh88Y https://t.co/1iW7tVVNCH",
    created_at: "Sat May 13 00:47:58 +0000 2017",
    retweet_count: 11067,
    favorite_count: 46679,
    is_retweet: false,
    id_str: "863194069891031041"
  },
  {
    source: "Twitter Ads",
    text:
      "Today, I welcomed the Victory Christian Center School. Good luck @ the Team America Rocketry Challenge! #TARC Watch… https://t.co/wFrRsK2wuo",
    created_at: "Fri May 12 21:16:56 +0000 2017",
    retweet_count: 10873,
    favorite_count: 52673,
    is_retweet: false,
    id_str: "863140961114886144"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today, @FLOTUS hosted a Military Mother's Day Event in the East Room of the WH. It was an honor to stop by, say hel… https://t.co/wNVB0PYoef",
    created_at: "Fri May 12 21:09:32 +0000 2017",
    retweet_count: 11970,
    favorite_count: 56985,
    is_retweet: false,
    id_str: "863139099825364994"
  },
  {
    source: "Twitter for iPhone",
    text:
      "China just agreed that the U.S. will be allowed to sell beef, and other major products, into China once again. This is REAL news!",
    created_at: "Fri May 12 13:20:04 +0000 2017",
    retweet_count: 31188,
    favorite_count: 125594,
    is_retweet: false,
    id_str: "863020954427043840"
  },
  {
    source: "Twitter for iPhone",
    text:
      "When James Clapper himself, and virtually everyone else with knowledge of the witch hunt, says there is no collusion, when does it end?",
    created_at: "Fri May 12 12:54:54 +0000 2017",
    retweet_count: 18349,
    favorite_count: 73483,
    is_retweet: false,
    id_str: "863014620516233216"
  },
  {
    source: "Twitter for iPhone",
    text:
      'James Comey better hope that there are no "tapes" of our conversations before he starts leaking to the press!',
    created_at: "Fri May 12 12:26:15 +0000 2017",
    retweet_count: 25845,
    favorite_count: 77509,
    is_retweet: false,
    id_str: "863007411132649473"
  },
  {
    source: "Twitter for iPhone",
    text:
      '...Maybe the best thing to do would be to cancel all future "press briefings" and hand out written responses for the sake of accuracy???',
    created_at: "Fri May 12 12:07:36 +0000 2017",
    retweet_count: 18824,
    favorite_count: 81862,
    is_retweet: false,
    id_str: "863002719400976384"
  },
  {
    source: "Twitter for iPhone",
    text:
      "As a very active President with lots of things happening, it is not possible for my surrogates to stand at podium with perfect accuracy!....",
    created_at: "Fri May 12 11:59:00 +0000 2017",
    retweet_count: 13334,
    favorite_count: 62986,
    is_retweet: false,
    id_str: "863000553265270786"
  },
  {
    source: "Twitter for iPhone",
    text: "The Fake Media is working overtime today!",
    created_at: "Fri May 12 11:53:48 +0000 2017",
    retweet_count: 20433,
    favorite_count: 80164,
    is_retweet: false,
    id_str: "862999243560288256"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Again, the story that there was collusion between the Russians &amp; Trump campaign was fabricated by Dems as an excuse for losing the election.",
    created_at: "Fri May 12 11:51:56 +0000 2017",
    retweet_count: 19493,
    favorite_count: 79116,
    is_retweet: false,
    id_str: "862998775731818496"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Yesterday, on the same day- I had meetings with Russian Foreign Minister Sergei Lavrov and the FM of Ukraine, Pavlo… https://t.co/hm4U54DCQO",
    created_at: "Thu May 11 21:54:24 +0000 2017",
    retweet_count: 13018,
    favorite_count: 53117,
    is_retweet: false,
    id_str: "862788002594127873"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Russia must be laughing up their sleeves watching as the U.S. tears itself apart over a Democrat EXCUSE for losing the election.",
    created_at: "Thu May 11 20:34:25 +0000 2017",
    retweet_count: 25437,
    favorite_count: 95102,
    is_retweet: false,
    id_str: "862767872879325185"
  },
  {
    source: "Twitter for iPhone",
    text: "We finally agree on something Rosie. https://t.co/BSP5F3PgbZ",
    created_at: "Thu May 11 19:55:34 +0000 2017",
    retweet_count: 42044,
    favorite_count: 123601,
    is_retweet: false,
    id_str: "862758098892619780"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Presidential Executive Order on the Establishment of Presidential Advisory Commission on Election Integrity'\n➡️… https://t.co/kVG8r7qZS5",
    created_at: "Thu May 11 19:35:22 +0000 2017",
    retweet_count: 9959,
    favorite_count: 41657,
    is_retweet: false,
    id_str: "862753016193089536"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Presidential Executive Order on Strengthening the Cybersecurity of Federal Networks and Critical Infrastructure'… https://t.co/kQDBvXPekk",
    created_at: "Thu May 11 19:34:00 +0000 2017",
    retweet_count: 8399,
    favorite_count: 38181,
    is_retweet: false,
    id_str: "862752672683839488"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats should be ashamed. This is a disgrace!\n#DrainTheSwamp https://t.co/UfbKEECm2V",
    created_at: "Thu May 11 00:14:58 +0000 2017",
    retweet_count: 42018,
    favorite_count: 101939,
    is_retweet: false,
    id_str: "862460991451344896"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Dems have been complaining for months &amp; months about Dir. Comey. Now that he has been fired they PRETEND to be aggrieved. Phony hypocrites!",
    created_at: "Wed May 10 19:23:52 +0000 2017",
    retweet_count: 25650,
    favorite_count: 95996,
    is_retweet: false,
    id_str: "862387734492663808"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Roger Stone report on @CNN is false - Fake News. Have not spoken to Roger in a long time - had nothing to do with my decision.",
    created_at: "Wed May 10 12:57:16 +0000 2017",
    retweet_count: 15780,
    favorite_count: 58364,
    is_retweet: false,
    id_str: "862290442129461249"
  },
  {
    source: "Twitter for iPhone",
    text:
      "caught, he cried like a baby and begged for forgiveness...and now he is judge &amp; jury. He should be the one who is investigated for his acts.",
    created_at: "Wed May 10 12:39:59 +0000 2017",
    retweet_count: 13771,
    favorite_count: 61884,
    is_retweet: false,
    id_str: "862286091759611905"
  },
  {
    source: "Twitter for iPhone",
    text:
      "years, as a pol in Connecticut, Blumenthal would talk of his great bravery and conquests in Vietnam - except he was never there. When....",
    created_at: "Wed May 10 12:30:51 +0000 2017",
    retweet_count: 14579,
    favorite_count: 56941,
    is_retweet: false,
    id_str: "862283792559616000"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Watching Senator Richard Blumenthal speak of Comey is a joke. "Richie" devised one of the greatest military frauds in U.S. history. For....',
    created_at: "Wed May 10 12:24:32 +0000 2017",
    retweet_count: 15037,
    favorite_count: 57754,
    is_retweet: false,
    id_str: "862282202188566529"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DRUDGE_REPORT: 10 SCANDALS ON DIRECTOR'S WATCH... https://t.co/dnGY08wTBP",
    created_at: "Wed May 10 11:28:38 +0000 2017",
    retweet_count: 8588,
    favorite_count: 0,
    is_retweet: true,
    id_str: "862268135944192000"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Comey lost the confidence of almost everyone in Washington, Republican and Democrat alike. When things calm down, they will be thanking me!",
    created_at: "Wed May 10 11:27:13 +0000 2017",
    retweet_count: 18002,
    favorite_count: 74805,
    is_retweet: false,
    id_str: "862267781336752128"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DRUDGE_REPORT: MEXICO 2ND DEADLIEST COUNTRY; TOPS AFGHAN, IRAQ... https://t.co/i4FtSpLiHV",
    created_at: "Wed May 10 11:21:02 +0000 2017",
    retweet_count: 7297,
    favorite_count: 0,
    is_retweet: true,
    id_str: "862266225157689349"
  },
  {
    source: "Twitter for iPhone",
    text:
      "James Comey will be replaced by someone who will do a far better job, bringing back the spirit and prestige of the FBI.",
    created_at: "Wed May 10 11:19:04 +0000 2017",
    retweet_count: 18385,
    favorite_count: 80064,
    is_retweet: false,
    id_str: "862265729718128641"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats have said some of the worst things about James Comey, including the fact that he should be fired, but now they play so sad!",
    created_at: "Wed May 10 11:10:48 +0000 2017",
    retweet_count: 19595,
    favorite_count: 77022,
    is_retweet: false,
    id_str: "862263649821503489"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Cryin\' Chuck Schumer stated recently, "I do not have confidence in him (James Comey) any longer." Then acts so indignant.  #draintheswamp',
    created_at: "Wed May 10 02:42:52 +0000 2017",
    retweet_count: 29846,
    favorite_count: 96844,
    is_retweet: false,
    id_str: "862135824745467905"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Manufacturing openings, hires rise to highest levels of the recovery'\nhttps://t.co/txFZDYYIOe",
    created_at: "Tue May 09 21:38:51 +0000 2017",
    retweet_count: 9893,
    favorite_count: 44303,
    is_retweet: false,
    id_str: "862059314277748736"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was an honor to welcome the Teachers of the Year to the WH last month. Today, we honor and thank all teachers!… https://t.co/sAUJfIZCwR",
    created_at: "Tue May 09 17:19:16 +0000 2017",
    retweet_count: 9988,
    favorite_count: 53028,
    is_retweet: false,
    id_str: "861993986436866049"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Biggest story today between Clapper &amp; Yates is on surveillance. Why doesn't the media report on this? #FakeNews!",
    created_at: "Mon May 08 22:50:45 +0000 2017",
    retweet_count: 14305,
    favorite_count: 54604,
    is_retweet: false,
    id_str: "861715019674910721"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Russia-Trump collusion story is a total hoax, when will this taxpayer funded charade end?",
    created_at: "Mon May 08 22:46:00 +0000 2017",
    retweet_count: 16471,
    favorite_count: 64797,
    is_retweet: false,
    id_str: "861713823505494016"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Sally Yates made the fake media extremely unhappy today --- she said nothing but old news!",
    created_at: "Mon May 08 22:43:39 +0000 2017",
    retweet_count: 11260,
    favorite_count: 53342,
    is_retweet: false,
    id_str: "861713233786404864"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Director Clapper reiterated what everybody, including the fake media already knows- there is "no evidence" of collusion w/ Russia and Trump.',
    created_at: "Mon May 08 22:41:12 +0000 2017",
    retweet_count: 17639,
    favorite_count: 67573,
    is_retweet: false,
    id_str: "861712617299210240"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Honored to welcome Georgia Prime Minister, Giorgi Kvirikashvili to the @WhiteHouse today with @VP Mike Pence.… https://t.co/ohXXgTNtWB",
    created_at: "Mon May 08 17:42:32 +0000 2017",
    retweet_count: 6842,
    favorite_count: 35879,
    is_retweet: false,
    id_str: "861637456281690113"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Ask Sally Yates, under oath, if she knows how classified information got into the newspapers soon after she explained it to W.H. Counsel.",
    created_at: "Mon May 08 14:43:35 +0000 2017",
    retweet_count: 16658,
    favorite_count: 60380,
    is_retweet: false,
    id_str: "861592420043157504"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Ask Sally Yates, under oath, if she knows how classified information got into the newspapers soon after she explained it to W.H. Council.",
    created_at: "Mon May 08 12:14:21 +0000 2017",
    retweet_count: 6818,
    favorite_count: 21739,
    is_retweet: false,
    id_str: "861554864542941185"
  },
  {
    source: "Twitter for iPhone",
    text:
      "General Flynn was given the highest security clearance by the Obama Administration - but the Fake News seldom likes talking about that.",
    created_at: "Mon May 08 11:57:42 +0000 2017",
    retweet_count: 16501,
    favorite_count: 59930,
    is_retweet: false,
    id_str: "861550676505219073"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to @PGA_JohnDaly on his big win yesterday. John is a great guy who never gave up - and now a winner again!",
    created_at: "Mon May 08 11:32:24 +0000 2017",
    retweet_count: 10448,
    favorite_count: 51262,
    is_retweet: false,
    id_str: "861544307043467264"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IsraeliPM: PM Benjamin Netanyahu at  weekly Cabinet meeting:\nIn two weeks, Israel will host @POTUS Trump on his first trip as President…",
    created_at: "Mon May 08 11:23:05 +0000 2017",
    retweet_count: 5800,
    favorite_count: 0,
    is_retweet: true,
    id_str: "861541965464207360"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Rexnord of Indiana made a deal during the Obama Administration to move to Mexico. Fired their employees. Tax product big that's sold in U.S.",
    created_at: "Sun May 07 22:58:47 +0000 2017",
    retweet_count: 10426,
    favorite_count: 44843,
    is_retweet: false,
    id_str: "861354654856249344"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to Emmanuel Macron on his big win today as the next President of France. I look very much forward to working with him!",
    created_at: "Sun May 07 19:22:17 +0000 2017",
    retweet_count: 22692,
    favorite_count: 80945,
    is_retweet: false,
    id_str: "861300169438113793"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republican Senators will not let the American people down! ObamaCare premiums and deductibles are way up - it was a lie and it is dead!",
    created_at: "Sun May 07 12:49:39 +0000 2017",
    retweet_count: 12994,
    favorite_count: 60352,
    is_retweet: false,
    id_str: "861201362834665472"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @brunelldonald: I thought about jobs that went overseas failing schools open borders not my skin color when I voted @realDonaldTrump! I…",
    created_at: "Sun May 07 11:37:35 +0000 2017",
    retweet_count: 14365,
    favorite_count: 0,
    is_retweet: true,
    id_str: "861183225082806272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FoxNews: .@POTUS: \"I'm not against the media. I'm against the FAKE media.\" #CashinIn https://t.co/F7mBIj7iVL",
    created_at: "Sun May 07 11:17:59 +0000 2017",
    retweet_count: 9877,
    favorite_count: 0,
    is_retweet: true,
    id_str: "861178291671244800"
  },
  {
    source: "Twitter for iPhone",
    text:
      "When will the Fake Media ask about the Dems dealings with Russia &amp; why the DNC wouldn't allow the FBI to check their server or investigate?",
    created_at: "Sun May 07 11:15:26 +0000 2017",
    retweet_count: 18592,
    favorite_count: 68200,
    is_retweet: false,
    id_str: "861177649179373569"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The reason I am staying in Bedminster, N. J., a beautiful community, is that staying in NYC is much more expensive and disruptive. Meetings!",
    created_at: "Sat May 06 22:39:42 +0000 2017",
    retweet_count: 11079,
    favorite_count: 63688,
    is_retweet: false,
    id_str: "860987464114110465"
  },
  {
    source: "Twitter for iPhone",
    text: "Great jobs report today - It is all beginning to work!",
    created_at: "Fri May 05 23:34:36 +0000 2017",
    retweet_count: 12727,
    favorite_count: 70188,
    is_retweet: false,
    id_str: "860638890570416132"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Why is it that the Fake News rarely reports Ocare is on its last legs and that insurance companies are fleeing for their lives? It's dead!",
    created_at: "Fri May 05 23:29:45 +0000 2017",
    retweet_count: 14503,
    favorite_count: 64403,
    is_retweet: false,
    id_str: "860637673744195584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Wow,the Fake News media did everything in its power to make the Republican Healthcare victory look as bad as possible.Far better than Ocare!",
    created_at: "Fri May 05 23:22:22 +0000 2017",
    retweet_count: 13976,
    favorite_count: 66676,
    is_retweet: false,
    id_str: "860635815277453313"
  },
  {
    source: "Twitter Ads",
    text: "#WeeklyAddress🇺🇸 https://t.co/4qckKpbtCR",
    created_at: "Fri May 05 19:43:37 +0000 2017",
    retweet_count: 9996,
    favorite_count: 39260,
    is_retweet: false,
    id_str: "860580764944969728"
  },
  {
    source: "Twitter for iPhone",
    text: "JOBS, JOBS, JOBS! https://t.co/UR0eetSEnO",
    created_at: "Fri May 05 19:32:08 +0000 2017",
    retweet_count: 12907,
    favorite_count: 47346,
    is_retweet: false,
    id_str: "860577873060651008"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Of course the Australians have better healthcare than we do --everybody does. ObamaCare is dead! But our healthcare will soon be great.",
    created_at: "Fri May 05 19:13:54 +0000 2017",
    retweet_count: 12912,
    favorite_count: 63624,
    is_retweet: false,
    id_str: "860573284462669824"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Rather than causing a big disruption in N.Y.C., I will be working out of my home in Bedminster, N.J. this weekend. Also saves country money!",
    created_at: "Fri May 05 13:02:46 +0000 2017",
    retweet_count: 11961,
    favorite_count: 66822,
    is_retweet: false,
    id_str: "860479885566980096"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big win in the House - very exciting! But when everything comes together with the inclusion of Phase 2, we will have truly great healthcare!",
    created_at: "Fri May 05 12:52:36 +0000 2017",
    retweet_count: 10182,
    favorite_count: 54711,
    is_retweet: false,
    id_str: "860477328882905089"
  },
  {
    source: "Twitter Ads",
    text:
      "An honor to welcome PM of Australia, @TurnbullMalcolm to America &amp; join him in marking the 75th Anniversary of the… https://t.co/foMUec7EAE",
    created_at: "Fri May 05 06:16:06 +0000 2017",
    retweet_count: 7146,
    favorite_count: 38682,
    is_retweet: false,
    id_str: "860377543878348800"
  },
  {
    source: "Twitter Ads",
    text:
      "It was a GREAT day for the United States of America! This is a great plan that is a repeal &amp; replace of ObamaCare.… https://t.co/0TnmLn55Lm",
    created_at: "Fri May 05 02:55:02 +0000 2017",
    retweet_count: 12850,
    favorite_count: 59214,
    is_retweet: false,
    id_str: "860326946147840001"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If victorious, Republicans will be having a big press conference at the beautiful Rose Garden of the White House immediately after vote!",
    created_at: "Thu May 04 18:07:29 +0000 2017",
    retweet_count: 8492,
    favorite_count: 49494,
    is_retweet: false,
    id_str: "860194183797243904"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Insurance companies are fleeing ObamaCare - it is dead. Our healthcare plan will lower premiums &amp; deductibles - and be great healthcare!",
    created_at: "Thu May 04 17:56:51 +0000 2017",
    retweet_count: 12494,
    favorite_count: 58383,
    is_retweet: false,
    id_str: "860191508619722752"
  },
  {
    source: "Twitter for iPhone",
    text:
      'I am watching the Democrats trying to defend the "you can keep you doctor, you can keep your plan &amp; premiums will go down" ObamaCare lie."',
    created_at: "Thu May 04 17:43:11 +0000 2017",
    retweet_count: 14676,
    favorite_count: 61739,
    is_retweet: false,
    id_str: "860188065758838785"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Beautiful evening with Religious Leaders here at the WH last night. Join us now for a #NationalDayofPrayer, LIVE:… https://t.co/b8j1tWZJuv",
    created_at: "Thu May 04 15:26:00 +0000 2017",
    retweet_count: 8249,
    favorite_count: 37555,
    is_retweet: false,
    id_str: "860153543151542272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Death spiral!\n'Aetna will exit Obamacare markets in VA in 2018, citing expected losses on INDV plans this year'\nhttps://t.co/5YnzDitF8r",
    created_at: "Thu May 04 12:28:39 +0000 2017",
    retweet_count: 8296,
    favorite_count: 29942,
    is_retweet: false,
    id_str: "860108914624532480"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: President Trump to sign an executive order on religious liberty today, the National Day of Prayer | @kevincorke https://…",
    created_at: "Thu May 04 11:09:26 +0000 2017",
    retweet_count: 10263,
    favorite_count: 0,
    is_retweet: true,
    id_str: "860088977277235201"
  },
  {
    source: "Twitter for iPhone",
    text: "Congratulations to @foxandfriends on its unbelievable ratings hike.",
    created_at: "Thu May 04 11:07:35 +0000 2017",
    retweet_count: 6802,
    favorite_count: 38184,
    is_retweet: false,
    id_str: "860088511202029569"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake News media is officially out of control. They will do or say anything in order to get attention - never been a time like this!",
    created_at: "Thu May 04 11:02:54 +0000 2017",
    retweet_count: 18941,
    favorite_count: 73565,
    is_retweet: false,
    id_str: "860087334519414784"
  },
  {
    source: "Twitter for iPhone",
    text: "...allegations of unmasking Trump transition officials. Not good!",
    created_at: "Thu May 04 10:49:10 +0000 2017",
    retweet_count: 9525,
    favorite_count: 40980,
    is_retweet: false,
    id_str: "860083874893897728"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Susan Rice, the former National Security Advisor to President Obama, is refusing to testify before a Senate Subcommittee next week on.....",
    created_at: "Thu May 04 10:40:33 +0000 2017",
    retweet_count: 13956,
    favorite_count: 47111,
    is_retweet: false,
    id_str: "860081707315232771"
  },
  {
    source: "Twitter for iPhone",
    text:
      "An honor to host President Mahmoud Abbas at the WH today. Hopefully something terrific could come out it between th… https://t.co/eyHLFZbKhn",
    created_at: "Wed May 03 22:01:42 +0000 2017",
    retweet_count: 6611,
    favorite_count: 28769,
    is_retweet: false,
    id_str: "859890737160302592"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was an honor to stop by a #SchoolChoice event hosted by @VP Pence and @usedgov Secretary @BetsyDeVosED at the… https://t.co/B8VxVsYNHA",
    created_at: "Wed May 03 20:57:56 +0000 2017",
    retweet_count: 8738,
    favorite_count: 41938,
    is_retweet: false,
    id_str: "859874689442775045"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...Trump/Russia story was an excuse used by the Democrats as justification for losing the election. Perhaps Trump just ran a great campaign?",
    created_at: "Wed May 03 03:06:16 +0000 2017",
    retweet_count: 18767,
    favorite_count: 82992,
    is_retweet: false,
    id_str: "859604996236742656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "FBI Director Comey was the best thing that ever happened to Hillary Clinton in that he gave her a free pass for many bad deeds! The phony...",
    created_at: "Wed May 03 02:51:07 +0000 2017",
    retweet_count: 20585,
    favorite_count: 80752,
    is_retweet: false,
    id_str: "859601184285491201"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to the winners of the Commander-in-Chief's Trophy, the great Air Force Falcons! \nWatch:… https://t.co/HyxxFCfaUh",
    created_at: "Tue May 02 21:08:14 +0000 2017",
    retweet_count: 8292,
    favorite_count: 42230,
    is_retweet: false,
    id_str: "859514893418082310"
  },
  {
    source: "Twitter for iPhone",
    text:
      'either elect more Republican Senators in 2018 or change the rules now to 51%. Our country needs a good "shutdown" in September to fix mess!',
    created_at: "Tue May 02 13:07:10 +0000 2017",
    retweet_count: 16972,
    favorite_count: 66895,
    is_retweet: false,
    id_str: "859393829505552385"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The reason for the plan negotiated between the Republicans and Democrats is that we need 60 votes in the Senate which are not there! We....",
    created_at: "Tue May 02 13:01:41 +0000 2017",
    retweet_count: 10001,
    favorite_count: 43751,
    is_retweet: false,
    id_str: "859392449181093888"
  },
  {
    source: "Twitter for iPhone",
    text:
      "President Andrew Jackson, who died 16 years before the Civil War started, saw it coming and was angry. Would never have let it happen!",
    created_at: "Tue May 02 00:55:54 +0000 2017",
    retweet_count: 11802,
    favorite_count: 57577,
    is_retweet: false,
    id_str: "859209801175269376"
  },
  {
    source: "Twitter Ads",
    text:
      "#ICYMI- On Saturday I signed two EO's to help keep jobs &amp; wealth in our country.\nEO1: https://t.co/XJggnJAiPi \nEO2:… https://t.co/2iEten4SVl",
    created_at: "Mon May 01 20:30:42 +0000 2017",
    retweet_count: 8107,
    favorite_count: 37321,
    is_retweet: false,
    id_str: "859143061678501892"
  },
  {
    source: "Twitter for iPhone",
    text:
      "This month we celebrate the contributions of Asian Americans &amp; Pacific Islanders that enrich our Nation. https://t.co/rEJi9ahOaY",
    created_at: "Mon May 01 19:29:41 +0000 2017",
    retweet_count: 7137,
    favorite_count: 36229,
    is_retweet: false,
    id_str: "859127705366921216"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...healthcare plan is on its way. Will have much lower premiums &amp; deductibles while at the same time taking care of pre-existing conditions!",
    created_at: "Sun Apr 30 12:32:50 +0000 2017",
    retweet_count: 14276,
    favorite_count: 75848,
    is_retweet: false,
    id_str: "858660413873025024"
  },
  {
    source: "Twitter for iPhone",
    text:
      "You can't compare anything to ObamaCare because ObamaCare is dead. Dems want billions to go to Insurance Companies to bail out donors....New",
    created_at: "Sun Apr 30 12:28:04 +0000 2017",
    retweet_count: 13336,
    favorite_count: 60839,
    is_retweet: false,
    id_str: "858659215451271168"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats, without a leader, have become the party of obstruction.They are only interested in themselves and not in what's best for U.S.",
    created_at: "Sun Apr 30 12:09:04 +0000 2017",
    retweet_count: 24380,
    favorite_count: 95028,
    is_retweet: false,
    id_str: "858654431956672512"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big excitement last night in the Great State of Pennsylvania! Fantastic crowd and people. MAKE AMERICA GREAT AGAIN!",
    created_at: "Sun Apr 30 12:05:31 +0000 2017",
    retweet_count: 11579,
    favorite_count: 67068,
    is_retweet: false,
    id_str: "858653541094879232"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be interviewed on @FaceTheNation this morning at 10:00 A.M. Have a great day!",
    created_at: "Sun Apr 30 11:33:12 +0000 2017",
    retweet_count: 5813,
    favorite_count: 39339,
    is_retweet: false,
    id_str: "858645405252374528"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @charliekirk11: 100 days ago a new message, leader, &amp; movement took the Oval Office! A government FOR the people BY the people. This is…",
    created_at: "Sat Apr 29 17:42:34 +0000 2017",
    retweet_count: 10644,
    favorite_count: 0,
    is_retweet: true,
    id_str: "858375971019399169"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Mainstream (FAKE) media refuses to state our long list of achievements, including 28 legislative signings, strong borders &amp; great optimism!",
    created_at: "Sat Apr 29 17:39:48 +0000 2017",
    retweet_count: 19990,
    favorite_count: 79930,
    is_retweet: false,
    id_str: "858375278686613504"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Looking forward to RALLY in the Great State of Pennsylvania tonight at 7:30. Big crowd, big energy!",
    created_at: "Sat Apr 29 15:35:26 +0000 2017",
    retweet_count: 10293,
    favorite_count: 59362,
    is_retweet: false,
    id_str: "858343980823703553"
  },
  {
    source: "Twitter for iPhone",
    text:
      '.@LouDobbs just stated that "President Trump\'s successes are unmatched in recent presidential history"  Thank you Lou!',
    created_at: "Sat Apr 29 02:40:11 +0000 2017",
    retweet_count: 15086,
    favorite_count: 72825,
    is_retweet: false,
    id_str: "858148882756325379"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxnation: . @TuckerCarlson : #Dems Don't Really Believe #Trump Is a Pawn of #Russia - That's Just Their Political Tool  https://t.co/K…",
    created_at: "Sat Apr 29 02:34:33 +0000 2017",
    retweet_count: 7067,
    favorite_count: 0,
    is_retweet: true,
    id_str: "858147464846729217"
  },
  {
    source: "Twitter for iPhone",
    text:
      "North Korea disrespected the wishes of China &amp; its highly respected President when it launched, though unsuccessfully, a missile today. Bad!",
    created_at: "Fri Apr 28 23:26:18 +0000 2017",
    retweet_count: 23417,
    favorite_count: 85241,
    is_retweet: false,
    id_str: "858100088253669376"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be interviewed by @MarthaMaccallum on @FoxNews tonight at 7pm. Enjoy!",
    created_at: "Fri Apr 28 22:31:25 +0000 2017",
    retweet_count: 5280,
    favorite_count: 35278,
    is_retweet: false,
    id_str: "858086278037950464"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We are making tremendous progress with the V. A. There has never been so much done so quickly, and we have just started. We love our VETS!",
    created_at: "Fri Apr 28 12:15:59 +0000 2017",
    retweet_count: 15697,
    favorite_count: 80605,
    is_retweet: false,
    id_str: "857931397562085376"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @foxandfriends: Former President Obama\'s $400K Wall Street speech stuns liberal base; Sen. Warren saying she "was troubled by that" http…',
    created_at: "Fri Apr 28 12:12:15 +0000 2017",
    retweet_count: 8866,
    favorite_count: 0,
    is_retweet: true,
    id_str: "857930456767111168"
  },
  {
    source: "Twitter Ads",
    text:
      "Today, I signed an Executive Order on Improving Accountability and Whistleblower Protection at the @DeptVetAffairs:… https://t.co/UQ6VNCyhlj",
    created_at: "Thu Apr 27 22:43:19 +0000 2017",
    retweet_count: 10913,
    favorite_count: 47053,
    is_retweet: false,
    id_str: "857726884045496325"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Presidential Memorandum for the @CommerceGov, @SecretaryRoss re: Aluminum Imports and Threats to National Security:… https://t.co/GnKoVz9GTO",
    created_at: "Thu Apr 27 21:42:47 +0000 2017",
    retweet_count: 5946,
    favorite_count: 28134,
    is_retweet: false,
    id_str: "857711651952500737"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@FLOTUS Melania and I were honored to welcome Argentina President @MauricioMacri and First Lady Juliana Awada to t… https://t.co/gR3EPznu1H",
    created_at: "Thu Apr 27 18:59:31 +0000 2017",
    retweet_count: 11929,
    favorite_count: 53239,
    is_retweet: false,
    id_str: "857670562478518273"
  },
  {
    source: "Twitter for iPhone",
    text:
      "As families prepare for summer vacations in our National Parks - Democrats threaten to close them and shut down the government. Terrible!",
    created_at: "Thu Apr 27 14:39:25 +0000 2017",
    retweet_count: 15064,
    favorite_count: 59887,
    is_retweet: false,
    id_str: "857605104417026049"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrats used to support border security — now they want illegals to pour through our borders.",
    created_at: "Thu Apr 27 14:39:04 +0000 2017",
    retweet_count: 14266,
    favorite_count: 58667,
    is_retweet: false,
    id_str: "857605018266062848"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrats jeopardizing the safety of our troops to bail out their donors from insurance companies. It is time to put #AmericaFirst🇺🇸",
    created_at: "Thu Apr 27 14:38:14 +0000 2017",
    retweet_count: 11977,
    favorite_count: 49085,
    is_retweet: false,
    id_str: "857604808676708353"
  },
  {
    source: "Twitter for iPhone",
    text:
      "What's more important? Rebuilding our military - or bailing out insurance companies? Ask the Democrats.",
    created_at: "Thu Apr 27 14:37:51 +0000 2017",
    retweet_count: 13824,
    favorite_count: 60019,
    is_retweet: false,
    id_str: "857604709829529601"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I promise to rebuild our military and secure our border. Democrats want to shut down the government. Politics!",
    created_at: "Thu Apr 27 14:37:30 +0000 2017",
    retweet_count: 13141,
    favorite_count: 60294,
    is_retweet: false,
    id_str: "857604623531749376"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I want to help our miners while the Democrats are blocking their healthcare.",
    created_at: "Thu Apr 27 14:37:09 +0000 2017",
    retweet_count: 9735,
    favorite_count: 45394,
    is_retweet: false,
    id_str: "857604537003200512"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats want to shut government if we don't bail out Puerto Rico and give billions to their insurance companies for OCare failure. NO!",
    created_at: "Thu Apr 27 11:30:20 +0000 2017",
    retweet_count: 17557,
    favorite_count: 70192,
    is_retweet: false,
    id_str: "857557522584088576"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...subject to the fact that if we do not reach a fair deal for all, we will then terminate NAFTA. Relationships are good-deal very possible!",
    created_at: "Thu Apr 27 11:21:20 +0000 2017",
    retweet_count: 10122,
    favorite_count: 49242,
    is_retweet: false,
    id_str: "857555256003227648"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I received calls from the President of Mexico and the Prime Minister of Canada asking to renegotiate NAFTA rather than terminate. I agreed..",
    created_at: "Thu Apr 27 11:12:12 +0000 2017",
    retweet_count: 16005,
    favorite_count: 70086,
    is_retweet: false,
    id_str: "857552956836786177"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrats are trying to bail out insurance companies from disastrous #ObamaCare, and Puerto Rico with your tax dollars. Sad!",
    created_at: "Wed Apr 26 23:06:16 +0000 2017",
    retweet_count: 15446,
    favorite_count: 53161,
    is_retweet: false,
    id_str: "857370270776086528"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A great great honor to welcome &amp; recognize the National Teacher of the Year, as well as the Teacher of the Year fro… https://t.co/pUGl7RDoVX",
    created_at: "Wed Apr 26 22:27:29 +0000 2017",
    retweet_count: 9593,
    favorite_count: 48969,
    is_retweet: false,
    id_str: "857360510534209536"
  },
  {
    source: "Twitter Ads",
    text:
      "Today, I signed an Executive Order on Enforcing Statutory Prohibitions on Federal Control of Education. EO:… https://t.co/YYafFQncbC",
    created_at: "Wed Apr 26 20:49:16 +0000 2017",
    retweet_count: 9090,
    favorite_count: 40184,
    is_retweet: false,
    id_str: "857335793261568000"
  },
  {
    source: "Twitter Ads",
    text:
      "Today, I signed an Executive Order @ the U.S. Dept. of @Interior: 'Review of Designations Under the Antiquities Act… https://t.co/Eq6JDzMqTY",
    created_at: "Wed Apr 26 18:10:04 +0000 2017",
    retweet_count: 7175,
    favorite_count: 33658,
    is_retweet: false,
    id_str: "857295731929034753"
  },
  {
    source: "Twitter for iPhone",
    text:
      "HAPPY BIRTHDAY to our @FLOTUS, Melania! \nhttps://t.co/rYYp51mxDQ https://t.co/np7KYHglSv",
    created_at: "Wed Apr 26 14:53:26 +0000 2017",
    retweet_count: 18178,
    favorite_count: 84792,
    is_retweet: false,
    id_str: "857246245672366081"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The U.S. recorded its slowest economic growth in five years (2016). GDP up only 1.6%. Trade deficits hurt the economy very badly.",
    created_at: "Wed Apr 26 10:51:06 +0000 2017",
    retweet_count: 9388,
    favorite_count: 47225,
    is_retweet: false,
    id_str: "857185261029126144"
  },
  {
    source: "Twitter for iPhone",
    text:
      '...the Ninth Circuit, which has a terrible record of being overturned (close to 80%). They used to call this "judge shopping!" Messy system.',
    created_at: "Wed Apr 26 10:38:51 +0000 2017",
    retweet_count: 12781,
    favorite_count: 56586,
    is_retweet: false,
    id_str: "857182179469774848"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Out of our very big country, with many choices, does everyone notice that both the "ban" case and now the "sanctuary" case is brought in ...',
    created_at: "Wed Apr 26 10:30:54 +0000 2017",
    retweet_count: 10380,
    favorite_count: 49005,
    is_retweet: false,
    id_str: "857180178736459776"
  },
  {
    source: "Twitter for iPhone",
    text:
      "First the Ninth Circuit rules against the ban &amp; now it hits again on sanctuary cities-both ridiculous rulings. See you in the Supreme Court!",
    created_at: "Wed Apr 26 10:20:00 +0000 2017",
    retweet_count: 18022,
    favorite_count: 68988,
    is_retweet: false,
    id_str: "857177434210304001"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Presidential Executive Order on Promoting Agriculture and Rural Prosperity in America'\nExecutive Order:… https://t.co/LVMjZ9Ax0U",
    created_at: "Tue Apr 25 23:32:13 +0000 2017",
    retweet_count: 8885,
    favorite_count: 39714,
    is_retweet: false,
    id_str: "857014413081137154"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Remarks at the United States Holocaust Memorial Museum's National Days of Remembrance. \nFull remarks:… https://t.co/BJbI6ZtGo7",
    created_at: "Tue Apr 25 17:51:03 +0000 2017",
    retweet_count: 7491,
    favorite_count: 36693,
    is_retweet: false,
    id_str: "856928555179143168"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Don't let the fake media tell you that I have changed my position on the WALL. It will get built and help stop drugs, human trafficking etc.",
    created_at: "Tue Apr 25 12:36:28 +0000 2017",
    retweet_count: 26296,
    favorite_count: 99995,
    is_retweet: false,
    id_str: "856849388026687492"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Canada has made business for our dairy farmers in Wisconsin and other border states very difficult. We will not stand for this. Watch!",
    created_at: "Tue Apr 25 12:30:15 +0000 2017",
    retweet_count: 14456,
    favorite_count: 62127,
    is_retweet: false,
    id_str: "856847826663460865"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Proud of @IvankaTrump for her leadership on these important issues. Looking forward to hearing her speak at the W20! https://t.co/e6Uajrm8zp",
    created_at: "Tue Apr 25 11:23:08 +0000 2017",
    retweet_count: 6673,
    favorite_count: 38213,
    is_retweet: false,
    id_str: "856830933709750272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today, I signed the Holocaust Remembrance Proclamation: https://t.co/762SqgdLMV #ICYMI- My statement last night at… https://t.co/vrqqFDi8En",
    created_at: "Mon Apr 24 20:32:08 +0000 2017",
    retweet_count: 10428,
    favorite_count: 44131,
    is_retweet: false,
    id_str: "856606707463725057"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If our healthcare plan is approved, you will see real healthcare and premiums will start tumbling down. ObamaCare is in a death spiral!",
    created_at: "Mon Apr 24 17:18:32 +0000 2017",
    retweet_count: 13571,
    favorite_count: 71615,
    is_retweet: false,
    id_str: "856557986474491904"
  },
  {
    source: "Twitter Ads",
    text:
      "Join me in congratulating @NASA's @AstroPeggy by using the hashtag #CongratsPeggy! Earlier today:… https://t.co/AUdJgxXiT4",
    created_at: "Mon Apr 24 17:11:31 +0000 2017",
    retweet_count: 7469,
    favorite_count: 37547,
    is_retweet: false,
    id_str: "856556220911681539"
  },
  {
    source: "Twitter for iPhone",
    text:
      "....the wall is not built, which it will be, the drug situation will NEVER be fixed the way it should be!\n#BuildTheWall",
    created_at: "Mon Apr 24 15:31:57 +0000 2017",
    retweet_count: 8029,
    favorite_count: 37967,
    is_retweet: false,
    id_str: "856531163799859201"
  },
  {
    source: "Twitter for iPhone",
    text: "#CongratsPeggy! https://t.co/e1q36nKT8g",
    created_at: "Mon Apr 24 14:02:01 +0000 2017",
    retweet_count: 5553,
    favorite_count: 30050,
    is_retweet: false,
    id_str: "856508531087990785"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Wall is a very important tool in stopping drugs from pouring into our country and poisoning our youth (and many others)! If",
    created_at: "Mon Apr 24 12:28:01 +0000 2017",
    retweet_count: 11354,
    favorite_count: 51718,
    is_retweet: false,
    id_str: "856484873133060101"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The two fake news polls released yesterday, ABC &amp; NBC, while containing some very positive info, were totally wrong in General E. Watch!",
    created_at: "Mon Apr 24 12:15:45 +0000 2017",
    retweet_count: 9043,
    favorite_count: 46670,
    is_retweet: false,
    id_str: "856481786938916865"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...popular vote. ABC News/Washington Post Poll (wrong big on election) said almost all stand by their vote on me &amp; 53% said strong leader.",
    created_at: "Sun Apr 23 19:55:04 +0000 2017",
    retweet_count: 11947,
    favorite_count: 60868,
    is_retweet: false,
    id_str: "856234989591121922"
  },
  {
    source: "Twitter for iPhone",
    text:
      "New polls out today are very good considering that much of the media is FAKE and almost always negative. Would still beat Hillary in .....",
    created_at: "Sun Apr 23 19:48:16 +0000 2017",
    retweet_count: 11742,
    favorite_count: 63642,
    is_retweet: false,
    id_str: "856233279841849344"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Eventually, but at a later date so we can get started early, Mexico will be paying, in some form, for the badly needed border wall.",
    created_at: "Sun Apr 23 15:44:59 +0000 2017",
    retweet_count: 15090,
    favorite_count: 64063,
    is_retweet: false,
    id_str: "856172056932700164"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats don't want money from budget going to border wall despite the fact that it will stop drugs and very bad MS 13 gang members.",
    created_at: "Sun Apr 23 15:42:07 +0000 2017",
    retweet_count: 16249,
    favorite_count: 64482,
    is_retweet: false,
    id_str: "856171332521820165"
  },
  {
    source: "Twitter for iPhone",
    text:
      "ObamaCare is in serious trouble. The Dems need big money to keep it going - otherwise it dies far sooner than anyone would have thought.",
    created_at: "Sun Apr 23 14:20:12 +0000 2017",
    retweet_count: 12233,
    favorite_count: 58486,
    is_retweet: false,
    id_str: "856150719656755200"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you Lake Worth, Florida. @foxandfriends",
    created_at: "Sun Apr 23 14:07:52 +0000 2017",
    retweet_count: 4844,
    favorite_count: 34704,
    is_retweet: false,
    id_str: "856147612952612864"
  },
  {
    source: "Twitter for iPhone",
    text: "Very interesting election currently taking place in France.",
    created_at: "Sun Apr 23 14:05:07 +0000 2017",
    retweet_count: 17186,
    favorite_count: 63159,
    is_retweet: false,
    id_str: "856146924705120256"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am committed to keeping our air and water clean but always remember that economic growth enhances environmental protection. Jobs matter!",
    created_at: "Sat Apr 22 21:49:10 +0000 2017",
    retweet_count: 18191,
    favorite_count: 89211,
    is_retweet: false,
    id_str: "855901315305795584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today on Earth Day, we celebrate our beautiful forests, lakes and land. We stand committed to preserving the natural beauty of our nation.",
    created_at: "Sat Apr 22 19:01:59 +0000 2017",
    retweet_count: 14707,
    favorite_count: 80115,
    is_retweet: false,
    id_str: "855859245023211520"
  },
  {
    source: "Twitter for iPhone",
    text: "Big TAX REFORM AND TAX REDUCTION will be announced next Wednesday.",
    created_at: "Sat Apr 22 16:15:01 +0000 2017",
    retweet_count: 16988,
    favorite_count: 74989,
    is_retweet: false,
    id_str: "855817226078879748"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Next Saturday night I will be holding a BIG rally in Pennsylvania. Look forward to it!",
    created_at: "Sat Apr 22 16:10:26 +0000 2017",
    retweet_count: 11786,
    favorite_count: 58692,
    is_retweet: false,
    id_str: "855816071663812608"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Getting ready to visit Walter Reed Medical Center with Melania. Looking forward to seeing our bravest and greatest Americans!",
    created_at: "Sat Apr 22 16:05:37 +0000 2017",
    retweet_count: 10446,
    favorite_count: 61868,
    is_retweet: false,
    id_str: "855814859069558784"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Israeli PM Netanyahu praises U.S. policy changes during meeting with Defense. Sec Mattis https://t.co/v2C9oaq3uY",
    created_at: "Sat Apr 22 15:18:49 +0000 2017",
    retweet_count: 5401,
    favorite_count: 0,
    is_retweet: true,
    id_str: "855803080310390784"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: Chicago approves new plan to hide illegal immigrants from the feds, plus give them access to city services https://t.co/…",
    created_at: "Sat Apr 22 15:18:11 +0000 2017",
    retweet_count: 7263,
    favorite_count: 0,
    is_retweet: true,
    id_str: "855802920956243969"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After 5 SB victories since 2002, it was my honor to give Bob Kraft, Coach Belichick, and the players their first to… https://t.co/UZPKjqoGZY",
    created_at: "Sat Apr 22 03:38:00 +0000 2017",
    retweet_count: 10397,
    favorite_count: 54523,
    is_retweet: false,
    id_str: "855626715707650048"
  },
  {
    source: "Twitter Ads",
    text:
      "'Presidential Executive Order on Identifying and Reducing Tax Regulatory Burdens' \nExecutive Order:… https://t.co/dpE6hDzlAt",
    created_at: "Sat Apr 22 00:43:21 +0000 2017",
    retweet_count: 9835,
    favorite_count: 42823,
    is_retweet: false,
    id_str: "855582764418162690"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: .@POTUS @realDonaldTrump, @IvankaTrump, Jared Kushner, &amp; Dina Powell in the Oval Office today w/ Aya &amp; her brother Basel.\n#W…",
    created_at: "Sat Apr 22 00:19:58 +0000 2017",
    retweet_count: 4960,
    favorite_count: 0,
    is_retweet: true,
    id_str: "855576880048738304"
  },
  {
    source: "Twitter for iPhone",
    text: "WELCOME HOME, AYA!\n#GodBlessTheUSA🇺🇸 https://t.co/CR4I8dvunc",
    created_at: "Fri Apr 21 20:22:14 +0000 2017",
    retweet_count: 19562,
    favorite_count: 76038,
    is_retweet: false,
    id_str: "855517053238870019"
  },
  {
    source: "Twitter for iPhone",
    text:
      "China is very much the economic lifeline to North Korea so, while nothing is easy, if they want to solve the North Korean problem, they will",
    created_at: "Fri Apr 21 13:04:19 +0000 2017",
    retweet_count: 14382,
    favorite_count: 66215,
    is_retweet: false,
    id_str: "855406847200768000"
  },
  {
    source: "Twitter for iPhone",
    text:
      "No matter how much I accomplish during the ridiculous standard of the first 100 days, &amp; it has been a lot (including S.C.), media will kill!",
    created_at: "Fri Apr 21 10:50:33 +0000 2017",
    retweet_count: 14753,
    favorite_count: 73399,
    is_retweet: false,
    id_str: "855373184861962240"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Another terrorist attack in Paris. The people of France will not take much more of this. Will have a big effect on presidential election!",
    created_at: "Fri Apr 21 10:32:01 +0000 2017",
    retweet_count: 18717,
    favorite_count: 75062,
    is_retweet: false,
    id_str: "855368516920332289"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: NYT editor apologizes for misleading tweet about New England Patriots' visit to the White House (via @FoxFriendsFirst) h…",
    created_at: "Fri Apr 21 10:11:27 +0000 2017",
    retweet_count: 8564,
    favorite_count: 0,
    is_retweet: true,
    id_str: "855363343607103489"
  },
  {
    source: "Twitter Ads",
    text:
      "A great honor to host PM Paolo Gentiloni of Italy at the White House this afternoon! #ICYMI- Joint Press Conference… https://t.co/lJAvEZJV1F",
    created_at: "Thu Apr 20 21:35:05 +0000 2017",
    retweet_count: 7010,
    favorite_count: 37208,
    is_retweet: false,
    id_str: "855172998747348998"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We're going to use American steel, we're going to use American labor, we are going to come first in all deals. ➡️… https://t.co/QYjWx9K4YY",
    created_at: "Thu Apr 20 19:33:46 +0000 2017",
    retweet_count: 11693,
    favorite_count: 52450,
    is_retweet: false,
    id_str: "855142466034556928"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Failing @nytimes, which has been calling me wrong for two years, just got caught in a big lie concerning New England Patriots visit to W.H.",
    created_at: "Thu Apr 20 13:48:14 +0000 2017",
    retweet_count: 19178,
    favorite_count: 81483,
    is_retweet: false,
    id_str: "855055509455593472"
  },
  {
    source: "Twitter Ads",
    text:
      "A great honor to host the @SuperBowl Champion New England @Patriots at the White House today. Congratulations!… https://t.co/tQ5XEPaIxn",
    created_at: "Thu Apr 20 01:34:10 +0000 2017",
    retweet_count: 9723,
    favorite_count: 49049,
    is_retweet: false,
    id_str: "854870777287634944"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today I signed the Veterans (OUR HEROES) Choice Program Extension &amp; Improvement Act @ the @WhiteHouse. #S544 \nWatch… https://t.co/0sMv4sPrmf",
    created_at: "Wed Apr 19 20:26:45 +0000 2017",
    retweet_count: 10614,
    favorite_count: 48196,
    is_retweet: false,
    id_str: "854793411110588418"
  },
  {
    source: "Twitter for iPhone",
    text: "#BuyAmericanHireAmerican🇺🇸 https://t.co/JPEXQTVR1E",
    created_at: "Wed Apr 19 17:31:28 +0000 2017",
    retweet_count: 12938,
    favorite_count: 54144,
    is_retweet: false,
    id_str: "854749300114546688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Dems failed in Kansas and are now failing in Georgia. Great job Karen Handel! It is now Hollywood vs. Georgia on June 20th.",
    created_at: "Wed Apr 19 12:43:18 +0000 2017",
    retweet_count: 15581,
    favorite_count: 72852,
    is_retweet: false,
    id_str: "854676780527079425"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Despite major outside money, FAKE media support and eleven Republican candidates, BIG "R" win with runoff in Georgia. Glad to be of help!',
    created_at: "Wed Apr 19 04:09:17 +0000 2017",
    retweet_count: 15355,
    favorite_count: 77097,
    is_retweet: false,
    id_str: "854547423464759296"
  },
  {
    source: "Twitter for iPhone",
    text:
      "#BuyAmericanHireAmerican🇺🇸\nWatch➡️https://t.co/AUqYcrgeyn https://t.co/rf9aivVb7g",
    created_at: "Tue Apr 18 20:56:16 +0000 2017",
    retweet_count: 6772,
    favorite_count: 33968,
    is_retweet: false,
    id_str: "854438452661809152"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just learned that Jon @Ossoff, who is running for Congress in Georgia, doesn't even live in the district. Republicans, get out and vote!",
    created_at: "Tue Apr 18 20:38:25 +0000 2017",
    retweet_count: 16473,
    favorite_count: 63042,
    is_retweet: false,
    id_str: "854433960566431746"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Republicans must get out today and VOTE in Georgia 6. Force runoff and easy win! Dem Ossoff will raise your taxes-very bad on crime &amp; 2nd A.",
    created_at: "Tue Apr 18 10:46:19 +0000 2017",
    retweet_count: 16046,
    favorite_count: 62665,
    is_retweet: false,
    id_str: "854284952539725828"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrat Jon Ossoff would be a disaster in Congress. VERY weak on crime and illegal immigration, bad for jobs and wants higher taxes. Say NO",
    created_at: "Tue Apr 18 10:38:59 +0000 2017",
    retweet_count: 14367,
    favorite_count: 56986,
    is_retweet: false,
    id_str: "854283110191685634"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be interviewed on @foxandfriends by @ainsleyearhardt starting at 6:00 A.M. Enjoy!",
    created_at: "Tue Apr 18 09:48:10 +0000 2017",
    retweet_count: 4683,
    favorite_count: 33641,
    is_retweet: false,
    id_str: "854270321620287490"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The weak illegal immigration policies of the Obama Admin. allowed bad MS 13 gangs to form in cities across U.S. We are removing them fast!",
    created_at: "Tue Apr 18 09:39:25 +0000 2017",
    retweet_count: 17597,
    favorite_count: 72694,
    is_retweet: false,
    id_str: "854268119774367745"
  },
  {
    source: "Twitter for iPhone",
    text:
      'With eleven Republican candidates running in Georgia (on Tuesday) for Congress, a runoff will be a win. Vote "R" for lower taxes &amp; safety!',
    created_at: "Tue Apr 18 02:18:38 +0000 2017",
    retweet_count: 13599,
    favorite_count: 61163,
    is_retweet: false,
    id_str: "854157191053553666"
  },
  {
    source: "Twitter for iPhone",
    text:
      "See you tomorrow Wisconsin!\n\n'Trump spurs small-business optimism in Milwaukee area'\nhttps://t.co/JUxhO3oqjO",
    created_at: "Mon Apr 17 22:41:53 +0000 2017",
    retweet_count: 8319,
    favorite_count: 42213,
    is_retweet: false,
    id_str: "854102644394254341"
  },
  {
    source: "Twitter for iPhone",
    text: "TRUMP APPROVAL HITS 50%\nhttps://t.co/vjZkGTyQb9",
    created_at: "Mon Apr 17 22:38:30 +0000 2017",
    retweet_count: 10793,
    favorite_count: 56216,
    is_retweet: false,
    id_str: "854101790886948866"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @DRUDGE_REPORT: TRUMP APPROVAL HITS 50% https://t.co/TruX3WzR3U",
    created_at: "Mon Apr 17 13:35:27 +0000 2017",
    retweet_count: 7632,
    favorite_count: 0,
    is_retweet: true,
    id_str: "853965129024712704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The super Liberal Democrat in the Georgia Congressioal race tomorrow wants to protect criminals, allow illegal immigration and raise taxes!",
    created_at: "Mon Apr 17 13:31:03 +0000 2017",
    retweet_count: 19415,
    favorite_count: 61174,
    is_retweet: false,
    id_str: "853964023846588420"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Fake Media (not Real Media) has gotten even worse since the election. Every story is badly slanted. We have to hold them to the truth!",
    created_at: "Mon Apr 17 12:17:59 +0000 2017",
    retweet_count: 18607,
    favorite_count: 83488,
    is_retweet: false,
    id_str: "853945633903923200"
  },
  {
    source: "Twitter for iPhone",
    text:
      'A great book for your reading enjoyment: "REASONS TO VOTE FOR DEMOCRATS" by Michael J. Knowles.',
    created_at: "Mon Apr 17 12:13:17 +0000 2017",
    retweet_count: 12663,
    favorite_count: 53324,
    is_retweet: false,
    id_str: "853944453538750464"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"The first 90 days of my presidency has exposed the total failure of the last eight years of foreign policy!" So true. @foxandfriends',
    created_at: "Mon Apr 17 12:07:16 +0000 2017",
    retweet_count: 16169,
    favorite_count: 75933,
    is_retweet: false,
    id_str: "853942936337350656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The recent Kansas election (Congress) was a really big media event, until the Republicans won. Now they play the same game with Georgia-BAD!",
    created_at: "Mon Apr 17 00:45:01 +0000 2017",
    retweet_count: 12804,
    favorite_count: 64082,
    is_retweet: false,
    id_str: "853771244579282944"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Our military is building and is rapidly becoming stronger than ever before. Frankly, we have no choice!",
    created_at: "Sun Apr 16 13:41:47 +0000 2017",
    retweet_count: 20803,
    favorite_count: 104462,
    is_retweet: false,
    id_str: "853604334944354305"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Someone should look into who paid for the small organized rallies yesterday. The election is over!",
    created_at: "Sun Apr 16 13:13:26 +0000 2017",
    retweet_count: 21244,
    favorite_count: 95808,
    is_retweet: false,
    id_str: "853597199619543041"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I did what was an almost an impossible thing to do for a Republican-easily won the Electoral College! Now Tax Returns are brought up again?",
    created_at: "Sun Apr 16 13:07:11 +0000 2017",
    retweet_count: 12384,
    favorite_count: 70664,
    is_retweet: false,
    id_str: "853595628655587334"
  },
  {
    source: "Twitter for iPhone",
    text: "Happy Easter to everyone!",
    created_at: "Sun Apr 16 12:24:49 +0000 2017",
    retweet_count: 40671,
    favorite_count: 186323,
    is_retweet: false,
    id_str: "853584968047636480"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Why would I call China a currency manipulator when they are working with us on the North Korean problem? We will see what happens!",
    created_at: "Sun Apr 16 12:18:40 +0000 2017",
    retweet_count: 15001,
    favorite_count: 72649,
    is_retweet: false,
    id_str: "853583417916755968"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @FLOTUS: Looking forward to hosting the annual Easter Egg Roll at the @WhiteHouse on Monday! https://t.co/nz7vucugx9",
    created_at: "Fri Apr 14 21:46:20 +0000 2017",
    retweet_count: 17662,
    favorite_count: 0,
    is_retweet: true,
    id_str: "853001499747725317"
  },
  {
    source: "Twitter for iPhone",
    text: "Weekly Address- https://t.co/tpZ7eqJLUH https://t.co/B2NQzj53ft",
    created_at: "Fri Apr 14 20:41:25 +0000 2017",
    retweet_count: 7089,
    favorite_count: 33563,
    is_retweet: false,
    id_str: "852985162870738944"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DRUDGE_REPORT: GREAT AGAIN: FEDS ARREST MURDER SUSPECT IN 'FAST AND FURIOUS' SCANDAL... https://t.co/clOLxTE3D4",
    created_at: "Fri Apr 14 03:18:24 +0000 2017",
    retweet_count: 5824,
    favorite_count: 0,
    is_retweet: true,
    id_str: "852722680851779584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was a great honor to welcome Atlanta's heroic first responders to the White House this afternoon! https://t.co/ZtC14AJ0xs",
    created_at: "Thu Apr 13 19:21:07 +0000 2017",
    retweet_count: 13013,
    favorite_count: 75042,
    is_retweet: false,
    id_str: "852602568433950720"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Things will work out fine between the U.S.A. and Russia. At the right time everyone will come to their senses &amp; there will be lasting peace!",
    created_at: "Thu Apr 13 13:16:30 +0000 2017",
    retweet_count: 24326,
    favorite_count: 111648,
    is_retweet: false,
    id_str: "852510810287075329"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I have great confidence that China will properly deal with North Korea. If they are unable to do so, the U.S., with its allies, will! U.S.A.",
    created_at: "Thu Apr 13 13:08:20 +0000 2017",
    retweet_count: 28207,
    favorite_count: 113289,
    is_retweet: false,
    id_str: "852508752142114816"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Jobs are returning, illegal immigration is plummeting, law, order and justice are being restored. We are truly making America great again!",
    created_at: "Thu Apr 13 00:32:25 +0000 2017",
    retweet_count: 30950,
    favorite_count: 139902,
    is_retweet: false,
    id_str: "852318522139168769"
  },
  {
    source: "Twitter for iPhone",
    text:
      "One by one we are keeping our promises - on the border, on energy, on jobs, on regulations. Big changes are happening!",
    created_at: "Wed Apr 12 23:10:37 +0000 2017",
    retweet_count: 17816,
    favorite_count: 95427,
    is_retweet: false,
    id_str: "852297935219982336"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Economic confidence is soaring as we unleash the power of private sector job creation and stand up for the American Workers. #AmericaFirst",
    created_at: "Wed Apr 12 23:09:56 +0000 2017",
    retweet_count: 12143,
    favorite_count: 65130,
    is_retweet: false,
    id_str: "852297762599313409"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great meeting w/ NATO Sec. Gen. We agreed on the importance of getting countries to pay their fair share &amp; focus on… https://t.co/G9TdjWezmH",
    created_at: "Wed Apr 12 21:48:48 +0000 2017",
    retweet_count: 10724,
    favorite_count: 52838,
    is_retweet: false,
    id_str: "852277347587952640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great win in Kansas last night for Ron Estes, easily winning the Congressional race against the Dems, who spent heavily &amp; predicted victory!",
    created_at: "Wed Apr 12 12:37:07 +0000 2017",
    retweet_count: 13165,
    favorite_count: 72078,
    is_retweet: false,
    id_str: "852138509355933697"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Had a very good call last night with the President of China concerning the menace of North Korea.",
    created_at: "Wed Apr 12 12:22:22 +0000 2017",
    retweet_count: 19588,
    favorite_count: 92666,
    is_retweet: false,
    id_str: "852134796436398086"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be interviewed by @MariaBartiromo at 6:00 A.M. @FoxBusiness. Enjoy!",
    created_at: "Wed Apr 12 03:16:00 +0000 2017",
    retweet_count: 6222,
    favorite_count: 40874,
    is_retweet: false,
    id_str: "851997299454742528"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great Strategic &amp; Policy CEO Forum today with my Cabinet Secretaries and top CEO's from around the United States.… https://t.co/pmGIL08OpP",
    created_at: "Tue Apr 11 20:27:35 +0000 2017",
    retweet_count: 8723,
    favorite_count: 43875,
    is_retweet: false,
    id_str: "851894518014238720"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Ron Estes is running TODAY for Congress in the Great State of Kansas. A wonderful guy, I need his help on Healthcare &amp; Tax Cuts (Reform).",
    created_at: "Tue Apr 11 12:59:20 +0000 2017",
    retweet_count: 12262,
    favorite_count: 58666,
    is_retweet: false,
    id_str: "851781714028494849"
  },
  {
    source: "Twitter for iPhone",
    text:
      "North Korea is looking for trouble. If China decides to help, that would be great. If not, we will solve the problem without them!  U.S.A.",
    created_at: "Tue Apr 11 12:03:43 +0000 2017",
    retweet_count: 53328,
    favorite_count: 136091,
    is_retweet: false,
    id_str: "851767718248361986"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I explained to the President of China that a trade deal with the U.S. will be far better for them if they solve the North Korean problem!",
    created_at: "Tue Apr 11 11:59:04 +0000 2017",
    retweet_count: 19145,
    favorite_count: 81554,
    is_retweet: false,
    id_str: "851766546825347076"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxnation: Grateful Syrians React To @realDonaldTrump Strike: 'I'll Name My Son Donald' https://t.co/7KexXsXLUx #SyrianStrikes",
    created_at: "Tue Apr 11 11:48:31 +0000 2017",
    retweet_count: 6245,
    favorite_count: 0,
    is_retweet: true,
    id_str: "851763890786635776"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Happy Passover to everyone celebrating in the United States of America, Israel, and around the world. #ChagSameach",
    created_at: "Mon Apr 10 23:56:35 +0000 2017",
    retweet_count: 16731,
    favorite_count: 89320,
    is_retweet: false,
    id_str: "851584729400979456"
  },
  {
    source: "Twitter Ads",
    text:
      "Congratulations to Justice Neil Gorsuch on his elevation to the United States Supreme Court. A great day for Americ… https://t.co/RM9lfTaePS",
    created_at: "Mon Apr 10 21:59:10 +0000 2017",
    retweet_count: 15760,
    favorite_count: 79752,
    is_retweet: false,
    id_str: "851555178910064640"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you @USNavy! #USA https://t.co/oD7L8vPgjq",
    created_at: "Mon Apr 10 01:35:45 +0000 2017",
    retweet_count: 14540,
    favorite_count: 71754,
    is_retweet: false,
    id_str: "851247294854856706"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...confidence that President Al Sisi will handle situation properly.",
    created_at: "Sun Apr 09 15:21:07 +0000 2017",
    retweet_count: 10391,
    favorite_count: 56646,
    is_retweet: false,
    id_str: "851092618754891781"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So sad to hear of the terrorist attack in Egypt. U.S. strongly condemns. I have great...",
    created_at: "Sun Apr 09 15:20:39 +0000 2017",
    retweet_count: 15606,
    favorite_count: 77604,
    is_retweet: false,
    id_str: "851092500056072198"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Judge Gorsuch will be sworn in at the Rose Garden of the White House on Monday at 11:00 A.M. He will be a great Justice. Very proud of him!",
    created_at: "Sat Apr 08 19:58:32 +0000 2017",
    retweet_count: 18538,
    favorite_count: 101425,
    is_retweet: false,
    id_str: "850800045012201473"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The reason you don't generally hit runways is that they are easy and inexpensive to quickly fix (fill in and top)!",
    created_at: "Sat Apr 08 19:00:08 +0000 2017",
    retweet_count: 11769,
    favorite_count: 61631,
    is_retweet: false,
    id_str: "850785347038576640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to our great military men and women for representing the United States, and the world, so well in the Syria attack.",
    created_at: "Sat Apr 08 14:54:24 +0000 2017",
    retweet_count: 27363,
    favorite_count: 135259,
    is_retweet: false,
    id_str: "850723509370327040"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...goodwill and friendship was formed, but only time will tell on trade.",
    created_at: "Sat Apr 08 14:51:10 +0000 2017",
    retweet_count: 7231,
    favorite_count: 48718,
    is_retweet: false,
    id_str: "850722694958075905"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was a great honor to have President Xi Jinping and Madame Peng Liyuan of China as our guests in the United States. Tremendous...",
    created_at: "Sat Apr 08 14:50:59 +0000 2017",
    retweet_count: 10521,
    favorite_count: 67145,
    is_retweet: false,
    id_str: "850722648883638272"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IvankaTrump: Very proud of Arabella and Joseph for their performance in honor of President Xi Jinping and Madame Peng Liyuan's official…",
    created_at: "Fri Apr 07 23:22:53 +0000 2017",
    retweet_count: 15195,
    favorite_count: 0,
    is_retweet: true,
    id_str: "850489084221018113"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was an honor to host our American heroes from the @WWP #SoldierRideDC at the @WhiteHouse today with @FLOTUS, @VP… https://t.co/u5AI1pupVV",
    created_at: "Thu Apr 06 18:30:49 +0000 2017",
    retweet_count: 10767,
    favorite_count: 60570,
    is_retweet: false,
    id_str: "850053194923298816"
  },
  {
    source: "Twitter for iPhone",
    text: "JOBS, JOBS, JOBS!\nhttps://t.co/XGOQPHywrt https://t.co/B5Qbn6llzE",
    created_at: "Thu Apr 06 02:12:43 +0000 2017",
    retweet_count: 23000,
    favorite_count: 83555,
    is_retweet: false,
    id_str: "849807049118625792"
  },
  {
    source: "Twitter Ads",
    text:
      "I am deeply committed to preserving our strong relationship &amp; to strengthening America's long-standing support for… https://t.co/GxrOR3ALCE",
    created_at: "Wed Apr 05 21:18:08 +0000 2017",
    retweet_count: 13159,
    favorite_count: 67325,
    is_retweet: false,
    id_str: "849732911377117185"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great to talk jobs with #NABTU2017. Tremendous spirit &amp; optimism - we will deliver! https://t.co/6lRuQZZHrc",
    created_at: "Tue Apr 04 21:03:51 +0000 2017",
    retweet_count: 9150,
    favorite_count: 49321,
    is_retweet: false,
    id_str: "849366930133839872"
  },
  {
    source: "Twitter Ads",
    text:
      "Thank you Sean McGarvey &amp; the entire Governing Board of Presidents for honoring me w/an invite to speak. #NABTU2017… https://t.co/dJlZvlq6Tj",
    created_at: "Tue Apr 04 19:38:59 +0000 2017",
    retweet_count: 9447,
    favorite_count: 48800,
    is_retweet: false,
    id_str: "849345573509574665"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@WhiteHouse #CEOTownHall\n➡️https://t.co/ADSKuUXf1b https://t.co/XHfQ6zmF2H",
    created_at: "Tue Apr 04 18:38:13 +0000 2017",
    retweet_count: 8409,
    favorite_count: 38111,
    is_retweet: false,
    id_str: "849330281412792320"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DRUDGE_REPORT: RICE ORDERED SPY DOCS ON TRUMP? https://t.co/bL2nZRFxk9",
    created_at: "Tue Apr 04 12:39:16 +0000 2017",
    retweet_count: 11466,
    favorite_count: 0,
    is_retweet: true,
    id_str: "849239946653290496"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was an honor to welcome President Al Sisi of Egypt to the @WhiteHouse as we renew the historic partnership betwe… https://t.co/9mRaGvcPHz",
    created_at: "Mon Apr 03 19:39:05 +0000 2017",
    retweet_count: 13265,
    favorite_count: 58198,
    is_retweet: false,
    id_str: "848983209580822529"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Looking forward to hosting our heroes from the Wounded Warrior Project (@WWP) Soldier Ride to the @WhiteHouse on Th… https://t.co/QLC0qFD94x",
    created_at: "Mon Apr 03 17:56:55 +0000 2017",
    retweet_count: 11042,
    favorite_count: 56195,
    is_retweet: false,
    id_str: "848957498040217603"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Getting ready to meet President al-Sisi of Egypt. On behalf of the United States, I look forward to a long and wonderful relationship.",
    created_at: "Mon Apr 03 16:00:33 +0000 2017",
    retweet_count: 12841,
    favorite_count: 76027,
    is_retweet: false,
    id_str: "848928217138384896"
  },
  {
    source: "Twitter for iPhone",
    text:
      '.@FoxNews from multiple sources: "There was electronic surveillance of Trump, and people close to Trump. This is unprecedented." @FBI',
    created_at: "Mon Apr 03 12:51:01 +0000 2017",
    retweet_count: 22045,
    favorite_count: 69597,
    is_retweet: false,
    id_str: "848880519458717698"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Did Hillary Clinton ever apologize for receiving the answers to the debate? Just asking!",
    created_at: "Mon Apr 03 11:21:11 +0000 2017",
    retweet_count: 27505,
    favorite_count: 108357,
    is_retweet: false,
    id_str: "848857910297980928"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Was the brother of John Podesta paid big money to get the sanctions on Russia lifted? Did Hillary know?",
    created_at: "Mon Apr 03 11:16:52 +0000 2017",
    retweet_count: 20532,
    favorite_count: 71599,
    is_retweet: false,
    id_str: "848856822312292354"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Such amazing reporting on unmasking and the crooked scheme against us by @foxandfriends. "Spied on before nomination." The real story.',
    created_at: "Mon Apr 03 10:15:17 +0000 2017",
    retweet_count: 19995,
    favorite_count: 73263,
    is_retweet: false,
    id_str: "848841326183534594"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Melania and I are honored to light up the @WhiteHouse this evening, for \n#WorldAutismAwarenessDay. Join us &amp; #LIUB.… https://t.co/tR3hqqyWvv",
    created_at: "Mon Apr 03 00:58:29 +0000 2017",
    retweet_count: 25161,
    favorite_count: 113112,
    is_retweet: false,
    id_str: "848701201315188736"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The real story turns out to be SURVEILLANCE and LEAKING! Find the leakers.",
    created_at: "Sun Apr 02 13:34:16 +0000 2017",
    retweet_count: 21334,
    favorite_count: 82776,
    is_retweet: false,
    id_str: "848529014667055105"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Talks on Repealing and Replacing ObamaCare are, and have been, going on, and will continue until such time as a deal is hopefully struck.",
    created_at: "Sun Apr 02 13:03:43 +0000 2017",
    retweet_count: 13677,
    favorite_count: 73325,
    is_retweet: false,
    id_str: "848521325480202240"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Anybody (especially  Fake News media) who thinks that Repeal &amp; Replace of ObamaCare is dead does not know the love and strength in R Party!",
    created_at: "Sun Apr 02 12:56:49 +0000 2017",
    retweet_count: 16341,
    favorite_count: 80080,
    is_retweet: false,
    id_str: "848519587675201538"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you @JCLayfield -- will get even better as my Administration continues to put #AmericaFirst🇺🇸 https://t.co/AQQzmt10x7",
    created_at: "Sat Apr 01 22:21:02 +0000 2017",
    retweet_count: 13760,
    favorite_count: 53703,
    is_retweet: false,
    id_str: "848299191646515202"
  },
  {
    source: "Twitter for iPhone",
    text:
      '..not associated with Russia. Trump team spied on before he was nominated." If this is true, does not get much bigger. Would be sad for U.S.',
    created_at: "Sat Apr 01 17:02:29 +0000 2017",
    retweet_count: 15671,
    favorite_count: 64746,
    is_retweet: false,
    id_str: "848219027659010051"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Wow, @FoxNews just reporting big news. Source: "Official behind unmasking is high up. Known Intel official is responsible. Some unmasked....',
    created_at: "Sat Apr 01 16:50:36 +0000 2017",
    retweet_count: 16136,
    favorite_count: 61205,
    is_retweet: false,
    id_str: "848216035153121285"
  },
  {
    source: "Twitter for iPhone",
    text:
      '...use subsidies to buy health plans." In other words, Ocare is dead. Good things will happen, however, either with Republicans or Dems.',
    created_at: "Sat Apr 01 16:06:14 +0000 2017",
    retweet_count: 10001,
    favorite_count: 51102,
    is_retweet: false,
    id_str: "848204870876356608"
  },
  {
    source: "Twitter for iPhone",
    text:
      'The failing @nytimes finally gets it - "In places where no insurance company offers plans, there will be no way for ObamaCare customers to..',
    created_at: "Sat Apr 01 15:59:36 +0000 2017",
    retweet_count: 11203,
    favorite_count: 48508,
    is_retweet: false,
    id_str: "848203201094483972"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DanScavino: .@POTUS @realDonaldTrump signs executive orders on trade that will set the stage for revival in American manufacturing. #Am…",
    created_at: "Sat Apr 01 15:35:12 +0000 2017",
    retweet_count: 7035,
    favorite_count: 0,
    is_retweet: true,
    id_str: "848197060625145856"
  },
  {
    source: "Twitter for iPhone",
    text:
      'It is the same Fake News Media that said there is "no path to victory for Trump" that is now pushing the phony Russia story. A total scam!',
    created_at: "Sat Apr 01 13:02:32 +0000 2017",
    retweet_count: 22380,
    favorite_count: 86222,
    is_retweet: false,
    id_str: "848158641056362496"
  },
  {
    source: "Twitter for iPhone",
    text:
      "When will Sleepy Eyes Chuck Todd and @NBCNews start talking about the Obama SURVEILLANCE SCANDAL and stop with the Fake Trump/Russia story?",
    created_at: "Sat Apr 01 12:43:32 +0000 2017",
    retweet_count: 21797,
    favorite_count: 78221,
    is_retweet: false,
    id_str: "848153860602507264"
  },
  {
    source: "Twitter Ads",
    text:
      "We are going to defend our industry &amp; create a level playing field for the American worker. It is time to put… https://t.co/dzPKJMghj1",
    created_at: "Fri Mar 31 21:31:44 +0000 2017",
    retweet_count: 14593,
    favorite_count: 65695,
    is_retweet: false,
    id_str: "847924397180583937"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Trump Celebrates American Manufacturing Survey Showing Highest Level of Optimism in 20 Years' ➡️… https://t.co/cVWXOa1MjY",
    created_at: "Fri Mar 31 19:37:00 +0000 2017",
    retweet_count: 9595,
    favorite_count: 44123,
    is_retweet: false,
    id_str: "847895524632129536"
  },
  {
    source: "Twitter Ads",
    text:
      "It is an exciting time for our country!\n#WeeklyAddress #ConfirmGorsuch https://t.co/tP4bkvTOBq",
    created_at: "Fri Mar 31 18:30:38 +0000 2017",
    retweet_count: 13694,
    favorite_count: 58319,
    is_retweet: false,
    id_str: "847878820220858369"
  },
  {
    source: "Twitter for iPhone",
    text: "#ConfirmGorsuch #SCOTUS https://t.co/WkqHYMcYa3",
    created_at: "Fri Mar 31 17:45:10 +0000 2017",
    retweet_count: 10927,
    favorite_count: 48064,
    is_retweet: false,
    id_str: "847867380562894848"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great meeting with a wonderful woman today, former Secretary of State, Condoleezza Rice! #USA🇺🇸 https://t.co/ZuriIC3YwG",
    created_at: "Fri Mar 31 17:28:44 +0000 2017",
    retweet_count: 10435,
    favorite_count: 57145,
    is_retweet: false,
    id_str: "847863243200753666"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was an honor to welcome the Prime Minister of Denmark, Lars Løkke Rasmussen {@larsloekke} to the @WhiteHouse yes… https://t.co/N1g0TiVnSp",
    created_at: "Fri Mar 31 14:35:47 +0000 2017",
    retweet_count: 6903,
    favorite_count: 40720,
    is_retweet: false,
    id_str: "847819720418111488"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Mike Flynn should ask for immunity in that this is a witch hunt (excuse for big election loss), by media &amp; Dems, of historic proportion!",
    created_at: "Fri Mar 31 11:04:32 +0000 2017",
    retweet_count: 17963,
    favorite_count: 74530,
    is_retweet: false,
    id_str: "847766558520856578"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Only by enlisting the full potential of women in our society will we be truly able to #MakeAmericaGreatAgain🇺🇸… https://t.co/cxhgYaxiek",
    created_at: "Fri Mar 31 01:43:35 +0000 2017",
    retweet_count: 13485,
    favorite_count: 59387,
    is_retweet: false,
    id_str: "847625389908217856"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...and job losses. American companies must be prepared to look at other alternatives.",
    created_at: "Thu Mar 30 22:16:50 +0000 2017",
    retweet_count: 7587,
    favorite_count: 42307,
    is_retweet: false,
    id_str: "847573358912974849"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The meeting next week with China will be a very difficult one in that we can no longer have massive trade deficits...",
    created_at: "Thu Mar 30 22:16:17 +0000 2017",
    retweet_count: 12126,
    favorite_count: 58102,
    is_retweet: false,
    id_str: "847573220417044480"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Where are @RepMarkMeadows, @Jim_Jordan and @Raul_Labrador?\n#RepealANDReplace #Obamacare",
    created_at: "Thu Mar 30 21:21:50 +0000 2017",
    retweet_count: 5895,
    favorite_count: 30401,
    is_retweet: false,
    id_str: "847559519085379584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If @RepMarkMeadows, @Jim_Jordan and @Raul_Labrador would get on board we would have both great healthcare and massive tax cuts &amp; reform.",
    created_at: "Thu Mar 30 21:20:44 +0000 2017",
    retweet_count: 7722,
    favorite_count: 38242,
    is_retweet: false,
    id_str: "847559239149158401"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If @RepMarkMeadows, @Jim_Jordan and Raul_Labrador would get on board we would have both great healthcare and massive tax cuts &amp; reform.",
    created_at: "Thu Mar 30 21:18:57 +0000 2017",
    retweet_count: 348,
    favorite_count: 1550,
    is_retweet: false,
    id_str: "847558790358728705"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great op-ed from @RepKenBuck. Looks like some in the Freedom Caucus are helping me end #Obamacare. https://t.co/Y2vTnIBTBZ",
    created_at: "Thu Mar 30 21:17:30 +0000 2017",
    retweet_count: 6645,
    favorite_count: 31807,
    is_retweet: false,
    id_str: "847558426557337600"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The failing @nytimes has disgraced the media world. Gotten me wrong for two solid years. Change libel laws? https://t.co/QIqLgvYLLi",
    created_at: "Thu Mar 30 14:27:14 +0000 2017",
    retweet_count: 13280,
    favorite_count: 54377,
    is_retweet: false,
    id_str: "847455180912181249"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Freedom Caucus will hurt the entire Republican agenda if they don't get on the team, &amp; fast. We must fight them, &amp; Dems, in 2018!",
    created_at: "Thu Mar 30 13:07:42 +0000 2017",
    retweet_count: 13845,
    favorite_count: 60193,
    is_retweet: false,
    id_str: "847435163143454723"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today we honored our true American heroes on the first-ever National Vietnam War Veterans Day.\n#ThankAVeteran… https://t.co/deOHapcV4J",
    created_at: "Thu Mar 30 02:12:09 +0000 2017",
    retweet_count: 16788,
    favorite_count: 73882,
    is_retweet: false,
    id_str: "847270189171228672"
  },
  {
    source: "Media Studio",
    text:
      ".@FLOTUS Melania and I were honored to stop by the Women's Empowerment  Panel this afternoon at the @WhiteHouse.… https://t.co/phLPw8lgTu",
    created_at: "Wed Mar 29 23:58:11 +0000 2017",
    retweet_count: 10386,
    favorite_count: 54285,
    is_retweet: false,
    id_str: "847236476815511552"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today's EO established a commission on combating drug addiction and the opioid crisis. Watch listening session➡️… https://t.co/ooF2ediqSt",
    created_at: "Wed Mar 29 21:39:01 +0000 2017",
    retweet_count: 8686,
    favorite_count: 40545,
    is_retweet: false,
    id_str: "847201455165624320"
  },
  {
    source: "Twitter for iPhone",
    text:
      "If the people of our great country could only see how viciously and inaccurately my administration is covered by certain media!",
    created_at: "Wed Mar 29 12:21:02 +0000 2017",
    retweet_count: 20281,
    favorite_count: 98068,
    is_retweet: false,
    id_str: "847061031293779969"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Remember when the failing @nytimes apologized to its subscribers, right after the election, because their coverage was so wrong. Now worse!",
    created_at: "Wed Mar 29 12:01:52 +0000 2017",
    retweet_count: 15624,
    favorite_count: 74900,
    is_retweet: false,
    id_str: "847056211006631936"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Why doesn't Fake News talk about Podesta ties to Russia as covered by @FoxNews or money from Russia to Clinton - sale of  Uranium?",
    created_at: "Tue Mar 28 22:41:09 +0000 2017",
    retweet_count: 25726,
    favorite_count: 86933,
    is_retweet: false,
    id_str: "846854703183020032"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A NEW ERA IN AMERICAN ENERGY! \n#MadeInTheUSA🇺🇸\nWatch here: https://t.co/EG02Fdlkba https://t.co/XT12jqoIqj",
    created_at: "Tue Mar 28 21:48:40 +0000 2017",
    retweet_count: 9616,
    favorite_count: 45784,
    is_retweet: false,
    id_str: "846841493952319489"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was an honor to welcome @GLFOP to the @WhiteHouse today with @VP Pence &amp; Attorney General Sessions. THANK YOU fo… https://t.co/VHzTB4c69h",
    created_at: "Tue Mar 28 20:57:17 +0000 2017",
    retweet_count: 7082,
    favorite_count: 39199,
    is_retweet: false,
    id_str: "846828561491202048"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The failing @NYTimes would do much better if they were honest! \nhttps://t.co/ATy8R3knS2",
    created_at: "Tue Mar 28 15:26:23 +0000 2017",
    retweet_count: 13142,
    favorite_count: 56580,
    is_retweet: false,
    id_str: "846745288735887360"
  },
  {
    source: "Twitter for iPhone",
    text: "Watch @foxandfriends now on Podesta and Russia!",
    created_at: "Tue Mar 28 11:16:44 +0000 2017",
    retweet_count: 9248,
    favorite_count: 47086,
    is_retweet: false,
    id_str: "846682464215076866"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Big announcement by Ford today. Major investment to be made in three Michigan plants. Car companies coming back to U.S.  JOBS! JOBS! JOBS!",
    created_at: "Tue Mar 28 10:36:02 +0000 2017",
    retweet_count: 23340,
    favorite_count: 109338,
    is_retweet: false,
    id_str: "846672219073863681"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats will make a deal with me on healthcare as soon as ObamaCare folds - not long. Do not worry, we are in very  good shape!",
    created_at: "Tue Mar 28 02:03:17 +0000 2017",
    retweet_count: 16103,
    favorite_count: 80864,
    is_retweet: false,
    id_str: "846543183223963649"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Republican House Freedom Caucus was able to snatch defeat from the jaws of victory. After so many bad years they were ready for a win!",
    created_at: "Tue Mar 28 01:41:15 +0000 2017",
    retweet_count: 9632,
    favorite_count: 52179,
    is_retweet: false,
    id_str: "846537639167713281"
  },
  {
    source: "Twitter for iPhone",
    text:
      '...money to Bill, the Hillary Russian "reset," praise of Russia by Hillary, or Podesta Russian Company. Trump Russia story is a hoax. #MAGA!',
    created_at: "Tue Mar 28 01:35:35 +0000 2017",
    retweet_count: 19170,
    favorite_count: 69350,
    is_retweet: false,
    id_str: "846536212362018816"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Why isn't the House Intelligence Committee looking into the Bill &amp; Hillary deal that allowed big Uranium to go to Russia, Russian speech....",
    created_at: "Tue Mar 28 01:26:04 +0000 2017",
    retweet_count: 26423,
    favorite_count: 89095,
    is_retweet: false,
    id_str: "846533818811080704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "General Kelly is doing a great job at the border. Numbers are way down. Many are not even trying to come in anymore.",
    created_at: "Mon Mar 27 01:04:42 +0000 2017",
    retweet_count: 21319,
    favorite_count: 108475,
    is_retweet: false,
    id_str: "846166053663191040"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Democrats are smiling in D.C. that the Freedom Caucus, with the help of Club For Growth and Heritage, have saved Planned Parenthood &amp; Ocare!",
    created_at: "Sun Mar 26 12:21:58 +0000 2017",
    retweet_count: 15590,
    favorite_count: 64422,
    is_retweet: false,
    id_str: "845974102619906048"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thanks you for all of the Trump Rallies today. Amazing support. We will all MAKE AMERICA GREAT AGAIN!",
    created_at: "Sat Mar 25 22:37:02 +0000 2017",
    retweet_count: 21430,
    favorite_count: 117494,
    is_retweet: false,
    id_str: "845766504608120833"
  },
  {
    source: "Twitter for Android",
    text: "Watch @JudgeJeanine on @FoxNews tonight at 9:00 P.M.",
    created_at: "Sat Mar 25 14:41:14 +0000 2017",
    retweet_count: 10116,
    favorite_count: 51247,
    is_retweet: false,
    id_str: "845646761704243200"
  },
  {
    source: "Twitter for Android",
    text:
      "ObamaCare will explode and we will all get together and piece together a great healthcare plan for THE PEOPLE. Do not worry!",
    created_at: "Sat Mar 25 14:37:52 +0000 2017",
    retweet_count: 22518,
    favorite_count: 104321,
    is_retweet: false,
    id_str: "845645916732358656"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Happy #MedalOfHonorDay to our heroes! ➡️https://t.co/juAB1RmMh0 https://t.co/Sw5ea1OwUf",
    created_at: "Sat Mar 25 13:29:17 +0000 2017",
    retweet_count: 14139,
    favorite_count: 68302,
    is_retweet: false,
    id_str: "845628655493677056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today, I was thrilled to announce a commitment of $25 BILLION &amp; 20K AMERICAN JOBS over the next 4 years. THANK YOU… https://t.co/nWJ1hNmzoR",
    created_at: "Fri Mar 24 17:59:42 +0000 2017",
    retweet_count: 20212,
    favorite_count: 89339,
    is_retweet: false,
    id_str: "845334323045765121"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today, I was pleased to announce the official approval of the presidential permit for the #KeystonePipeline. A grea… https://t.co/GWNo2XAueg",
    created_at: "Fri Mar 24 17:03:46 +0000 2017",
    retweet_count: 12933,
    favorite_count: 66692,
    is_retweet: false,
    id_str: "845320243614547968"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The irony is that the Freedom Caucus, which is very pro-life and against Planned Parenthood, allows P.P. to continue if they stop this plan!",
    created_at: "Fri Mar 24 12:23:00 +0000 2017",
    retweet_count: 13364,
    favorite_count: 61991,
    is_retweet: false,
    id_str: "845249587178819584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "After seven horrible years of ObamaCare (skyrocketing premiums &amp; deductibles, bad healthcare), this is finally your chance for a great plan!",
    created_at: "Fri Mar 24 12:14:32 +0000 2017",
    retweet_count: 12566,
    favorite_count: 68241,
    is_retweet: false,
    id_str: "845247455868391425"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It was an honor to welcome so many truckers and trucking industry leaders to the @WhiteHouse today! https://t.co/M1veooVBNE",
    created_at: "Thu Mar 23 22:19:43 +0000 2017",
    retweet_count: 16516,
    favorite_count: 77882,
    is_retweet: false,
    id_str: "845037368386207746"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We are taking action to #RepealANDReplace #Obamacare! Contact your Rep &amp; tell them you support #AHCA. #PassTheBill… https://t.co/5lsrDJXfzb",
    created_at: "Thu Mar 23 16:07:55 +0000 2017",
    retweet_count: 9250,
    favorite_count: 41226,
    is_retweet: false,
    id_str: "844943801848414209"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A great American, Kurt Cochran, was killed in the London terror attack. My prayers and condolences are with his family and friends.",
    created_at: "Thu Mar 23 15:16:24 +0000 2017",
    retweet_count: 23258,
    favorite_count: 117021,
    is_retweet: false,
    id_str: "844930836663357440"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just watched the totally biased and fake news reports of the so-called Russia story on NBC and ABC. Such dishonesty!",
    created_at: "Thu Mar 23 12:18:33 +0000 2017",
    retweet_count: 21324,
    favorite_count: 94648,
    is_retweet: false,
    id_str: "844886082663698436"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Spoke to U.K. Prime Minister Theresa May today to offer condolences on the terrorist attack in London. She is strong and doing very well.",
    created_at: "Thu Mar 23 01:33:54 +0000 2017",
    retweet_count: 19750,
    favorite_count: 117705,
    is_retweet: false,
    id_str: "844723847094026242"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @mitchellvii: Trump always ends up being right.  It's almost a little freaky.",
    created_at: "Thu Mar 23 01:04:32 +0000 2017",
    retweet_count: 18742,
    favorite_count: 0,
    is_retweet: true,
    id_str: "844716458844311553"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @mitchellvii: EXACTLY AS I SAID - House Intel Chair: We Cannot Rule Out Sr. Obama Officials Were Involved in Trump Surveillance https://…",
    created_at: "Thu Mar 23 01:03:18 +0000 2017",
    retweet_count: 13778,
    favorite_count: 0,
    is_retweet: true,
    id_str: "844716149828993025"
  },
  {
    source: "Twitter for iPhone",
    text: "Big day for healthcare. Working hard!",
    created_at: "Wed Mar 22 13:09:35 +0000 2017",
    retweet_count: 13100,
    favorite_count: 89890,
    is_retweet: false,
    id_str: "844536536930619393"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today on #NationalAgDay, we honor our great American farmers &amp; ranchers. Their hard work &amp; dedication are ingrained… https://t.co/IpGRhly2zj",
    created_at: "Tue Mar 21 18:12:05 +0000 2017",
    retweet_count: 14861,
    favorite_count: 67189,
    is_retweet: false,
    id_str: "844250273740738562"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Honored to sign S.442 today. With this legislation, we support @NASA's scientists, engineers, and astronauts in the… https://t.co/Z5VwluvJQx",
    created_at: "Tue Mar 21 17:33:23 +0000 2017",
    retweet_count: 14933,
    favorite_count: 66831,
    is_retweet: false,
    id_str: "844240534562594817"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Joined the @HouseGOP Conference this morning at the U.S. Capitol. https://t.co/03e4YBIWr0 #PassTheBill #MAGA🇺🇸… https://t.co/3swdFWGQtP",
    created_at: "Tue Mar 21 17:02:31 +0000 2017",
    retweet_count: 6104,
    favorite_count: 36015,
    is_retweet: false,
    id_str: "844232766711648256"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you Louisville, Kentucky. Together, we will MAKE AMERICA SAFE AND GREAT AGAIN! https://t.co/qGgWEWUvek",
    created_at: "Tue Mar 21 02:18:20 +0000 2017",
    retweet_count: 14694,
    favorite_count: 76178,
    is_retweet: false,
    id_str: "844010257454153729"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you Louisville, Kentucky- on my way! #MAGA🇺🇸 https://t.co/3QsBsib6kt",
    created_at: "Mon Mar 20 23:03:36 +0000 2017",
    retweet_count: 11182,
    favorite_count: 61295,
    is_retweet: false,
    id_str: "843961248811225089"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations Eric &amp; Lara. Very proud and happy for the two of you! https://t.co/s0T3cTQc40",
    created_at: "Mon Mar 20 17:15:18 +0000 2017",
    retweet_count: 13712,
    favorite_count: 101328,
    is_retweet: false,
    id_str: "843873596963459072"
  },
  {
    source: "Twitter for iPhone",
    text:
      "What about all of the contact with the Clinton campaign and the Russians? Also, is it true that the DNC would not let the FBI in to look?",
    created_at: "Mon Mar 20 13:14:49 +0000 2017",
    retweet_count: 21762,
    favorite_count: 82212,
    is_retweet: false,
    id_str: "843813078076719107"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Just heard Fake News CNN is doing polls again despite the fact that their election polls were a WAY OFF disaster. Much higher ratings at Fox",
    created_at: "Mon Mar 20 12:35:14 +0000 2017",
    retweet_count: 18554,
    favorite_count: 90586,
    is_retweet: false,
    id_str: "843803115044454402"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The real story that Congress, the FBI and all others should be looking into is the leaking of Classified information. Must find leaker now!",
    created_at: "Mon Mar 20 11:02:57 +0000 2017",
    retweet_count: 16524,
    favorite_count: 64829,
    is_retweet: false,
    id_str: "843779892776964097"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The Democrats made up and pushed the Russian story as an excuse for running a terrible campaign. Big advantage in Electoral College &amp; lost!",
    created_at: "Mon Mar 20 10:49:48 +0000 2017",
    retweet_count: 20285,
    favorite_count: 88161,
    is_retweet: false,
    id_str: "843776582825267201"
  },
  {
    source: "Twitter for iPhone",
    text:
      "James Clapper and others stated that there is no evidence Potus colluded with Russia. This story is FAKE NEWS and everyone knows it!",
    created_at: "Mon Mar 20 10:35:28 +0000 2017",
    retweet_count: 17306,
    favorite_count: 71349,
    is_retweet: false,
    id_str: "843772976151642112"
  },
  {
    source: "Twitter for iPhone",
    text:
      "#ICYMI: Weekly Address \n➡️https://t.co/ckVx2zgA1x https://t.co/dTGZLvlsGv",
    created_at: "Sun Mar 19 20:20:22 +0000 2017",
    retweet_count: 7472,
    favorite_count: 36626,
    is_retweet: false,
    id_str: "843557782666317826"
  },
  {
    source: "Twitter for iPhone",
    text:
      "...vast sums of money to NATO &amp; the United States must be paid more for the powerful, and very expensive, defense it provides to Germany!",
    created_at: "Sat Mar 18 13:23:37 +0000 2017",
    retweet_count: 19439,
    favorite_count: 86753,
    is_retweet: false,
    id_str: "843090516283723776"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Despite what you have heard from the FAKE NEWS, I had a GREAT meeting with German Chancellor Angela Merkel. Nevertheless, Germany owes.....",
    created_at: "Sat Mar 18 13:15:41 +0000 2017",
    retweet_count: 21088,
    favorite_count: 95449,
    is_retweet: false,
    id_str: "843088518339612673"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great meeting with the @RepublicanStudy Committee this morning at the @WhiteHouse! https://t.co/8Y2UoHoYaY",
    created_at: "Fri Mar 17 15:39:10 +0000 2017",
    retweet_count: 8244,
    favorite_count: 46668,
    is_retweet: false,
    id_str: "842762240184999936"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"The President Changed. So Has Small Businesses\' Confidence"\nhttps://t.co/daTGjPmYeJ',
    created_at: "Fri Mar 17 14:07:26 +0000 2017",
    retweet_count: 11473,
    favorite_count: 51602,
    is_retweet: false,
    id_str: "842739155230740481"
  },
  {
    source: "Twitter for iPhone",
    text:
      'North Korea is behaving very badly. They have been "playing" the United States for years. China has done little to help!',
    created_at: "Fri Mar 17 13:07:15 +0000 2017",
    retweet_count: 20995,
    favorite_count: 89407,
    is_retweet: false,
    id_str: "842724011234791424"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: FOX NEWS ALERT: Jihadis using religious visa to enter US, experts warn (via @FoxFriendsFirst) https://t.co/pwXeR9OMQC",
    created_at: "Fri Mar 17 12:34:17 +0000 2017",
    retweet_count: 11472,
    favorite_count: 0,
    is_retweet: true,
    id_str: "842715710765830147"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: VIDEO: Rep. Scalise — GOP agrees on over 85 percent of health care bill https://t.co/05dtfjAUbx",
    created_at: "Fri Mar 17 12:30:25 +0000 2017",
    retweet_count: 3436,
    favorite_count: 0,
    is_retweet: true,
    id_str: "842714739365105664"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @AmericaFirstPol: MAJOR IMPACT: @POTUS Trump is 50 Days in and moving swiftly to get America back on the right track. #MAGA \nhttps://t.c…",
    created_at: "Fri Mar 17 12:26:12 +0000 2017",
    retweet_count: 6006,
    favorite_count: 0,
    is_retweet: true,
    id_str: "842713677174358016"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @FoxNews: Jobs created in February. https://t.co/sOaMDxxTA8",
    created_at: "Fri Mar 17 12:20:22 +0000 2017",
    retweet_count: 7649,
    favorite_count: 0,
    is_retweet: true,
    id_str: "842712210896052225"
  },
  {
    source: "Twitter for iPhone",
    text: "Happy Lá Fheile Phadraig to all of my great Irish friends!",
    created_at: "Fri Mar 17 12:12:04 +0000 2017",
    retweet_count: 12118,
    favorite_count: 68486,
    is_retweet: false,
    id_str: "842710123852320770"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @DiamondandSilk: When the President says "You\'re Fired"     That means: "Pack Yo Stuff and Go, Not Say "You Refuse to Go!  #DrainTheSwam…',
    created_at: "Fri Mar 17 09:35:58 +0000 2017",
    retweet_count: 10854,
    favorite_count: 0,
    is_retweet: true,
    id_str: "842670836905639936"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My representatives had a great meeting w/ the Hispanic Chamber of Commerce at the WH today. Look forward to tremendous growth &amp; future mtgs!",
    created_at: "Thu Mar 16 22:43:32 +0000 2017",
    retweet_count: 10595,
    favorite_count: 64627,
    is_retweet: false,
    id_str: "842506649122279425"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great progress on healthcare. Improvements being made - Republicans coming together!",
    created_at: "Thu Mar 16 21:54:02 +0000 2017",
    retweet_count: 11256,
    favorite_count: 70239,
    is_retweet: false,
    id_str: "842494190990901248"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @USHCC: USHCC was delighted to host @IvankaTrump for a roundtable discussion w/ Hispanic women biz owners today in Washington #USHCCLegi…",
    created_at: "Thu Mar 16 21:43:07 +0000 2017",
    retweet_count: 7391,
    favorite_count: 0,
    is_retweet: true,
    id_str: "842491443675611138"
  },
  {
    source: "Twitter for iPhone",
    text:
      "An honor to welcome the Taoiseach of Ireland, @EndaKennyTD to the @WhiteHouse today with @VP Pence. 🇺🇸🇮🇪 https://t.co/J3iTl2iSiQ",
    created_at: "Thu Mar 16 20:09:38 +0000 2017",
    retweet_count: 10786,
    favorite_count: 53018,
    is_retweet: false,
    id_str: "842467917639913472"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A budget that puts #AmericaFirst must make safety its no. 1 priority—without safety there can be no prosperity: https://t.co/9lxx1iQo7m",
    created_at: "Thu Mar 16 15:52:22 +0000 2017",
    retweet_count: 14546,
    favorite_count: 68627,
    is_retweet: false,
    id_str: "842403173742579714"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you Nashville, Tennessee! https://t.co/6snvQ0DzXN",
    created_at: "Thu Mar 16 04:20:41 +0000 2017",
    retweet_count: 15166,
    favorite_count: 80319,
    is_retweet: false,
    id_str: "842229104434913280"
  },
  {
    source: "Twitter for iPhone",
    text:
      "In Nashville, Tennessee! Lets MAKE AMERICA GREAT AGAIN! https://t.co/m5UR4vv6UH",
    created_at: "Thu Mar 16 00:03:23 +0000 2017",
    retweet_count: 16683,
    favorite_count: 86434,
    is_retweet: false,
    id_str: "842164356297175040"
  },
  {
    source: "Twitter for iPhone",
    text: "Thank you Andrew Jackson! #POTUS7 #USA🇺🇸 https://t.co/GToWsWXiNv",
    created_at: "Wed Mar 15 23:25:25 +0000 2017",
    retweet_count: 13334,
    favorite_count: 66816,
    is_retweet: false,
    id_str: "842154802058543105"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be interviewed by @TuckerCarlson tonight at 9:00 P.M. on @FoxNews. Enjoy!",
    created_at: "Wed Mar 15 20:55:52 +0000 2017",
    retweet_count: 9500,
    favorite_count: 59957,
    is_retweet: false,
    id_str: "842117164144431104"
  },
  {
    source: "Twitter for iPhone",
    text:
      "CEO's most optimistic since 2009. It will only get better as we continue to slash unnecessary regulations and when we begin our big tax cut!",
    created_at: "Wed Mar 15 12:14:20 +0000 2017",
    retweet_count: 14336,
    favorite_count: 80595,
    is_retweet: false,
    id_str: "841985915778142209"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Looking forward to a big rally in Nashville, Tennessee, tonight. Big crowd of great people expected. Will be fun!",
    created_at: "Wed Mar 15 11:29:05 +0000 2017",
    retweet_count: 14352,
    favorite_count: 84918,
    is_retweet: false,
    id_str: "841974528683192320"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Will be going to Detroit, Michigan (love), today for a big meeting on bringing back car production to State &amp; U.S. Already happening!",
    created_at: "Wed Mar 15 11:13:58 +0000 2017",
    retweet_count: 14913,
    favorite_count: 89398,
    is_retweet: false,
    id_str: "841970726341074945"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Can you imagine what the outcry would be if @SnoopDogg, failing career and all, had aimed and fired the gun at President Obama? Jail time!",
    created_at: "Wed Mar 15 11:02:40 +0000 2017",
    retweet_count: 40630,
    favorite_count: 127012,
    is_retweet: false,
    id_str: "841967881516679168"
  },
  {
    source: "Twitter for iPhone",
    text:
      'Does anybody really believe that a reporter, who nobody ever heard of, "went to his mailbox" and found my tax returns? @NBCNews  FAKE NEWS!',
    created_at: "Wed Mar 15 10:55:30 +0000 2017",
    retweet_count: 25824,
    favorite_count: 102694,
    is_retweet: false,
    id_str: "841966077005463553"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great optimism in America – and the results will be even better! https://t.co/SYBl47CsZn",
    created_at: "Tue Mar 14 16:12:22 +0000 2017",
    retweet_count: 12406,
    favorite_count: 62952,
    is_retweet: false,
    id_str: "841683431398469632"
  },
  {
    source: "Twitter for iPhone",
    text: "JOBS, JOBS, JOBS! https://t.co/wAkQMKdPXA",
    created_at: "Tue Mar 14 15:00:25 +0000 2017",
    retweet_count: 24676,
    favorite_count: 99054,
    is_retweet: false,
    id_str: "841665325682827265"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Meeting w/ Washington, D.C. @MayorBowser and Metro GM Paul Wiedefeld about incoming winter storm preparations here… https://t.co/mg0A4Hq3bD",
    created_at: "Mon Mar 13 22:54:16 +0000 2017",
    retweet_count: 8053,
    favorite_count: 48515,
    is_retweet: false,
    id_str: "841422186573369345"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Proud to welcome our great Cabinet this afternoon for our first meeting. Unfortunately 4 seats were empty because S… https://t.co/bMYph832hF",
    created_at: "Mon Mar 13 20:57:02 +0000 2017",
    retweet_count: 15791,
    favorite_count: 71930,
    is_retweet: false,
    id_str: "841392683625172992"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Healthcare listening session w/ @VP &amp; @SecPriceMD. Watch: https://t.co/5ayQ4dr8Ip #ReadTheBill:… https://t.co/1cQI0ZBUv8",
    created_at: "Mon Mar 13 17:20:15 +0000 2017",
    retweet_count: 6846,
    favorite_count: 39015,
    is_retweet: false,
    id_str: "841338126316511233"
  },
  {
    source: "Twitter for iPhone",
    text:
      "ObamaCare is imploding. It is a disaster and 2017 will be the worst year yet, by far! Republicans will come together and save the day.",
    created_at: "Mon Mar 13 13:11:17 +0000 2017",
    retweet_count: 10454,
    favorite_count: 58300,
    is_retweet: false,
    id_str: "841275470796738560"
  },
  {
    source: "Twitter for iPhone",
    text:
      "It is amazing how rude much of the media is to my very hard working representatives. Be nice, you will do much better!",
    created_at: "Mon Mar 13 12:52:29 +0000 2017",
    retweet_count: 19556,
    favorite_count: 100557,
    is_retweet: false,
    id_str: "841270741060464648"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @AmericaFirstPol: .@POTUS Trump led a historic journey to the White House. 50 days in, that historic journey continues. Take a look 👉 ht…",
    created_at: "Sun Mar 12 12:36:59 +0000 2017",
    retweet_count: 6868,
    favorite_count: 0,
    is_retweet: true,
    id_str: "840904454836781056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We are making great progress with healthcare. ObamaCare is imploding and will only get worse. Republicans coming together to get job done!",
    created_at: "Sat Mar 11 14:39:07 +0000 2017",
    retweet_count: 16563,
    favorite_count: 103623,
    is_retweet: false,
    id_str: "840572799202783233"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Weekly Address - 11:00 A.M. at the @WhiteHouse! #MAGA🇺🇸\n➡️https://t.co/YSaPJnSX2i https://t.co/Gb8iTGzb6j",
    created_at: "Fri Mar 10 15:40:53 +0000 2017",
    retweet_count: 8650,
    favorite_count: 42988,
    is_retweet: false,
    id_str: "840225958854561792"
  },
  {
    source: "Twitter for iPhone",
    text: "RT @DRUDGE_REPORT: GREAT AGAIN:  +235,000 https://t.co/GkockGNdtC",
    created_at: "Fri Mar 10 13:45:02 +0000 2017",
    retweet_count: 7724,
    favorite_count: 0,
    is_retweet: true,
    id_str: "840196801009451009"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxandfriends: \"Never give up....that's the worst thing you could do. There's always a chance.\" -Kyle Coddington's message to those als…",
    created_at: "Fri Mar 10 13:32:05 +0000 2017",
    retweet_count: 9419,
    favorite_count: 0,
    is_retweet: true,
    id_str: "840193545046773760"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Honored to meet this years @SenateYouth delegates w/ @VP Pence in the East Room of the @WhiteHouse. Congratulations… https://t.co/oQIx7LybCV",
    created_at: "Thu Mar 09 23:11:27 +0000 2017",
    retweet_count: 10506,
    favorite_count: 56480,
    is_retweet: false,
    id_str: "839976956703748096"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'U.S. Consumer Comfort Just Reached Its Highest Level in a Decade' ➡️https://t.co/S8nZgmeMMV https://t.co/xC0piRa6eP",
    created_at: "Thu Mar 09 22:36:27 +0000 2017",
    retweet_count: 16144,
    favorite_count: 67344,
    is_retweet: false,
    id_str: "839968149890076672"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Despite what you hear in the press, healthcare is coming along great. We are talking to many groups and it will end in a beautiful picture!",
    created_at: "Thu Mar 09 17:01:17 +0000 2017",
    retweet_count: 21021,
    favorite_count: 111369,
    is_retweet: false,
    id_str: "839883804315684864"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @foxnation: .@realDonaldTrump's First Full Month in Office Sees Biggest Jobs Gain 'In Years': Report: https://t.co/rx4bgI1MWK",
    created_at: "Thu Mar 09 13:13:54 +0000 2017",
    retweet_count: 12324,
    favorite_count: 0,
    is_retweet: true,
    id_str: "839826581354921984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great news. We are only just beginning. Together, we are going to #MAGA! https://t.co/BSp685Q9Qf https://t.co/K7yeBZsf6r",
    created_at: "Wed Mar 08 23:54:16 +0000 2017",
    retweet_count: 21965,
    favorite_count: 89867,
    is_retweet: false,
    id_str: "839625347524096000"
  },
  {
    source: "Twitter for iPhone",
    text: "Met with @RepCummings today at the @WhiteHouse. Great discussion!",
    created_at: "Wed Mar 08 23:50:25 +0000 2017",
    retweet_count: 7824,
    favorite_count: 54222,
    is_retweet: false,
    id_str: "839624377826230272"
  },
  {
    source: "Twitter for Android",
    text:
      "LinkedIn Workforce Report: January and February were the strongest consecutive months for hiring since August and September 2015",
    created_at: "Wed Mar 08 12:11:25 +0000 2017",
    retweet_count: 15769,
    favorite_count: 84906,
    is_retweet: false,
    id_str: "839448469374894080"
  },
  {
    source: "Twitter for iPhone",
    text:
      "On International Women's Day, join me in honoring the critical role of women here in America &amp; around the world.",
    created_at: "Wed Mar 08 11:13:44 +0000 2017",
    retweet_count: 21689,
    favorite_count: 115070,
    is_retweet: false,
    id_str: "839433951957696513"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I have tremendous respect for women and the many roles they serve that are vital to the fabric of our society and our economy.",
    created_at: "Wed Mar 08 11:12:39 +0000 2017",
    retweet_count: 23139,
    favorite_count: 120999,
    is_retweet: false,
    id_str: "839433678275153921"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I feel sure that my friend @RandPaul will come along with the new and great health care program because he knows Obamacare is a disaster!",
    created_at: "Wed Mar 08 00:14:30 +0000 2017",
    retweet_count: 15496,
    favorite_count: 81422,
    is_retweet: false,
    id_str: "839268048313929729"
  },
  {
    source: "Twitter for Android",
    text:
      "Don't let the FAKE NEWS tell you that there is big infighting in the Trump Admin. We are getting along great, and getting major things done!",
    created_at: "Tue Mar 07 14:14:03 +0000 2017",
    retweet_count: 25982,
    favorite_count: 121937,
    is_retweet: false,
    id_str: "839116941956640768"
  },
  {
    source: "Twitter for Android",
    text:
      "I am working on a new system where there will be competition in the Drug Industry. Pricing for the American people will come way down!",
    created_at: "Tue Mar 07 13:46:28 +0000 2017",
    retweet_count: 23777,
    favorite_count: 124413,
    is_retweet: false,
    id_str: "839110000870109184"
  },
  {
    source: "Twitter for Android",
    text:
      "Don't worry, getting rid of state lines, which will promote competition, will be in phase 2 &amp; 3 of healthcare rollout. @foxandfriends",
    created_at: "Tue Mar 07 13:41:58 +0000 2017",
    retweet_count: 16405,
    favorite_count: 82197,
    is_retweet: false,
    id_str: "839108868584124417"
  },
  {
    source: "Twitter for Android",
    text:
      'For eight years Russia "ran over" President Obama, got stronger and stronger, picked-off Crimea and added missiles. Weak! @foxandfriends',
    created_at: "Tue Mar 07 13:13:20 +0000 2017",
    retweet_count: 17573,
    favorite_count: 78880,
    is_retweet: false,
    id_str: "839101660886614016"
  },
  {
    source: "Twitter for Android",
    text:
      "Our wonderful new Healthcare Bill is now out for review and negotiation. ObamaCare is a complete and total disaster - is imploding fast!",
    created_at: "Tue Mar 07 12:13:59 +0000 2017",
    retweet_count: 15068,
    favorite_count: 81473,
    is_retweet: false,
    id_str: "839086723552411648"
  },
  {
    source: "Twitter for Android",
    text:
      "122 vicious prisoners, released by the Obama Administration from Gitmo, have returned to the battlefield. Just another terrible decision!",
    created_at: "Tue Mar 07 12:04:13 +0000 2017",
    retweet_count: 22911,
    favorite_count: 92823,
    is_retweet: false,
    id_str: "839084268991229952"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to @exxonmobil for your $20 billion investment that is creating more than 45,000 manufacturing &amp; construction jobs in the USA!",
    created_at: "Tue Mar 07 03:50:49 +0000 2017",
    retweet_count: 19379,
    favorite_count: 99441,
    is_retweet: false,
    id_str: "838960097674002432"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Buy American &amp; hire American are the principles at the core of my agenda, which is: JOBS, JOBS, JOBS! Thank you @exxonmobil.",
    created_at: "Tue Mar 07 03:49:54 +0000 2017",
    retweet_count: 16192,
    favorite_count: 87209,
    is_retweet: false,
    id_str: "838959869772328960"
  },
  {
    source: "Twitter for iPhone",
    text:
      "There is an incredible spirit of optimism sweeping the country right now—we're bringing back the JOBS! https://t.co/BNSLvKiEVj",
    created_at: "Mon Mar 06 23:49:53 +0000 2017",
    retweet_count: 25176,
    favorite_count: 108591,
    is_retweet: false,
    id_str: "838899465390018560"
  },
  {
    source: "Twitter for iPhone",
    text:
      "45,000 construction &amp; manufacturing jobs in the U.S. Gulf Coast region. $20 billion investment. We are already winning again, America!",
    created_at: "Mon Mar 06 21:22:15 +0000 2017",
    retweet_count: 24663,
    favorite_count: 116785,
    is_retweet: false,
    id_str: "838862312685637640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Buy American &amp; hire American are the principals at the core of my agenda, which is: JOBS, JOBS, JOBS! Thank you @exxonmobil.",
    created_at: "Mon Mar 06 21:21:32 +0000 2017",
    retweet_count: 13723,
    favorite_count: 65634,
    is_retweet: false,
    id_str: "838862131852369922"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'President Trump Congratulates Exxon Mobil for Job-Creating Investment Program'\nhttps://t.co/adBzWhtq8S",
    created_at: "Mon Mar 06 21:19:04 +0000 2017",
    retweet_count: 12846,
    favorite_count: 70675,
    is_retweet: false,
    id_str: "838861512999649286"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you for the great rallies all across the country. Tremendous support. Make America Great Again!",
    created_at: "Sun Mar 05 17:30:11 +0000 2017",
    retweet_count: 30764,
    favorite_count: 172217,
    is_retweet: false,
    id_str: "838441522546769923"
  },
  {
    source: "Twitter for Android",
    text:
      'Who was it that secretly said to Russian President, "Tell Vladimir that after the election I\'ll have more flexibility?" @foxandfriends',
    created_at: "Sun Mar 05 11:40:20 +0000 2017",
    retweet_count: 37134,
    favorite_count: 126453,
    is_retweet: false,
    id_str: "838353481526312961"
  },
  {
    source: "Twitter for Android",
    text:
      "Is it true the DNC would not allow the FBI access to check server or other equipment after learning it was hacked? Can that be possible?",
    created_at: "Sun Mar 05 11:32:22 +0000 2017",
    retweet_count: 24515,
    favorite_count: 96318,
    is_retweet: false,
    id_str: "838351476401520640"
  },
  {
    source: "Twitter for Android",
    text:
      "Arnold Schwarzenegger isn't voluntarily leaving the Apprentice, he was fired by his bad (pathetic) ratings, not by me. Sad end to great show",
    created_at: "Sat Mar 04 13:19:29 +0000 2017",
    retweet_count: 23117,
    favorite_count: 106606,
    is_retweet: false,
    id_str: "838016045222854656"
  },
  {
    source: "Twitter for Android",
    text:
      "How low has President Obama gone to tapp my phones during the very sacred election process. This is Nixon/Watergate. Bad (or sick) guy!",
    created_at: "Sat Mar 04 12:02:48 +0000 2017",
    retweet_count: 52836,
    favorite_count: 162336,
    is_retweet: false,
    id_str: "837996746236182529"
  },
  {
    source: "Twitter for Android",
    text:
      "I'd bet a good lawyer could make a great case out of the fact that President Obama was tapping my phones in October, just prior to Election!",
    created_at: "Sat Mar 04 11:52:54 +0000 2017",
    retweet_count: 37162,
    favorite_count: 131657,
    is_retweet: false,
    id_str: "837994257566863360"
  },
  {
    source: "Twitter for Android",
    text:
      'Is it legal for a sitting President to be "wire tapping" a race for president prior to an election? Turned down by court earlier. A NEW LOW!',
    created_at: "Sat Mar 04 11:49:00 +0000 2017",
    retweet_count: 36359,
    favorite_count: 123508,
    is_retweet: false,
    id_str: "837993273679560704"
  },
  {
    source: "Twitter for Android",
    text:
      "Just out: The same Russian Ambassador that met Jeff Sessions visited the Obama White House 22 times, and 4 times last year alone.",
    created_at: "Sat Mar 04 11:42:59 +0000 2017",
    retweet_count: 37452,
    favorite_count: 121080,
    is_retweet: false,
    id_str: "837991759045079040"
  },
  {
    source: "Twitter for Android",
    text:
      'Terrible! Just found out that Obama had my "wires tapped" in Trump Tower just before the victory. Nothing found. This is McCarthyism!',
    created_at: "Sat Mar 04 11:35:20 +0000 2017",
    retweet_count: 50573,
    favorite_count: 143525,
    is_retweet: false,
    id_str: "837989835818287106"
  },
  {
    source: "Twitter for Android",
    text:
      "The first meeting Jeff Sessions had with the Russian Amb was set up by the Obama Administration under education program for 100 Ambs......",
    created_at: "Sat Mar 04 11:26:47 +0000 2017",
    retweet_count: 24412,
    favorite_count: 88057,
    is_retweet: false,
    id_str: "837987684660412416"
  },
  {
    source: "Twitter for iPhone",
    text: "MAKE AMERICA GREAT AGAIN! https://t.co/kuQiZDz4rA",
    created_at: "Fri Mar 03 22:13:10 +0000 2017",
    retweet_count: 36635,
    favorite_count: 122851,
    is_retweet: false,
    id_str: "837787963027144706"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I hereby demand a second investigation, after Schumer, of Pelosi for her close ties to Russia, and lying about it. https://t.co/qCDljfF3wN",
    created_at: "Fri Mar 03 21:02:23 +0000 2017",
    retweet_count: 39957,
    favorite_count: 121937,
    is_retweet: false,
    id_str: "837770149767827456"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I hearby demand a second investigation, after Schumer, of Pelosi for her close ties to Russia, and lying about it. https://t.co/qCDljfF3wN",
    created_at: "Fri Mar 03 20:49:53 +0000 2017",
    retweet_count: 11,
    favorite_count: 4,
    is_retweet: false,
    id_str: "837767004236955649"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We must fix our education system for our kids to Make America Great Again. Wonderful day at Saint Andrew in Orlando. https://t.co/OTJaHcvLzf",
    created_at: "Fri Mar 03 20:48:21 +0000 2017",
    retweet_count: 16510,
    favorite_count: 83126,
    is_retweet: false,
    id_str: "837766616603586560"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I hear by demand a second investigation, after Schumer, of Pelosi for her close ties to Russia, and lying about it. https://t.co/qCDljfF3wN",
    created_at: "Fri Mar 03 20:47:30 +0000 2017",
    retweet_count: 41,
    favorite_count: 93,
    is_retweet: false,
    id_str: "837766402937393155"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We should start an immediate investigation into @SenSchumer and his ties to Russia and Putin. A total hypocrite! https://t.co/Ik3yqjHzsA",
    created_at: "Fri Mar 03 17:54:30 +0000 2017",
    retweet_count: 54593,
    favorite_count: 150081,
    is_retweet: false,
    id_str: "837722869106880517"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Weekly Address\nJoin me here: https://t.co/SEavQK5zy5 https://t.co/EnyXYeqgcp",
    created_at: "Fri Mar 03 16:41:55 +0000 2017",
    retweet_count: 10173,
    favorite_count: 53969,
    is_retweet: false,
    id_str: "837704599704375296"
  },
  {
    source: "Twitter for Android",
    text:
      "It is so pathetic that the Dems have still not approved my full Cabinet.",
    created_at: "Fri Mar 03 12:19:12 +0000 2017",
    retweet_count: 27814,
    favorite_count: 136744,
    is_retweet: false,
    id_str: "837638488656920576"
  },
  {
    source: "Twitter for Android",
    text:
      "Nick Adams new book, Green Card Warrior, is a must read. The merit-based system is the way to go. Canada, Australia! @foxandfriends",
    created_at: "Fri Mar 03 12:00:39 +0000 2017",
    retweet_count: 13812,
    favorite_count: 66624,
    is_retweet: false,
    id_str: "837633820417482754"
  },
  {
    source: "Twitter for Android",
    text:
      '...is all of the illegal leaks of classified and other information. It is a total "witch hunt!"',
    created_at: "Fri Mar 03 02:38:48 +0000 2017",
    retweet_count: 18089,
    favorite_count: 93134,
    is_retweet: false,
    id_str: "837492425283219458"
  },
  {
    source: "Twitter for Android",
    text:
      "...to win. The Democrats are overplaying their hand. They lost the election, and now they have lost their grip on reality. The real story...",
    created_at: "Fri Mar 03 02:35:33 +0000 2017",
    retweet_count: 23200,
    favorite_count: 109820,
    is_retweet: false,
    id_str: "837491607171629057"
  },
  {
    source: "Twitter for Android",
    text:
      "...intentional. This whole narrative is a way of saving face for Democrats losing an election that everyone thought they were supposed.....",
    created_at: "Fri Mar 03 02:27:29 +0000 2017",
    retweet_count: 17470,
    favorite_count: 90273,
    is_retweet: false,
    id_str: "837489578193846278"
  },
  {
    source: "Twitter for Android",
    text:
      "Jeff Sessions is an honest man. He did not say anything wrong. He could have stated his response more accurately, but it was clearly not....",
    created_at: "Fri Mar 03 02:22:49 +0000 2017",
    retweet_count: 19804,
    favorite_count: 102261,
    is_retweet: false,
    id_str: "837488402438176769"
  },
  {
    source: "Twitter for Android",
    text:
      "Since November 8th, Election Day, the Stock Market has posted $3.2 trillion in GAINS and consumer confidence is at a 15 year high. Jobs!",
    created_at: "Thu Mar 02 11:00:41 +0000 2017",
    retweet_count: 37270,
    favorite_count: 175684,
    is_retweet: false,
    id_str: "837256338203881472"
  },
  {
    source: "Twitter for Android",
    text: "THANK YOU!",
    created_at: "Wed Mar 01 13:38:44 +0000 2017",
    retweet_count: 27371,
    favorite_count: 183969,
    is_retweet: false,
    id_str: "836933725602656256"
  },
  {
    source: "Twitter for iPhone",
    text: "#JointSession #MAGA🇺🇸\nhttps://t.co/RDO6Jt2pip",
    created_at: "Wed Mar 01 01:42:16 +0000 2017",
    retweet_count: 10160,
    favorite_count: 63709,
    is_retweet: false,
    id_str: "836753422271582208"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me live at 9:00 P.M. \n#JointAddress https://t.co/J882zbyVkJ https://t.co/gTtK3vJmkU",
    created_at: "Wed Mar 01 01:30:49 +0000 2017",
    retweet_count: 7388,
    favorite_count: 54871,
    is_retweet: false,
    id_str: "836750538943377408"
  },
  {
    source: "Twitter for Android",
    text: "I will be interviewed on @foxandfriends at 6:00 A.M. Enjoy!",
    created_at: "Tue Feb 28 02:43:03 +0000 2017",
    retweet_count: 11039,
    favorite_count: 82888,
    is_retweet: false,
    id_str: "836406328369242113"
  },
  {
    source: "Twitter for iPhone",
    text:
      "GOP now viewed more favorably than Dems, in Trump era (per NBC/WSJ poll) via @HotlineJosh:\nhttps://t.co/Soebxtg2Zd",
    created_at: "Mon Feb 27 21:48:21 +0000 2017",
    retweet_count: 14662,
    favorite_count: 70544,
    is_retweet: false,
    id_str: "836332166728527872"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great meeting with CEOs of leading U.S. health insurance companies who provide great healthcare to the American peo… https://t.co/60jigi6ffS",
    created_at: "Mon Feb 27 17:06:23 +0000 2017",
    retweet_count: 15400,
    favorite_count: 89597,
    is_retweet: false,
    id_str: "836261209540288513"
  },
  {
    source: "Twitter for Android",
    text:
      "Big dinner with Governors tonight at White House. Much to be discussed, including healthcare.",
    created_at: "Sun Feb 26 20:13:52 +0000 2017",
    retweet_count: 15716,
    favorite_count: 105941,
    is_retweet: false,
    id_str: "835946001873657858"
  },
  {
    source: "Twitter for Android",
    text:
      "Russia talk is FAKE NEWS put out by the Dems, and played up by the media, in order to mask the big election defeat and the illegal leaks!",
    created_at: "Sun Feb 26 18:16:41 +0000 2017",
    retweet_count: 24677,
    favorite_count: 113140,
    is_retweet: false,
    id_str: "835916511944523777"
  },
  {
    source: "Twitter for Android",
    text:
      "For first time the failing @nytimes will take an ad (a bad one) to help save its failing reputation. Try reporting accurately &amp; fairly!",
    created_at: "Sun Feb 26 11:42:39 +0000 2017",
    retweet_count: 21792,
    favorite_count: 109318,
    is_retweet: false,
    id_str: "835817351178301440"
  },
  {
    source: "Twitter for Android",
    text:
      'The race for DNC Chairman was, of course, totally "rigged." Bernie\'s guy, like Bernie himself, never had a chance. Clinton demanded Perez!',
    created_at: "Sun Feb 26 11:33:16 +0000 2017",
    retweet_count: 19073,
    favorite_count: 87092,
    is_retweet: false,
    id_str: "835814988686233601"
  },
  {
    source: "Twitter for Android",
    text:
      "Congratulations to Thomas Perez, who has just been named Chairman of the DNC. I could not be happier for him, or for the Republican Party!",
    created_at: "Sat Feb 25 22:02:22 +0000 2017",
    retweet_count: 28744,
    favorite_count: 130499,
    is_retweet: false,
    id_str: "835610917568200705"
  },
  {
    source: "Twitter for Android",
    text:
      "I will not be attending the White House Correspondents' Association Dinner this year. Please wish everyone well and have a great evening!",
    created_at: "Sat Feb 25 21:53:21 +0000 2017",
    retweet_count: 23860,
    favorite_count: 123926,
    is_retweet: false,
    id_str: "835608648625836032"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Weekly Address from @WhiteHouse: https://t.co/uaoQSHBOQB https://t.co/7eF6aC6kEC",
    created_at: "Sat Feb 25 18:12:25 +0000 2017",
    retweet_count: 10068,
    favorite_count: 45735,
    is_retweet: false,
    id_str: "835553050530099200"
  },
  {
    source: "Twitter for Android",
    text:
      "Great optimism for future of U.S. business, AND JOBS, with the DOW having an 11th straight record close. Big tax &amp; regulation cuts coming!",
    created_at: "Sat Feb 25 13:27:04 +0000 2017",
    retweet_count: 19846,
    favorite_count: 104027,
    is_retweet: false,
    id_str: "835481237879926784"
  },
  {
    source: "Twitter for Android",
    text:
      "The media has not reported that the National Debt in my first month went down by $12 billion vs a $200 billion increase in Obama first mo.",
    created_at: "Sat Feb 25 13:19:18 +0000 2017",
    retweet_count: 62450,
    favorite_count: 201400,
    is_retweet: false,
    id_str: "835479283699224576"
  },
  {
    source: "Twitter for Android",
    text:
      "Maybe the millions of people who voted to MAKE AMERICA GREAT AGAIN should have their own rally. It would be the biggest of them all!",
    created_at: "Sat Feb 25 12:25:24 +0000 2017",
    retweet_count: 34603,
    favorite_count: 158646,
    is_retweet: false,
    id_str: "835465719970217984"
  },
  {
    source: "Twitter for Android",
    text:
      "FAKE NEWS media knowingly doesn't tell the truth. A great danger to our country. The failing @nytimes has become a joke. Likewise @CNN. Sad!",
    created_at: "Sat Feb 25 03:09:18 +0000 2017",
    retweet_count: 26341,
    favorite_count: 108710,
    is_retweet: false,
    id_str: "835325771858251776"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Trump vows to fight 'epidemic' of human trafficking \nhttps://t.co/oDLZ2NdrtA",
    created_at: "Fri Feb 24 17:04:19 +0000 2017",
    retweet_count: 20245,
    favorite_count: 91082,
    is_retweet: false,
    id_str: "835173525522624512"
  },
  {
    source: "Twitter for Android",
    text: "Going to CPAC!",
    created_at: "Fri Feb 24 13:49:27 +0000 2017",
    retweet_count: 8911,
    favorite_count: 71701,
    is_retweet: false,
    id_str: "835124485632180224"
  },
  {
    source: "Twitter for Android",
    text:
      "find the leakers within the FBI itself. Classified information is being given to media that could have a devastating effect on U.S. FIND NOW",
    created_at: "Fri Feb 24 12:36:34 +0000 2017",
    retweet_count: 21720,
    favorite_count: 100526,
    is_retweet: false,
    id_str: "835106143462703104"
  },
  {
    source: "Twitter for Android",
    text:
      'The FBI is totally unable to stop the national security "leakers" that have permeated our government for a long time. They can\'t even......',
    created_at: "Fri Feb 24 12:31:49 +0000 2017",
    retweet_count: 18342,
    favorite_count: 81076,
    is_retweet: false,
    id_str: "835104946034991106"
  },
  {
    source: "Twitter for Android",
    text:
      "Big interview tonight by Henry Kravis at The Business Council of Washington. Looking forward to it!",
    created_at: "Fri Feb 24 00:06:44 +0000 2017",
    retweet_count: 8265,
    favorite_count: 58140,
    is_retweet: false,
    id_str: "834917440450609152"
  },
  {
    source: "Twitter for Android",
    text:
      "Seven people shot and killed yesterday in Chicago. What is going on there - totally out of control. Chicago needs help!",
    created_at: "Fri Feb 24 00:01:40 +0000 2017",
    retweet_count: 23171,
    favorite_count: 108261,
    is_retweet: false,
    id_str: "834916167177371648"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'S&amp;P 500 Edges Higher After Trump Renews Jobs Pledge' https://t.co/WtrRJVFmvU",
    created_at: "Thu Feb 23 22:53:45 +0000 2017",
    retweet_count: 10563,
    favorite_count: 56246,
    is_retweet: false,
    id_str: "834899071982841856"
  },
  {
    source: "Twitter for Android",
    text:
      "Very much enjoyed my tour of the Smithsonian's National Museum of African American History and Culture...A great job done by amazing people!",
    created_at: "Wed Feb 22 12:50:56 +0000 2017",
    retweet_count: 16220,
    favorite_count: 116640,
    is_retweet: false,
    id_str: "834384982495940613"
  },
  {
    source: "Twitter for Android",
    text:
      "One thing I will say about Rep. Keith Ellison, in his fight to lead the DNC, is that he was the one who predicted early that I would win!",
    created_at: "Wed Feb 22 12:20:40 +0000 2017",
    retweet_count: 12132,
    favorite_count: 79330,
    is_retweet: false,
    id_str: "834377364947816448"
  },
  {
    source: "Twitter for Android",
    text:
      "The so-called angry crowds in home districts of some Republicans are actually, in numerous cases, planned out by liberal activists. Sad!",
    created_at: "Tue Feb 21 23:23:13 +0000 2017",
    retweet_count: 26055,
    favorite_count: 118125,
    is_retweet: false,
    id_str: "834181712783560705"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Americans overwhelmingly oppose sanctuary cities' https://t.co/s5QvsJWA6u",
    created_at: "Tue Feb 21 20:46:42 +0000 2017",
    retweet_count: 23693,
    favorite_count: 106937,
    is_retweet: false,
    id_str: "834142323881684993"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to our new National Security Advisor, General H.R. McMaster. Video: https://t.co/BKn9r225Kk https://t.co/VBXcJ1b6Pv",
    created_at: "Tue Feb 21 00:38:40 +0000 2017",
    retweet_count: 16021,
    favorite_count: 94069,
    is_retweet: false,
    id_str: "833838311315763200"
  },
  {
    source: "Twitter for Android",
    text: "Just named General H.R. McMaster National Security Advisor.",
    created_at: "Mon Feb 20 21:00:37 +0000 2017",
    retweet_count: 15766,
    favorite_count: 106326,
    is_retweet: false,
    id_str: "833783438922629125"
  },
  {
    source: "Twitter for Android",
    text: "Meeting with Generals at Mar-a-Lago in Florida. Very interesting!",
    created_at: "Mon Feb 20 19:33:35 +0000 2017",
    retweet_count: 33,
    favorite_count: 97,
    is_retweet: false,
    id_str: "833761537525444608"
  },
  {
    source: "Twitter for Android",
    text: "HAPPY PRESIDENTS DAY - MAKE AMERICA GREAT AGAIN!",
    created_at: "Mon Feb 20 14:33:33 +0000 2017",
    retweet_count: 48802,
    favorite_count: 242519,
    is_retweet: false,
    id_str: "833686030679207936"
  },
  {
    source: "Twitter for Android",
    text:
      "Give the public a break - The FAKE NEWS media is trying to say that large scale immigration in Sweden is working out just beautifully. NOT!",
    created_at: "Mon Feb 20 14:15:42 +0000 2017",
    retweet_count: 34840,
    favorite_count: 140919,
    is_retweet: false,
    id_str: "833681539997253636"
  },
  {
    source: "Twitter for Android",
    text:
      "My statement as to what's happening in Sweden was in reference to a story that was broadcast on @FoxNews concerning immigrants &amp; Sweden.",
    created_at: "Sun Feb 19 21:57:01 +0000 2017",
    retweet_count: 26224,
    favorite_count: 112115,
    is_retweet: false,
    id_str: "833435244451753984"
  },
  {
    source: "Twitter for Android",
    text: "Getting ready to leave for Melbourne, Florida. See you all soon!",
    created_at: "Sat Feb 18 20:26:31 +0000 2017",
    retweet_count: 37,
    favorite_count: 162,
    is_retweet: false,
    id_str: "833050081641234435"
  },
  {
    source: "Twitter for Android",
    text:
      "Will be having many meetings this weekend at The Southern White House. Big 5:00 P.M. speech in Melbourne, Florida. A lot to talk about!",
    created_at: "Sat Feb 18 13:51:20 +0000 2017",
    retweet_count: 15213,
    favorite_count: 99263,
    is_retweet: false,
    id_str: "832950628750127106"
  },
  {
    source: "Twitter for Android",
    text:
      "Don't believe the main stream (fake news) media.The White House is running VERY WELL. I inherited a MESS and am in the process of fixing it.",
    created_at: "Sat Feb 18 13:31:53 +0000 2017",
    retweet_count: 39020,
    favorite_count: 186074,
    is_retweet: false,
    id_str: "832945737625387008"
  },
  {
    source: "Twitter for Android",
    text: "Looking forward to the Florida rally tomorrow. Big crowd expected!",
    created_at: "Sat Feb 18 00:02:58 +0000 2017",
    retweet_count: 14143,
    favorite_count: 99028,
    is_retweet: false,
    id_str: "832742165436579840"
  },
  {
    source: "Twitter for Android",
    text:
      '"One of the most effective press conferences I\'ve ever seen!" says Rush Limbaugh. Many agree.Yet FAKE MEDIA  calls it differently! Dishonest',
    created_at: "Fri Feb 17 23:15:56 +0000 2017",
    retweet_count: 21751,
    favorite_count: 120315,
    is_retweet: false,
    id_str: "832730328108134402"
  },
  {
    source: "Twitter for Android",
    text:
      "The FAKE NEWS media (failing @nytimes, @NBCNews, @ABC, @CBS, @CNN) is not my enemy, it is the enemy of the American People!",
    created_at: "Fri Feb 17 21:48:22 +0000 2017",
    retweet_count: 52654,
    favorite_count: 162368,
    is_retweet: false,
    id_str: "832708293516632065"
  },
  {
    source: "Twitter for Android",
    text:
      "The FAKE NEWS media (failing @nytimes, @CNN, @NBCNews and many more)    is not my enemy, it is the enemy of the American people. SICK!",
    created_at: "Fri Feb 17 21:32:29 +0000 2017",
    retweet_count: 112,
    favorite_count: 247,
    is_retweet: false,
    id_str: "832704292993847296"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me at 11:00am:\nWatch here: https://t.co/veqKmsGAwf https://t.co/UzndIjIqjM",
    created_at: "Fri Feb 17 15:34:14 +0000 2017",
    retweet_count: 9912,
    favorite_count: 56533,
    is_retweet: false,
    id_str: "832614137586933760"
  },
  {
    source: "Twitter for iPhone",
    text:
      "General Keith Kellogg, who I have known for a long time, is very much in play for NSA - as are three others.",
    created_at: "Fri Feb 17 13:16:22 +0000 2017",
    retweet_count: 10955,
    favorite_count: 69643,
    is_retweet: false,
    id_str: "832579442790772736"
  },
  {
    source: "Twitter for Android",
    text:
      "Thank you for all of the nice statements on the Press Conference yesterday. Rush Limbaugh said one of greatest ever. Fake media not happy!",
    created_at: "Fri Feb 17 11:43:10 +0000 2017",
    retweet_count: 26347,
    favorite_count: 150763,
    is_retweet: false,
    id_str: "832555987299082242"
  },
  {
    source: "Twitter for Android",
    text:
      "Going to Charleston, South Carolina, in order to spend time with Boeing and talk jobs! Look forward to it.",
    created_at: "Fri Feb 17 11:38:20 +0000 2017",
    retweet_count: 14334,
    favorite_count: 99095,
    is_retweet: false,
    id_str: "832554772318322688"
  },
  {
    source: "Twitter for Android",
    text:
      "Despite the long delays by the Democrats in finally approving Dr. Tom Price, the repeal and replacement of ObamaCare is moving fast!",
    created_at: "Fri Feb 17 10:13:32 +0000 2017",
    retweet_count: 17252,
    favorite_count: 102948,
    is_retweet: false,
    id_str: "832533430168608768"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Trump signs bill undoing Obama coal mining rule' https://t.co/yMfT5r5RGh",
    created_at: "Thu Feb 16 23:44:54 +0000 2017",
    retweet_count: 18722,
    favorite_count: 93656,
    is_retweet: false,
    id_str: "832375230274400256"
  },
  {
    source: "Twitter for Android",
    text:
      "The Democrats had to come up with a story as to why they lost the election, and so badly (306), so they made up a story - RUSSIA. Fake news!",
    created_at: "Thu Feb 16 14:39:52 +0000 2017",
    retweet_count: 27003,
    favorite_count: 121137,
    is_retweet: false,
    id_str: "832238070460186625"
  },
  {
    source: "Twitter for Android",
    text:
      'FAKE NEWS media, which makes up stories and "sources," is far more effective than the discredited Democrats - but they are fading fast!',
    created_at: "Thu Feb 16 14:10:49 +0000 2017",
    retweet_count: 19854,
    favorite_count: 99214,
    is_retweet: false,
    id_str: "832230758299340800"
  },
  {
    source: "Twitter for Android",
    text:
      "The spotlight has finally been put on the low-life leakers! They will be caught!",
    created_at: "Thu Feb 16 12:02:59 +0000 2017",
    retweet_count: 25247,
    favorite_count: 126205,
    is_retweet: false,
    id_str: "832198588201594880"
  },
  {
    source: "Twitter for Android",
    text:
      "Leaking, and even illegal classified leaking, has been a big problem in Washington for years. Failing @nytimes (and others) must apologize!",
    created_at: "Thu Feb 16 11:58:43 +0000 2017",
    retweet_count: 17274,
    favorite_count: 89827,
    is_retweet: false,
    id_str: "832197515248275456"
  },
  {
    source: "Twitter for Android",
    text:
      "Stock market hits new high with longest winning streak in decades. Great level of confidence and optimism - even before tax plan rollout!",
    created_at: "Thu Feb 16 11:34:46 +0000 2017",
    retweet_count: 23643,
    favorite_count: 127764,
    is_retweet: false,
    id_str: "832191485701451777"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Venezuela should allow Leopoldo Lopez, a political prisoner &amp; husband of @liliantintori (just met w/ @marcorubio) o… https://t.co/HhgE51dtSN",
    created_at: "Wed Feb 15 23:59:26 +0000 2017",
    retweet_count: 53977,
    favorite_count: 110166,
    is_retweet: false,
    id_str: "832016501657968640"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Aetna CEO: Obamacare in 'Death Spiral' #RepealAndReplace \nhttps://t.co/dmHL7xIEQv",
    created_at: "Wed Feb 15 21:34:05 +0000 2017",
    retweet_count: 14576,
    favorite_count: 58732,
    is_retweet: false,
    id_str: "831979921555742732"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me in Florida this Saturday at 5pm for a rally at the Orlando-Melbourne International Airport!\nTickets:… https://t.co/OigfXFECPp",
    created_at: "Wed Feb 15 19:45:16 +0000 2017",
    retweet_count: 17852,
    favorite_count: 72138,
    is_retweet: false,
    id_str: "831952535544070145"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Welcome to the United States, @IsraeliPM Benjamin &amp; Sara!\n#ICYMI🇺🇸🇮🇱Joint Press Conference: \nhttps://t.co/GN6ALWUusN https://t.co/bH60nBL5FP",
    created_at: "Wed Feb 15 19:17:59 +0000 2017",
    retweet_count: 14224,
    favorite_count: 74512,
    is_retweet: false,
    id_str: "831945670324060164"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great listening session with CEO's of the Retail Industry Leaders Association this morning! https://t.co/sy6xJcWfcF",
    created_at: "Wed Feb 15 16:34:27 +0000 2017",
    retweet_count: 10692,
    favorite_count: 66081,
    is_retweet: false,
    id_str: "831904516316479489"
  },
  {
    source: "Twitter for Android",
    text:
      'The real scandal here is that classified information is illegally given out by "intelligence" like candy. Very un-American!',
    created_at: "Wed Feb 15 13:13:10 +0000 2017",
    retweet_count: 31903,
    favorite_count: 128448,
    is_retweet: false,
    id_str: "831853862281699331"
  },
  {
    source: "Twitter for Android",
    text:
      "Crimea was TAKEN by Russia during the Obama Administration. Was Obama too soft on Russia?",
    created_at: "Wed Feb 15 12:42:20 +0000 2017",
    retweet_count: 25351,
    favorite_count: 100698,
    is_retweet: false,
    id_str: "831846101179314177"
  },
  {
    source: "Twitter for Android",
    text:
      'Thank you to Eli Lake of The Bloomberg View - "The NSA &amp; FBI...should not interfere in our politics...and is" Very serious situation for USA',
    created_at: "Wed Feb 15 12:28:37 +0000 2017",
    retweet_count: 16346,
    favorite_count: 77692,
    is_retweet: false,
    id_str: "831842652085686273"
  },
  {
    source: "Twitter for Android",
    text:
      "Information is being illegally given to the failing @nytimes &amp; @washingtonpost by the intelligence community (NSA and FBI?).Just like Russia",
    created_at: "Wed Feb 15 12:19:18 +0000 2017",
    retweet_count: 21143,
    favorite_count: 80376,
    is_retweet: false,
    id_str: "831840306161123328"
  },
  {
    source: "Twitter for Android",
    text:
      "This Russian connection non-sense is merely an attempt to cover-up the many mistakes made in Hillary Clinton's losing campaign.",
    created_at: "Wed Feb 15 12:08:12 +0000 2017",
    retweet_count: 27541,
    favorite_count: 117900,
    is_retweet: false,
    id_str: "831837514226921472"
  },
  {
    source: "Twitter for Android",
    text:
      "The fake news media is going crazy with their conspiracy theories and blind hatred. @MSNBC &amp; @CNN are unwatchable. @foxandfriends is great!",
    created_at: "Wed Feb 15 11:40:32 +0000 2017",
    retweet_count: 25838,
    favorite_count: 104434,
    is_retweet: false,
    id_str: "831830548565852160"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Obamacare continues to fail. Humana to pull out in 2018. Will repeal, replace &amp; save healthcare for ALL Americans. \nhttps://t.co/glWEQ0lNR4",
    created_at: "Tue Feb 14 22:50:33 +0000 2017",
    retweet_count: 17872,
    favorite_count: 87852,
    is_retweet: false,
    id_str: "831636777110757377"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Remarks by President Trump at Signing of H.J. Resolution 41'\nhttps://t.co/Q3MoCGAc54 https://t.co/yGDDTKm9Br",
    created_at: "Tue Feb 14 21:48:10 +0000 2017",
    retweet_count: 8503,
    favorite_count: 46093,
    is_retweet: false,
    id_str: "831621079747723264"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great parent-teacher listening session this morning with @VP Pence &amp; @usedgov Secretary @BetsyDeVos. Watch:… https://t.co/nuLTs513Ot",
    created_at: "Tue Feb 14 20:21:59 +0000 2017",
    retweet_count: 11349,
    favorite_count: 59006,
    is_retweet: false,
    id_str: "831599387906301952"
  },
  {
    source: "Twitter for Android",
    text:
      "The real story here is why are there so many illegal leaks coming out of Washington? Will these leaks be happening as I deal on N.Korea etc?",
    created_at: "Tue Feb 14 14:28:54 +0000 2017",
    retweet_count: 26588,
    favorite_count: 111318,
    is_retweet: false,
    id_str: "831510532318429184"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to our new #VASecretary Dr. David Shulkin. Time to take care of Veterans who have fought to protect… https://t.co/FNewjbHuw4",
    created_at: "Tue Feb 14 03:30:45 +0000 2017",
    retweet_count: 16252,
    favorite_count: 90851,
    is_retweet: false,
    id_str: "831344902990655489"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations Treasury Secretary Steven Mnuchin! #ICYMI- watch here: https://t.co/RPsmw4yD7y https://t.co/K8tWLlXiYK",
    created_at: "Tue Feb 14 02:57:05 +0000 2017",
    retweet_count: 10918,
    favorite_count: 63937,
    is_retweet: false,
    id_str: "831336432073658368"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Wonderful meeting with Canadian PM @JustinTrudeau and a group of leading CEO's &amp; business women from Canada🇨🇦and th… https://t.co/wAoCOaYeZ6",
    created_at: "Mon Feb 13 18:50:57 +0000 2017",
    retweet_count: 15431,
    favorite_count: 85397,
    is_retweet: false,
    id_str: "831214091993751552"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Welcome to the @WhiteHouse Prime Minister @JustinTrudeau! https://t.co/WKgF8Zo9ri",
    created_at: "Mon Feb 13 16:59:06 +0000 2017",
    retweet_count: 13466,
    favorite_count: 84754,
    is_retweet: false,
    id_str: "831185943482793986"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today I will meet with Canadian PM Trudeau and a group of leading business women to discuss women in the workforce. https://t.co/bFAHPRXHdP",
    created_at: "Mon Feb 13 15:53:08 +0000 2017",
    retweet_count: 11763,
    favorite_count: 74360,
    is_retweet: false,
    id_str: "831169341358014475"
  },
  {
    source: "Twitter for Android",
    text:
      "Just leaving Florida. Big crowds of enthusiastic supporters lining the road that the FAKE NEWS media refuses to mention. Very dishonest!",
    created_at: "Sun Feb 12 22:19:05 +0000 2017",
    retweet_count: 25504,
    favorite_count: 141359,
    is_retweet: false,
    id_str: "830904083519242241"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations Stephen Miller- on representing me this morning on the various Sunday morning shows. Great job!",
    created_at: "Sun Feb 12 15:41:55 +0000 2017",
    retweet_count: 16088,
    favorite_count: 102935,
    is_retweet: false,
    id_str: "830804130692268032"
  },
  {
    source: "Twitter for Android",
    text:
      "I know Mark Cuban well. He backed me big-time but I wasn't interested in taking all of his calls.He's not smart enough to run for president!",
    created_at: "Sun Feb 12 13:23:18 +0000 2017",
    retweet_count: 15285,
    favorite_count: 82264,
    is_retweet: false,
    id_str: "830769247185952772"
  },
  {
    source: "Twitter for Android",
    text:
      "After two days of very productive talks, Prime Minister Abe is heading back to Japan. L",
    created_at: "Sun Feb 12 13:04:49 +0000 2017",
    retweet_count: 13121,
    favorite_count: 82736,
    is_retweet: false,
    id_str: "830764596235485188"
  },
  {
    source: "Twitter for Android",
    text:
      "While on FAKE NEWS @CNN, Bernie Sanders was cut off for using the term fake news to describe the network. They said technical difficulties!",
    created_at: "Sun Feb 12 12:14:16 +0000 2017",
    retweet_count: 25000,
    favorite_count: 113074,
    is_retweet: false,
    id_str: "830751875578355713"
  },
  {
    source: "Twitter for Android",
    text:
      "72% of refugees admitted into U.S. (2/3 -2/11) during COURT BREAKDOWN are from 7 countries: SYRIA, IRAQ, SOMALIA, IRAN, SUDAN, LIBYA &amp; YEMEN",
    created_at: "Sun Feb 12 11:55:10 +0000 2017",
    retweet_count: 22544,
    favorite_count: 80492,
    is_retweet: false,
    id_str: "830747067379232769"
  },
  {
    source: "Twitter for Android",
    text:
      "The crackdown on illegal criminals is merely the keeping of my campaign promise. Gang members, drug dealers &amp; others are being removed!",
    created_at: "Sun Feb 12 11:34:45 +0000 2017",
    retweet_count: 29437,
    favorite_count: 148471,
    is_retweet: false,
    id_str: "830741932099960834"
  },
  {
    source: "Twitter for iPhone",
    text:
      "#ICYMI: Joint Statement with Prime Minister Shinzo Abe on North Korea. https://t.co/qEC87FKB1D",
    created_at: "Sun Feb 12 05:02:01 +0000 2017",
    retweet_count: 14676,
    favorite_count: 62151,
    is_retweet: false,
    id_str: "830643095150657536"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Scavino45: LIVE Joint Statement by President Trump and Prime Minister Shinzo Abe: https://t.co/c3Fe5cUaaS",
    created_at: "Sun Feb 12 03:23:13 +0000 2017",
    retweet_count: 4810,
    favorite_count: 0,
    is_retweet: true,
    id_str: "830618234726543360"
  },
  {
    source: "Twitter for Android",
    text:
      "A working dinner tonight with Prime Minister Abe of Japan, and his representatives, at the Winter White House (Mar-a-Lago). Very good talks!",
    created_at: "Sat Feb 11 23:24:08 +0000 2017",
    retweet_count: 13843,
    favorite_count: 97579,
    is_retweet: false,
    id_str: "830558065715998726"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Played golf today with Prime Minister Abe of Japan and @TheBig_Easy, Ernie Els, and had a great time. Japan is very well represented!",
    created_at: "Sat Feb 11 23:15:34 +0000 2017",
    retweet_count: 13298,
    favorite_count: 84098,
    is_retweet: false,
    id_str: "830555911559249926"
  },
  {
    source: "Twitter for Android",
    text:
      "Playef golf today with Prime Minister Abe of Japan and @TheBig_Easy, Ernie Els, and had a great time. Japan is very well represented!",
    created_at: "Sat Feb 11 23:07:52 +0000 2017",
    retweet_count: 8,
    favorite_count: 1,
    is_retweet: false,
    id_str: "830553970225590277"
  },
  {
    source: "Twitter for Android",
    text:
      "I am so proud of my daughter Ivanka. To be abused and treated so badly by the media, and to still hold her head so high, is truly wonderful!",
    created_at: "Sat Feb 11 23:00:21 +0000 2017",
    retweet_count: 28439,
    favorite_count: 207438,
    is_retweet: false,
    id_str: "830552079240409089"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Having a great time hosting Prime Minister Shinzo Abe in the United States! \nhttps://t.co/Fvjsac89qS… https://t.co/hKqbMB2aQ9",
    created_at: "Sat Feb 11 18:28:31 +0000 2017",
    retweet_count: 16879,
    favorite_count: 92194,
    is_retweet: false,
    id_str: "830483672096768001"
  },
  {
    source: "Twitter for Android",
    text:
      "Melania and I are hosting Japanese Prime Minister Shinzo Abe and Mrs. Abe at Mar-a-Lago in Palm Beach, Fla. They are a wonderful couple!",
    created_at: "Sat Feb 11 13:33:53 +0000 2017",
    retweet_count: 16875,
    favorite_count: 120072,
    is_retweet: false,
    id_str: "830409522397184000"
  },
  {
    source: "Twitter for Android",
    text:
      "...design or negotiations yet. When I do, just like with the F-35 FighterJet or the Air Force One Program, price will come WAY DOWN!",
    created_at: "Sat Feb 11 13:24:32 +0000 2017",
    retweet_count: 12905,
    favorite_count: 83752,
    is_retweet: false,
    id_str: "830407172747988992"
  },
  {
    source: "Twitter for Android",
    text:
      "I am reading that the great border WALL will cost more than the government originally thought, but I have not gotten involved in the.....",
    created_at: "Sat Feb 11 13:18:43 +0000 2017",
    retweet_count: 14024,
    favorite_count: 77068,
    is_retweet: false,
    id_str: "830405706255912960"
  },
  {
    source: "Twitter for Android",
    text:
      'Our legal system is broken! "77% of refugees allowed into U.S. since travel reprieve hail from seven suspect countries." (WT)  SO DANGEROUS!',
    created_at: "Sat Feb 11 12:12:51 +0000 2017",
    retweet_count: 23082,
    favorite_count: 101179,
    is_retweet: false,
    id_str: "830389130311921667"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Heading to Joint Base Andrews on #MarineOne with Prime Minister Shinzō earlier today. https://t.co/4JFhyYdeHO",
    created_at: "Fri Feb 10 23:24:51 +0000 2017",
    retweet_count: 40351,
    favorite_count: 160212,
    is_retweet: false,
    id_str: "830195857530183684"
  },
  {
    source: "Twitter for Android",
    text:
      'The failing @nytimes does major FAKE NEWS China story saying "Mr.Xi has not spoken to Mr. Trump since Nov.14." We spoke at length yesterday!',
    created_at: "Fri Feb 10 13:35:50 +0000 2017",
    retweet_count: 23732,
    favorite_count: 106953,
    is_retweet: false,
    id_str: "830047626414477312"
  },
  {
    source: "Twitter for Android",
    text:
      'LAWFARE: "Remarkably, in the entire opinion, the panel did not bother even to cite this (the) statute." A disgraceful decision!',
    created_at: "Fri Feb 10 13:15:27 +0000 2017",
    retweet_count: 17556,
    favorite_count: 89202,
    is_retweet: false,
    id_str: "830042498806460417"
  },
  {
    source: "Twitter for Android",
    text: "SEE YOU IN COURT, THE SECURITY OF OUR NATION IS AT STAKE!",
    created_at: "Thu Feb 09 23:35:49 +0000 2017",
    retweet_count: 67448,
    favorite_count: 237614,
    is_retweet: false,
    id_str: "829836231802515457"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join us live in the Oval Office for the swearing in of our new Attorney General, @SenatorSessions!\nLIVE:… https://t.co/QeW6vjog4A",
    created_at: "Thu Feb 09 15:58:01 +0000 2017",
    retweet_count: 10756,
    favorite_count: 71140,
    is_retweet: false,
    id_str: "829721019720015872"
  },
  {
    source: "Twitter for Android",
    text:
      '..Ryan died on a winning mission ( according to General Mattis), not a "failure." Time for the U.S. to get smart and start winning again!',
    created_at: "Thu Feb 09 13:52:31 +0000 2017",
    retweet_count: 14900,
    favorite_count: 91185,
    is_retweet: false,
    id_str: "829689436279603206"
  },
  {
    source: "Twitter for Android",
    text:
      "...long he doesn't know how to win anymore, just look at the mess our country is in - bogged down in conflict all over the place. Our hero..",
    created_at: "Thu Feb 09 13:31:59 +0000 2017",
    retweet_count: 11801,
    favorite_count: 67986,
    is_retweet: false,
    id_str: "829684271812067328"
  },
  {
    source: "Twitter for Android",
    text:
      "Sen. McCain should not be talking about the success or failure of a mission to the media. Only emboldens the enemy! He's been losing so....",
    created_at: "Thu Feb 09 13:26:07 +0000 2017",
    retweet_count: 15800,
    favorite_count: 85781,
    is_retweet: false,
    id_str: "829682794951475200"
  },
  {
    source: "Twitter for Android",
    text:
      'Chris Cuomo, in his interview with Sen. Blumenthal, never asked him about his long-term lie about his brave "service" in Vietnam. FAKE NEWS!',
    created_at: "Thu Feb 09 13:19:08 +0000 2017",
    retweet_count: 14894,
    favorite_count: 73700,
    is_retweet: false,
    id_str: "829681034564341760"
  },
  {
    source: "Twitter for Android",
    text:
      "Sen.Richard Blumenthal, who never fought in Vietnam when he said for years he had (major lie),now misrepresents what Judge Gorsuch told him?",
    created_at: "Thu Feb 09 11:57:59 +0000 2017",
    retweet_count: 19352,
    favorite_count: 84674,
    is_retweet: false,
    id_str: "829660612452036608"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congratulations to our new Attorney General, @SenatorSessions! https://t.co/e0buP1K83z",
    created_at: "Thu Feb 09 01:05:53 +0000 2017",
    retweet_count: 32534,
    favorite_count: 163235,
    is_retweet: false,
    id_str: "829496507841789952"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Trump administration seen as more truthful than news media'\nhttps://t.co/6LmsR5JOSW",
    created_at: "Wed Feb 08 22:07:18 +0000 2017",
    retweet_count: 17626,
    favorite_count: 87896,
    is_retweet: false,
    id_str: "829451566000242688"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Majority in Leading EU Nations Support Trump-Style Travel Ban' \nPoll of more than 10,000 people in 10 countries...https://t.co/KWsIWhtC9o",
    created_at: "Wed Feb 08 21:46:14 +0000 2017",
    retweet_count: 21885,
    favorite_count: 83029,
    is_retweet: false,
    id_str: "829446266111287305"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Immigration Ban Is One Of Trump's Most Popular Orders So Far' https://t.co/wAelwuQ4BE",
    created_at: "Wed Feb 08 19:39:51 +0000 2017",
    retweet_count: 30541,
    favorite_count: 123007,
    is_retweet: false,
    id_str: "829414457126313986"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you Brian Krzanich, CEO of @Intel. A great investment ($7 BILLION) in American INNOVATION and JOBS!… https://t.co/oicfDsPKHQ",
    created_at: "Wed Feb 08 19:22:33 +0000 2017",
    retweet_count: 22030,
    favorite_count: 97758,
    is_retweet: false,
    id_str: "829410107406614534"
  },
  {
    source: "Twitter for Android",
    text:
      "Big increase in traffic into our country from certain areas, while our people are far more vulnerable, as we wait for what should be EASY D!",
    created_at: "Wed Feb 08 17:41:09 +0000 2017",
    retweet_count: 17539,
    favorite_count: 88547,
    is_retweet: false,
    id_str: "829384587482656768"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'16 Fake News Stories Reporters Have Run Since Trump Won' https://t.co/0dHld5kiVc",
    created_at: "Wed Feb 08 15:54:01 +0000 2017",
    retweet_count: 19076,
    favorite_count: 64126,
    is_retweet: false,
    id_str: "829357626798530561"
  },
  {
    source: "Twitter for iPhone",
    text:
      "My daughter Ivanka has been treated so unfairly by @Nordstrom. She is a great person -- always pushing me to do the right thing! Terrible!",
    created_at: "Wed Feb 08 15:51:01 +0000 2017",
    retweet_count: 27189,
    favorite_count: 142427,
    is_retweet: false,
    id_str: "829356871848951809"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to our great Police Chiefs &amp; Sheriffs for your leadership &amp; service. You have a true friend in the… https://t.co/Lysnv8ZR1h",
    created_at: "Wed Feb 08 15:23:29 +0000 2017",
    retweet_count: 16188,
    favorite_count: 90091,
    is_retweet: false,
    id_str: "829349943613734912"
  },
  {
    source: "Twitter for Android",
    text:
      "I will be speaking at 9:00 A.M. today to Police Chiefs and Sheriffs and will be discussing the horrible, dangerous and wrong decision.......",
    created_at: "Wed Feb 08 13:04:47 +0000 2017",
    retweet_count: 10807,
    favorite_count: 74978,
    is_retweet: false,
    id_str: "829315036329963521"
  },
  {
    source: "Twitter for Android",
    text:
      "If the U.S. does not win this case as it so obviously should, we can never have the security and safety to which we are entitled. Politics!",
    created_at: "Wed Feb 08 12:03:18 +0000 2017",
    retweet_count: 22277,
    favorite_count: 114959,
    is_retweet: false,
    id_str: "829299566344359936"
  },
  {
    source: "Twitter for Android",
    text:
      "It is a disgrace that my full Cabinet is still not in place, the longest such delay in the history of our country. Obstruction by Democrats!",
    created_at: "Wed Feb 08 01:04:00 +0000 2017",
    retweet_count: 36410,
    favorite_count: 157210,
    is_retweet: false,
    id_str: "829133645055135750"
  },
  {
    source: "Twitter for iPhone",
    text:
      "An honor having the National Sheriffs' Assoc. join me at the @WhiteHouse. Incredible men &amp; women who protect &amp; serv… https://t.co/1LkhbCNh8L",
    created_at: "Tue Feb 07 16:25:13 +0000 2017",
    retweet_count: 18399,
    favorite_count: 108216,
    is_retweet: false,
    id_str: "829003091735359488"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I don't know Putin, have no deals in Russia, and the haters are going crazy - yet Obama can make a deal with Iran, #1 in terror, no problem!",
    created_at: "Tue Feb 07 12:11:29 +0000 2017",
    retweet_count: 50474,
    favorite_count: 188271,
    is_retweet: false,
    id_str: "828939235499638784"
  },
  {
    source: "Twitter for Android",
    text:
      "I don't know Putin, have no deals in Russia, and the haters are going crazy - yet Obama can make a deal with Iran, #1in terror, no problem!",
    created_at: "Tue Feb 07 12:04:01 +0000 2017",
    retweet_count: 2,
    favorite_count: 2,
    is_retweet: false,
    id_str: "828937357147635713"
  },
  {
    source: "Twitter for Android",
    text:
      "The threat from radical Islamic terrorism is very real, just look at what is happening in Europe and the Middle-East. Courts must act fast!",
    created_at: "Tue Feb 07 02:49:28 +0000 2017",
    retweet_count: 32538,
    favorite_count: 145673,
    is_retweet: false,
    id_str: "828797801630937089"
  },
  {
    source: "Twitter for Android",
    text:
      "The failing @nytimes was forced to apologize to its subscribers for the poor reporting it did on my election win. Now they are worse!",
    created_at: "Tue Feb 07 02:33:55 +0000 2017",
    retweet_count: 16419,
    favorite_count: 91894,
    is_retweet: false,
    id_str: "828793887275761665"
  },
  {
    source: "Twitter for iPhone",
    text:
      "An extended interview from the Super Bowl with @oreillyfactor airs tonight at 8:00 P.M. Enjoy! https://t.co/kZdHqaNTVR",
    created_at: "Mon Feb 06 23:33:52 +0000 2017",
    retweet_count: 8058,
    favorite_count: 53603,
    is_retweet: false,
    id_str: "828748574255091714"
  },
  {
    source: "Twitter for Android",
    text:
      "The failing @nytimes writes total fiction concerning me. They have gotten it wrong for two years, and now are making up stories &amp; sources!",
    created_at: "Mon Feb 06 16:32:24 +0000 2017",
    retweet_count: 19275,
    favorite_count: 96642,
    is_retweet: false,
    id_str: "828642511698669569"
  },
  {
    source: "Twitter for Android",
    text: "Will be interviewed on @oreillyfactor tonight at 8:00 P.M.",
    created_at: "Mon Feb 06 16:27:45 +0000 2017",
    retweet_count: 6,
    favorite_count: 18,
    is_retweet: false,
    id_str: "828641340313460736"
  },
  {
    source: "Twitter for Android",
    text:
      "I call my own shots, largely based on an accumulation of data, and everyone knows it. Some FAKE NEWS media, in order to marginalize, lies!",
    created_at: "Mon Feb 06 12:07:55 +0000 2017",
    retweet_count: 23963,
    favorite_count: 125344,
    is_retweet: false,
    id_str: "828575949268606977"
  },
  {
    source: "Twitter for Android",
    text:
      "Any negative polls are fake news, just like the CNN, ABC, NBC polls in the election. Sorry, people want border security and extreme vetting.",
    created_at: "Mon Feb 06 12:01:53 +0000 2017",
    retweet_count: 36259,
    favorite_count: 161819,
    is_retweet: false,
    id_str: "828574430800539648"
  },
  {
    source: "Twitter for Android",
    text:
      "What an amazing comeback and win by the Patriots. Tom Brady, Bob Kraft and Coach B are total winners. Wow!",
    created_at: "Mon Feb 06 03:36:54 +0000 2017",
    retweet_count: 72934,
    favorite_count: 267584,
    is_retweet: false,
    id_str: "828447350200926212"
  },
  {
    source: "Twitter for Android",
    text:
      "Enjoy the #SuperBowl and then we continue: MAKE AMERICA GREAT AGAIN!",
    created_at: "Sun Feb 05 22:49:42 +0000 2017",
    retweet_count: 36535,
    favorite_count: 185073,
    is_retweet: false,
    id_str: "828375073006444544"
  },
  {
    source: "Twitter for Android",
    text:
      "I will be interviewed by @oreillyfactor at 4:00 P.M. (prior to the #SuperBowl Pre-game Show) on Fox Network. Enjoy!",
    created_at: "Sun Feb 05 20:47:25 +0000 2017",
    retweet_count: 147,
    favorite_count: 541,
    is_retweet: false,
    id_str: "828344301381939200"
  },
  {
    source: "Twitter for Android",
    text:
      "I have instructed Homeland Security to check people coming into our country VERY CAREFULLY. The courts are making the job very difficult!",
    created_at: "Sun Feb 05 20:42:33 +0000 2017",
    retweet_count: 28490,
    favorite_count: 147041,
    is_retweet: false,
    id_str: "828343072840900610"
  },
  {
    source: "Twitter for Android",
    text:
      "Just cannot  believe a judge would put our country in such peril. If something happens blame him and court system. People pouring in. Bad!",
    created_at: "Sun Feb 05 20:39:05 +0000 2017",
    retweet_count: 29114,
    favorite_count: 138219,
    is_retweet: false,
    id_str: "828342202174668800"
  },
  {
    source: "Twitter for Android",
    text:
      "The judge opens up our country to potential terrorists and others that do not have our best interests at heart. Bad people are very happy!",
    created_at: "Sun Feb 05 00:48:12 +0000 2017",
    retweet_count: 28096,
    favorite_count: 129523,
    is_retweet: false,
    id_str: "828042506851934209"
  },
  {
    source: "Twitter for Android",
    text:
      "Interview with @oreillyfactor on Fox Network - 4:00 P.M. (prior to Super Bowl). Enjoy!",
    created_at: "Sun Feb 05 00:34:50 +0000 2017",
    retweet_count: 11343,
    favorite_count: 70877,
    is_retweet: false,
    id_str: "828039143318024194"
  },
  {
    source: "Twitter for Android",
    text:
      "Why aren't the lawyers looking at and using the Federal Court decision in Boston, which is at conflict with ridiculous lift ban decision?",
    created_at: "Sat Feb 04 23:37:59 +0000 2017",
    retweet_count: 17863,
    favorite_count: 97489,
    is_retweet: false,
    id_str: "828024835670413312"
  },
  {
    source: "Twitter for Android",
    text:
      "Because the ban was lifted by a judge, many very bad and dangerous people may be pouring into our country. A terrible decision",
    created_at: "Sat Feb 04 21:44:49 +0000 2017",
    retweet_count: 29446,
    favorite_count: 136941,
    is_retweet: false,
    id_str: "827996357252243456"
  },
  {
    source: "Twitter for Android",
    text:
      "What is our country coming to when a judge can halt a Homeland Security travel ban and anyone, even with bad intentions, can come into U.S.?",
    created_at: "Sat Feb 04 20:44:07 +0000 2017",
    retweet_count: 33272,
    favorite_count: 148698,
    is_retweet: false,
    id_str: "827981079042805761"
  },
  {
    source: "Twitter for Android",
    text: "MAKE AMERICA GREAT AGAIN!",
    created_at: "Sat Feb 04 14:26:10 +0000 2017",
    retweet_count: 66140,
    favorite_count: 255896,
    is_retweet: false,
    id_str: "827885966509604865"
  },
  {
    source: "Twitter for Android",
    text:
      "After being forced to apologize for its bad and inaccurate coverage of me after winning the election, the FAKE NEWS @nytimes is still lost!",
    created_at: "Sat Feb 04 13:39:27 +0000 2017",
    retweet_count: 17438,
    favorite_count: 102747,
    is_retweet: false,
    id_str: "827874208021639168"
  },
  {
    source: "Twitter for Android",
    text:
      "The opinion of this so-called judge, which essentially takes law-enforcement away from our country, is ridiculous and will be overturned!",
    created_at: "Sat Feb 04 13:12:02 +0000 2017",
    retweet_count: 33518,
    favorite_count: 159207,
    is_retweet: false,
    id_str: "827867311054974976"
  },
  {
    source: "Twitter for Android",
    text:
      "Interesting that certain Middle-Eastern countries agree with the ban. They know if certain people are allowed in it's death &amp; destruction!",
    created_at: "Sat Feb 04 13:06:39 +0000 2017",
    retweet_count: 28311,
    favorite_count: 139881,
    is_retweet: false,
    id_str: "827865957750161408"
  },
  {
    source: "Twitter for Android",
    text:
      "When a country is no longer able to say who can, and who cannot , come in &amp; out, especially for reasons of safety &amp;.security - big trouble!",
    created_at: "Sat Feb 04 12:59:35 +0000 2017",
    retweet_count: 38069,
    favorite_count: 175399,
    is_retweet: false,
    id_str: "827864176043376640"
  },
  {
    source: "Twitter for Android",
    text:
      "Countries charge U.S. companies taxes or tariffs while the U.S. charges them nothing or little.We should charge them SAME as they charge us!",
    created_at: "Sat Feb 04 03:07:47 +0000 2017",
    retweet_count: 27046,
    favorite_count: 154637,
    is_retweet: false,
    id_str: "827715246135574530"
  },
  {
    source: "Twitter for Android",
    text: 'We must keep "evil" out of our country!',
    created_at: "Fri Feb 03 23:08:38 +0000 2017",
    retweet_count: 44904,
    favorite_count: 204985,
    is_retweet: false,
    id_str: "827655062835052544"
  },
  {
    source: "Twitter for Android",
    text:
      "A new radical Islamic terrorist has just attacked in Louvre Museum in Paris. Tourists were locked down. France on edge again. GET SMART U.S.",
    created_at: "Fri Feb 03 12:51:58 +0000 2017",
    retweet_count: 41566,
    favorite_count: 163923,
    is_retweet: false,
    id_str: "827499871011819520"
  },
  {
    source: "Twitter for Android",
    text:
      "Professional anarchists, thugs and paid protesters are proving the point of the millions of people who voted to MAKE AMERICA GREAT AGAIN!",
    created_at: "Fri Feb 03 11:48:16 +0000 2017",
    retweet_count: 42421,
    favorite_count: 172191,
    is_retweet: false,
    id_str: "827483841589891073"
  },
  {
    source: "Twitter for Android",
    text:
      "Meeting with biggest business leaders this morning. Good jobs are coming back to U.S., health care and tax bills are being crafted NOW!",
    created_at: "Fri Feb 03 11:41:11 +0000 2017",
    retweet_count: 19308,
    favorite_count: 125846,
    is_retweet: false,
    id_str: "827482059438432260"
  },
  {
    source: "Twitter for Android",
    text:
      "Thank you to Prime Minister of Australia for telling the truth about our very civil conversation that FAKE NEWS media lied about. Very nice!",
    created_at: "Fri Feb 03 11:34:32 +0000 2017",
    retweet_count: 32508,
    favorite_count: 148912,
    is_retweet: false,
    id_str: "827480386120929280"
  },
  {
    source: "Twitter for Android",
    text:
      'Iran is playing with fire - they don\'t appreciate how "kind" President Obama was to them. Not me!',
    created_at: "Fri Feb 03 11:28:02 +0000 2017",
    retweet_count: 64118,
    favorite_count: 173210,
    is_retweet: false,
    id_str: "827478751931924480"
  },
  {
    source: "Twitter for Android",
    text:
      "Yes, Arnold Schwarzenegger did a really bad job as Governor of California and even worse on the Apprentice...but at least he tried hard!",
    created_at: "Fri Feb 03 11:24:51 +0000 2017",
    retweet_count: 23451,
    favorite_count: 117196,
    is_retweet: false,
    id_str: "827477947154063361"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you, @Samsung! We would love to have you! https://t.co/r5nxC9oOA4",
    created_at: "Thu Feb 02 17:29:16 +0000 2017",
    retweet_count: 26161,
    favorite_count: 125661,
    is_retweet: false,
    id_str: "827207267632164868"
  },
  {
    source: "Twitter for Android",
    text:
      "Iran was on its last legs and ready to collapse until the U.S. came along and gave it a life-line in the form of the Iran Deal: $150 billion",
    created_at: "Thu Feb 02 11:39:49 +0000 2017",
    retweet_count: 24173,
    favorite_count: 97481,
    is_retweet: false,
    id_str: "827119326880813056"
  },
  {
    source: "Twitter for Android",
    text:
      "Iran has been formally PUT ON NOTICE for firing a ballistic missile.Should have been thankful for the terrible deal the U.S. made with them!",
    created_at: "Thu Feb 02 11:34:36 +0000 2017",
    retweet_count: 39629,
    favorite_count: 121480,
    is_retweet: false,
    id_str: "827118012784373760"
  },
  {
    source: "Twitter for Android",
    text:
      "Attending Chief Ryan Owens' Dignified Transfer yesterday with my daughter Ivanka was my great honor. To a great and brave man - thank you!",
    created_at: "Thu Feb 02 11:25:40 +0000 2017",
    retweet_count: 16711,
    favorite_count: 123763,
    is_retweet: false,
    id_str: "827115768202534913"
  },
  {
    source: "Twitter for Android",
    text:
      "Congratulations to Rex Tillerson on being sworn in as our new Secretary of State. He will be a star!",
    created_at: "Thu Feb 02 11:18:21 +0000 2017",
    retweet_count: 15883,
    favorite_count: 115116,
    is_retweet: false,
    id_str: "827113926517194757"
  },
  {
    source: "Twitter for Android",
    text:
      "If U.C. Berkeley does not allow free speech and practices violence on innocent people with a different point of view - NO FEDERAL FUNDS?",
    created_at: "Thu Feb 02 11:13:13 +0000 2017",
    retweet_count: 60266,
    favorite_count: 213655,
    is_retweet: false,
    id_str: "827112633224544256"
  },
  {
    source: "Twitter for Android",
    text:
      "Do you believe it? The Obama Administration agreed to take thousands of illegal immigrants from Australia. Why? I will study this dumb deal!",
    created_at: "Thu Feb 02 03:55:49 +0000 2017",
    retweet_count: 37373,
    favorite_count: 152041,
    is_retweet: false,
    id_str: "827002559122567168"
  },
  {
    source: "Twitter for Android",
    text:
      "Iran is rapidly taking over more and more of Iraq even after the U.S. has squandered three trillion dollars there. Obvious long ago!",
    created_at: "Thu Feb 02 03:06:14 +0000 2017",
    retweet_count: 20915,
    favorite_count: 93611,
    is_retweet: false,
    id_str: "826990079738540033"
  },
  {
    source: "Twitter for Android",
    text:
      "Everybody is arguing whether or not it is a BAN. Call it what you want, it is about keeping bad people (with bad intentions) out of country!",
    created_at: "Wed Feb 01 12:50:16 +0000 2017",
    retweet_count: 60583,
    favorite_count: 252382,
    is_retweet: false,
    id_str: "826774668245946368"
  },
  {
    source: "Twitter for Android",
    text:
      "Hope you like my nomination of Judge Neil Gorsuch for the United States Supreme Court. He is a good and brilliant man, respected by all.",
    created_at: "Wed Feb 01 03:45:26 +0000 2017",
    retweet_count: 34238,
    favorite_count: 250940,
    is_retweet: false,
    id_str: "826637556787838976"
  },
  {
    source: "Twitter for iPhone",
    text: "Join me live from the @WhiteHouse.\nhttps://t.co/LHOs4nAaGl",
    created_at: "Wed Feb 01 01:01:03 +0000 2017",
    retweet_count: 6621,
    favorite_count: 53239,
    is_retweet: false,
    id_str: "826596187453153281"
  },
  {
    source: "Twitter for Android",
    text: "Getting ready to deliver a VERY IMPORTANT DECISION!  8:00 P.M.",
    created_at: "Wed Feb 01 00:31:08 +0000 2017",
    retweet_count: 16427,
    favorite_count: 103201,
    is_retweet: false,
    id_str: "826588658304217088"
  },
  {
    source: "Twitter for Android",
    text:
      "When will the Democrats give us our Attorney General and rest of Cabinet! They should be ashamed of themselves! No wonder D.C. doesn't work!",
    created_at: "Tue Jan 31 11:27:02 +0000 2017",
    retweet_count: 38848,
    favorite_count: 179221,
    is_retweet: false,
    id_str: "826391334248407040"
  },
  {
    source: "Twitter for Android",
    text:
      "Nancy Pelosi and Fake Tears Chuck Schumer held a rally  at the steps of The Supreme Court and mic did not work (a mess)-just like Dem party!",
    created_at: "Tue Jan 31 11:21:52 +0000 2017",
    retweet_count: 31063,
    favorite_count: 152518,
    is_retweet: false,
    id_str: "826390034693623809"
  },
  {
    source: "Twitter for Android",
    text:
      "The Democrats are delaying my cabinet picks for purely political reasons. They have nothing going but to obstruct. Now have an Obama A.G.",
    created_at: "Tue Jan 31 00:45:50 +0000 2017",
    retweet_count: 27841,
    favorite_count: 127361,
    is_retweet: false,
    id_str: "826229971584708608"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The American dream is back. We’re going to create an environment for small business like we haven’t had in many, ma… https://t.co/Bh7SrNEgz1",
    created_at: "Mon Jan 30 21:07:52 +0000 2017",
    retweet_count: 34595,
    favorite_count: 176861,
    is_retweet: false,
    id_str: "826175120238604288"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Where was all the outrage from Democrats and the opposition party (the media) when our jobs were fleeing our country?",
    created_at: "Mon Jan 30 14:23:49 +0000 2017",
    retweet_count: 32607,
    favorite_count: 163273,
    is_retweet: false,
    id_str: "826073437735100418"
  },
  {
    source: "Twitter for Android",
    text:
      "I have made my decision on who I will nominate for The United States Supreme Court. It will be announced live on Tuesday at 8:00 P.M. (W.H.)",
    created_at: "Mon Jan 30 13:43:25 +0000 2017",
    retweet_count: 24983,
    favorite_count: 127061,
    is_retweet: false,
    id_str: "826063267760046080"
  },
  {
    source: "Twitter for Android",
    text:
      'If the ban were announced with a one week notice, the "bad" would rush into our country during that week. A lot of bad "dudes" out there!',
    created_at: "Mon Jan 30 13:31:00 +0000 2017",
    retweet_count: 35502,
    favorite_count: 171722,
    is_retweet: false,
    id_str: "826060143825666051"
  },
  {
    source: "Twitter for Android",
    text:
      "There is nothing nice about searching for terrorists before they can enter our country. This was a big part of my campaign. Study the world!",
    created_at: "Mon Jan 30 12:27:05 +0000 2017",
    retweet_count: 34992,
    favorite_count: 173239,
    is_retweet: false,
    id_str: "826044059647107073"
  },
  {
    source: "Twitter for Android",
    text:
      "protesters and the tears of Senator Schumer. Secretary Kelly said that all is going well with very few problems. MAKE AMERICA SAFE AGAIN!",
    created_at: "Mon Jan 30 12:20:49 +0000 2017",
    retweet_count: 24007,
    favorite_count: 133963,
    is_retweet: false,
    id_str: "826042483155013632"
  },
  {
    source: "Twitter for Android",
    text:
      "Only 109 people out of 325,000 were detained and held for questioning. Big problems at airports were caused by Delta computer outage,.....",
    created_at: "Mon Jan 30 12:16:30 +0000 2017",
    retweet_count: 30965,
    favorite_count: 130943,
    is_retweet: false,
    id_str: "826041397232943104"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be interviewed by @TheBrodyFile on @CBNNews tonight at 11pm. Enjoy!",
    created_at: "Sun Jan 29 23:39:53 +0000 2017",
    retweet_count: 11097,
    favorite_count: 67714,
    is_retweet: false,
    id_str: "825850987348914184"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Statement Regarding Recent Executive Order Concerning Extreme Vetting: https://t.co/f6JO60I0Ul",
    created_at: "Sun Jan 29 23:28:50 +0000 2017",
    retweet_count: 16894,
    favorite_count: 69207,
    is_retweet: false,
    id_str: "825848204633731074"
  },
  {
    source: "Twitter for Android",
    text:
      "...Senators should focus their energies on ISIS, illegal immigration and border security instead of always looking to start World War III.",
    created_at: "Sun Jan 29 21:49:32 +0000 2017",
    retweet_count: 42371,
    favorite_count: 170039,
    is_retweet: false,
    id_str: "825823217025691648"
  },
  {
    source: "Twitter for Android",
    text:
      "The joint statement of former presidential candidates John McCain &amp; Lindsey Graham is wrong - they are sadly weak on immigration. The two...",
    created_at: "Sun Jan 29 21:45:58 +0000 2017",
    retweet_count: 23764,
    favorite_count: 107416,
    is_retweet: false,
    id_str: "825822320128303110"
  },
  {
    source: "Twitter for Android",
    text:
      "Christians in the Middle-East have been executed in large numbers. We cannot allow this horror to continue!",
    created_at: "Sun Jan 29 15:03:58 +0000 2017",
    retweet_count: 59432,
    favorite_count: 223856,
    is_retweet: false,
    id_str: "825721153142521858"
  },
  {
    source: "Twitter for Android",
    text:
      "Our country needs strong borders and extreme vetting, NOW. Look what is happening all over Europe and, indeed, the world - a horrible mess!",
    created_at: "Sun Jan 29 13:08:18 +0000 2017",
    retweet_count: 50439,
    favorite_count: 218717,
    is_retweet: false,
    id_str: "825692045532618753"
  },
  {
    source: "Twitter for Android",
    text:
      "Somebody with aptitude and conviction should buy the FAKE NEWS and failing @nytimes and either run it correctly or let it fold with dignity!",
    created_at: "Sun Jan 29 13:00:32 +0000 2017",
    retweet_count: 22256,
    favorite_count: 111984,
    is_retweet: false,
    id_str: "825690087857995776"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be interviewed by @TheBrodyFile on @CBNNews tonight at 11pm. Enjoy!",
    created_at: "Sat Jan 28 22:50:06 +0000 2017",
    retweet_count: 305,
    favorite_count: 1300,
    is_retweet: false,
    id_str: "825476070946328584"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today, we remember the crew of the Space Shuttle Challenger, 31 years later. #NeverForget https://t.co/OhshQsFRfl",
    created_at: "Sat Jan 28 15:42:58 +0000 2017",
    retweet_count: 32623,
    favorite_count: 170093,
    is_retweet: false,
    id_str: "825368580325773312"
  },
  {
    source: "Twitter for Android",
    text:
      "...dwindling subscribers and readers.They got me wrong right from the beginning and still have not changed course, and never will. DISHONEST",
    created_at: "Sat Jan 28 13:16:17 +0000 2017",
    retweet_count: 15990,
    favorite_count: 105413,
    is_retweet: false,
    id_str: "825331665509691393"
  },
  {
    source: "Twitter for Android",
    text:
      "Thr coverage about me in the @nytimes and the @washingtonpost gas been so false and angry that the times actually apologized to its.....",
    created_at: "Sat Jan 28 13:08:42 +0000 2017",
    retweet_count: 13676,
    favorite_count: 79522,
    is_retweet: false,
    id_str: "825329757646618624"
  },
  {
    source: "Twitter for Android",
    text:
      "The failing @nytimes has been wrong about me from the very beginning. Said I would lose the primaries, then the general election. FAKE NEWS!",
    created_at: "Sat Jan 28 13:04:58 +0000 2017",
    retweet_count: 20740,
    favorite_count: 109402,
    is_retweet: false,
    id_str: "825328817833123840"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I promise that our administration will ALWAYS have your back. We will ALWAYS be with you! https://t.co/D0aOWhOH4X",
    created_at: "Fri Jan 27 23:46:22 +0000 2017",
    retweet_count: 28954,
    favorite_count: 149205,
    is_retweet: false,
    id_str: "825127844066054144"
  },
  {
    source: "Twitter for iPhone",
    text: "Congratulations Secretary Mattis! https://t.co/mkuhbegzqS",
    created_at: "Fri Jan 27 22:00:47 +0000 2017",
    retweet_count: 19030,
    favorite_count: 111729,
    is_retweet: false,
    id_str: "825101272982355968"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Statement on International Holocaust Remembrance Day: https://t.co/KjU0MOxCHk",
    created_at: "Fri Jan 27 20:20:15 +0000 2017",
    retweet_count: 10718,
    favorite_count: 57833,
    is_retweet: false,
    id_str: "825075972659613696"
  },
  {
    source: "Twitter for iPhone",
    text:
      ".@VP Mike Pence will be speaking at today's #MarchForLife -- You have our full support! https://t.co/1jb53SEGV4",
    created_at: "Fri Jan 27 16:30:29 +0000 2017",
    retweet_count: 16032,
    favorite_count: 88516,
    is_retweet: false,
    id_str: "825018149397463040"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The #MarchForLife is so important. To all of you marching --- you have my full support!",
    created_at: "Fri Jan 27 16:27:02 +0000 2017",
    retweet_count: 45457,
    favorite_count: 184954,
    is_retweet: false,
    id_str: "825017279209410561"
  },
  {
    source: "Twitter for Android",
    text:
      "Mexico has taken advantage of the U.S. for long enough. Massive trade deficits &amp; little help on the very weak border must change, NOW!",
    created_at: "Fri Jan 27 13:19:10 +0000 2017",
    retweet_count: 30604,
    favorite_count: 160660,
    is_retweet: false,
    id_str: "824970003153842176"
  },
  {
    source: "Twitter for Android",
    text:
      "Look forward to seeing final results of VoteStand. Gregg Phillips and crew say at least 3,000,000 votes were illegal. We must do better!",
    created_at: "Fri Jan 27 13:12:52 +0000 2017",
    retweet_count: 17319,
    favorite_count: 88640,
    is_retweet: false,
    id_str: "824968416486387713"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Miami-Dade Mayor drops sanctuary policy. Right decision. Strong! https://t.co/MtPvaDC4jM",
    created_at: "Thu Jan 26 23:53:37 +0000 2017",
    retweet_count: 24835,
    favorite_count: 112620,
    is_retweet: false,
    id_str: "824767281146245120"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Will be interviewed by @SeanHannity on @FoxNews at 10:00pm tonight. Enjoy!",
    created_at: "Thu Jan 26 23:45:28 +0000 2017",
    retweet_count: 10658,
    favorite_count: 73559,
    is_retweet: false,
    id_str: "824765229527605248"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Spoke at the Congressional @GOP Retreat in Philadelphia, PA. this afternoon w/ @VP, @SenateMajLdr, @SpeakerRyan. Th… https://t.co/ALSADGrwoe",
    created_at: "Thu Jan 26 19:21:17 +0000 2017",
    retweet_count: 11365,
    favorite_count: 72438,
    is_retweet: false,
    id_str: "824698743630995457"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Spoke at the Congressional @GOP Retreat in Philadelphia, PA. this afternoon w/ @VP, @SenMajLeader, @SpeakerRyan. Th… https://t.co/s4sTbSyBSR",
    created_at: "Thu Jan 26 19:15:44 +0000 2017",
    retweet_count: 9,
    favorite_count: 9,
    is_retweet: false,
    id_str: "824697349335293952"
  },
  {
    source: "Twitter for Android",
    text:
      "of jobs and companies lost. If Mexico is unwilling to pay for the badly needed wall, then it would be better to cancel the upcoming meeting.",
    created_at: "Thu Jan 26 13:55:03 +0000 2017",
    retweet_count: 28106,
    favorite_count: 115631,
    is_retweet: false,
    id_str: "824616644370714627"
  },
  {
    source: "Twitter for Android",
    text:
      "The U.S. has a 60 billion dollar trade deficit with Mexico. It has been a one-sided deal from the beginning of NAFTA with massive numbers...",
    created_at: "Thu Jan 26 13:51:46 +0000 2017",
    retweet_count: 25881,
    favorite_count: 106893,
    is_retweet: false,
    id_str: "824615820391305216"
  },
  {
    source: "Twitter for Android",
    text:
      "Ungrateful TRAITOR Chelsea Manning, who should never have been released from prison, is now calling President Obama a weak leader. Terrible!",
    created_at: "Thu Jan 26 11:04:24 +0000 2017",
    retweet_count: 28033,
    favorite_count: 128497,
    is_retweet: false,
    id_str: "824573698774601729"
  },
  {
    source: "Twitter for Android",
    text: "Interview with David Muir of @ABC News in 10 minutes. Enjoy!",
    created_at: "Thu Jan 26 02:48:25 +0000 2017",
    retweet_count: 6517,
    favorite_count: 53811,
    is_retweet: false,
    id_str: "824448880993509376"
  },
  {
    source: "Twitter for Android",
    text:
      '"@romoabcnews: .@DavidMuir first @POTUS interview since taking office.  Tonight on @ABCWorldNews @ABC2020 tonight. https://t.co/I4Vz1mRdBK"',
    created_at: "Thu Jan 26 02:45:32 +0000 2017",
    retweet_count: 6455,
    favorite_count: 44924,
    is_retweet: false,
    id_str: "824448156935081984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "As your President, I have no higher duty than to protect the lives of the American people. https://t.co/o7YNUNwb8f",
    created_at: "Thu Jan 26 02:14:56 +0000 2017",
    retweet_count: 29219,
    favorite_count: 152335,
    is_retweet: false,
    id_str: "824440456813707265"
  },
  {
    source: "Twitter Web Client",
    text:
      "Beginning today, the United States of America gets back control of its borders. Full speech from today @DHSgov:… https://t.co/8aDaHsAhg9",
    created_at: "Thu Jan 26 00:03:33 +0000 2017",
    retweet_count: 23095,
    favorite_count: 109885,
    is_retweet: false,
    id_str: "824407390674157568"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I will be interviewed by @DavidMuir tonight at 10 o'clock on @ABC. Will be my first interview from the White House.… https://t.co/4zuOrRdcoc",
    created_at: "Wed Jan 25 22:05:59 +0000 2017",
    retweet_count: 12454,
    favorite_count: 75988,
    is_retweet: false,
    id_str: "824377804590563339"
  },
  {
    source: "Twitter for Android",
    text:
      "I will be making my Supreme Court pick on Thursday of next week.Thank you!",
    created_at: "Wed Jan 25 12:17:01 +0000 2017",
    retweet_count: 21700,
    favorite_count: 132199,
    is_retweet: false,
    id_str: "824229586091307008"
  },
  {
    source: "Twitter for Android",
    text:
      "even, those registered to vote who are dead (and many for a long time). Depending on results, we will strengthen up voting procedures!",
    created_at: "Wed Jan 25 12:13:46 +0000 2017",
    retweet_count: 18914,
    favorite_count: 107227,
    is_retweet: false,
    id_str: "824228768227217408"
  },
  {
    source: "Twitter for Android",
    text:
      "I will be asking for a major investigation into VOTER FRAUD, including those registered to vote in two states, those who are illegal and....",
    created_at: "Wed Jan 25 12:10:01 +0000 2017",
    retweet_count: 26155,
    favorite_count: 129979,
    is_retweet: false,
    id_str: "824227824903090176"
  },
  {
    source: "Twitter for Android",
    text:
      "Big day planned on NATIONAL SECURITY tomorrow. Among many other things, we will build the wall!",
    created_at: "Wed Jan 25 02:37:48 +0000 2017",
    retweet_count: 53949,
    favorite_count: 193872,
    is_retweet: false,
    id_str: "824083821889015809"
  },
  {
    source: "Twitter for Android",
    text:
      'If Chicago doesn\'t fix the horrible "carnage" going on, 228 shootings in 2017 with 42 killings (up 24% from 2016), I will send in the Feds!',
    created_at: "Wed Jan 25 02:25:40 +0000 2017",
    retweet_count: 56038,
    favorite_count: 209363,
    is_retweet: false,
    id_str: "824080766288228352"
  },
  {
    source: "Twitter for Android",
    text:
      "Congratulations to @FoxNews for being number one in inauguration ratings. They were many times higher than FAKE NEWS @CNN - public is smart!",
    created_at: "Wed Jan 25 02:16:19 +0000 2017",
    retweet_count: 32107,
    favorite_count: 162721,
    is_retweet: false,
    id_str: "824078417213747200"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great meeting with Ford CEO Mark Fields and General Motors CEO Mary Barra at the @WhiteHouse today. https://t.co/T0eIgO6LP8",
    created_at: "Wed Jan 25 00:46:57 +0000 2017",
    retweet_count: 18697,
    favorite_count: 101012,
    is_retweet: false,
    id_str: "824055927200423936"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Signing orders to move forward with the construction of the Keystone XL and Dakota Access pipelines in the Oval Off… https://t.co/aOxmfO0vOK",
    created_at: "Tue Jan 24 17:49:17 +0000 2017",
    retweet_count: 25694,
    favorite_count: 131943,
    is_retweet: false,
    id_str: "823950814163140609"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great meeting with automobile industry leaders at the @WhiteHouse this morning. Together, we will #MAGA! https://t.co/OXdiLOkGsZ",
    created_at: "Tue Jan 24 17:04:01 +0000 2017",
    retweet_count: 16331,
    favorite_count: 99607,
    is_retweet: false,
    id_str: "823939422743830528"
  },
  {
    source: "Twitter for iPhone",
    text:
      "A photo delivered yesterday that will be displayed in the upper/lower press hall. Thank you Abbas! https://t.co/Uzp0ivvRp0",
    created_at: "Tue Jan 24 16:58:06 +0000 2017",
    retweet_count: 20939,
    favorite_count: 109406,
    is_retweet: false,
    id_str: "823937936056008704"
  },
  {
    source: "Twitter for Android",
    text:
      "Will be meeting at 9:00 with top automobile executives concerning jobs in America. I want new plants to be built here for cars sold here!",
    created_at: "Tue Jan 24 11:11:47 +0000 2017",
    retweet_count: 23743,
    favorite_count: 154857,
    is_retweet: false,
    id_str: "823850781946343427"
  },
  {
    source: "Twitter for Android",
    text:
      "Busy week planned with a heavy focus on jobs and national security. Top executives coming in at 9:00 A.M. to talk manufacturing in America.",
    created_at: "Mon Jan 23 11:38:16 +0000 2017",
    retweet_count: 26750,
    favorite_count: 177839,
    is_retweet: false,
    id_str: "823495059010109440"
  },
  {
    source: "Twitter for Android",
    text:
      "Peaceful protests are a hallmark of our democracy. Even if I don't always agree, I recognize the rights of people to express their views.",
    created_at: "Sun Jan 22 14:23:17 +0000 2017",
    retweet_count: 81527,
    favorite_count: 390826,
    is_retweet: false,
    id_str: "823174199036542980"
  },
  {
    source: "Twitter for Android",
    text:
      "Wow, television ratings just out: 31 million people watched the Inauguration, 11 million more than the very good ratings from 4 years ago!",
    created_at: "Sun Jan 22 12:51:36 +0000 2017",
    retweet_count: 40085,
    favorite_count: 217610,
    is_retweet: false,
    id_str: "823151124815507460"
  },
  {
    source: "Twitter for Android",
    text:
      "Watched protests yesterday but was under the impression that we just had an election! Why didn't these people vote? Celebs hurt cause badly.",
    created_at: "Sun Jan 22 12:47:21 +0000 2017",
    retweet_count: 45718,
    favorite_count: 213295,
    is_retweet: false,
    id_str: "823150055418920960"
  },
  {
    source: "Twitter for Android",
    text:
      "Had a great meeting at CIA Headquarters yesterday, packed house, paid great respect to Wall, long standing ovations, amazing people. WIN!",
    created_at: "Sun Jan 22 12:35:09 +0000 2017",
    retweet_count: 16906,
    favorite_count: 127677,
    is_retweet: false,
    id_str: "823146987117772800"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @WhiteHouse: "Do not allow anyone to tell you that it cannot be done. No challenge can match the HEART and FIGHT and SPIRIT of America."…',
    created_at: "Sat Jan 21 23:54:31 +0000 2017",
    retweet_count: 28013,
    favorite_count: 0,
    is_retweet: true,
    id_str: "822955565949272065"
  },
  {
    source: "Twitter for Android",
    text:
      "A fantastic day and evening in Washington D.C.Thank you to @FoxNews and so many other news outlets for the GREAT reviews of the speech!",
    created_at: "Sat Jan 21 11:53:41 +0000 2017",
    retweet_count: 23337,
    favorite_count: 177579,
    is_retweet: false,
    id_str: "822774162011910144"
  },
  {
    source: "Twitter for iPhone",
    text:
      "THANK YOU for another wonderful evening in Washington, D.C. TOGETHER, we will MAKE AMERICA GREAT AGAIN🇺🇸 https://t.co/V3aoj9RUh4",
    created_at: "Sat Jan 21 04:56:15 +0000 2017",
    retweet_count: 52468,
    favorite_count: 289942,
    is_retweet: false,
    id_str: "822669114237943808"
  },
  {
    source: "Twitter for iPhone",
    text: "TO ALL AMERICANS🇺🇸\nhttps://t.co/D7Es6ie4fY",
    created_at: "Fri Jan 20 18:13:48 +0000 2017",
    retweet_count: 16522,
    favorite_count: 92002,
    is_retweet: false,
    id_str: "822507434396753921"
  },
  {
    source: "Twitter for iPhone",
    text:
      "So to all Americans, in every city near and far, small and large, from mountain to mountain...https://t.co/cZKkrGXLSi",
    created_at: "Fri Jan 20 18:00:43 +0000 2017",
    retweet_count: 14039,
    favorite_count: 86467,
    is_retweet: false,
    id_str: "822504142178500608"
  },
  {
    source: "Twitter for iPhone",
    text: "It is time to remember that...https://t.co/ZKyOiOor62",
    created_at: "Fri Jan 20 17:58:24 +0000 2017",
    retweet_count: 9139,
    favorite_count: 58946,
    is_retweet: false,
    id_str: "822503558369181697"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We will follow two simple rules: BUY AMERICAN &amp; HIRE AMERICAN!\n#InaugurationDay #MAGA🇺🇸",
    created_at: "Fri Jan 20 17:55:44 +0000 2017",
    retweet_count: 38092,
    favorite_count: 161358,
    is_retweet: false,
    id_str: "822502887477673984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "We will bring back our jobs. We will bring back our borders. We will bring back our wealth - and we will bring back our dreams!",
    created_at: "Fri Jan 20 17:54:36 +0000 2017",
    retweet_count: 37458,
    favorite_count: 173821,
    is_retweet: false,
    id_str: "822502601304526848"
  },
  {
    source: "Twitter for iPhone",
    text:
      "The forgotten men and women of our country will be forgotten no longer. From this moment on, it’s going to be #AmericaFirst🇺🇸",
    created_at: "Fri Jan 20 17:54:00 +0000 2017",
    retweet_count: 34939,
    favorite_count: 148031,
    is_retweet: false,
    id_str: "822502450007515137"
  },
  {
    source: "Twitter for iPhone",
    text:
      "January 20th 2017, will be remembered as the day the people became the rulers of this nation again.",
    created_at: "Fri Jan 20 17:53:17 +0000 2017",
    retweet_count: 60604,
    favorite_count: 218555,
    is_retweet: false,
    id_str: "822502270503972872"
  },
  {
    source: "Twitter for iPhone",
    text:
      "What truly matters is not which party controls our government, but whether our government is controlled by the people.",
    created_at: "Fri Jan 20 17:52:45 +0000 2017",
    retweet_count: 42790,
    favorite_count: 180394,
    is_retweet: false,
    id_str: "822502135233384448"
  },
  {
    source: "Twitter for iPhone",
    text:
      "power from Washington, D.C. and giving it back to you, the American People. #InaugurationDay",
    created_at: "Fri Jan 20 17:51:58 +0000 2017",
    retweet_count: 18362,
    favorite_count: 91143,
    is_retweet: false,
    id_str: "822501939267141634"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Today we are not merely transferring power from one Administration to another, or from one party to another – but we are transferring...",
    created_at: "Fri Jan 20 17:51:25 +0000 2017",
    retweet_count: 20125,
    favorite_count: 109640,
    is_retweet: false,
    id_str: "822501803615014918"
  },
  {
    source: "Twitter for Android",
    text:
      "It all begins today! I will see you at 11:00 A.M. for the swearing-in. THE MOVEMENT CONTINUES - THE WORK BEGINS!",
    created_at: "Fri Jan 20 12:31:53 +0000 2017",
    retweet_count: 70523,
    favorite_count: 268372,
    is_retweet: false,
    id_str: "822421390125043713"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you for a wonderful evening in Washington, D.C. #Inauguration https://t.co/a6xpFQTHj5",
    created_at: "Fri Jan 20 04:24:33 +0000 2017",
    retweet_count: 20770,
    favorite_count: 112829,
    is_retweet: false,
    id_str: "822298747421986828"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you for joining us at the Lincoln Memorial tonight- a very special evening! Together, we are going to MAKE AM… https://t.co/OSxa3BamHs",
    created_at: "Fri Jan 20 00:40:51 +0000 2017",
    retweet_count: 34204,
    favorite_count: 165943,
    is_retweet: false,
    id_str: "822242449053614081"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Join me at 4pm over at the Lincoln Memorial with my family!\n#Inauguration2017 https://t.co/GQeQpJOgWz",
    created_at: "Thu Jan 19 20:21:36 +0000 2017",
    retweet_count: 12297,
    favorite_count: 66188,
    is_retweet: false,
    id_str: "822177206633955328"
  },
  {
    source: "Twitter for Android",
    text: "Great Concert at 4:00 P.M. today at Lincoln Memorial. Enjoy!",
    created_at: "Thu Jan 19 20:18:32 +0000 2017",
    retweet_count: 8392,
    favorite_count: 65389,
    is_retweet: false,
    id_str: "822176438627536897"
  },
  {
    source: "Twitter for iPhone",
    text: "On my way! #Inauguration2017 https://t.co/hOuMbxGnpe",
    created_at: "Thu Jan 19 20:13:57 +0000 2017",
    retweet_count: 8884,
    favorite_count: 56474,
    is_retweet: false,
    id_str: "822175285151928320"
  },
  {
    source: "Twitter for Android",
    text:
      "the American people. I have no doubt that we will, together, MAKE AMERICA GREAT AGAIN!",
    created_at: "Thu Jan 19 13:02:18 +0000 2017",
    retweet_count: 38818,
    favorite_count: 159832,
    is_retweet: false,
    id_str: "822066653953458177"
  },
  {
    source: "Twitter for Android",
    text:
      "Getting ready to leave for Washington, D.C. The journey begins and I will be working and fighting very hard to make it a great journey for..",
    created_at: "Thu Jan 19 13:00:13 +0000 2017",
    retweet_count: 25639,
    favorite_count: 150003,
    is_retweet: false,
    id_str: "822066132307808256"
  },
  {
    source: "Twitter for Android",
    text:
      '"It wasn\'t Donald Trump that divided this country, this country has been divided for a long time!" Stated today by Reverend Franklin Graham.',
    created_at: "Thu Jan 19 12:52:22 +0000 2017",
    retweet_count: 27797,
    favorite_count: 125166,
    is_retweet: false,
    id_str: "822064153426857984"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to our amazing Wounded Warriors for their service. It was an honor to be with them tonight in D.C.… https://t.co/Qj5cpfaykD",
    created_at: "Thu Jan 19 04:01:40 +0000 2017",
    retweet_count: 16320,
    favorite_count: 82131,
    is_retweet: false,
    id_str: "821930600290521089"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Great seeing @TheLeeGreenwood  and Kimberly at this evenings VP dinner! #GodBlessTheUSA https://t.co/SxVmaWvOFT",
    created_at: "Thu Jan 19 01:54:13 +0000 2017",
    retweet_count: 10083,
    favorite_count: 64810,
    is_retweet: false,
    id_str: "821898525432811520"
  },
  {
    source: "Twitter Web Client",
    text:
      "Looking forward to a speedy recovery for George and Barbara Bush, both hospitalized. Thank you for your wonderful letter!",
    created_at: "Wed Jan 18 22:21:02 +0000 2017",
    retweet_count: 21141,
    favorite_count: 135864,
    is_retweet: false,
    id_str: "821844875268255744"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Writing my inaugural address at the Winter White House, Mar-a-Lago, three weeks ago. Looking forward to Friday.… https://t.co/J0ojOXjrga",
    created_at: "Wed Jan 18 17:33:25 +0000 2017",
    retweet_count: 21051,
    favorite_count: 107464,
    is_retweet: false,
    id_str: "821772494864580614"
  },
  {
    source: "Twitter for Android",
    text:
      ".@TheAlabamaBand was great last night in D.C. playing for 147 Diplomats and Ambassadors from countries around the world. Thanks Alabama!",
    created_at: "Wed Jan 18 14:03:53 +0000 2017",
    retweet_count: 11370,
    favorite_count: 65795,
    is_retweet: false,
    id_str: "821719763214880769"
  },
  {
    source: "Twitter for Android",
    text:
      "No wonder the Today Show on biased @NBC is doing so badly compared to its glorious past. Little credibility!",
    created_at: "Wed Jan 18 13:06:58 +0000 2017",
    retweet_count: 10617,
    favorite_count: 57294,
    is_retweet: false,
    id_str: "821705440178348033"
  },
  {
    source: "Twitter for Android",
    text:
      '"Bayer AG has pledged to add U.S. jobs and investments after meeting with President-elect Donald Trump, the latest in a string..." @WSJ',
    created_at: "Wed Jan 18 13:00:51 +0000 2017",
    retweet_count: 11976,
    favorite_count: 58143,
    is_retweet: false,
    id_str: "821703902940827648"
  },
  {
    source: "Twitter for Android",
    text:
      "to the U.S., but had nothing to do with TRUMP, is more FAKE NEWS. Ask top CEO's of those companies for real facts. Came back because of me!",
    created_at: "Wed Jan 18 12:44:03 +0000 2017",
    retweet_count: 11518,
    favorite_count: 57775,
    is_retweet: false,
    id_str: "821699672687448064"
  },
  {
    source: "Twitter for Android",
    text:
      "Totally biased @NBCNews went out of its way to say that the big announcement from Ford, G.M., Lockheed &amp; others that jobs are coming back...",
    created_at: "Wed Jan 18 12:34:09 +0000 2017",
    retweet_count: 10178,
    favorite_count: 48148,
    is_retweet: false,
    id_str: "821697182235496450"
  },
  {
    source: "Twitter for Android",
    text: "Will be interviewed by @ainsleyearhardt on @foxandfriends - Enjoy!",
    created_at: "Wed Jan 18 11:53:24 +0000 2017",
    retweet_count: 5657,
    favorite_count: 37526,
    is_retweet: false,
    id_str: "821686928680583169"
  },
  {
    source: "Twitter Web Client",
    text:
      'RT @EricTrump: Thank you to @GolfDigest for this incredible feature! "Golfer-in-Chief" @RealDonaldTrump https://t.co/vpdY4jNbI4 https://t.c…',
    created_at: "Tue Jan 17 19:58:10 +0000 2017",
    retweet_count: 9066,
    favorite_count: 0,
    is_retweet: true,
    id_str: "821446536278274050"
  },
  {
    source: "Twitter Web Client",
    text:
      "RT @MoskowitzEva: .@BetsyDeVos has the talent, commitment, and leadership capacity to revitalize our public schools and deliver the promise…",
    created_at: "Tue Jan 17 19:36:21 +0000 2017",
    retweet_count: 6856,
    favorite_count: 0,
    is_retweet: true,
    id_str: "821441044097224704"
  },
  {
    source: "Twitter Web Client",
    text:
      "Thank you to General Motors and Walmart for starting the big jobs push back into the U.S.!",
    created_at: "Tue Jan 17 17:55:38 +0000 2017",
    retweet_count: 21503,
    favorite_count: 103996,
    is_retweet: false,
    id_str: "821415698278875137"
  },
  {
    source: "Twitter Web Client",
    text:
      '"How Trump Won--And How The Media Missed It" https://t.co/Hfab41h65X',
    created_at: "Tue Jan 17 17:36:45 +0000 2017",
    retweet_count: 11434,
    favorite_count: 42827,
    is_retweet: false,
    id_str: "821410947864653825"
  },
  {
    source: "Twitter for Android",
    text:
      "\"thought it would be hypocritical to attend Bush's swearing-in....he doesn't believe Bush is the true elected president.\" Sound familiar! WP",
    created_at: "Tue Jan 17 14:52:39 +0000 2017",
    retweet_count: 13981,
    favorite_count: 64105,
    is_retweet: false,
    id_str: "821369651968012288"
  },
  {
    source: "Twitter for Android",
    text:
      'John Lewis said about my inauguration, "It will be the first one that I\'ve missed." WRONG (or lie)! He boycotted Bush 43 also because he...',
    created_at: "Tue Jan 17 14:46:27 +0000 2017",
    retweet_count: 16240,
    favorite_count: 66871,
    is_retweet: false,
    id_str: "821368088935432196"
  },
  {
    source: "Twitter for Android",
    text:
      'country and with the massive cost reductions I have negotiated on military purchases and more, I believe the people are seeing "big stuff."',
    created_at: "Tue Jan 17 14:36:26 +0000 2017",
    retweet_count: 10419,
    favorite_count: 56220,
    is_retweet: false,
    id_str: "821365569366671360"
  },
  {
    source: "Twitter for Android",
    text:
      "With all of the jobs I am bringing back into the U.S. (even before taking office), with all of the new auto plants coming back into our.....",
    created_at: "Tue Jan 17 14:30:19 +0000 2017",
    retweet_count: 11043,
    favorite_count: 59063,
    is_retweet: false,
    id_str: "821364027506966532"
  },
  {
    source: "Twitter for Android",
    text:
      "The same people who did the phony election polls, and were so wrong, are now doing approval rating polls. They are rigged just like before.",
    created_at: "Tue Jan 17 13:11:56 +0000 2017",
    retweet_count: 24425,
    favorite_count: 106609,
    is_retweet: false,
    id_str: "821344302651555840"
  },
  {
    source: "Twitter for Android",
    text:
      "People are pouring into Washington in record numbers. Bikers for Trump are on their way. It will be a great Thursday, Friday and Saturday!",
    created_at: "Tue Jan 17 13:05:10 +0000 2017",
    retweet_count: 24946,
    favorite_count: 120615,
    is_retweet: false,
    id_str: "821342600322043905"
  },
  {
    source: "Twitter for Android",
    text:
      '"@drgoodspine: @realDonaldTrump @Ivanka Trump is great, a woman with real character and class."',
    created_at: "Tue Jan 17 02:08:21 +0000 2017",
    retweet_count: 8199,
    favorite_count: 46914,
    is_retweet: false,
    id_str: "821177307708661761"
  },
  {
    source: "Twitter for Android",
    text:
      "At 9:00 P.M. @CNN, of all places, is doing a Special Report on my daughter, Ivanka. Considering it is CNN, can't imagine it will be great!",
    created_at: "Tue Jan 17 01:49:38 +0000 2017",
    retweet_count: 11523,
    favorite_count: 58075,
    is_retweet: false,
    id_str: "821172595869577220"
  },
  {
    source: "Twitter for Android",
    text:
      '"@levisteveholt: @realDonaldTrump I appreciate your use of Twitter to keep us informed and maintain transparency." Very dishonest media!',
    created_at: "Tue Jan 17 01:42:18 +0000 2017",
    retweet_count: 12578,
    favorite_count: 61205,
    is_retweet: false,
    id_str: "821170750983995392"
  },
  {
    source: "Twitter for Android",
    text:
      "Celebrate Martin Luther King Day and all of the many wonderful things that he stood for. Honor him for being the great man that he was!",
    created_at: "Mon Jan 16 13:54:52 +0000 2017",
    retweet_count: 37896,
    favorite_count: 161320,
    is_retweet: false,
    id_str: "820992721120854016"
  },
  {
    source: "Twitter for Android",
    text:
      "much worse - just look at Syria (red line), Crimea, Ukraine and the build-up of Russian nukes. Not good! Was this the leaker of Fake News?",
    created_at: "Mon Jan 16 00:29:05 +0000 2017",
    retweet_count: 13993,
    favorite_count: 58849,
    is_retweet: false,
    id_str: "820789938887294977"
  },
  {
    source: "Twitter for Android",
    text:
      '.@FoxNews "Outgoing CIA Chief, John Brennan, blasts Pres-Elect Trump on Russia threat. Does not fully understand." Oh really, couldn\'t do...',
    created_at: "Mon Jan 16 00:16:20 +0000 2017",
    retweet_count: 11443,
    favorite_count: 45324,
    is_retweet: false,
    id_str: "820786730257285120"
  },
  {
    source: "Twitter for Android",
    text:
      ".@NBCNews is bad but Saturday Night Live is the worst of NBC. Not funny, cast is terrible, always a complete hit job. Really bad television!",
    created_at: "Sun Jan 15 22:46:33 +0000 2017",
    retweet_count: 18845,
    favorite_count: 84723,
    is_retweet: false,
    id_str: "820764134857969666"
  },
  {
    source: "Twitter for Android",
    text:
      'about that...Those Intelligence chiefs made a mistake here, &amp; when people make mistakes, they should APOLOGIZE." Media should also apologize',
    created_at: "Sun Jan 15 20:13:00 +0000 2017",
    retweet_count: 15313,
    favorite_count: 70395,
    is_retweet: false,
    id_str: "820725491812487170"
  },
  {
    source: "Twitter for Android",
    text:
      "Thank you to Bob Woodward who said, \"That is a garbage document...it never should have been presented...Trump's right to be upset (angry)...",
    created_at: "Sun Jan 15 20:04:38 +0000 2017",
    retweet_count: 16099,
    favorite_count: 69696,
    is_retweet: false,
    id_str: "820723387995717632"
  },
  {
    source: "Twitter for Android",
    text:
      "For many years our country has been divided, angry and untrusting. Many say it will never change, the hatred is too deep. IT WILL CHANGE!!!!",
    created_at: "Sun Jan 15 19:00:21 +0000 2017",
    retweet_count: 29527,
    favorite_count: 127759,
    is_retweet: false,
    id_str: "820707210565132288"
  },
  {
    source: "Twitter for Android",
    text:
      "will only get higher. Car companies and others, if they want to do business in our country, have to start making things here again. WIN!",
    created_at: "Sun Jan 15 14:02:41 +0000 2017",
    retweet_count: 15210,
    favorite_count: 78268,
    is_retweet: false,
    id_str: "820632299037409280"
  },
  {
    source: "Twitter for Android",
    text:
      "The Democrats are most angry that so many Obama Democrats voted for me. With all of the jobs I am bringing back to our Nation, that number..",
    created_at: "Sun Jan 15 13:59:29 +0000 2017",
    retweet_count: 16139,
    favorite_count: 79126,
    is_retweet: false,
    id_str: "820631495660408835"
  },
  {
    source: "Twitter for Android",
    text:
      "Inauguration Day is turning out to be even bigger than expected. January 20th, Washington D.C. Have fun!",
    created_at: "Sun Jan 15 01:58:57 +0000 2017",
    retweet_count: 25132,
    favorite_count: 121185,
    is_retweet: false,
    id_str: "820450166331346944"
  },
  {
    source: "Twitter for Android",
    text:
      "Congressman John Lewis should finally focus on the burning and crime infested inner-cities of the U.S. I can use all the help I can get!",
    created_at: "Sun Jan 15 00:22:01 +0000 2017",
    retweet_count: 22082,
    favorite_count: 95424,
    is_retweet: false,
    id_str: "820425770925338624"
  },
  {
    source: "Twitter for Android",
    text:
      'INTELLIGENCE INSIDERS NOW CLAIM THE TRUMP DOSSIER IS "A COMPLETE FRAUD!"  @OANN',
    created_at: "Sat Jan 14 13:14:13 +0000 2017",
    retweet_count: 19016,
    favorite_count: 68388,
    is_retweet: false,
    id_str: "820257714362314753"
  },
  {
    source: "Twitter for Android",
    text:
      "mention crime infested) rather than falsely complaining about the election results. All talk, talk, talk - no action or results. Sad!",
    created_at: "Sat Jan 14 13:07:12 +0000 2017",
    retweet_count: 16589,
    favorite_count: 76914,
    is_retweet: false,
    id_str: "820255947956383744"
  },
  {
    source: "Twitter for Android",
    text:
      "Congressman John Lewis should spend more time on fixing and helping his district, which is in horrible shape and falling apart (not to......",
    created_at: "Sat Jan 14 12:50:26 +0000 2017",
    retweet_count: 21049,
    favorite_count: 87998,
    is_retweet: false,
    id_str: "820251730407473153"
  },
  {
    source: "Twitter Web Client",
    text:
      "A beautiful funeral today for a real NYC hero, Detective Steven McDonald. Our law enforcement community has my complete and total support.",
    created_at: "Fri Jan 13 17:42:42 +0000 2017",
    retweet_count: 21197,
    favorite_count: 109424,
    is_retweet: false,
    id_str: "819962894616064001"
  },
  {
    source: "Twitter for Android",
    text: 'The "Unaffordable" Care Act will soon be history!',
    created_at: "Fri Jan 13 11:33:24 +0000 2017",
    retweet_count: 30025,
    favorite_count: 129591,
    is_retweet: false,
    id_str: "819869953692155904"
  },
  {
    source: "Twitter for Android",
    text:
      "have been allowed to run - guilty as hell. They were VERY nice to her. She lost because she campaigned in the wrong states - no enthusiasm!",
    created_at: "Fri Jan 13 11:25:54 +0000 2017",
    retweet_count: 13436,
    favorite_count: 67252,
    is_retweet: false,
    id_str: "819868066364461058"
  },
  {
    source: "Twitter for Android",
    text:
      "What are Hillary Clinton's people complaining about with respect to the F.B.I. Based on the information they had she should never.....",
    created_at: "Fri Jan 13 11:22:38 +0000 2017",
    retweet_count: 12744,
    favorite_count: 58039,
    is_retweet: false,
    id_str: "819867246352801792"
  },
  {
    source: "Twitter for Android",
    text:
      'released by "Intelligence" even knowing there is no proof, and never will be. My people will have a full report on hacking within 90 days!',
    created_at: "Fri Jan 13 11:16:54 +0000 2017",
    retweet_count: 12255,
    favorite_count: 54075,
    is_retweet: false,
    id_str: "819865802849587200"
  },
  {
    source: "Twitter for Android",
    text:
      "Totally made up facts by sleazebag political operatives, both Democrats and Republicans - FAKE NEWS! Russia says nothing exists. Probably...",
    created_at: "Fri Jan 13 11:11:13 +0000 2017",
    retweet_count: 12500,
    favorite_count: 54584,
    is_retweet: false,
    id_str: "819864373988573184"
  },
  {
    source: "Twitter for Android",
    text:
      "It now turns out that the phony allegations against me were put together by my political opponents and a failed spy afraid of being sued....",
    created_at: "Fri Jan 13 11:05:55 +0000 2017",
    retweet_count: 17299,
    favorite_count: 72507,
    is_retweet: false,
    id_str: "819863039902097408"
  },
  {
    source: "Twitter for Android",
    text:
      "All of my Cabinet nominee are looking good and doing a great job. I want them to be themselves and express their own thoughts, not mine!",
    created_at: "Fri Jan 13 10:49:34 +0000 2017",
    retweet_count: 16644,
    favorite_count: 80961,
    is_retweet: false,
    id_str: "819858926455967744"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Congrats to the Senate for taking the first step to #RepealObamacare- now it's onto the House!",
    created_at: "Thu Jan 12 17:41:11 +0000 2017",
    retweet_count: 19307,
    favorite_count: 85951,
    is_retweet: false,
    id_str: "819600124133474307"
  },
  {
    source: "Twitter for Android",
    text:
      ".@CNN is in a total meltdown with their FAKE NEWS because their ratings are tanking since election and their credibility will soon be gone!",
    created_at: "Thu Jan 12 14:22:21 +0000 2017",
    retweet_count: 35250,
    favorite_count: 127608,
    is_retweet: false,
    id_str: "819550083742109696"
  },
  {
    source: "Twitter for Android",
    text:
      "Thank you to Linda Bean of L.L.Bean for your great support and courage. People will support you even more now. Buy L.L.Bean. @LBPerfectMaine",
    created_at: "Thu Jan 12 13:50:13 +0000 2017",
    retweet_count: 21477,
    favorite_count: 92600,
    is_retweet: false,
    id_str: "819541997325316096"
  },
  {
    source: "Twitter for Android",
    text:
      "James Clapper called me yesterday to denounce the false and fictitious report that was illegally circulated. Made up, phony facts.Too bad!",
    created_at: "Thu Jan 12 12:23:45 +0000 2017",
    retweet_count: 17156,
    favorite_count: 71695,
    is_retweet: false,
    id_str: "819520238446411777"
  },
  {
    source: "Twitter for Android",
    text:
      '"@zhu_amy3: @realDonaldTrump It\'s Morning in America again!!!  ☀️☀️☀️Thank you President-Elect Donald Trump!!! So proud of you!!!!" THANKS!',
    created_at: "Thu Jan 12 04:24:52 +0000 2017",
    retweet_count: 9407,
    favorite_count: 52250,
    is_retweet: false,
    id_str: "819399723924803585"
  },
  {
    source: "Twitter for Android",
    text:
      "We had a great News Conference at Trump Tower today. A couple of FAKE NEWS organizations were there but the people truly get what's going on",
    created_at: "Thu Jan 12 04:01:38 +0000 2017",
    retweet_count: 28013,
    favorite_count: 117510,
    is_retweet: false,
    id_str: "819393877174087682"
  },
  {
    source: "Twitter for Android",
    text:
      'Intelligence agencies should never have allowed this fake news to "leak" into the public. One last shot at me.Are we living in Nazi Germany?',
    created_at: "Wed Jan 11 12:48:52 +0000 2017",
    retweet_count: 31725,
    favorite_count: 108284,
    is_retweet: false,
    id_str: "819164172781060096"
  },
  {
    source: "Twitter for Android",
    text:
      'I win an election easily, a great "movement" is verified, and crooked opponents try to belittle our victory with FAKE NEWS. A sorry state!',
    created_at: "Wed Jan 11 12:44:05 +0000 2017",
    retweet_count: 28585,
    favorite_count: 115066,
    is_retweet: false,
    id_str: "819162968592183298"
  },
  {
    source: "Twitter for Android",
    text:
      "Russia has never tried to use leverage over me. I HAVE NOTHING TO DO WITH RUSSIA - NO DEALS, NO LOANS, NO NOTHING!",
    created_at: "Wed Jan 11 12:31:31 +0000 2017",
    retweet_count: 23709,
    favorite_count: 85813,
    is_retweet: false,
    id_str: "819159806489591809"
  },
  {
    source: "Twitter for Android",
    text:
      'Russia just said the unverified report paid for by political opponents is "A COMPLETE AND TOTAL FABRICATION, UTTER NONSENSE." Very unfair!',
    created_at: "Wed Jan 11 12:13:40 +0000 2017",
    retweet_count: 17574,
    favorite_count: 66237,
    is_retweet: false,
    id_str: "819155311793700865"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'BuzzFeed Runs Unverifiable Trump-Russia Claims' #FakeNews \nhttps://t.co/d6daCFZHNh",
    created_at: "Wed Jan 11 02:00:11 +0000 2017",
    retweet_count: 15013,
    favorite_count: 45277,
    is_retweet: false,
    id_str: "819000924207251456"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @MichaelCohen212: I have never been to Prague in my life. #fakenews https://t.co/CMil9Rha3D",
    created_at: "Wed Jan 11 01:35:41 +0000 2017",
    retweet_count: 11160,
    favorite_count: 0,
    is_retweet: true,
    id_str: "818994757569564673"
  },
  {
    source: "Twitter for Android",
    text: "FAKE NEWS - A TOTAL POLITICAL WITCH HUNT!",
    created_at: "Wed Jan 11 01:19:23 +0000 2017",
    retweet_count: 29205,
    favorite_count: 93960,
    is_retweet: false,
    id_str: "818990655418617856"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Trump Helps Lift Small Business Confidence to 12-Yr. High'\nhttps://t.co/MhbABREhzt https://t.co/CWAvJ4fRdx",
    created_at: "Tue Jan 10 22:30:53 +0000 2017",
    retweet_count: 10499,
    favorite_count: 43435,
    is_retweet: false,
    id_str: "818948254943604736"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'Small business optimism soars after Trump election' https://t.co/WjBaTp824U",
    created_at: "Tue Jan 10 20:50:31 +0000 2017",
    retweet_count: 11791,
    favorite_count: 49639,
    is_retweet: false,
    id_str: "818922995980845056"
  },
  {
    source: "Twitter for iPhone",
    text:
      "'U.S. Small-Business Optimism Index Surges by Most Since 1980'\nhttps://t.co/X22x1BttdG",
    created_at: "Tue Jan 10 15:26:22 +0000 2017",
    retweet_count: 11159,
    favorite_count: 42009,
    is_retweet: false,
    id_str: "818841421364989952"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Thank you to all of the men and women who protect &amp; serve our communities 24/7/365! \n#LawEnforcementAppreciationDay… https://t.co/aqUbDipSgv",
    created_at: "Tue Jan 10 02:20:01 +0000 2017",
    retweet_count: 23231,
    favorite_count: 93051,
    is_retweet: false,
    id_str: "818643528905621504"
  },
  {
    source: "Twitter for iPhone",
    text:
      "An old picture with Nancy and Ronald Reagan. https://t.co/8kvQ1PzPAf",
    created_at: "Mon Jan 09 22:32:33 +0000 2017",
    retweet_count: 24973,
    favorite_count: 123554,
    is_retweet: false,
    id_str: "818586286034485250"
  },
  {
    source: "Twitter for Android",
    text:
      "Ford said last week that it will expand in Michigan and U.S. instead of building a BILLION dollar plant in Mexico. Thank you Ford &amp; Fiat C!",
    created_at: "Mon Jan 09 14:16:34 +0000 2017",
    retweet_count: 23379,
    favorite_count: 109595,
    is_retweet: false,
    id_str: "818461467766824961"
  },
  {
    source: "Twitter for Android",
    text:
      "It's finally happening - Fiat Chrysler just announced plans to invest $1BILLION in Michigan and Ohio plants, adding 2000 jobs. This after...",
    created_at: "Mon Jan 09 14:14:10 +0000 2017",
    retweet_count: 23305,
    favorite_count: 100861,
    is_retweet: false,
    id_str: "818460862675558400"
  },
  {
    source: "Twitter for Android",
    text:
      '"groveling" when he totally changed a 16 year old story that he had written in order to make me look bad. Just more very dishonest media!',
    created_at: "Mon Jan 09 11:43:26 +0000 2017",
    retweet_count: 16028,
    favorite_count: 69118,
    is_retweet: false,
    id_str: "818422930157830144"
  },
  {
    source: "Twitter for Android",
    text:
      'Hillary flunky who lost big. For the 100th time, I never "mocked" a disabled reporter (would never do that) but simply showed him.......',
    created_at: "Mon Jan 09 11:36:02 +0000 2017",
    retweet_count: 21354,
    favorite_count: 84171,
    is_retweet: false,
    id_str: "818421066859167746"
  },
  {
    source: "Twitter for Android",
    text:
      "Meryl Streep, one of the most over-rated actresses in Hollywood, doesn't know me but attacked last night at the Golden Globes. She is a.....",
    created_at: "Mon Jan 09 11:27:50 +0000 2017",
    retweet_count: 37502,
    favorite_count: 123217,
    is_retweet: false,
    id_str: "818419002548568064"
  },
  {
    source: "Twitter for Android",
    text:
      "Rupert Murdoch is a great guy who likes me much better as a very successful candidate than he ever did as a very successful developer!",
    created_at: "Mon Jan 09 11:17:40 +0000 2017",
    retweet_count: 7303,
    favorite_count: 37714,
    is_retweet: false,
    id_str: "818416446527172608"
  },
  {
    source: "Twitter for Android",
    text:
      "Dishonest media says Mexico won't be paying for the wall if they pay a little later so the wall can be built more quickly. Media is fake!",
    created_at: "Mon Jan 09 04:05:31 +0000 2017",
    retweet_count: 19152,
    favorite_count: 77977,
    is_retweet: false,
    id_str: "818307689323368448"
  },
  {
    source: "Twitter for Android",
    text:
      "Before I, or anyone, saw the classified and/or highly confidential hacking intelligence report, it was leaked out to @NBCNews. So serious!",
    created_at: "Sun Jan 08 18:56:20 +0000 2017",
    retweet_count: 20653,
    favorite_count: 74117,
    is_retweet: false,
    id_str: "818169485169410048"
  },
  {
    source: "Twitter for iPhone",
    text:
      'RT @MeetThePress: Watch our interview with @KellyannePolls: Russia "did not succeed" in attempts to sway election https://t.co/EZhgUIUbYx #…',
    created_at: "Sun Jan 08 16:57:46 +0000 2017",
    retweet_count: 6715,
    favorite_count: 0,
    is_retweet: true,
    id_str: "818139647687753733"
  },
  {
    source: "Twitter for Android",
    text:
      "Kellyanne Conway went to @MeetThePress this morning for an interview with @chucktodd. Dishonest media cut out 9 of her 10 minutes. Terrible!",
    created_at: "Sun Jan 08 16:46:07 +0000 2017",
    retweet_count: 18009,
    favorite_count: 58246,
    is_retweet: false,
    id_str: "818136714396975104"
  },
  {
    source: "Twitter for Android",
    text:
      '"@FoxNews: "We certainly don’t want intelligence interfering with politics and we don’t want politics interfe… https://t.co/bwDjEg1d7S"',
    created_at: "Sun Jan 08 16:39:14 +0000 2017",
    retweet_count: 8043,
    favorite_count: 35121,
    is_retweet: false,
    id_str: "818134981344165888"
  },
  {
    source: "Twitter for Android",
    text:
      '"@KellyannePolls: Welcome to President and Mrs. Bush.  \nhttps://t.co/I1K4nj1gVu" Very nice!',
    created_at: "Sun Jan 08 16:36:46 +0000 2017",
    retweet_count: 5437,
    favorite_count: 28740,
    is_retweet: false,
    id_str: "818134360712953858"
  },
  {
    source: "Twitter for Android",
    text:
      "I look very much forward to meeting Prime Minister Theresa May in Washington in the Spring. Britain, a longtime U.S. ally, is very special!",
    created_at: "Sun Jan 08 02:07:09 +0000 2017",
    retweet_count: 17231,
    favorite_count: 85216,
    is_retweet: false,
    id_str: "817915516018892805"
  },
  {
    source: "Twitter for Android",
    text:
      "Congratulation to Jane Timken on her major upset victory in becoming the Ohio Republican Party Chair. Jane is a loyal Trump supporter &amp; star",
    created_at: "Sat Jan 07 23:54:05 +0000 2017",
    retweet_count: 12192,
    favorite_count: 65268,
    is_retweet: false,
    id_str: "817882028272128001"
  },
  {
    source: "Twitter for Android",
    text:
      "both countries will, perhaps, work together to solve some of the many great and pressing problems and issues of the WORLD!",
    created_at: "Sat Jan 07 15:21:42 +0000 2017",
    retweet_count: 16259,
    favorite_count: 69956,
    is_retweet: false,
    id_str: "817753083707015168"
  },
  {
    source: "Twitter for Android",
    text:
      "have enough problems around the world without yet another one. When I am President, Russia will respect us far more than they do now and....",
    created_at: "Sat Jan 07 15:10:46 +0000 2017",
    retweet_count: 18629,
    favorite_count: 78260,
    is_retweet: false,
    id_str: "817750330196819968"
  },
  {
    source: "Twitter for Android",
    text:
      'Having a good relationship with Russia is a good thing, not a bad thing. Only "stupid" people, or fools, would think that it is bad! We.....',
    created_at: "Sat Jan 07 15:02:20 +0000 2017",
    retweet_count: 29384,
    favorite_count: 100987,
    is_retweet: false,
    id_str: "817748207694467072"
  },
  {
    source: "Twitter for Android",
    text:
      "Only reason the hacking of the poorly defended DNC is discussed is that the loss by the Dems was so big that they are totally embarrassed!",
    created_at: "Sat Jan 07 12:03:31 +0000 2017",
    retweet_count: 19739,
    favorite_count: 84016,
    is_retweet: false,
    id_str: "817703208567078913"
  },
  {
    source: "Twitter for Android",
    text:
      "Intelligence stated very strongly there was absolutely no evidence that hacking affected the election results. Voting machines not touched!",
    created_at: "Sat Jan 07 11:56:29 +0000 2017",
    retweet_count: 18247,
    favorite_count: 68966,
    is_retweet: false,
    id_str: "817701436096126977"
  },
  {
    source: "Twitter for Android",
    text:
      "Gross negligence by the Democratic National Committee allowed hacking to take place.The Republican National Committee had strong defense!",
    created_at: "Sat Jan 07 03:53:38 +0000 2017",
    retweet_count: 16472,
    favorite_count: 67736,
    is_retweet: false,
    id_str: "817579925771341825"
  },
  {
    source: "Twitter for iPhone",
    text: "Happy Birthday @EricTrump!\nhttps://t.co/bJaEY7qFSn",
    created_at: "Sat Jan 07 00:07:09 +0000 2017",
    retweet_count: 7769,
    favorite_count: 48269,
    is_retweet: false,
    id_str: "817522928862502913"
  },
  {
    source: "Twitter Web Client",
    text:
      "Monitoring the terrible situation in Florida. Just spoke to Governor Scott. Thoughts and prayers for all. Stay safe!",
    created_at: "Fri Jan 06 19:30:09 +0000 2017",
    retweet_count: 22189,
    favorite_count: 96091,
    is_retweet: false,
    id_str: "817453219613917185"
  },
  {
    source: "Twitter for iPhone",
    text:
      "I am asking the chairs of the House and Senate committees to investigate top secret intelligence shared with NBC prior to me seeing it.",
    created_at: "Fri Jan 06 16:51:37 +0000 2017",
    retweet_count: 26007,
    favorite_count: 92540,
    is_retweet: false,
    id_str: "817413321058029568"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Anna Wintour came to my office at Trump Tower to ask me to meet with the editors of Conde Nast &amp; Steven Newhouse, a friend. Will go this AM.",
    created_at: "Fri Jan 06 14:18:51 +0000 2017",
    retweet_count: 6471,
    favorite_count: 34982,
    is_retweet: false,
    id_str: "817374875962769408"
  },
  {
    source: "Twitter for Android",
    text:
      "being a movie star-and that was season 1 compared to season 14. Now compare him to my season 1. But who cares, he supported Kasich &amp; Hillary",
    created_at: "Fri Jan 06 12:42:53 +0000 2017",
    retweet_count: 8809,
    favorite_count: 41032,
    is_retweet: false,
    id_str: "817350726800306177"
  },
  {
    source: "Twitter for Android",
    text:
      'Wow, the ratings are in and Arnold Schwarzenegger got "swamped" (or destroyed) by comparison to the ratings machine, DJT. So much for....',
    created_at: "Fri Jan 06 12:34:37 +0000 2017",
    retweet_count: 9331,
    favorite_count: 39031,
    is_retweet: false,
    id_str: "817348644647108609"
  },
  {
    source: "Twitter for Android",
    text:
      "Hopefully, all supporters, and those who want to MAKE AMERICA GREAT AGAIN, will go to D.C. on January 20th. It will be a GREAT SHOW!",
    created_at: "Fri Jan 06 12:05:01 +0000 2017",
    retweet_count: 14381,
    favorite_count: 66190,
    is_retweet: false,
    id_str: "817341196251070464"
  },
  {
    source: "Twitter for Android",
    text:
      "and knew they were in big trouble - which is why they cancelled their big fireworks at the last minute.THEY SAW A MOVEMENT LIKE NEVER BEFORE",
    created_at: "Fri Jan 06 11:45:47 +0000 2017",
    retweet_count: 8277,
    favorite_count: 41623,
    is_retweet: false,
    id_str: "817336355193753600"
  },
  {
    source: "Twitter for Android",
    text:
      "Hillary and the Dems were never going to beat the PASSION of my voters. They saw what was happening in the last two weeks before the......",
    created_at: "Fri Jan 06 11:39:35 +0000 2017",
    retweet_count: 10555,
    favorite_count: 51431,
    is_retweet: false,
    id_str: "817334794958807042"
  },
  {
    source: "Twitter for Android",
    text:
      "The dishonest media does not report that any money spent on building the Great Wall (for sake of speed), will be paid back by Mexico later!",
    created_at: "Fri Jan 06 11:19:49 +0000 2017",
    retweet_count: 19129,
    favorite_count: 65840,
    is_retweet: false,
    id_str: "817329823374831617"
  },
  {
    source: "Twitter for Android",
    text:
      "So how and why are they so sure about hacking if they never even requested an examination of the computer servers? What is going on?",
    created_at: "Fri Jan 06 00:40:03 +0000 2017",
    retweet_count: 20758,
    favorite_count: 71070,
    is_retweet: false,
    id_str: "817168818539757568"
  },
  {
    source: "Twitter for Android",
    text:
      "The Democratic National Committee would not allow the FBI to study or see its computer info after it was supposedly hacked by Russia......",
    created_at: "Fri Jan 06 00:30:15 +0000 2017",
    retweet_count: 18774,
    favorite_count: 57162,
    is_retweet: false,
    id_str: "817166353266262016"
  },
  {
    source: "Twitter for Android",
    text:
      'How did NBC get "an exclusive look into the top secret report he (Obama) was presented?" Who gave them this report and why? Politics!',
    created_at: "Fri Jan 06 00:24:34 +0000 2017",
    retweet_count: 20594,
    favorite_count: 68079,
    is_retweet: false,
    id_str: "817164923843280896"
  },
  {
    source: "Twitter for Android",
    text:
      "Toyota Motor said will build a new plant in Baja, Mexico, to build Corolla cars for U.S. NO WAY! Build plant in U.S. or pay big border tax.",
    created_at: "Thu Jan 05 18:14:30 +0000 2017",
    retweet_count: 32121,
    favorite_count: 107842,
    is_retweet: false,
    id_str: "817071792711942145"
  },
  {
    source: "Twitter for Android",
    text:
      'to make up their own minds as to the truth. The media lies to make it look like I am against "Intelligence" when in fact I am a big fan!',
    created_at: "Thu Jan 05 13:45:57 +0000 2017",
    retweet_count: 15333,
    favorite_count: 67888,
    is_retweet: false,
    id_str: "817004210529116160"
  },
  {
    source: "Twitter for Android",
    text:
      "The dishonest media likes saying that I am in Agreement with Julian Assange - wrong. I simply state what he states, it is for the people....",
    created_at: "Thu Jan 05 13:25:30 +0000 2017",
    retweet_count: 16324,
    favorite_count: 61944,
    is_retweet: false,
    id_str: "816999062562107392"
  },
  {
    source: "Twitter for Android",
    text:
      "...time for Republicans &amp; Democrats to get together and come up with a healthcare plan that really works - much less expensive &amp; FAR BETTER!",
    created_at: "Thu Jan 05 12:06:42 +0000 2017",
    retweet_count: 16580,
    favorite_count: 78310,
    is_retweet: false,
    id_str: "816979231217483776"
  },
  {
    source: "Twitter for Android",
    text:
      '...do the typical political thing and BLAME. The fact is ObamaCare was a lie from the beginning."Keep you doctor, keep your plan!" It is....',
    created_at: "Thu Jan 05 12:01:33 +0000 2017",
    retweet_count: 12288,
    favorite_count: 51725,
    is_retweet: false,
    id_str: "816977937731878912"
  },
  {
    source: "Twitter for Android",
    text:
      "The Democrats, lead by head clown Chuck Schumer, know how bad ObamaCare is and what a mess they are in. Instead of working to fix it, they..",
    created_at: "Thu Jan 05 11:57:57 +0000 2017",
    retweet_count: 13117,
    favorite_count: 53297,
    is_retweet: false,
    id_str: "816977032433270784"
  },
  {
    source: "Twitter Web Client",
    text:
      "Jackie Evancho's album sales have skyrocketed after announcing her Inauguration performance.Some people just don't understand the \"Movement\"",
    created_at: "Wed Jan 04 18:52:09 +0000 2017",
    retweet_count: 17093,
    favorite_count: 79498,
    is_retweet: false,
    id_str: "816718880731234304"
  },
  {
    source: "Twitter for Android",
    text:
      "massive increases of ObamaCare will take place this year and Dems are to blame for the mess. It will fall of its own weight - be careful!",
    created_at: "Wed Jan 04 14:26:45 +0000 2017",
    retweet_count: 13596,
    favorite_count: 54146,
    is_retweet: false,
    id_str: "816652088662958082"
  },
  {
    source: "Twitter for Android",
    text:
      "like the 116% hike in Arizona. Also, deductibles are so high that it is practically useless. Don't let the Schumer clowns out of this web...",
    created_at: "Wed Jan 04 14:01:53 +0000 2017",
    retweet_count: 11224,
    favorite_count: 46485,
    is_retweet: false,
    id_str: "816645831659061248"
  },
  {
    source: "Twitter for Android",
    text:
      "Republicans must be careful in that the Dems own the failed ObamaCare disaster, with its poor coverage and massive premium increases......",
    created_at: "Wed Jan 04 13:55:53 +0000 2017",
    retweet_count: 11128,
    favorite_count: 46212,
    is_retweet: false,
    id_str: "816644321768312832"
  },
  {
    source: "Twitter for Android",
    text:
      "things they did and said (like giving the questions to the debate to H). A total double standard! Media, as usual, gave them a pass.",
    created_at: "Wed Jan 04 13:31:32 +0000 2017",
    retweet_count: 10731,
    favorite_count: 46561,
    is_retweet: false,
    id_str: "816638194468999169"
  },
  {
    source: "Twitter for Android",
    text:
      'Somebody hacked the DNC but why did they not have "hacking defense" like the RNC has and why have they not responded to the terrible......',
    created_at: "Wed Jan 04 13:27:03 +0000 2017",
    retweet_count: 10260,
    favorite_count: 42611,
    is_retweet: false,
    id_str: "816637064708030464"
  },
  {
    source: "Twitter for Android",
    text:
      "Thank you to Ford for scrapping a new plant in Mexico and creating 700 new jobs in the U.S. This is just the beginning - much more to follow",
    created_at: "Wed Jan 04 13:19:09 +0000 2017",
    retweet_count: 19529,
    favorite_count: 86542,
    is_retweet: false,
    id_str: "816635078067490816"
  },
  {
    source: "Twitter for Android",
    text:
      '"@FoxNews: Julian Assange on U.S. media coverage: “It’s very dishonest.” #Hannity https://t.co/ADcPRQifH9" More dishonest than anyone knows',
    created_at: "Wed Jan 04 13:10:05 +0000 2017",
    retweet_count: 14810,
    favorite_count: 42047,
    is_retweet: false,
    id_str: "816632793862176769"
  },
  {
    source: "Twitter for Android",
    text:
      'Julian Assange said "a 14 year old could have hacked Podesta" - why was DNC so careless? Also said Russians did not give him the info!',
    created_at: "Wed Jan 04 12:22:38 +0000 2017",
    retweet_count: 18118,
    favorite_count: 61018,
    is_retweet: false,
    id_str: "816620855958601730"
  },
  {
    source: "Twitter for Android",
    text:
      'The "Intelligence" briefing on so-called "Russian hacking" was delayed until Friday, perhaps more time needed to build a case. Very strange!',
    created_at: "Wed Jan 04 01:14:52 +0000 2017",
    retweet_count: 23441,
    favorite_count: 80009,
    is_retweet: false,
    id_str: "816452807024840704"
  },
  {
    source: "Twitter for Android",
    text:
      "I will be having a general news conference on JANUARY ELEVENTH in N.Y.C. Thank you.",
    created_at: "Tue Jan 03 23:58:31 +0000 2017",
    retweet_count: 14678,
    favorite_count: 57750,
    is_retweet: false,
    id_str: "816433590892429312"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"Trump is already delivering the jobs he promised America" https://t.co/11spTMa6Tm',
    created_at: "Tue Jan 03 18:44:47 +0000 2017",
    retweet_count: 14057,
    favorite_count: 53127,
    is_retweet: false,
    id_str: "816354639859871745"
  },
  {
    source: "Twitter for Android",
    text:
      "There should be no further releases from Gitmo. These are extremely dangerous people and should not be allowed back onto the battlefield.",
    created_at: "Tue Jan 03 17:20:43 +0000 2017",
    retweet_count: 20653,
    favorite_count: 82862,
    is_retweet: false,
    id_str: "816333480409833472"
  },
  {
    source: "Twitter for iPhone",
    text:
      "Instead of driving jobs and wealth away, AMERICA will become the world's great magnet for INNOVATION &amp; JOB CREATION.\nhttps://t.co/siXrptsOrt",
    created_at: "Tue Jan 03 17:00:11 +0000 2017",
    retweet_count: 12727,
    favorite_count: 54691,
    is_retweet: false,
    id_str: "816328314759606272"
  },
  {
    source: "Twitter for iPhone",
    text:
      '"@DanScavino: Ford to scrap Mexico plant, invest in Michigan due to Trump policies"\nhttps://t.co/137nUo03Gl',
    created_at: "Tue Jan 03 16:44:13 +0000 2017",
    retweet_count: 15571,
    favorite_count: 52850,
    is_retweet: false,
    id_str: "816324295781740544"
  },
  {
    source: "Twitter for Android",
    text:
      "........may be, their number one act and priority. Focus on tax reform, healthcare and so many other things of far greater importance! #DTS",
    created_at: "Tue Jan 03 15:07:41 +0000 2017",
    retweet_count: 9525,
    favorite_count: 42800,
    is_retweet: false,
    id_str: "816300003442495488"
  },
  {
    source: "Twitter for Android",
    text:
      "With all that Congress has to work on, do they really have to make the weakening of the Independent Ethics Watchdog, as unfair as it",
    created_at: "Tue Jan 03 15:03:29 +0000 2017",
    retweet_count: 10851,
    favorite_count: 43062,
    is_retweet: false,
    id_str: "816298944456232960"
  },
  {
    source: "Twitter for Android",
    text:
      'The Democrat Governor.of Minnesota said "The Affordable Care Act (ObamaCare) is no longer affordable!" - And, it is lousy healthcare.',
    created_at: "Tue Jan 03 12:51:15 +0000 2017",
    retweet_count: 12599,
    favorite_count: 53372,
    is_retweet: false,
    id_str: "816265668958031872"
  },
  {
    source: "Twitter for Android",
    text:
      'People must remember that ObamaCare just doesn\'t work, and it is not affordable - 116% increases (Arizona). Bill Clinton called it "CRAZY"',
    created_at: "Tue Jan 03 12:46:33 +0000 2017",
    retweet_count: 14481,
    favorite_count: 58809,
    is_retweet: false,
    id_str: "816264484629184513"
  },
  {
    source: "Twitter for Android",
    text:
      "General Motors is sending Mexican made model of Chevy Cruze to U.S. car dealers-tax free across border. Make in U.S.A.or pay big border tax!",
    created_at: "Tue Jan 03 12:30:05 +0000 2017",
    retweet_count: 18864,
    favorite_count: 73104,
    is_retweet: false,
    id_str: "816260343391514624"
  },
  {
    source: "Twitter for Android",
    text:
      "China has been taking out massive amounts of money &amp; wealth from the U.S. in totally one-sided trade, but won't help with North Korea. Nice!",
    created_at: "Mon Jan 02 23:47:12 +0000 2017",
    retweet_count: 17507,
    favorite_count: 64480,
    is_retweet: false,
    id_str: "816068355555815424"
  },
  {
    source: "Twitter for Android",
    text:
      "North Korea just stated that it is in the final stages of developing a nuclear weapon capable of reaching parts of the U.S. It won't happen!",
    created_at: "Mon Jan 02 23:05:44 +0000 2017",
    retweet_count: 26703,
    favorite_count: 92256,
    is_retweet: false,
    id_str: "816057920223846400"
  },
  {
    source: "Twitter for Android",
    text:
      "I thought and felt I would win big, easily over the fabled 270 (306). When they cancelled fireworks, they knew, and so did I.",
    created_at: "Mon Jan 02 18:44:04 +0000 2017",
    retweet_count: 13437,
    favorite_count: 62670,
    is_retweet: false,
    id_str: "815992069412057088"
  },
  {
    source: "Twitter for Android",
    text:
      "Various media outlets and pundits say that I thought I was going to lose the election. Wrong, it all came together in the last week and.....",
    created_at: "Mon Jan 02 18:37:10 +0000 2017",
    retweet_count: 9057,
    favorite_count: 47285,
    is_retweet: false,
    id_str: "815990335318982656"
  },
  {
    source: "Twitter for Android",
    text:
      '@CNN just released a book called "Unprecedented" which explores the 2016 race &amp; victory. Hope it does well but used worst cover photo of me!',
    created_at: "Mon Jan 02 18:32:29 +0000 2017",
    retweet_count: 3948,
    favorite_count: 13862,
    is_retweet: false,
    id_str: "815989154555297792"
  },
  {
    source: "Twitter for Android",
    text:
      "Chicago murder rate is record setting - 4,331 shooting victims with 762 murders in 2016. If Mayor can't do it he must ask for Federal help!",
    created_at: "Mon Jan 02 17:31:17 +0000 2017",
    retweet_count: 17411,
    favorite_count: 63340,
    is_retweet: false,
    id_str: "815973752785793024"
  },
  {
    source: "Twitter for Android",
    text:
      "Well, the New Year begins. We will, together, MAKE AMERICA GREAT AGAIN!",
    created_at: "Mon Jan 02 14:40:10 +0000 2017",
    retweet_count: 29248,
    favorite_count: 124024,
    is_retweet: false,
    id_str: "815930688889352192"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @IvankaTrump: 2016 has been one of the most eventful and exciting years of my life. I wish you peace, joy, love and laughter. Happy New…",
    created_at: "Sun Jan 01 06:49:49 +0000 2017",
    retweet_count: 13659,
    favorite_count: 0,
    is_retweet: true,
    id_str: "815449933453127681"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DonaldJTrumpJr: Happy new year everyone. #newyear #family #vacation #familytime https://t.co/u9fJIKNoZq",
    created_at: "Sun Jan 01 06:49:33 +0000 2017",
    retweet_count: 6847,
    favorite_count: 0,
    is_retweet: true,
    id_str: "815449868739211265"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @EricTrump: 2016 was such an incredible year for our entire family! My beautiful wife @LaraLeaTrump made it even better! 🇺🇸🇺🇸 https://t.…",
    created_at: "Sun Jan 01 05:44:17 +0000 2017",
    retweet_count: 6941,
    favorite_count: 0,
    is_retweet: true,
    id_str: "815433444591304704"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @Reince: Happy New Year + God's blessings to you all.  Looking forward to incredible things in 2017!  @realDonaldTrump will Make America…",
    created_at: "Sun Jan 01 05:43:23 +0000 2017",
    retweet_count: 7144,
    favorite_count: 0,
    is_retweet: true,
    id_str: "815433217595547648"
  },
  {
    source: "Twitter for iPhone",
    text:
      "RT @DanScavino: On behalf of our next #POTUS &amp; @TeamTrump-\n\n#HappyNewYear AMERICA🇺🇸\n\nhttps://t.co/Y6XDdijXea\nhttps://t.co/D8plL7xHql\nhttps:…",
    created_at: "Sun Jan 01 05:39:13 +0000 2017",
    retweet_count: 5548,
    favorite_count: 0,
    is_retweet: true,
    id_str: "815432169464197121"
  },
  {
    source: "Twitter for iPhone",
    text:
      "TO ALL AMERICANS-\n#HappyNewYear &amp; many blessings to you all! Looking forward to a wonderful &amp; prosperous 2017 as we… https://t.co/1asdMAL4iy",
    created_at: "Sun Jan 01 05:00:10 +0000 2017",
    retweet_count: 32665,
    favorite_count: 126230,
    is_retweet: false,
    id_str: "815422340540547073"
  }
];



// WEBPACK FOOTER //
// ./src/data/data.js